var $A = Object.defineProperty;
var jA = (n, e, t) => e in n ? $A(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var Ee = (n, e, t) => (jA(n, typeof e != "symbol" ? e + "" : e, t), t);
import { computed as Oi, ref as Rc, reactive as Kn, unref as WA } from "vue";
var Pt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Bc(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Yn = { exports: {} };
Yn.exports;
(function(n, e) {
  var t = 9007199254740991, O = "[object Arguments]", q = "[object Function]", re = "[object GeneratorFunction]", F = "[object Map]", be = "[object Object]", me = "[object Promise]", xe = "[object Set]", Re = "[object WeakMap]", ye = "[object DataView]", or = /[\\^$.*+?()[\]{}|]/g, $t = /^\[object .+?Constructor\]$/, jt = typeof Pt == "object" && Pt && Pt.Object === Object && Pt, kr = typeof self == "object" && self && self.Object === Object && self, De = jt || kr || Function("return this")(), bt = e && !e.nodeType && e, Ot = bt && !0 && n && !n.nodeType && n, Ze = Ot && Ot.exports === bt;
  function Wt(U, pe) {
    return U == null ? void 0 : U[pe];
  }
  function je(U) {
    var pe = !1;
    if (U != null && typeof U.toString != "function")
      try {
        pe = !!(U + "");
      } catch {
      }
    return pe;
  }
  function Ht(U, pe) {
    return function(Oe) {
      return U(pe(Oe));
    };
  }
  var yt = Function.prototype, st = Object.prototype, ir = De["__core-js_shared__"], vr = function() {
    var U = /[^.]+$/.exec(ir && ir.keys && ir.keys.IE_PROTO || "");
    return U ? "Symbol(src)_1." + U : "";
  }(), xo = yt.toString, Kr = st.hasOwnProperty, Vr = st.toString, Do = RegExp(
    "^" + xo.call(Kr).replace(or, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), To = Ze ? De.Buffer : void 0, So = st.propertyIsEnumerable, Qt = To ? To.isBuffer : void 0, qt = Ht(Object.keys, Object), Yr = Ct(De, "DataView"), nr = Ct(De, "Map"), ze = Ct(De, "Promise"), Jr = Ct(De, "Set"), Zr = Ct(De, "WeakMap"), ei = !So.call({ valueOf: 1 }, "valueOf"), ar = Bt(Yr), Nr = Bt(nr), ti = Bt(ze), se = Bt(Jr), ur = Bt(Zr);
  function ri(U) {
    return Vr.call(U);
  }
  function Xe(U) {
    if (!sr(U) || et(U))
      return !1;
    var pe = br(U) || je(U) ? Do : $t;
    return pe.test(Bt(U));
  }
  function Ct(U, pe) {
    var Oe = Wt(U, pe);
    return Xe(Oe) ? Oe : void 0;
  }
  var xt = ri;
  (Yr && xt(new Yr(new ArrayBuffer(1))) != ye || nr && xt(new nr()) != F || ze && xt(ze.resolve()) != me || Jr && xt(new Jr()) != xe || Zr && xt(new Zr()) != Re) && (xt = function(U) {
    var pe = Vr.call(U), Oe = pe == be ? U.constructor : void 0, pr = Oe ? Bt(Oe) : void 0;
    if (pr)
      switch (pr) {
        case ar:
          return ye;
        case Nr:
          return F;
        case ti:
          return me;
        case se:
          return xe;
        case ur:
          return Re;
      }
    return pe;
  });
  function et(U) {
    return !!vr && vr in U;
  }
  function yr(U) {
    var pe = U && U.constructor, Oe = typeof pe == "function" && pe.prototype || st;
    return U === Oe;
  }
  function Bt(U) {
    if (U != null) {
      try {
        return xo.call(U);
      } catch {
      }
      try {
        return U + "";
      } catch {
      }
    }
    return "";
  }
  function pt(U) {
    return Ar(U) && Kr.call(U, "callee") && (!So.call(U, "callee") || Vr.call(U) == O);
  }
  var Ro = Array.isArray;
  function wo(U) {
    return U != null && Xr(U.length) && !br(U);
  }
  function Ar(U) {
    return Io(U) && wo(U);
  }
  var tt = Qt || Cr;
  function hr(U) {
    if (wo(U) && (Ro(U) || typeof U == "string" || typeof U.splice == "function" || tt(U) || pt(U)))
      return !U.length;
    var pe = xt(U);
    if (pe == F || pe == xe)
      return !U.size;
    if (ei || yr(U))
      return !qt(U).length;
    for (var Oe in U)
      if (Kr.call(U, Oe))
        return !1;
    return !0;
  }
  function br(U) {
    var pe = sr(U) ? Vr.call(U) : "";
    return pe == q || pe == re;
  }
  function Xr(U) {
    return typeof U == "number" && U > -1 && U % 1 == 0 && U <= t;
  }
  function sr(U) {
    var pe = typeof U;
    return !!U && (pe == "object" || pe == "function");
  }
  function Io(U) {
    return !!U && typeof U == "object";
  }
  function Cr() {
    return !1;
  }
  n.exports = hr;
})(Yn, Yn.exports);
var HA = Yn.exports, QA = "[object Object]";
function zA(n) {
  var e = !1;
  if (n != null && typeof n.toString != "function")
    try {
      e = !!(n + "");
    } catch {
    }
  return e;
}
function GA(n, e) {
  return function(t) {
    return n(e(t));
  };
}
var KA = Function.prototype, Uc = Object.prototype, Mc = KA.toString, YA = Uc.hasOwnProperty, JA = Mc.call(Object), ZA = Uc.toString, XA = GA(Object.getPrototypeOf, Object);
function eh(n) {
  return !!n && typeof n == "object";
}
function th(n) {
  if (!eh(n) || ZA.call(n) != QA || zA(n))
    return !1;
  var e = XA(n);
  if (e === null)
    return !0;
  var t = YA.call(e, "constructor") && e.constructor;
  return typeof t == "function" && t instanceof t && Mc.call(t) == JA;
}
var rh = th, Jn = { exports: {} };
Jn.exports;
(function(n, e) {
  var t = 200, O = "Expected a function", q = "__lodash_hash_undefined__", re = 1, F = 2, be = 1 / 0, me = 9007199254740991, xe = "[object Arguments]", Re = "[object Array]", ye = "[object Boolean]", or = "[object Date]", $t = "[object Error]", jt = "[object Function]", kr = "[object GeneratorFunction]", De = "[object Map]", bt = "[object Number]", Ot = "[object Object]", Ze = "[object Promise]", Wt = "[object RegExp]", je = "[object Set]", Ht = "[object String]", yt = "[object Symbol]", st = "[object WeakMap]", ir = "[object ArrayBuffer]", vr = "[object DataView]", xo = "[object Float32Array]", Kr = "[object Float64Array]", Vr = "[object Int8Array]", Do = "[object Int16Array]", To = "[object Int32Array]", So = "[object Uint8Array]", Qt = "[object Uint8ClampedArray]", qt = "[object Uint16Array]", Yr = "[object Uint32Array]", nr = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, ze = /^\w*$/, Jr = /^\./, Zr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ei = /[\\^$.*+?()[\]{}|]/g, ar = /\\(\\)?/g, Nr = /^\[object .+?Constructor\]$/, ti = /^(?:0|[1-9]\d*)$/, se = {};
  se[xo] = se[Kr] = se[Vr] = se[Do] = se[To] = se[So] = se[Qt] = se[qt] = se[Yr] = !0, se[xe] = se[Re] = se[ir] = se[ye] = se[vr] = se[or] = se[$t] = se[jt] = se[De] = se[bt] = se[Ot] = se[Wt] = se[je] = se[Ht] = se[st] = !1;
  var ur = typeof Pt == "object" && Pt && Pt.Object === Object && Pt, ri = typeof self == "object" && self && self.Object === Object && self, Xe = ur || ri || Function("return this")(), Ct = e && !e.nodeType && e, xt = Ct && !0 && n && !n.nodeType && n, et = xt && xt.exports === Ct, yr = et && ur.process, Bt = function() {
    try {
      return yr && yr.binding("util");
    } catch {
    }
  }(), pt = Bt && Bt.isTypedArray;
  function Ro(c, g) {
    for (var x = -1, P = c ? c.length : 0; ++x < P && g(c[x], x, c) !== !1; )
      ;
    return c;
  }
  function wo(c, g) {
    for (var x = -1, P = c ? c.length : 0; ++x < P; )
      if (g(c[x], x, c))
        return !0;
    return !1;
  }
  function Ar(c) {
    return function(g) {
      return g == null ? void 0 : g[c];
    };
  }
  function tt(c, g) {
    for (var x = -1, P = Array(c); ++x < c; )
      P[x] = g(x);
    return P;
  }
  function hr(c) {
    return function(g) {
      return c(g);
    };
  }
  function br(c, g) {
    return c == null ? void 0 : c[g];
  }
  function Xr(c) {
    var g = !1;
    if (c != null && typeof c.toString != "function")
      try {
        g = !!(c + "");
      } catch {
      }
    return g;
  }
  function sr(c) {
    var g = -1, x = Array(c.size);
    return c.forEach(function(P, j) {
      x[++g] = [j, P];
    }), x;
  }
  function Io(c, g) {
    return function(x) {
      return c(g(x));
    };
  }
  function Cr(c) {
    var g = -1, x = Array(c.size);
    return c.forEach(function(P) {
      x[++g] = P;
    }), x;
  }
  var U = Array.prototype, pe = Function.prototype, Oe = Object.prototype, pr = Xe["__core-js_shared__"], Po = function() {
    var c = /[^.]+$/.exec(pr && pr.keys && pr.keys.IE_PROTO || "");
    return c ? "Symbol(src)_1." + c : "";
  }(), Oo = pe.toString, Dt = Oe.hasOwnProperty, fr = Oe.toString, oi = RegExp(
    "^" + Oo.call(Dt).replace(ei, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), qo = Xe.Symbol, Ui = Xe.Uint8Array, ky = Io(Object.getPrototypeOf, Object), Vy = Object.create, Mi = Oe.propertyIsEnumerable, Ei = U.splice, Ny = Io(Object.keys, Object), ii = Fr(Xe, "DataView"), eo = Fr(Xe, "Map"), ni = Fr(Xe, "Promise"), Bo = Fr(Xe, "Set"), ai = Fr(Xe, "WeakMap"), to = Fr(Object, "create"), Ly = Dr(ii), ui = Dr(eo), Fy = Dr(ni), yi = Dr(Bo), $y = Dr(ai), Uo = qo ? qo.prototype : void 0, si = Uo ? Uo.valueOf : void 0, ki = Uo ? Uo.toString : void 0;
  function xr(c) {
    var g = -1, x = c ? c.length : 0;
    for (this.clear(); ++g < x; ) {
      var P = c[g];
      this.set(P[0], P[1]);
    }
  }
  function jy() {
    this.__data__ = to ? to(null) : {};
  }
  function Wy(c) {
    return this.has(c) && delete this.__data__[c];
  }
  function Hy(c) {
    var g = this.__data__;
    if (to) {
      var x = g[c];
      return x === q ? void 0 : x;
    }
    return Dt.call(g, c) ? g[c] : void 0;
  }
  function Vi(c) {
    var g = this.__data__;
    return to ? g[c] !== void 0 : Dt.call(g, c);
  }
  function Qy(c, g) {
    var x = this.__data__;
    return x[c] = to && g === void 0 ? q : g, this;
  }
  xr.prototype.clear = jy, xr.prototype.delete = Wy, xr.prototype.get = Hy, xr.prototype.has = Vi, xr.prototype.set = Qy;
  function zt(c) {
    var g = -1, x = c ? c.length : 0;
    for (this.clear(); ++g < x; ) {
      var P = c[g];
      this.set(P[0], P[1]);
    }
  }
  function zy() {
    this.__data__ = [];
  }
  function Gy(c) {
    var g = this.__data__, x = ko(g, c);
    if (x < 0)
      return !1;
    var P = g.length - 1;
    return x == P ? g.pop() : Ei.call(g, x, 1), !0;
  }
  function Ky(c) {
    var g = this.__data__, x = ko(g, c);
    return x < 0 ? void 0 : g[x][1];
  }
  function Yy(c) {
    return ko(this.__data__, c) > -1;
  }
  function Mo(c, g) {
    var x = this.__data__, P = ko(x, c);
    return P < 0 ? x.push([c, g]) : x[P][1] = g, this;
  }
  zt.prototype.clear = zy, zt.prototype.delete = Gy, zt.prototype.get = Ky, zt.prototype.has = Yy, zt.prototype.set = Mo;
  function Gt(c) {
    var g = -1, x = c ? c.length : 0;
    for (this.clear(); ++g < x; ) {
      var P = c[g];
      this.set(P[0], P[1]);
    }
  }
  function Eo() {
    this.__data__ = {
      hash: new xr(),
      map: new (eo || zt)(),
      string: new xr()
    };
  }
  function Jy(c) {
    return io(this, c).delete(c);
  }
  function Zy(c) {
    return io(this, c).get(c);
  }
  function Xy(c) {
    return io(this, c).has(c);
  }
  function Ni(c, g) {
    return io(this, c).set(c, g), this;
  }
  Gt.prototype.clear = Eo, Gt.prototype.delete = Jy, Gt.prototype.get = Zy, Gt.prototype.has = Xy, Gt.prototype.set = Ni;
  function ro(c) {
    var g = -1, x = c ? c.length : 0;
    for (this.__data__ = new Gt(); ++g < x; )
      this.add(c[g]);
  }
  function Li(c) {
    return this.__data__.set(c, q), this;
  }
  function es(c) {
    return this.__data__.has(c);
  }
  ro.prototype.add = ro.prototype.push = Li, ro.prototype.has = es;
  function Kt(c) {
    this.__data__ = new zt(c);
  }
  function ts() {
    this.__data__ = new zt();
  }
  function rs(c) {
    return this.__data__.delete(c);
  }
  function Fi(c) {
    return this.__data__.get(c);
  }
  function $i(c) {
    return this.__data__.has(c);
  }
  function ji(c, g) {
    var x = this.__data__;
    if (x instanceof zt) {
      var P = x.__data__;
      if (!eo || P.length < t - 1)
        return P.push([c, g]), this;
      x = this.__data__ = new Gt(P);
    }
    return x.set(c, g), this;
  }
  Kt.prototype.clear = ts, Kt.prototype.delete = rs, Kt.prototype.get = Fi, Kt.prototype.has = $i, Kt.prototype.set = ji;
  function pi(c, g) {
    var x = Yt(c) || nn(c) ? tt(c.length, String) : [], P = x.length, j = !!P;
    for (var k in c)
      (g || Dt.call(c, k)) && !(j && (k == "length" || No(k, P))) && x.push(k);
    return x;
  }
  function ko(c, g) {
    for (var x = c.length; x--; )
      if (on(c[x][0], g))
        return x;
    return -1;
  }
  function Wi(c) {
    return ft(c) ? Vy(c) : {};
  }
  var Vo = en();
  function Hi(c, g) {
    return c && Vo(c, g, yo);
  }
  function Qi(c, g) {
    g = Lo(g, c) ? [g] : li(g);
    for (var x = 0, P = g.length; c != null && x < P; )
      c = c[Fo(g[x++])];
    return x && x == P ? c : void 0;
  }
  function zi(c) {
    return fr.call(c);
  }
  function Gi(c, g) {
    return c != null && g in Object(c);
  }
  function oo(c, g, x, P, j) {
    return c === g ? !0 : c == null || g == null || !ft(c) && !ao(g) ? c !== c && g !== g : os(c, g, oo, x, P, j);
  }
  function os(c, g, x, P, j, k) {
    var ie = Yt(c), W = Yt(g), fe = Re, Ie = Re;
    ie || (fe = cr(c), fe = fe == xe ? Ot : fe), W || (Ie = cr(g), Ie = Ie == xe ? Ot : Ie);
    var We = fe == Ot && !Xr(c), Fe = Ie == Ot && !Xr(g), Me = fe == Ie;
    if (Me && !We)
      return k || (k = new Kt()), ie || rt(c) ? tn(c, g, x, P, j, k) : ns(c, g, fe, x, P, j, k);
    if (!(j & F)) {
      var ct = We && Dt.call(c, "__wrapped__"), lt = Fe && Dt.call(g, "__wrapped__");
      if (ct || lt) {
        var Jt = ct ? c.value() : c, dt = lt ? g.value() : g;
        return k || (k = new Kt()), x(Jt, dt, P, j, k);
      }
    }
    return Me ? (k || (k = new Kt()), as(c, g, x, P, j, k)) : !1;
  }
  function Ki(c, g, x, P) {
    var j = x.length, k = j, ie = !P;
    if (c == null)
      return !k;
    for (c = Object(c); j--; ) {
      var W = x[j];
      if (ie && W[2] ? W[1] !== c[W[0]] : !(W[0] in c))
        return !1;
    }
    for (; ++j < k; ) {
      W = x[j];
      var fe = W[0], Ie = c[fe], We = W[1];
      if (ie && W[2]) {
        if (Ie === void 0 && !(fe in c))
          return !1;
      } else {
        var Fe = new Kt();
        if (P)
          var Me = P(Ie, We, fe, c, g, Fe);
        if (!(Me === void 0 ? oo(We, Ie, P, re | F, Fe) : Me))
          return !1;
      }
    }
    return !0;
  }
  function fi(c) {
    if (!ft(c) || ps(c))
      return !1;
    var g = qe(c) || Xr(c) ? oi : Nr;
    return g.test(Dr(c));
  }
  function ci(c) {
    return ao(c) && no(c.length) && !!se[fr.call(c)];
  }
  function Lr(c) {
    return typeof c == "function" ? c : c == null ? pn : typeof c == "object" ? Yt(c) ? is(c[0], c[1]) : Ji(c) : ot(c);
  }
  function Yi(c) {
    if (!fs(c))
      return Ny(c);
    var g = [];
    for (var x in Object(c))
      Dt.call(c, x) && x != "constructor" && g.push(x);
    return g;
  }
  function Ji(c) {
    var g = us(c);
    return g.length == 1 && g[0][2] ? ve(g[0][0], g[0][1]) : function(x) {
      return x === c || Ki(x, c, g);
    };
  }
  function is(c, g) {
    return Lo(c) && rn(g) ? ve(Fo(c), g) : function(x) {
      var P = un(x, c);
      return P === void 0 && P === g ? yn(x, c) : oo(g, P, void 0, re | F);
    };
  }
  function Zi(c) {
    return function(g) {
      return Qi(g, c);
    };
  }
  function Xi(c) {
    if (typeof c == "string")
      return c;
    if (uo(c))
      return ki ? ki.call(c) : "";
    var g = c + "";
    return g == "0" && 1 / c == -be ? "-0" : g;
  }
  function li(c) {
    return Yt(c) ? c : Ae(c);
  }
  function en(c) {
    return function(g, x, P) {
      for (var j = -1, k = Object(g), ie = P(g), W = ie.length; W--; ) {
        var fe = ie[c ? W : ++j];
        if (x(k[fe], fe, k) === !1)
          break;
      }
      return g;
    };
  }
  function tn(c, g, x, P, j, k) {
    var ie = j & F, W = c.length, fe = g.length;
    if (W != fe && !(ie && fe > W))
      return !1;
    var Ie = k.get(c);
    if (Ie && k.get(g))
      return Ie == g;
    var We = -1, Fe = !0, Me = j & re ? new ro() : void 0;
    for (k.set(c, g), k.set(g, c); ++We < W; ) {
      var ct = c[We], lt = g[We];
      if (P)
        var Jt = ie ? P(lt, ct, We, g, c, k) : P(ct, lt, We, c, g, k);
      if (Jt !== void 0) {
        if (Jt)
          continue;
        Fe = !1;
        break;
      }
      if (Me) {
        if (!wo(g, function(dt, gt) {
          if (!Me.has(gt) && (ct === dt || x(ct, dt, P, j, k)))
            return Me.add(gt);
        })) {
          Fe = !1;
          break;
        }
      } else if (!(ct === lt || x(ct, lt, P, j, k))) {
        Fe = !1;
        break;
      }
    }
    return k.delete(c), k.delete(g), Fe;
  }
  function ns(c, g, x, P, j, k, ie) {
    switch (x) {
      case vr:
        if (c.byteLength != g.byteLength || c.byteOffset != g.byteOffset)
          return !1;
        c = c.buffer, g = g.buffer;
      case ir:
        return !(c.byteLength != g.byteLength || !P(new Ui(c), new Ui(g)));
      case ye:
      case or:
      case bt:
        return on(+c, +g);
      case $t:
        return c.name == g.name && c.message == g.message;
      case Wt:
      case Ht:
        return c == g + "";
      case De:
        var W = sr;
      case je:
        var fe = k & F;
        if (W || (W = Cr), c.size != g.size && !fe)
          return !1;
        var Ie = ie.get(c);
        if (Ie)
          return Ie == g;
        k |= re, ie.set(c, g);
        var We = tn(W(c), W(g), P, j, k, ie);
        return ie.delete(c), We;
      case yt:
        if (si)
          return si.call(c) == si.call(g);
    }
    return !1;
  }
  function as(c, g, x, P, j, k) {
    var ie = j & F, W = yo(c), fe = W.length, Ie = yo(g), We = Ie.length;
    if (fe != We && !ie)
      return !1;
    for (var Fe = fe; Fe--; ) {
      var Me = W[Fe];
      if (!(ie ? Me in g : Dt.call(g, Me)))
        return !1;
    }
    var ct = k.get(c);
    if (ct && k.get(g))
      return ct == g;
    var lt = !0;
    k.set(c, g), k.set(g, c);
    for (var Jt = ie; ++Fe < fe; ) {
      Me = W[Fe];
      var dt = c[Me], gt = g[Me];
      if (P)
        var fn = ie ? P(gt, dt, Me, g, c, k) : P(dt, gt, Me, c, g, k);
      if (!(fn === void 0 ? dt === gt || x(dt, gt, P, j, k) : fn)) {
        lt = !1;
        break;
      }
      Jt || (Jt = Me == "constructor");
    }
    if (lt && !Jt) {
      var so = c.constructor, po = g.constructor;
      so != po && "constructor" in c && "constructor" in g && !(typeof so == "function" && so instanceof so && typeof po == "function" && po instanceof po) && (lt = !1);
    }
    return k.delete(c), k.delete(g), lt;
  }
  function io(c, g) {
    var x = c.__data__;
    return ss(g) ? x[typeof g == "string" ? "string" : "hash"] : x.map;
  }
  function us(c) {
    for (var g = yo(c), x = g.length; x--; ) {
      var P = g[x], j = c[P];
      g[x] = [P, j, rn(j)];
    }
    return g;
  }
  function Fr(c, g) {
    var x = br(c, g);
    return fi(x) ? x : void 0;
  }
  var cr = zi;
  (ii && cr(new ii(new ArrayBuffer(1))) != vr || eo && cr(new eo()) != De || ni && cr(ni.resolve()) != Ze || Bo && cr(new Bo()) != je || ai && cr(new ai()) != st) && (cr = function(c) {
    var g = fr.call(c), x = g == Ot ? c.constructor : void 0, P = x ? Dr(x) : void 0;
    if (P)
      switch (P) {
        case Ly:
          return vr;
        case ui:
          return De;
        case Fy:
          return Ze;
        case yi:
          return je;
        case $y:
          return st;
      }
    return g;
  });
  function ys(c, g, x) {
    g = Lo(g, c) ? [g] : li(g);
    for (var P, j = -1, ie = g.length; ++j < ie; ) {
      var k = Fo(g[j]);
      if (!(P = c != null && x(c, k)))
        break;
      c = c[k];
    }
    if (P)
      return P;
    var ie = c ? c.length : 0;
    return !!ie && no(ie) && No(k, ie) && (Yt(c) || nn(c));
  }
  function No(c, g) {
    return g = g ?? me, !!g && (typeof c == "number" || ti.test(c)) && c > -1 && c % 1 == 0 && c < g;
  }
  function Lo(c, g) {
    if (Yt(c))
      return !1;
    var x = typeof c;
    return x == "number" || x == "symbol" || x == "boolean" || c == null || uo(c) ? !0 : ze.test(c) || !nr.test(c) || g != null && c in Object(g);
  }
  function ss(c) {
    var g = typeof c;
    return g == "string" || g == "number" || g == "symbol" || g == "boolean" ? c !== "__proto__" : c === null;
  }
  function ps(c) {
    return !!Po && Po in c;
  }
  function fs(c) {
    var g = c && c.constructor, x = typeof g == "function" && g.prototype || Oe;
    return c === x;
  }
  function rn(c) {
    return c === c && !ft(c);
  }
  function ve(c, g) {
    return function(x) {
      return x == null ? !1 : x[c] === g && (g !== void 0 || c in Object(x));
    };
  }
  var Ae = di(function(c) {
    c = an(c);
    var g = [];
    return Jr.test(c) && g.push(""), c.replace(Zr, function(x, P, j, k) {
      g.push(j ? k.replace(ar, "$1") : P || x);
    }), g;
  });
  function Fo(c) {
    if (typeof c == "string" || uo(c))
      return c;
    var g = c + "";
    return g == "0" && 1 / c == -be ? "-0" : g;
  }
  function Dr(c) {
    if (c != null) {
      try {
        return Oo.call(c);
      } catch {
      }
      try {
        return c + "";
      } catch {
      }
    }
    return "";
  }
  function di(c, g) {
    if (typeof c != "function" || g && typeof g != "function")
      throw new TypeError(O);
    var x = function() {
      var P = arguments, j = g ? g.apply(this, P) : P[0], k = x.cache;
      if (k.has(j))
        return k.get(j);
      var ie = c.apply(this, P);
      return x.cache = k.set(j, ie), ie;
    };
    return x.cache = new (di.Cache || Gt)(), x;
  }
  di.Cache = Gt;
  function on(c, g) {
    return c === g || c !== c && g !== g;
  }
  function nn(c) {
    return cs(c) && Dt.call(c, "callee") && (!Mi.call(c, "callee") || fr.call(c) == xe);
  }
  var Yt = Array.isArray;
  function gi(c) {
    return c != null && no(c.length) && !qe(c);
  }
  function cs(c) {
    return ao(c) && gi(c);
  }
  function qe(c) {
    var g = ft(c) ? fr.call(c) : "";
    return g == jt || g == kr;
  }
  function no(c) {
    return typeof c == "number" && c > -1 && c % 1 == 0 && c <= me;
  }
  function ft(c) {
    var g = typeof c;
    return !!c && (g == "object" || g == "function");
  }
  function ao(c) {
    return !!c && typeof c == "object";
  }
  function uo(c) {
    return typeof c == "symbol" || ao(c) && fr.call(c) == yt;
  }
  var rt = pt ? hr(pt) : ci;
  function an(c) {
    return c == null ? "" : Xi(c);
  }
  function un(c, g, x) {
    var P = c == null ? void 0 : Qi(c, g);
    return P === void 0 ? x : P;
  }
  function yn(c, g) {
    return c != null && ys(c, g, Gi);
  }
  function yo(c) {
    return gi(c) ? pi(c) : Yi(c);
  }
  function sn(c, g, x) {
    var P = Yt(c) || rt(c);
    if (g = Lr(g), x == null)
      if (P || ft(c)) {
        var j = c.constructor;
        P ? x = Yt(c) ? new j() : [] : x = qe(j) ? Wi(ky(c)) : {};
      } else
        x = {};
    return (P ? Ro : Hi)(c, function(k, ie, W) {
      return g(x, k, ie, W);
    }), x;
  }
  function pn(c) {
    return c;
  }
  function ot(c) {
    return Lo(c) ? Ar(Fo(c)) : Zi(c);
  }
  n.exports = sn;
})(Jn, Jn.exports);
var oh = Jn.exports;
const ih = HA, wc = rh, nh = oh;
var ah = function n(e, {
  cleanKeys: t = [],
  cleanValues: O = [],
  emptyArrays: q = !0,
  emptyObjects: re = !0,
  emptyStrings: F = !0,
  NaNValues: be = !1,
  nullValues: me = !0,
  undefinedValues: xe = !0
} = {}) {
  return nh(e, (Re, ye, or) => {
    if (!t.includes(or) && ((Array.isArray(ye) || wc(ye)) && (ye = n(ye, { NaNValues: be, cleanKeys: t, cleanValues: O, emptyArrays: q, emptyObjects: re, emptyStrings: F, nullValues: me, undefinedValues: xe })), !O.includes(ye) && !(re && wc(ye) && ih(ye)) && !(q && Array.isArray(ye) && !ye.length) && !(F && ye === "") && !(be && Number.isNaN(ye)) && !(me && ye === null) && !(xe && ye === void 0))) {
      if (Array.isArray(Re))
        return Re.push(ye);
      Re[or] = ye;
    }
  });
};
const ho = /* @__PURE__ */ Bc(ah);
function Te(n) {
  const e = n;
  return r(e) && (typeof e.city > "u" || typeof e.city == "string") && (typeof e._city > "u" || r(e._city)) && (typeof e.country > "u" || typeof e.country == "string") && (typeof e._country > "u" || r(e._country)) && (typeof e.district > "u" || typeof e.district == "string") && (typeof e._district > "u" || r(e._district)) && (typeof e.line > "u" || Array.isArray(e.line) && e.line.every(
    (t) => typeof t == "string"
  )) && (typeof e._line > "u" || Array.isArray(e._line) && e._line.every(
    (t) => r(t)
  )) && (typeof e.period > "u" || D(e.period)) && (typeof e.postalCode > "u" || typeof e.postalCode == "string") && (typeof e._postalCode > "u" || r(e._postalCode)) && (typeof e.state > "u" || typeof e.state == "string") && (typeof e._state > "u" || r(e._state)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || e.type === "postal" || e.type === "physical" || e.type === "both") && (typeof e._type > "u" || r(e._type)) && (typeof e.use > "u" || e.use === "home" || e.use === "work" || e.use === "temp" || e.use === "old" || e.use === "billing") && (typeof e._use > "u" || r(e._use));
}
function Le(n) {
  return S(n);
}
function $(n) {
  const e = n;
  return r(e) && (typeof e.authorReference > "u" || y(e.authorReference)) && (typeof e.authorString > "u" || typeof e.authorString == "string") && (typeof e._authorString > "u" || r(e._authorString)) && typeof e.text == "string" && (typeof e._text > "u" || r(e._text)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || r(e._time));
}
function te(n) {
  const e = n;
  return r(e) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || r(e._contentType)) && (typeof e.creation > "u" || typeof e.creation == "string") && (typeof e._creation > "u" || r(e._creation)) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || r(e._data)) && (typeof e.hash > "u" || typeof e.hash == "string") && (typeof e._hash > "u" || r(e._hash)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language)) && (typeof e.size > "u" || typeof e.size == "number") && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function p(n) {
  const e = n;
  return r(e) && (typeof e.modifierExtension > "u" || Array.isArray(e.modifierExtension) && e.modifierExtension.every(
    (t) => Zn(t)
  ));
}
function u(n) {
  const e = n;
  return r(e) && (typeof e.coding > "u" || Array.isArray(e.coding) && e.coding.every(
    (t) => V(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text));
}
function V(n) {
  const e = n;
  return r(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && (typeof e.userSelected > "u" || e.userSelected === !1 || e.userSelected === !0) && (typeof e._userSelected > "u" || r(e._userSelected)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function B(n) {
  const e = n;
  return r(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function he(n) {
  const e = n;
  return r(e) && (typeof e.period > "u" || D(e.period)) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.system > "u" || e.system === "phone" || e.system === "fax" || e.system === "email" || e.system === "pager" || e.system === "url" || e.system === "sms" || e.system === "other") && (typeof e._system > "u" || r(e._system)) && (typeof e.use > "u" || e.use === "home" || e.use === "work" || e.use === "temp" || e.use === "old" || e.use === "mobile") && (typeof e._use > "u" || r(e._use)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || r(e._value));
}
function Ur(n) {
  const e = n;
  return r(e) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (e.type === "author" || e.type === "editor" || e.type === "reviewer" || e.type === "endorser") && (typeof e._type > "u" || r(e._type));
}
function Mr(n) {
  return S(n);
}
function uh(n) {
  const e = n;
  return r(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => V(t)
  )) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path)) && (typeof e.searchParam > "u" || typeof e.searchParam == "string") && (typeof e._searchParam > "u" || r(e._searchParam)) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || r(e._valueSet));
}
function yh(n) {
  const e = n;
  return r(e) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path)) && (typeof e.searchParam > "u" || typeof e.searchParam == "string") && (typeof e._searchParam > "u" || r(e._searchParam)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueDuration > "u" || ue(e.valueDuration));
}
function sh(n) {
  const e = n;
  return r(e) && (e.direction === "ascending" || e.direction === "descending") && (typeof e._direction > "u" || r(e._direction)) && typeof e.path == "string" && (typeof e._path > "u" || r(e._path));
}
function Ye(n) {
  const e = n;
  return r(e) && (typeof e.codeFilter > "u" || Array.isArray(e.codeFilter) && e.codeFilter.every(
    (t) => uh(t)
  )) && (typeof e.dateFilter > "u" || Array.isArray(e.dateFilter) && e.dateFilter.every(
    (t) => yh(t)
  )) && (typeof e.limit > "u" || typeof e.limit == "number") && (typeof e.mustSupport > "u" || Array.isArray(e.mustSupport) && e.mustSupport.every(
    (t) => typeof t == "string"
  )) && (typeof e._mustSupport > "u" || Array.isArray(e._mustSupport) && e._mustSupport.every(
    (t) => r(t)
  )) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => r(t)
  )) && (typeof e.sort > "u" || Array.isArray(e.sort) && e.sort.every(
    (t) => sh(t)
  )) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type));
}
function Er(n) {
  return S(n);
}
function ph(n) {
  const e = n;
  return r(e) && (typeof e.doseRange > "u" || K(e.doseRange)) && (typeof e.doseQuantity > "u" || S(e.doseQuantity)) && (typeof e.rateRatio > "u" || ge(e.rateRatio)) && (typeof e.rateRange > "u" || K(e.rateRange)) && (typeof e.rateQuantity > "u" || S(e.rateQuantity)) && (typeof e.type > "u" || u(e.type));
}
function ht(n) {
  const e = n;
  return p(e) && (typeof e.additionalInstruction > "u" || Array.isArray(e.additionalInstruction) && e.additionalInstruction.every(
    (t) => u(t)
  )) && (typeof e.asNeededBoolean > "u" || e.asNeededBoolean === !1 || e.asNeededBoolean === !0) && (typeof e._asNeededBoolean > "u" || r(e._asNeededBoolean)) && (typeof e.asNeededCodeableConcept > "u" || u(e.asNeededCodeableConcept)) && (typeof e.doseAndRate > "u" || Array.isArray(e.doseAndRate) && e.doseAndRate.every(
    (t) => ph(t)
  )) && (typeof e.maxDosePerAdministration > "u" || S(e.maxDosePerAdministration)) && (typeof e.maxDosePerLifetime > "u" || S(e.maxDosePerLifetime)) && (typeof e.maxDosePerPeriod > "u" || ge(e.maxDosePerPeriod)) && (typeof e.method > "u" || u(e.method)) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || r(e._patientInstruction)) && (typeof e.route > "u" || u(e.route)) && (typeof e.sequence > "u" || typeof e.sequence == "number") && (typeof e.site > "u" || u(e.site)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.timing > "u" || le(e.timing));
}
function ue(n) {
  return S(n);
}
function r(n) {
  const e = n;
  return (e !== null && typeof e == "object" || typeof e == "function") && (typeof e.extension > "u" || Array.isArray(e.extension) && e.extension.every(
    (t) => Zn(t)
  )) && (typeof e.id > "u" || typeof e.id == "string") && (typeof e._id > "u" || r(e._id));
}
function fh(n) {
  const e = n;
  return r(e) && typeof e.path == "string" && (typeof e._path > "u" || r(e._path)) && (e.type === "value" || e.type === "exists" || e.type === "pattern" || e.type === "type" || e.type === "profile") && (typeof e._type > "u" || r(e._type));
}
function ch(n) {
  const e = n;
  return r(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.discriminator > "u" || Array.isArray(e.discriminator) && e.discriminator.every(
    (t) => fh(t)
  )) && (typeof e.ordered > "u" || e.ordered === !1 || e.ordered === !0) && (typeof e._ordered > "u" || r(e._ordered)) && (e.rules === "closed" || e.rules === "open" || e.rules === "openAtEnd") && (typeof e._rules > "u" || r(e._rules));
}
function lh(n) {
  const e = n;
  return r(e) && typeof e.max == "string" && (typeof e._max > "u" || r(e._max)) && typeof e.min == "number" && typeof e.path == "string" && (typeof e._path > "u" || r(e._path));
}
function dh(n) {
  const e = n;
  return r(e) && (typeof e.aggregation > "u" || Array.isArray(e.aggregation) && e.aggregation.every(
    (t) => t === "contained" || t === "referenced" || t === "bundled"
  )) && (typeof e._aggregation > "u" || Array.isArray(e._aggregation) && e._aggregation.every(
    (t) => r(t)
  )) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => r(t)
  )) && (typeof e.targetProfile > "u" || Array.isArray(e.targetProfile) && e.targetProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetProfile > "u" || Array.isArray(e._targetProfile) && e._targetProfile.every(
    (t) => r(t)
  )) && (typeof e.versioning > "u" || e.versioning === "either" || e.versioning === "independent" || e.versioning === "specific") && (typeof e._versioning > "u" || r(e._versioning));
}
function gh(n) {
  const e = n;
  return r(e) && typeof e.label == "string" && (typeof e._label > "u" || r(e._label)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || r(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || r(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || r(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || r(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || r(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || r(e._valueUuid)) && (typeof e.valueAddress > "u" || Te(e.valueAddress)) && (typeof e.valueAge > "u" || Le(e.valueAge)) && (typeof e.valueAnnotation > "u" || $(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueContactPoint > "u" || he(e.valueContactPoint)) && (typeof e.valueCount > "u" || Mr(e.valueCount)) && (typeof e.valueDistance > "u" || Er(e.valueDistance)) && (typeof e.valueDuration > "u" || ue(e.valueDuration)) && (typeof e.valueHumanName > "u" || Je(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || A(e.valueIdentifier)) && (typeof e.valueMoney > "u" || L(e.valueMoney)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueReference > "u" || y(e.valueReference)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueSignature > "u" || ut(e.valueSignature)) && (typeof e.valueTiming > "u" || le(e.valueTiming)) && (typeof e.valueContactDetail > "u" || B(e.valueContactDetail)) && (typeof e.valueContributor > "u" || Ur(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || Ye(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || ke(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || _r(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || Se(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || Ft(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || X(e.valueUsageContext)) && (typeof e.valueDosage > "u" || ht(e.valueDosage)) && (typeof e.valueMeta > "u" || mr(e.valueMeta));
}
function mh(n) {
  const e = n;
  return r(e) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && typeof e.human == "string" && (typeof e._human > "u" || r(e._human)) && typeof e.key == "string" && (typeof e._key > "u" || r(e._key)) && (typeof e.requirements > "u" || typeof e.requirements == "string") && (typeof e._requirements > "u" || r(e._requirements)) && (e.severity === "error" || e.severity === "warning") && (typeof e._severity > "u" || r(e._severity)) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || r(e._source)) && (typeof e.xpath > "u" || typeof e.xpath == "string") && (typeof e._xpath > "u" || r(e._xpath));
}
function _h(n) {
  const e = n;
  return r(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (e.strength === "required" || e.strength === "extensible" || e.strength === "preferred" || e.strength === "example") && (typeof e._strength > "u" || r(e._strength)) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || r(e._valueSet));
}
function vh(n) {
  const e = n;
  return r(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && typeof e.identity == "string" && (typeof e._identity > "u" || r(e._identity)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language)) && typeof e.map == "string" && (typeof e._map > "u" || r(e._map));
}
function Ec(n) {
  const e = n;
  return p(e) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => r(t)
  )) && (typeof e.base > "u" || lh(e.base)) && (typeof e.binding > "u" || _h(e.binding)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => V(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => typeof t == "string"
  )) && (typeof e._condition > "u" || Array.isArray(e._condition) && e._condition.every(
    (t) => r(t)
  )) && (typeof e.constraint > "u" || Array.isArray(e.constraint) && e.constraint.every(
    (t) => mh(t)
  )) && (typeof e.contentReference > "u" || typeof e.contentReference == "string") && (typeof e._contentReference > "u" || r(e._contentReference)) && (typeof e.defaultValueBase64Binary > "u" || typeof e.defaultValueBase64Binary == "string") && (typeof e._defaultValueBase64Binary > "u" || r(e._defaultValueBase64Binary)) && (typeof e.defaultValueBoolean > "u" || e.defaultValueBoolean === !1 || e.defaultValueBoolean === !0) && (typeof e._defaultValueBoolean > "u" || r(e._defaultValueBoolean)) && (typeof e.defaultValueCanonical > "u" || typeof e.defaultValueCanonical == "string") && (typeof e._defaultValueCanonical > "u" || r(e._defaultValueCanonical)) && (typeof e.defaultValueCode > "u" || typeof e.defaultValueCode == "string") && (typeof e._defaultValueCode > "u" || r(e._defaultValueCode)) && (typeof e.defaultValueDate > "u" || typeof e.defaultValueDate == "string") && (typeof e._defaultValueDate > "u" || r(e._defaultValueDate)) && (typeof e.defaultValueDateTime > "u" || typeof e.defaultValueDateTime == "string") && (typeof e._defaultValueDateTime > "u" || r(e._defaultValueDateTime)) && (typeof e.defaultValueDecimal > "u" || typeof e.defaultValueDecimal == "number") && (typeof e.defaultValueId > "u" || typeof e.defaultValueId == "string") && (typeof e._defaultValueId > "u" || r(e._defaultValueId)) && (typeof e.defaultValueInstant > "u" || typeof e.defaultValueInstant == "string") && (typeof e._defaultValueInstant > "u" || r(e._defaultValueInstant)) && (typeof e.defaultValueInteger > "u" || typeof e.defaultValueInteger == "number") && (typeof e.defaultValueMarkdown > "u" || typeof e.defaultValueMarkdown == "string") && (typeof e._defaultValueMarkdown > "u" || r(e._defaultValueMarkdown)) && (typeof e.defaultValueOid > "u" || typeof e.defaultValueOid == "string") && (typeof e._defaultValueOid > "u" || r(e._defaultValueOid)) && (typeof e.defaultValuePositiveInt > "u" || typeof e.defaultValuePositiveInt == "number") && (typeof e.defaultValueString > "u" || typeof e.defaultValueString == "string") && (typeof e._defaultValueString > "u" || r(e._defaultValueString)) && (typeof e.defaultValueTime > "u" || typeof e.defaultValueTime == "string") && (typeof e._defaultValueTime > "u" || r(e._defaultValueTime)) && (typeof e.defaultValueUnsignedInt > "u" || typeof e.defaultValueUnsignedInt == "number") && (typeof e.defaultValueUri > "u" || typeof e.defaultValueUri == "string") && (typeof e._defaultValueUri > "u" || r(e._defaultValueUri)) && (typeof e.defaultValueUrl > "u" || typeof e.defaultValueUrl == "string") && (typeof e._defaultValueUrl > "u" || r(e._defaultValueUrl)) && (typeof e.defaultValueUuid > "u" || typeof e.defaultValueUuid == "string") && (typeof e._defaultValueUuid > "u" || r(e._defaultValueUuid)) && (typeof e.defaultValueAddress > "u" || Te(e.defaultValueAddress)) && (typeof e.defaultValueAge > "u" || Le(e.defaultValueAge)) && (typeof e.defaultValueAnnotation > "u" || $(e.defaultValueAnnotation)) && (typeof e.defaultValueAttachment > "u" || te(e.defaultValueAttachment)) && (typeof e.defaultValueCodeableConcept > "u" || u(e.defaultValueCodeableConcept)) && (typeof e.defaultValueCoding > "u" || V(e.defaultValueCoding)) && (typeof e.defaultValueContactPoint > "u" || he(e.defaultValueContactPoint)) && (typeof e.defaultValueCount > "u" || Mr(e.defaultValueCount)) && (typeof e.defaultValueDistance > "u" || Er(e.defaultValueDistance)) && (typeof e.defaultValueDuration > "u" || ue(e.defaultValueDuration)) && (typeof e.defaultValueHumanName > "u" || Je(e.defaultValueHumanName)) && (typeof e.defaultValueIdentifier > "u" || A(e.defaultValueIdentifier)) && (typeof e.defaultValueMoney > "u" || L(e.defaultValueMoney)) && (typeof e.defaultValuePeriod > "u" || D(e.defaultValuePeriod)) && (typeof e.defaultValueQuantity > "u" || S(e.defaultValueQuantity)) && (typeof e.defaultValueRange > "u" || K(e.defaultValueRange)) && (typeof e.defaultValueRatio > "u" || ge(e.defaultValueRatio)) && (typeof e.defaultValueReference > "u" || y(e.defaultValueReference)) && (typeof e.defaultValueSampledData > "u" || rr(e.defaultValueSampledData)) && (typeof e.defaultValueSignature > "u" || ut(e.defaultValueSignature)) && (typeof e.defaultValueTiming > "u" || le(e.defaultValueTiming)) && (typeof e.defaultValueContactDetail > "u" || B(e.defaultValueContactDetail)) && (typeof e.defaultValueContributor > "u" || Ur(e.defaultValueContributor)) && (typeof e.defaultValueDataRequirement > "u" || Ye(e.defaultValueDataRequirement)) && (typeof e.defaultValueExpression > "u" || ke(e.defaultValueExpression)) && (typeof e.defaultValueParameterDefinition > "u" || _r(e.defaultValueParameterDefinition)) && (typeof e.defaultValueRelatedArtifact > "u" || Se(e.defaultValueRelatedArtifact)) && (typeof e.defaultValueTriggerDefinition > "u" || Ft(e.defaultValueTriggerDefinition)) && (typeof e.defaultValueUsageContext > "u" || X(e.defaultValueUsageContext)) && (typeof e.defaultValueDosage > "u" || ht(e.defaultValueDosage)) && (typeof e.defaultValueMeta > "u" || mr(e.defaultValueMeta)) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.example > "u" || Array.isArray(e.example) && e.example.every(
    (t) => gh(t)
  )) && (typeof e.fixedBase64Binary > "u" || typeof e.fixedBase64Binary == "string") && (typeof e._fixedBase64Binary > "u" || r(e._fixedBase64Binary)) && (typeof e.fixedBoolean > "u" || e.fixedBoolean === !1 || e.fixedBoolean === !0) && (typeof e._fixedBoolean > "u" || r(e._fixedBoolean)) && (typeof e.fixedCanonical > "u" || typeof e.fixedCanonical == "string") && (typeof e._fixedCanonical > "u" || r(e._fixedCanonical)) && (typeof e.fixedCode > "u" || typeof e.fixedCode == "string") && (typeof e._fixedCode > "u" || r(e._fixedCode)) && (typeof e.fixedDate > "u" || typeof e.fixedDate == "string") && (typeof e._fixedDate > "u" || r(e._fixedDate)) && (typeof e.fixedDateTime > "u" || typeof e.fixedDateTime == "string") && (typeof e._fixedDateTime > "u" || r(e._fixedDateTime)) && (typeof e.fixedDecimal > "u" || typeof e.fixedDecimal == "number") && (typeof e.fixedId > "u" || typeof e.fixedId == "string") && (typeof e._fixedId > "u" || r(e._fixedId)) && (typeof e.fixedInstant > "u" || typeof e.fixedInstant == "string") && (typeof e._fixedInstant > "u" || r(e._fixedInstant)) && (typeof e.fixedInteger > "u" || typeof e.fixedInteger == "number") && (typeof e.fixedMarkdown > "u" || typeof e.fixedMarkdown == "string") && (typeof e._fixedMarkdown > "u" || r(e._fixedMarkdown)) && (typeof e.fixedOid > "u" || typeof e.fixedOid == "string") && (typeof e._fixedOid > "u" || r(e._fixedOid)) && (typeof e.fixedPositiveInt > "u" || typeof e.fixedPositiveInt == "number") && (typeof e.fixedString > "u" || typeof e.fixedString == "string") && (typeof e._fixedString > "u" || r(e._fixedString)) && (typeof e.fixedTime > "u" || typeof e.fixedTime == "string") && (typeof e._fixedTime > "u" || r(e._fixedTime)) && (typeof e.fixedUnsignedInt > "u" || typeof e.fixedUnsignedInt == "number") && (typeof e.fixedUri > "u" || typeof e.fixedUri == "string") && (typeof e._fixedUri > "u" || r(e._fixedUri)) && (typeof e.fixedUrl > "u" || typeof e.fixedUrl == "string") && (typeof e._fixedUrl > "u" || r(e._fixedUrl)) && (typeof e.fixedUuid > "u" || typeof e.fixedUuid == "string") && (typeof e._fixedUuid > "u" || r(e._fixedUuid)) && (typeof e.fixedAddress > "u" || Te(e.fixedAddress)) && (typeof e.fixedAge > "u" || Le(e.fixedAge)) && (typeof e.fixedAnnotation > "u" || $(e.fixedAnnotation)) && (typeof e.fixedAttachment > "u" || te(e.fixedAttachment)) && (typeof e.fixedCodeableConcept > "u" || u(e.fixedCodeableConcept)) && (typeof e.fixedCoding > "u" || V(e.fixedCoding)) && (typeof e.fixedContactPoint > "u" || he(e.fixedContactPoint)) && (typeof e.fixedCount > "u" || Mr(e.fixedCount)) && (typeof e.fixedDistance > "u" || Er(e.fixedDistance)) && (typeof e.fixedDuration > "u" || ue(e.fixedDuration)) && (typeof e.fixedHumanName > "u" || Je(e.fixedHumanName)) && (typeof e.fixedIdentifier > "u" || A(e.fixedIdentifier)) && (typeof e.fixedMoney > "u" || L(e.fixedMoney)) && (typeof e.fixedPeriod > "u" || D(e.fixedPeriod)) && (typeof e.fixedQuantity > "u" || S(e.fixedQuantity)) && (typeof e.fixedRange > "u" || K(e.fixedRange)) && (typeof e.fixedRatio > "u" || ge(e.fixedRatio)) && (typeof e.fixedReference > "u" || y(e.fixedReference)) && (typeof e.fixedSampledData > "u" || rr(e.fixedSampledData)) && (typeof e.fixedSignature > "u" || ut(e.fixedSignature)) && (typeof e.fixedTiming > "u" || le(e.fixedTiming)) && (typeof e.fixedContactDetail > "u" || B(e.fixedContactDetail)) && (typeof e.fixedContributor > "u" || Ur(e.fixedContributor)) && (typeof e.fixedDataRequirement > "u" || Ye(e.fixedDataRequirement)) && (typeof e.fixedExpression > "u" || ke(e.fixedExpression)) && (typeof e.fixedParameterDefinition > "u" || _r(e.fixedParameterDefinition)) && (typeof e.fixedRelatedArtifact > "u" || Se(e.fixedRelatedArtifact)) && (typeof e.fixedTriggerDefinition > "u" || Ft(e.fixedTriggerDefinition)) && (typeof e.fixedUsageContext > "u" || X(e.fixedUsageContext)) && (typeof e.fixedDosage > "u" || ht(e.fixedDosage)) && (typeof e.fixedMeta > "u" || mr(e.fixedMeta)) && (typeof e.isModifier > "u" || e.isModifier === !1 || e.isModifier === !0) && (typeof e._isModifier > "u" || r(e._isModifier)) && (typeof e.isModifierReason > "u" || typeof e.isModifierReason == "string") && (typeof e._isModifierReason > "u" || r(e._isModifierReason)) && (typeof e.isSummary > "u" || e.isSummary === !1 || e.isSummary === !0) && (typeof e._isSummary > "u" || r(e._isSummary)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || r(e._label)) && (typeof e.mapping > "u" || Array.isArray(e.mapping) && e.mapping.every(
    (t) => vh(t)
  )) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || r(e._max)) && (typeof e.maxLength > "u" || typeof e.maxLength == "number") && (typeof e.maxValueDate > "u" || typeof e.maxValueDate == "string") && (typeof e._maxValueDate > "u" || r(e._maxValueDate)) && (typeof e.maxValueDateTime > "u" || typeof e.maxValueDateTime == "string") && (typeof e._maxValueDateTime > "u" || r(e._maxValueDateTime)) && (typeof e.maxValueInstant > "u" || typeof e.maxValueInstant == "string") && (typeof e._maxValueInstant > "u" || r(e._maxValueInstant)) && (typeof e.maxValueTime > "u" || typeof e.maxValueTime == "string") && (typeof e._maxValueTime > "u" || r(e._maxValueTime)) && (typeof e.maxValueDecimal > "u" || typeof e.maxValueDecimal == "number") && (typeof e.maxValueInteger > "u" || typeof e.maxValueInteger == "number") && (typeof e.maxValuePositiveInt > "u" || typeof e.maxValuePositiveInt == "number") && (typeof e.maxValueUnsignedInt > "u" || typeof e.maxValueUnsignedInt == "number") && (typeof e.maxValueQuantity > "u" || S(e.maxValueQuantity)) && (typeof e.meaningWhenMissing > "u" || typeof e.meaningWhenMissing == "string") && (typeof e._meaningWhenMissing > "u" || r(e._meaningWhenMissing)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.minValueDate > "u" || typeof e.minValueDate == "string") && (typeof e._minValueDate > "u" || r(e._minValueDate)) && (typeof e.minValueDateTime > "u" || typeof e.minValueDateTime == "string") && (typeof e._minValueDateTime > "u" || r(e._minValueDateTime)) && (typeof e.minValueInstant > "u" || typeof e.minValueInstant == "string") && (typeof e._minValueInstant > "u" || r(e._minValueInstant)) && (typeof e.minValueTime > "u" || typeof e.minValueTime == "string") && (typeof e._minValueTime > "u" || r(e._minValueTime)) && (typeof e.minValueDecimal > "u" || typeof e.minValueDecimal == "number") && (typeof e.minValueInteger > "u" || typeof e.minValueInteger == "number") && (typeof e.minValuePositiveInt > "u" || typeof e.minValuePositiveInt == "number") && (typeof e.minValueUnsignedInt > "u" || typeof e.minValueUnsignedInt == "number") && (typeof e.minValueQuantity > "u" || S(e.minValueQuantity)) && (typeof e.mustSupport > "u" || e.mustSupport === !1 || e.mustSupport === !0) && (typeof e._mustSupport > "u" || r(e._mustSupport)) && (typeof e.orderMeaning > "u" || typeof e.orderMeaning == "string") && (typeof e._orderMeaning > "u" || r(e._orderMeaning)) && typeof e.path == "string" && (typeof e._path > "u" || r(e._path)) && (typeof e.patternBase64Binary > "u" || typeof e.patternBase64Binary == "string") && (typeof e._patternBase64Binary > "u" || r(e._patternBase64Binary)) && (typeof e.patternBoolean > "u" || e.patternBoolean === !1 || e.patternBoolean === !0) && (typeof e._patternBoolean > "u" || r(e._patternBoolean)) && (typeof e.patternCanonical > "u" || typeof e.patternCanonical == "string") && (typeof e._patternCanonical > "u" || r(e._patternCanonical)) && (typeof e.patternCode > "u" || typeof e.patternCode == "string") && (typeof e._patternCode > "u" || r(e._patternCode)) && (typeof e.patternDate > "u" || typeof e.patternDate == "string") && (typeof e._patternDate > "u" || r(e._patternDate)) && (typeof e.patternDateTime > "u" || typeof e.patternDateTime == "string") && (typeof e._patternDateTime > "u" || r(e._patternDateTime)) && (typeof e.patternDecimal > "u" || typeof e.patternDecimal == "number") && (typeof e.patternId > "u" || typeof e.patternId == "string") && (typeof e._patternId > "u" || r(e._patternId)) && (typeof e.patternInstant > "u" || typeof e.patternInstant == "string") && (typeof e._patternInstant > "u" || r(e._patternInstant)) && (typeof e.patternInteger > "u" || typeof e.patternInteger == "number") && (typeof e.patternMarkdown > "u" || typeof e.patternMarkdown == "string") && (typeof e._patternMarkdown > "u" || r(e._patternMarkdown)) && (typeof e.patternOid > "u" || typeof e.patternOid == "string") && (typeof e._patternOid > "u" || r(e._patternOid)) && (typeof e.patternPositiveInt > "u" || typeof e.patternPositiveInt == "number") && (typeof e.patternString > "u" || typeof e.patternString == "string") && (typeof e._patternString > "u" || r(e._patternString)) && (typeof e.patternTime > "u" || typeof e.patternTime == "string") && (typeof e._patternTime > "u" || r(e._patternTime)) && (typeof e.patternUnsignedInt > "u" || typeof e.patternUnsignedInt == "number") && (typeof e.patternUri > "u" || typeof e.patternUri == "string") && (typeof e._patternUri > "u" || r(e._patternUri)) && (typeof e.patternUrl > "u" || typeof e.patternUrl == "string") && (typeof e._patternUrl > "u" || r(e._patternUrl)) && (typeof e.patternUuid > "u" || typeof e.patternUuid == "string") && (typeof e._patternUuid > "u" || r(e._patternUuid)) && (typeof e.patternAddress > "u" || Te(e.patternAddress)) && (typeof e.patternAge > "u" || Le(e.patternAge)) && (typeof e.patternAnnotation > "u" || $(e.patternAnnotation)) && (typeof e.patternAttachment > "u" || te(e.patternAttachment)) && (typeof e.patternCodeableConcept > "u" || u(e.patternCodeableConcept)) && (typeof e.patternCoding > "u" || V(e.patternCoding)) && (typeof e.patternContactPoint > "u" || he(e.patternContactPoint)) && (typeof e.patternCount > "u" || Mr(e.patternCount)) && (typeof e.patternDistance > "u" || Er(e.patternDistance)) && (typeof e.patternDuration > "u" || ue(e.patternDuration)) && (typeof e.patternHumanName > "u" || Je(e.patternHumanName)) && (typeof e.patternIdentifier > "u" || A(e.patternIdentifier)) && (typeof e.patternMoney > "u" || L(e.patternMoney)) && (typeof e.patternPeriod > "u" || D(e.patternPeriod)) && (typeof e.patternQuantity > "u" || S(e.patternQuantity)) && (typeof e.patternRange > "u" || K(e.patternRange)) && (typeof e.patternRatio > "u" || ge(e.patternRatio)) && (typeof e.patternReference > "u" || y(e.patternReference)) && (typeof e.patternSampledData > "u" || rr(e.patternSampledData)) && (typeof e.patternSignature > "u" || ut(e.patternSignature)) && (typeof e.patternTiming > "u" || le(e.patternTiming)) && (typeof e.patternContactDetail > "u" || B(e.patternContactDetail)) && (typeof e.patternContributor > "u" || Ur(e.patternContributor)) && (typeof e.patternDataRequirement > "u" || Ye(e.patternDataRequirement)) && (typeof e.patternExpression > "u" || ke(e.patternExpression)) && (typeof e.patternParameterDefinition > "u" || _r(e.patternParameterDefinition)) && (typeof e.patternRelatedArtifact > "u" || Se(e.patternRelatedArtifact)) && (typeof e.patternTriggerDefinition > "u" || Ft(e.patternTriggerDefinition)) && (typeof e.patternUsageContext > "u" || X(e.patternUsageContext)) && (typeof e.patternDosage > "u" || ht(e.patternDosage)) && (typeof e.patternMeta > "u" || mr(e.patternMeta)) && (typeof e.representation > "u" || Array.isArray(e.representation) && e.representation.every(
    (t) => t === "xmlAttr" || t === "xmlText" || t === "typeAttr" || t === "cdaText" || t === "xhtml"
  )) && (typeof e._representation > "u" || Array.isArray(e._representation) && e._representation.every(
    (t) => r(t)
  )) && (typeof e.requirements > "u" || typeof e.requirements == "string") && (typeof e._requirements > "u" || r(e._requirements)) && (typeof e.short > "u" || typeof e.short == "string") && (typeof e._short > "u" || r(e._short)) && (typeof e.sliceIsConstraining > "u" || e.sliceIsConstraining === !1 || e.sliceIsConstraining === !0) && (typeof e._sliceIsConstraining > "u" || r(e._sliceIsConstraining)) && (typeof e.sliceName > "u" || typeof e.sliceName == "string") && (typeof e._sliceName > "u" || r(e._sliceName)) && (typeof e.slicing > "u" || ch(e.slicing)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => dh(t)
  ));
}
function ke(n) {
  const e = n;
  return r(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && typeof e.language == "string" && (typeof e._language > "u" || r(e._language)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || r(e._reference));
}
function Zn(n) {
  const e = n;
  return r(e) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || r(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || r(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || r(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || r(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || r(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || r(e._valueUuid)) && (typeof e.valueAddress > "u" || Te(e.valueAddress)) && (typeof e.valueAge > "u" || Le(e.valueAge)) && (typeof e.valueAnnotation > "u" || $(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueContactPoint > "u" || he(e.valueContactPoint)) && (typeof e.valueCount > "u" || Mr(e.valueCount)) && (typeof e.valueDistance > "u" || Er(e.valueDistance)) && (typeof e.valueDuration > "u" || ue(e.valueDuration)) && (typeof e.valueHumanName > "u" || Je(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || A(e.valueIdentifier)) && (typeof e.valueMoney > "u" || L(e.valueMoney)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueReference > "u" || y(e.valueReference)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueSignature > "u" || ut(e.valueSignature)) && (typeof e.valueTiming > "u" || le(e.valueTiming)) && (typeof e.valueContactDetail > "u" || B(e.valueContactDetail)) && (typeof e.valueContributor > "u" || Ur(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || Ye(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || ke(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || _r(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || Se(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || Ft(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || X(e.valueUsageContext)) && (typeof e.valueDosage > "u" || ht(e.valueDosage)) && (typeof e.valueMeta > "u" || mr(e.valueMeta));
}
function Je(n) {
  const e = n;
  return r(e) && (typeof e.family > "u" || typeof e.family == "string") && (typeof e._family > "u" || r(e._family)) && (typeof e.given > "u" || Array.isArray(e.given) && e.given.every(
    (t) => typeof t == "string"
  )) && (typeof e._given > "u" || Array.isArray(e._given) && e._given.every(
    (t) => r(t)
  )) && (typeof e.period > "u" || D(e.period)) && (typeof e.prefix > "u" || Array.isArray(e.prefix) && e.prefix.every(
    (t) => typeof t == "string"
  )) && (typeof e._prefix > "u" || Array.isArray(e._prefix) && e._prefix.every(
    (t) => r(t)
  )) && (typeof e.suffix > "u" || Array.isArray(e.suffix) && e.suffix.every(
    (t) => typeof t == "string"
  )) && (typeof e._suffix > "u" || Array.isArray(e._suffix) && e._suffix.every(
    (t) => r(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.use > "u" || e.use === "temp" || e.use === "old" || e.use === "usual" || e.use === "official" || e.use === "nickname" || e.use === "anonymous" || e.use === "maiden") && (typeof e._use > "u" || r(e._use));
}
function A(n) {
  const e = n;
  return r(e) && (typeof e.assigner > "u" || y(e.assigner)) && (typeof e.period > "u" || D(e.period)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && (typeof e.type > "u" || u(e.type)) && (typeof e.use > "u" || e.use === "temp" || e.use === "old" || e.use === "usual" || e.use === "official" || e.use === "secondary") && (typeof e._use > "u" || r(e._use)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || r(e._value));
}
function kc(n) {
  const e = n;
  return p(e) && u(e.country) && D(e.dateRange) && (typeof e.jurisdiction > "u" || u(e.jurisdiction)) && (typeof e.restoreDate > "u" || typeof e.restoreDate == "string") && (typeof e._restoreDate > "u" || r(e._restoreDate)) && u(e.status);
}
function mr(n) {
  const e = n;
  return r(e) && (typeof e.lastUpdated > "u" || typeof e.lastUpdated == "string") && (typeof e._lastUpdated > "u" || r(e._lastUpdated)) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => typeof t == "string"
  )) && (typeof e._profile > "u" || Array.isArray(e._profile) && e._profile.every(
    (t) => r(t)
  )) && (typeof e.security > "u" || Array.isArray(e.security) && e.security.every(
    (t) => V(t)
  )) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || r(e._source)) && (typeof e.tag > "u" || Array.isArray(e.tag) && e.tag.every(
    (t) => V(t)
  )) && (typeof e.versionId > "u" || typeof e.versionId == "string") && (typeof e._versionId > "u" || r(e._versionId));
}
function L(n) {
  const e = n;
  return r(e) && (typeof e.currency > "u" || typeof e.currency == "string") && (typeof e._currency > "u" || r(e._currency)) && (typeof e.value > "u" || typeof e.value == "number");
}
function Vc(n) {
  const e = n;
  return r(e) && typeof e.div == "string" && (typeof e._div > "u" || r(e._div)) && (e.status === "generated" || e.status === "extensions" || e.status === "additional" || e.status === "empty") && (typeof e._status > "u" || r(e._status));
}
function _r(n) {
  const e = n;
  return r(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || r(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type)) && (e.use === "in" || e.use === "out") && (typeof e._use > "u" || r(e._use));
}
function D(n) {
  const e = n;
  return r(e) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || r(e._end)) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || r(e._start));
}
function hp(n) {
  const e = n;
  return p(e) && (typeof e.ageRange > "u" || K(e.ageRange)) && (typeof e.ageCodeableConcept > "u" || u(e.ageCodeableConcept)) && (typeof e.gender > "u" || u(e.gender)) && (typeof e.physiologicalCondition > "u" || u(e.physiologicalCondition)) && (typeof e.race > "u" || u(e.race));
}
function bp(n) {
  const e = n;
  return p(e) && (typeof e.color > "u" || Array.isArray(e.color) && e.color.every(
    (t) => typeof t == "string"
  )) && (typeof e._color > "u" || Array.isArray(e._color) && e._color.every(
    (t) => r(t)
  )) && (typeof e.depth > "u" || S(e.depth)) && (typeof e.externalDiameter > "u" || S(e.externalDiameter)) && (typeof e.height > "u" || S(e.height)) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => te(t)
  )) && (typeof e.imprint > "u" || Array.isArray(e.imprint) && e.imprint.every(
    (t) => typeof t == "string"
  )) && (typeof e._imprint > "u" || Array.isArray(e._imprint) && e._imprint.every(
    (t) => r(t)
  )) && (typeof e.nominalVolume > "u" || S(e.nominalVolume)) && (typeof e.scoring > "u" || u(e.scoring)) && (typeof e.shape > "u" || typeof e.shape == "string") && (typeof e._shape > "u" || r(e._shape)) && (typeof e.weight > "u" || S(e.weight)) && (typeof e.width > "u" || S(e.width));
}
function Nc(n) {
  const e = n;
  return p(e) && (typeof e.identifier > "u" || A(e.identifier)) && S(e.period) && (typeof e.specialPrecautionsForStorage > "u" || Array.isArray(e.specialPrecautionsForStorage) && e.specialPrecautionsForStorage.every(
    (t) => u(t)
  )) && u(e.type);
}
function S(n) {
  const e = n;
  return r(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.comparator > "u" || e.comparator === "<" || e.comparator === "<=" || e.comparator === ">=" || e.comparator === ">") && (typeof e._comparator > "u" || r(e._comparator)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && (typeof e.unit > "u" || typeof e.unit == "string") && (typeof e._unit > "u" || r(e._unit)) && (typeof e.value > "u" || typeof e.value == "number");
}
function K(n) {
  const e = n;
  return r(e) && (typeof e.high > "u" || S(e.high)) && (typeof e.low > "u" || S(e.low));
}
function ge(n) {
  const e = n;
  return r(e) && (typeof e.denominator > "u" || S(e.denominator)) && (typeof e.numerator > "u" || S(e.numerator));
}
function y(n) {
  const e = n;
  return r(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || r(e._reference)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type));
}
function Se(n) {
  const e = n;
  return r(e) && (typeof e.citation > "u" || typeof e.citation == "string") && (typeof e._citation > "u" || r(e._citation)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.document > "u" || te(e.document)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || r(e._label)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || r(e._resource)) && (e.type === "documentation" || e.type === "justification" || e.type === "citation" || e.type === "predecessor" || e.type === "successor" || e.type === "derived-from" || e.type === "depends-on" || e.type === "composed-of") && (typeof e._type > "u" || r(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function rr(n) {
  const e = n;
  return r(e) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || r(e._data)) && typeof e.dimensions == "number" && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.lowerLimit > "u" || typeof e.lowerLimit == "number") && S(e.origin) && typeof e.period == "number" && (typeof e.upperLimit > "u" || typeof e.upperLimit == "number");
}
function ut(n) {
  const e = n;
  return r(e) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || r(e._data)) && (typeof e.onBehalfOf > "u" || y(e.onBehalfOf)) && (typeof e.sigFormat > "u" || typeof e.sigFormat == "string") && (typeof e._sigFormat > "u" || r(e._sigFormat)) && (typeof e.targetFormat > "u" || typeof e.targetFormat == "string") && (typeof e._targetFormat > "u" || r(e._targetFormat)) && Array.isArray(e.type) && e.type.every(
    (t) => V(t)
  ) && typeof e.when == "string" && (typeof e._when > "u" || r(e._when)) && y(e.who);
}
function Ah(n) {
  const e = n;
  return r(e) && (typeof e.highLimit > "u" || S(e.highLimit)) && (typeof e.lowLimit > "u" || S(e.lowLimit));
}
function Cp(n) {
  const e = n;
  return p(e) && (typeof e.amountQuantity > "u" || S(e.amountQuantity)) && (typeof e.amountRange > "u" || K(e.amountRange)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || r(e._amountString)) && (typeof e.amountText > "u" || typeof e.amountText == "string") && (typeof e._amountText > "u" || r(e._amountText)) && (typeof e.amountType > "u" || u(e.amountType)) && (typeof e.referenceRange > "u" || Ah(e.referenceRange));
}
function hh(n) {
  const e = n;
  return r(e) && (typeof e.boundsDuration > "u" || ue(e.boundsDuration)) && (typeof e.boundsRange > "u" || K(e.boundsRange)) && (typeof e.boundsPeriod > "u" || D(e.boundsPeriod)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.countMax > "u" || typeof e.countMax == "number") && (typeof e.dayOfWeek > "u" || Array.isArray(e.dayOfWeek) && e.dayOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._dayOfWeek > "u" || Array.isArray(e._dayOfWeek) && e._dayOfWeek.every(
    (t) => r(t)
  )) && (typeof e.duration > "u" || typeof e.duration == "number") && (typeof e.durationMax > "u" || typeof e.durationMax == "number") && (typeof e.durationUnit > "u" || e.durationUnit === "s" || e.durationUnit === "min" || e.durationUnit === "h" || e.durationUnit === "d" || e.durationUnit === "wk" || e.durationUnit === "mo" || e.durationUnit === "a") && (typeof e._durationUnit > "u" || r(e._durationUnit)) && (typeof e.frequency > "u" || typeof e.frequency == "number") && (typeof e.frequencyMax > "u" || typeof e.frequencyMax == "number") && (typeof e.offset > "u" || typeof e.offset == "number") && (typeof e.period > "u" || typeof e.period == "number") && (typeof e.periodMax > "u" || typeof e.periodMax == "number") && (typeof e.periodUnit > "u" || e.periodUnit === "s" || e.periodUnit === "min" || e.periodUnit === "h" || e.periodUnit === "d" || e.periodUnit === "wk" || e.periodUnit === "mo" || e.periodUnit === "a") && (typeof e._periodUnit > "u" || r(e._periodUnit)) && (typeof e.timeOfDay > "u" || Array.isArray(e.timeOfDay) && e.timeOfDay.every(
    (t) => typeof t == "string"
  )) && (typeof e._timeOfDay > "u" || Array.isArray(e._timeOfDay) && e._timeOfDay.every(
    (t) => r(t)
  )) && (typeof e.when > "u" || Array.isArray(e.when) && e.when.every(
    (t) => typeof t == "string"
  )) && (typeof e._when > "u" || Array.isArray(e._when) && e._when.every(
    (t) => r(t)
  ));
}
function le(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => typeof t == "string"
  )) && (typeof e._event > "u" || Array.isArray(e._event) && e._event.every(
    (t) => r(t)
  )) && (typeof e.repeat > "u" || hh(e.repeat));
}
function Ft(n) {
  const e = n;
  return r(e) && (typeof e.condition > "u" || ke(e.condition)) && (typeof e.data > "u" || Array.isArray(e.data) && e.data.every(
    (t) => Ye(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.timingTiming > "u" || le(e.timingTiming)) && (typeof e.timingReference > "u" || y(e.timingReference)) && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || r(e._timingDate)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || r(e._timingDateTime)) && (e.type === "named-event" || e.type === "periodic" || e.type === "data-changed" || e.type === "data-added" || e.type === "data-modified" || e.type === "data-removed" || e.type === "data-accessed" || e.type === "data-access-ended") && (typeof e._type > "u" || r(e._type));
}
function X(n) {
  const e = n;
  return r(e) && V(e.code) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function bh(n) {
  const e = n;
  return p(e) && y(e.coverage) && (typeof e.priority > "u" || typeof e.priority == "number");
}
function Ch(n) {
  const e = n;
  return p(e) && (typeof e.onHold > "u" || e.onHold === !1 || e.onHold === !0) && (typeof e._onHold > "u" || r(e._onHold)) && y(e.party) && (typeof e.period > "u" || D(e.period));
}
function ea(n) {
  const e = n;
  return b(e) && e.resourceType === "Account" && (typeof e.coverage > "u" || Array.isArray(e.coverage) && e.coverage.every(
    (t) => bh(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.guarantor > "u" || Array.isArray(e.guarantor) && e.guarantor.every(
    (t) => Ch(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.owner > "u" || y(e.owner)) && (typeof e.partOf > "u" || y(e.partOf)) && (typeof e.servicePeriod > "u" || D(e.servicePeriod)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function xh(n) {
  const e = n;
  return p(e) && (typeof e.role > "u" || u(e.role)) && (e.type === "patient" || e.type === "practitioner" || e.type === "related-person" || e.type === "device") && (typeof e._type > "u" || r(e._type));
}
function Dh(n) {
  const e = n;
  return p(e) && ke(e.expression) && typeof e.path == "string" && (typeof e._path > "u" || r(e._path));
}
function ta(n) {
  const e = n;
  return b(e) && e.resourceType === "ActivityDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => u(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => ht(t)
  )) && (typeof e.dynamicValue > "u" || Array.isArray(e.dynamicValue) && e.dynamicValue.every(
    (t) => Dh(t)
  )) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.intent > "u" || e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.kind > "u" || typeof e.kind == "string") && (typeof e._kind > "u" || r(e._kind)) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => r(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.observationRequirement > "u" || Array.isArray(e.observationRequirement) && e.observationRequirement.every(
    (t) => y(t)
  )) && (typeof e.observationResultRequirement > "u" || Array.isArray(e.observationResultRequirement) && e.observationResultRequirement.every(
    (t) => y(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => xh(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.productReference > "u" || y(e.productReference)) && (typeof e.productCodeableConcept > "u" || u(e.productCodeableConcept)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.specimenRequirement > "u" || Array.isArray(e.specimenRequirement) && e.specimenRequirement.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.timingTiming > "u" || le(e.timingTiming)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || r(e._timingDateTime)) && (typeof e.timingAge > "u" || Le(e.timingAge)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.timingRange > "u" || K(e.timingRange)) && (typeof e.timingDuration > "u" || ue(e.timingDuration)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.transform > "u" || typeof e.transform == "string") && (typeof e._transform > "u" || r(e._transform)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Th(n) {
  const e = n;
  return p(e) && (typeof e.assessment > "u" || u(e.assessment)) && (typeof e.author > "u" || y(e.author)) && (typeof e.method > "u" || u(e.method)) && (typeof e.productRelatedness > "u" || typeof e.productRelatedness == "string") && (typeof e._productRelatedness > "u" || r(e._productRelatedness));
}
function Sh(n) {
  const e = n;
  return p(e) && (typeof e.causality > "u" || Array.isArray(e.causality) && e.causality.every(
    (t) => Th(t)
  )) && y(e.instance);
}
function ra(n) {
  const e = n;
  return b(e) && e.resourceType === "AdverseEvent" && (e.actuality === "actual" || e.actuality === "potential") && (typeof e._actuality > "u" || r(e._actuality)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.contributor > "u" || Array.isArray(e.contributor) && e.contributor.every(
    (t) => y(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.detected > "u" || typeof e.detected == "string") && (typeof e._detected > "u" || r(e._detected)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.event > "u" || u(e.event)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.location > "u" || y(e.location)) && (typeof e.outcome > "u" || u(e.outcome)) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || r(e._recordedDate)) && (typeof e.recorder > "u" || y(e.recorder)) && (typeof e.referenceDocument > "u" || Array.isArray(e.referenceDocument) && e.referenceDocument.every(
    (t) => y(t)
  )) && (typeof e.resultingCondition > "u" || Array.isArray(e.resultingCondition) && e.resultingCondition.every(
    (t) => y(t)
  )) && (typeof e.seriousness > "u" || u(e.seriousness)) && (typeof e.severity > "u" || u(e.severity)) && (typeof e.study > "u" || Array.isArray(e.study) && e.study.every(
    (t) => y(t)
  )) && y(e.subject) && (typeof e.subjectMedicalHistory > "u" || Array.isArray(e.subjectMedicalHistory) && e.subjectMedicalHistory.every(
    (t) => y(t)
  )) && (typeof e.suspectEntity > "u" || Array.isArray(e.suspectEntity) && e.suspectEntity.every(
    (t) => Sh(t)
  ));
}
function Rh(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.exposureRoute > "u" || u(e.exposureRoute)) && Array.isArray(e.manifestation) && e.manifestation.every(
    (t) => u(t)
  ) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.onset > "u" || typeof e.onset == "string") && (typeof e._onset > "u" || r(e._onset)) && (typeof e.severity > "u" || e.severity === "mild" || e.severity === "moderate" || e.severity === "severe") && (typeof e._severity > "u" || r(e._severity)) && (typeof e.substance > "u" || u(e.substance));
}
function oa(n) {
  const e = n;
  return b(e) && e.resourceType === "AllergyIntolerance" && (typeof e.asserter > "u" || y(e.asserter)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => t === "food" || t === "medication" || t === "environment" || t === "biologic"
  )) && (typeof e._category > "u" || Array.isArray(e._category) && e._category.every(
    (t) => r(t)
  )) && (typeof e.clinicalStatus > "u" || u(e.clinicalStatus)) && (typeof e.code > "u" || u(e.code)) && (typeof e.criticality > "u" || e.criticality === "low" || e.criticality === "high" || e.criticality === "unable-to-assess") && (typeof e._criticality > "u" || r(e._criticality)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.lastOccurrence > "u" || typeof e.lastOccurrence == "string") && (typeof e._lastOccurrence > "u" || r(e._lastOccurrence)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.onsetDateTime > "u" || typeof e.onsetDateTime == "string") && (typeof e._onsetDateTime > "u" || r(e._onsetDateTime)) && (typeof e.onsetAge > "u" || Le(e.onsetAge)) && (typeof e.onsetPeriod > "u" || D(e.onsetPeriod)) && (typeof e.onsetRange > "u" || K(e.onsetRange)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || r(e._onsetString)) && y(e.patient) && (typeof e.reaction > "u" || Array.isArray(e.reaction) && e.reaction.every(
    (t) => Rh(t)
  )) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || r(e._recordedDate)) && (typeof e.recorder > "u" || y(e.recorder)) && (typeof e.type > "u" || e.type === "allergy" || e.type === "intolerance") && (typeof e._type > "u" || r(e._type)) && (typeof e.verificationStatus > "u" || u(e.verificationStatus));
}
function wh(n) {
  const e = n;
  return p(e) && (typeof e.actor > "u" || y(e.actor)) && (typeof e.period > "u" || D(e.period)) && (typeof e.required > "u" || e.required === "required" || e.required === "optional" || e.required === "information-only") && (typeof e._required > "u" || r(e._required)) && (e.status === "accepted" || e.status === "declined" || e.status === "tentative" || e.status === "needs-action") && (typeof e._status > "u" || r(e._status)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function ia(n) {
  const e = n;
  return b(e) && e.resourceType === "Appointment" && (typeof e.appointmentType > "u" || u(e.appointmentType)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.cancelationReason > "u" || u(e.cancelationReason)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || r(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.minutesDuration > "u" || typeof e.minutesDuration == "number") && Array.isArray(e.participant) && e.participant.every(
    (t) => wh(t)
  ) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || r(e._patientInstruction)) && (typeof e.priority > "u" || typeof e.priority == "number") && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.requestedPeriod > "u" || Array.isArray(e.requestedPeriod) && e.requestedPeriod.every(
    (t) => D(t)
  )) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => u(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => u(t)
  )) && (typeof e.slot > "u" || Array.isArray(e.slot) && e.slot.every(
    (t) => y(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  )) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || r(e._start)) && (e.status === "entered-in-error" || e.status === "proposed" || e.status === "pending" || e.status === "booked" || e.status === "arrived" || e.status === "fulfilled" || e.status === "cancelled" || e.status === "noshow" || e.status === "checked-in" || e.status === "waitlist") && (typeof e._status > "u" || r(e._status)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => y(t)
  ));
}
function na(n) {
  const e = n;
  return b(e) && e.resourceType === "AppointmentResponse" && (typeof e.actor > "u" || y(e.actor)) && y(e.appointment) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || r(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (e.participantStatus === "accepted" || e.participantStatus === "declined" || e.participantStatus === "tentative" || e.participantStatus === "needs-action") && (typeof e._participantStatus > "u" || r(e._participantStatus)) && (typeof e.participantType > "u" || Array.isArray(e.participantType) && e.participantType.every(
    (t) => u(t)
  )) && (typeof e.start > "u" || typeof e.start == "string") && (typeof e._start > "u" || r(e._start));
}
function Ih(n) {
  const e = n;
  return p(e) && (typeof e.address > "u" || typeof e.address == "string") && (typeof e._address > "u" || r(e._address)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type));
}
function Ph(n) {
  const e = n;
  return p(e) && (typeof e.altId > "u" || typeof e.altId == "string") && (typeof e._altId > "u" || r(e._altId)) && (typeof e.location > "u" || y(e.location)) && (typeof e.media > "u" || V(e.media)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.network > "u" || Ih(e.network)) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => typeof t == "string"
  )) && (typeof e._policy > "u" || Array.isArray(e._policy) && e._policy.every(
    (t) => r(t)
  )) && (typeof e.purposeOfUse > "u" || Array.isArray(e.purposeOfUse) && e.purposeOfUse.every(
    (t) => u(t)
  )) && typeof e.requestor == "boolean" && (typeof e._requestor > "u" || r(e._requestor)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.who > "u" || y(e.who));
}
function Oh(n) {
  const e = n;
  return p(e) && y(e.observer) && (typeof e.site > "u" || typeof e.site == "string") && (typeof e._site > "u" || r(e._site)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => V(t)
  ));
}
function qh(n) {
  const e = n;
  return p(e) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary));
}
function Bh(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => qh(t)
  )) && (typeof e.lifecycle > "u" || V(e.lifecycle)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.query > "u" || typeof e.query == "string") && (typeof e._query > "u" || r(e._query)) && (typeof e.role > "u" || V(e.role)) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => V(t)
  )) && (typeof e.type > "u" || V(e.type)) && (typeof e.what > "u" || y(e.what));
}
function aa(n) {
  const e = n;
  return b(e) && e.resourceType === "AuditEvent" && (typeof e.action > "u" || typeof e.action == "string") && (typeof e._action > "u" || r(e._action)) && Array.isArray(e.agent) && e.agent.every(
    (t) => Ph(t)
  ) && (typeof e.entity > "u" || Array.isArray(e.entity) && e.entity.every(
    (t) => Bh(t)
  )) && (typeof e.outcome > "u" || typeof e.outcome == "string") && (typeof e._outcome > "u" || r(e._outcome)) && (typeof e.outcomeDesc > "u" || typeof e.outcomeDesc == "string") && (typeof e._outcomeDesc > "u" || r(e._outcomeDesc)) && (typeof e.period > "u" || D(e.period)) && (typeof e.purposeOfEvent > "u" || Array.isArray(e.purposeOfEvent) && e.purposeOfEvent.every(
    (t) => u(t)
  )) && typeof e.recorded == "string" && (typeof e._recorded > "u" || r(e._recorded)) && Oh(e.source) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => V(t)
  )) && V(e.type);
}
function ua(n) {
  const e = n;
  return b(e) && e.resourceType === "Basic" && (typeof e.author > "u" || y(e.author)) && u(e.code) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.subject > "u" || y(e.subject));
}
function ya(n) {
  const e = n;
  return sy(e) && e.resourceType === "Binary" && typeof e.contentType == "string" && (typeof e._contentType > "u" || r(e._contentType)) && (typeof e.data > "u" || typeof e.data == "string") && (typeof e._data > "u" || r(e._data)) && (typeof e.securityContext > "u" || y(e.securityContext));
}
function Uh(n) {
  const e = n;
  return p(e) && (typeof e.collectedDateTime > "u" || typeof e.collectedDateTime == "string") && (typeof e._collectedDateTime > "u" || r(e._collectedDateTime)) && (typeof e.collectedPeriod > "u" || D(e.collectedPeriod)) && (typeof e.collector > "u" || y(e.collector)) && (typeof e.source > "u" || y(e.source));
}
function Mh(n) {
  const e = n;
  return p(e) && (typeof e.additive > "u" || y(e.additive)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.procedure > "u" || u(e.procedure)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || r(e._timeDateTime)) && (typeof e.timePeriod > "u" || D(e.timePeriod));
}
function Eh(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || r(e._timeDateTime)) && (typeof e.timePeriod > "u" || D(e.timePeriod));
}
function kh(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.duration > "u" || D(e.duration)) && (typeof e.scale > "u" || e.scale === "farenheit" || e.scale === "celsius" || e.scale === "kelvin") && (typeof e._scale > "u" || r(e._scale)) && (typeof e.temperature > "u" || typeof e.temperature == "number");
}
function sa(n) {
  const e = n;
  return b(e) && e.resourceType === "BiologicallyDerivedProduct" && (typeof e.collection > "u" || Uh(e.collection)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.manipulation > "u" || Eh(e.manipulation)) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => y(t)
  )) && (typeof e.processing > "u" || Array.isArray(e.processing) && e.processing.every(
    (t) => Mh(t)
  )) && (typeof e.productCategory > "u" || e.productCategory === "organ" || e.productCategory === "tissue" || e.productCategory === "fluid" || e.productCategory === "cells" || e.productCategory === "biologicalAgent") && (typeof e._productCategory > "u" || r(e._productCategory)) && (typeof e.productCode > "u" || u(e.productCode)) && (typeof e.quantity > "u" || typeof e.quantity == "number") && (typeof e.request > "u" || Array.isArray(e.request) && e.request.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || e.status === "available" || e.status === "unavailable") && (typeof e._status > "u" || r(e._status)) && (typeof e.storage > "u" || Array.isArray(e.storage) && e.storage.every(
    (t) => kh(t)
  ));
}
function pa(n) {
  const e = n;
  return b(e) && e.resourceType === "BodyStructure" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => te(t)
  )) && (typeof e.location > "u" || u(e.location)) && (typeof e.locationQualifier > "u" || Array.isArray(e.locationQualifier) && e.locationQualifier.every(
    (t) => u(t)
  )) && (typeof e.morphology > "u" || u(e.morphology)) && y(e.patient);
}
function Lc(n) {
  const e = n;
  return p(e) && typeof e.relation == "string" && (typeof e._relation > "u" || r(e._relation)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url));
}
function Vh(n) {
  const e = n;
  return p(e) && (typeof e.mode > "u" || e.mode === "match" || e.mode === "include" || e.mode === "outcome") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.score > "u" || typeof e.score == "number");
}
function Nh(n) {
  const e = n;
  return p(e) && (typeof e.ifMatch > "u" || typeof e.ifMatch == "string") && (typeof e._ifMatch > "u" || r(e._ifMatch)) && (typeof e.ifModifiedSince > "u" || typeof e.ifModifiedSince == "string") && (typeof e._ifModifiedSince > "u" || r(e._ifModifiedSince)) && (typeof e.ifNoneExist > "u" || typeof e.ifNoneExist == "string") && (typeof e._ifNoneExist > "u" || r(e._ifNoneExist)) && (typeof e.ifNoneMatch > "u" || typeof e.ifNoneMatch == "string") && (typeof e._ifNoneMatch > "u" || r(e._ifNoneMatch)) && (e.method === "GET" || e.method === "HEAD" || e.method === "POST" || e.method === "PUT" || e.method === "DELETE" || e.method === "PATCH") && (typeof e._method > "u" || r(e._method)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url));
}
function Lh(n) {
  const e = n;
  return p(e) && (typeof e.etag > "u" || typeof e.etag == "string") && (typeof e._etag > "u" || r(e._etag)) && (typeof e.lastModified > "u" || typeof e.lastModified == "string") && (typeof e._lastModified > "u" || r(e._lastModified)) && (typeof e.location > "u" || typeof e.location == "string") && (typeof e._location > "u" || r(e._location)) && (typeof e.outcome > "u" || ea(e.outcome) || ta(e.outcome) || ra(e.outcome) || oa(e.outcome) || ia(e.outcome) || na(e.outcome) || aa(e.outcome) || ua(e.outcome) || ya(e.outcome) || sa(e.outcome) || pa(e.outcome) || fa(e.outcome) || ca(e.outcome) || la(e.outcome) || da(e.outcome) || ga(e.outcome) || ma(e.outcome) || _a(e.outcome) || va(e.outcome) || Aa(e.outcome) || ha(e.outcome) || ba(e.outcome) || Ca(e.outcome) || xa(e.outcome) || Da(e.outcome) || Ta(e.outcome) || Sa(e.outcome) || Ra(e.outcome) || wa(e.outcome) || Ia(e.outcome) || Pa(e.outcome) || Oa(e.outcome) || qa(e.outcome) || Ba(e.outcome) || Ua(e.outcome) || Ma(e.outcome) || Ea(e.outcome) || ka(e.outcome) || Va(e.outcome) || Na(e.outcome) || La(e.outcome) || Fa(e.outcome) || $a(e.outcome) || ja(e.outcome) || Wa(e.outcome) || Ha(e.outcome) || Qa(e.outcome) || za(e.outcome) || Ga(e.outcome) || Ka(e.outcome) || Ya(e.outcome) || Ja(e.outcome) || Za(e.outcome) || Xa(e.outcome) || eu(e.outcome) || tu(e.outcome) || ru(e.outcome) || ou(e.outcome) || iu(e.outcome) || nu(e.outcome) || au(e.outcome) || uu(e.outcome) || yu(e.outcome) || su(e.outcome) || pu(e.outcome) || fu(e.outcome) || cu(e.outcome) || lu(e.outcome) || du(e.outcome) || gu(e.outcome) || mu(e.outcome) || _u(e.outcome) || vu(e.outcome) || Au(e.outcome) || hu(e.outcome) || bu(e.outcome) || Cu(e.outcome) || xu(e.outcome) || Du(e.outcome) || Tu(e.outcome) || Su(e.outcome) || Ru(e.outcome) || wu(e.outcome) || Iu(e.outcome) || Pu(e.outcome) || Ou(e.outcome) || qu(e.outcome) || Bu(e.outcome) || Uu(e.outcome) || Mu(e.outcome) || Eu(e.outcome) || ku(e.outcome) || Vu(e.outcome) || Nu(e.outcome) || Lu(e.outcome) || Fu(e.outcome) || $u(e.outcome) || ju(e.outcome) || Wu(e.outcome) || Hu(e.outcome) || Qu(e.outcome) || zu(e.outcome) || Gu(e.outcome) || Ku(e.outcome) || Yu(e.outcome) || Ju(e.outcome) || Zu(e.outcome) || Xu(e.outcome) || ey(e.outcome) || ty(e.outcome) || ry(e.outcome) || qi(e.outcome) || Bi(e.outcome) || oy(e.outcome) || iy(e.outcome) || ny(e.outcome) || ay(e.outcome) || uy(e.outcome) || yy(e.outcome) || py(e.outcome) || fy(e.outcome) || cy(e.outcome) || ly(e.outcome) || dy(e.outcome) || gy(e.outcome) || my(e.outcome) || _y(e.outcome) || vy(e.outcome) || Ay(e.outcome) || hy(e.outcome) || by(e.outcome) || Cy(e.outcome) || xy(e.outcome) || Dy(e.outcome) || Ty(e.outcome) || Sy(e.outcome) || Ry(e.outcome) || wy(e.outcome) || Iy(e.outcome) || Py(e.outcome) || Oy(e.outcome) || qy(e.outcome) || By(e.outcome) || Uy(e.outcome) || My(e.outcome) || Ey(e.outcome)) && typeof e.status == "string" && (typeof e._status > "u" || r(e._status));
}
function Fh(n) {
  const e = n;
  return p(e) && (typeof e.fullUrl > "u" || typeof e.fullUrl == "string") && (typeof e._fullUrl > "u" || r(e._fullUrl)) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Lc(t)
  )) && (typeof e.request > "u" || Nh(e.request)) && (typeof e.resource > "u" || ea(e.resource) || ta(e.resource) || ra(e.resource) || oa(e.resource) || ia(e.resource) || na(e.resource) || aa(e.resource) || ua(e.resource) || ya(e.resource) || sa(e.resource) || pa(e.resource) || fa(e.resource) || ca(e.resource) || la(e.resource) || da(e.resource) || ga(e.resource) || ma(e.resource) || _a(e.resource) || va(e.resource) || Aa(e.resource) || ha(e.resource) || ba(e.resource) || Ca(e.resource) || xa(e.resource) || Da(e.resource) || Ta(e.resource) || Sa(e.resource) || Ra(e.resource) || wa(e.resource) || Ia(e.resource) || Pa(e.resource) || Oa(e.resource) || qa(e.resource) || Ba(e.resource) || Ua(e.resource) || Ma(e.resource) || Ea(e.resource) || ka(e.resource) || Va(e.resource) || Na(e.resource) || La(e.resource) || Fa(e.resource) || $a(e.resource) || ja(e.resource) || Wa(e.resource) || Ha(e.resource) || Qa(e.resource) || za(e.resource) || Ga(e.resource) || Ka(e.resource) || Ya(e.resource) || Ja(e.resource) || Za(e.resource) || Xa(e.resource) || eu(e.resource) || tu(e.resource) || ru(e.resource) || ou(e.resource) || iu(e.resource) || nu(e.resource) || au(e.resource) || uu(e.resource) || yu(e.resource) || su(e.resource) || pu(e.resource) || fu(e.resource) || cu(e.resource) || lu(e.resource) || du(e.resource) || gu(e.resource) || mu(e.resource) || _u(e.resource) || vu(e.resource) || Au(e.resource) || hu(e.resource) || bu(e.resource) || Cu(e.resource) || xu(e.resource) || Du(e.resource) || Tu(e.resource) || Su(e.resource) || Ru(e.resource) || wu(e.resource) || Iu(e.resource) || Pu(e.resource) || Ou(e.resource) || qu(e.resource) || Bu(e.resource) || Uu(e.resource) || Mu(e.resource) || Eu(e.resource) || ku(e.resource) || Vu(e.resource) || Nu(e.resource) || Lu(e.resource) || Fu(e.resource) || $u(e.resource) || ju(e.resource) || Wu(e.resource) || Hu(e.resource) || Qu(e.resource) || zu(e.resource) || Gu(e.resource) || Ku(e.resource) || Yu(e.resource) || Ju(e.resource) || Zu(e.resource) || Xu(e.resource) || ey(e.resource) || ty(e.resource) || ry(e.resource) || qi(e.resource) || Bi(e.resource) || oy(e.resource) || iy(e.resource) || ny(e.resource) || ay(e.resource) || uy(e.resource) || yy(e.resource) || py(e.resource) || fy(e.resource) || cy(e.resource) || ly(e.resource) || dy(e.resource) || gy(e.resource) || my(e.resource) || _y(e.resource) || vy(e.resource) || Ay(e.resource) || hy(e.resource) || by(e.resource) || Cy(e.resource) || xy(e.resource) || Dy(e.resource) || Ty(e.resource) || Sy(e.resource) || Ry(e.resource) || wy(e.resource) || Iy(e.resource) || Py(e.resource) || Oy(e.resource) || qy(e.resource) || By(e.resource) || Uy(e.resource) || My(e.resource) || Ey(e.resource)) && (typeof e.response > "u" || Lh(e.response)) && (typeof e.search > "u" || Vh(e.search));
}
function fa(n) {
  const e = n;
  return sy(e) && e.resourceType === "Bundle" && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => Fh(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Lc(t)
  )) && (typeof e.signature > "u" || ut(e.signature)) && (typeof e.timestamp > "u" || typeof e.timestamp == "string") && (typeof e._timestamp > "u" || r(e._timestamp)) && (typeof e.total > "u" || typeof e.total == "number") && (e.type === "document" || e.type === "message" || e.type === "transaction" || e.type === "transaction-response" || e.type === "batch" || e.type === "batch-response" || e.type === "history" || e.type === "searchset" || e.type === "collection") && (typeof e._type > "u" || r(e._type));
}
function $h(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.releaseDate > "u" || typeof e.releaseDate == "string") && (typeof e._releaseDate > "u" || r(e._releaseDate)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function jh(n) {
  const e = n;
  return p(e) && (typeof e.custodian > "u" || y(e.custodian)) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function Wh(n) {
  const e = n;
  return p(e) && (typeof e.cors > "u" || e.cors === !1 || e.cors === !0) && (typeof e._cors > "u" || r(e._cors)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.service > "u" || Array.isArray(e.service) && e.service.every(
    (t) => u(t)
  ));
}
function Hh(n) {
  const e = n;
  return p(e) && (e.code === "read" || e.code === "vread" || e.code === "update" || e.code === "patch" || e.code === "delete" || e.code === "history-instance" || e.code === "history-type" || e.code === "create" || e.code === "search-type") && (typeof e._code > "u" || r(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation));
}
function Fc(n) {
  const e = n;
  return p(e) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (e.type === "string" || e.type === "number" || e.type === "date" || e.type === "token" || e.type === "reference" || e.type === "composite" || e.type === "quantity" || e.type === "uri" || e.type === "special") && (typeof e._type > "u" || r(e._type));
}
function $c(n) {
  const e = n;
  return p(e) && typeof e.definition == "string" && (typeof e._definition > "u" || r(e._definition)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name));
}
function Qh(n) {
  const e = n;
  return p(e) && (typeof e.conditionalCreate > "u" || e.conditionalCreate === !1 || e.conditionalCreate === !0) && (typeof e._conditionalCreate > "u" || r(e._conditionalCreate)) && (typeof e.conditionalDelete > "u" || e.conditionalDelete === "not-supported" || e.conditionalDelete === "single" || e.conditionalDelete === "multiple") && (typeof e._conditionalDelete > "u" || r(e._conditionalDelete)) && (typeof e.conditionalRead > "u" || e.conditionalRead === "not-supported" || e.conditionalRead === "modified-since" || e.conditionalRead === "not-match" || e.conditionalRead === "full-support") && (typeof e._conditionalRead > "u" || r(e._conditionalRead)) && (typeof e.conditionalUpdate > "u" || e.conditionalUpdate === !1 || e.conditionalUpdate === !0) && (typeof e._conditionalUpdate > "u" || r(e._conditionalUpdate)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.interaction > "u" || Array.isArray(e.interaction) && e.interaction.every(
    (t) => Hh(t)
  )) && (typeof e.operation > "u" || Array.isArray(e.operation) && e.operation.every(
    (t) => $c(t)
  )) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile)) && (typeof e.readHistory > "u" || e.readHistory === !1 || e.readHistory === !0) && (typeof e._readHistory > "u" || r(e._readHistory)) && (typeof e.referencePolicy > "u" || Array.isArray(e.referencePolicy) && e.referencePolicy.every(
    (t) => t === "literal" || t === "logical" || t === "resolves" || t === "enforced" || t === "local"
  )) && (typeof e._referencePolicy > "u" || Array.isArray(e._referencePolicy) && e._referencePolicy.every(
    (t) => r(t)
  )) && (typeof e.searchInclude > "u" || Array.isArray(e.searchInclude) && e.searchInclude.every(
    (t) => typeof t == "string"
  )) && (typeof e._searchInclude > "u" || Array.isArray(e._searchInclude) && e._searchInclude.every(
    (t) => r(t)
  )) && (typeof e.searchParam > "u" || Array.isArray(e.searchParam) && e.searchParam.every(
    (t) => Fc(t)
  )) && (typeof e.searchRevInclude > "u" || Array.isArray(e.searchRevInclude) && e.searchRevInclude.every(
    (t) => typeof t == "string"
  )) && (typeof e._searchRevInclude > "u" || Array.isArray(e._searchRevInclude) && e._searchRevInclude.every(
    (t) => r(t)
  )) && (typeof e.supportedProfile > "u" || Array.isArray(e.supportedProfile) && e.supportedProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._supportedProfile > "u" || Array.isArray(e._supportedProfile) && e._supportedProfile.every(
    (t) => r(t)
  )) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type)) && (typeof e.updateCreate > "u" || e.updateCreate === !1 || e.updateCreate === !0) && (typeof e._updateCreate > "u" || r(e._updateCreate)) && (typeof e.versioning > "u" || e.versioning === "no-version" || e.versioning === "versioned" || e.versioning === "versioned-update") && (typeof e._versioning > "u" || r(e._versioning));
}
function zh(n) {
  const e = n;
  return p(e) && (e.code === "transaction" || e.code === "batch" || e.code === "search-system" || e.code === "history-system") && (typeof e._code > "u" || r(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation));
}
function Gh(n) {
  const e = n;
  return p(e) && (typeof e.compartment > "u" || Array.isArray(e.compartment) && e.compartment.every(
    (t) => typeof t == "string"
  )) && (typeof e._compartment > "u" || Array.isArray(e._compartment) && e._compartment.every(
    (t) => r(t)
  )) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.interaction > "u" || Array.isArray(e.interaction) && e.interaction.every(
    (t) => zh(t)
  )) && (e.mode === "client" || e.mode === "server") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.operation > "u" || Array.isArray(e.operation) && e.operation.every(
    (t) => $c(t)
  )) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => Qh(t)
  )) && (typeof e.searchParam > "u" || Array.isArray(e.searchParam) && e.searchParam.every(
    (t) => Fc(t)
  )) && (typeof e.security > "u" || Wh(e.security));
}
function Kh(n) {
  const e = n;
  return p(e) && typeof e.address == "string" && (typeof e._address > "u" || r(e._address)) && V(e.protocol);
}
function Yh(n) {
  const e = n;
  return p(e) && typeof e.definition == "string" && (typeof e._definition > "u" || r(e._definition)) && (e.mode === "sender" || e.mode === "receiver") && (typeof e._mode > "u" || r(e._mode));
}
function Jh(n) {
  const e = n;
  return p(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => Kh(t)
  )) && (typeof e.reliableCache > "u" || typeof e.reliableCache == "number") && (typeof e.supportedMessage > "u" || Array.isArray(e.supportedMessage) && e.supportedMessage.every(
    (t) => Yh(t)
  ));
}
function Zh(n) {
  const e = n;
  return p(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (e.mode === "producer" || e.mode === "consumer") && (typeof e._mode > "u" || r(e._mode)) && typeof e.profile == "string" && (typeof e._profile > "u" || r(e._profile));
}
function ca(n) {
  const e = n;
  return b(e) && e.resourceType === "CapabilityStatement" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.document > "u" || Array.isArray(e.document) && e.document.every(
    (t) => Zh(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && typeof e.fhirVersion == "string" && (typeof e._fhirVersion > "u" || r(e._fhirVersion)) && Array.isArray(e.format) && e.format.every(
    (t) => typeof t == "string"
  ) && (typeof e._format > "u" || Array.isArray(e._format) && e._format.every(
    (t) => r(t)
  )) && (typeof e.implementation > "u" || jh(e.implementation)) && (typeof e.implementationGuide > "u" || Array.isArray(e.implementationGuide) && e.implementationGuide.every(
    (t) => typeof t == "string"
  )) && (typeof e._implementationGuide > "u" || Array.isArray(e._implementationGuide) && e._implementationGuide.every(
    (t) => r(t)
  )) && (typeof e.imports > "u" || Array.isArray(e.imports) && e.imports.every(
    (t) => typeof t == "string"
  )) && (typeof e._imports > "u" || Array.isArray(e._imports) && e._imports.every(
    (t) => r(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => r(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (e.kind === "instance" || e.kind === "capability" || e.kind === "requirements") && (typeof e._kind > "u" || r(e._kind)) && (typeof e.messaging > "u" || Array.isArray(e.messaging) && e.messaging.every(
    (t) => Jh(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.patchFormat > "u" || Array.isArray(e.patchFormat) && e.patchFormat.every(
    (t) => typeof t == "string"
  )) && (typeof e._patchFormat > "u" || Array.isArray(e._patchFormat) && e._patchFormat.every(
    (t) => r(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.rest > "u" || Array.isArray(e.rest) && e.rest.every(
    (t) => Gh(t)
  )) && (typeof e.software > "u" || $h(e.software)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Xh(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.dailyAmount > "u" || S(e.dailyAmount)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => y(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.kind > "u" || e.kind === "Appointment" || e.kind === "CommunicationRequest" || e.kind === "DeviceRequest" || e.kind === "MedicationRequest" || e.kind === "NutritionOrder" || e.kind === "Task" || e.kind === "ServiceRequest" || e.kind === "VisionPrescription") && (typeof e._kind > "u" || r(e._kind)) && (typeof e.location > "u" || y(e.location)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => y(t)
  )) && (typeof e.productCodeableConcept > "u" || u(e.productCodeableConcept)) && (typeof e.productReference > "u" || y(e.productReference)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.scheduledTiming > "u" || le(e.scheduledTiming)) && (typeof e.scheduledPeriod > "u" || D(e.scheduledPeriod)) && (typeof e.scheduledString > "u" || typeof e.scheduledString == "string") && (typeof e._scheduledString > "u" || r(e._scheduledString)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "cancelled" || e.status === "not-started" || e.status === "scheduled" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason));
}
function eb(n) {
  const e = n;
  return p(e) && (typeof e.detail > "u" || Xh(e.detail)) && (typeof e.outcomeCodeableConcept > "u" || Array.isArray(e.outcomeCodeableConcept) && e.outcomeCodeableConcept.every(
    (t) => u(t)
  )) && (typeof e.outcomeReference > "u" || Array.isArray(e.outcomeReference) && e.outcomeReference.every(
    (t) => y(t)
  )) && (typeof e.progress > "u" || Array.isArray(e.progress) && e.progress.every(
    (t) => $(t)
  )) && (typeof e.reference > "u" || y(e.reference));
}
function la(n) {
  const e = n;
  return b(e) && e.resourceType === "CarePlan" && (typeof e.activity > "u" || Array.isArray(e.activity) && e.activity.every(
    (t) => eb(t)
  )) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => y(t)
  )) && (typeof e.author > "u" || y(e.author)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.contributor > "u" || Array.isArray(e.contributor) && e.contributor.every(
    (t) => y(t)
  )) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.period > "u" || D(e.period)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && y(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => y(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title));
}
function tb(n) {
  const e = n;
  return p(e) && (typeof e.member > "u" || y(e.member)) && (typeof e.onBehalfOf > "u" || y(e.onBehalfOf)) && (typeof e.period > "u" || D(e.period)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => u(t)
  ));
}
function da(n) {
  const e = n;
  return b(e) && e.resourceType === "CareTeam" && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.managingOrganization > "u" || Array.isArray(e.managingOrganization) && e.managingOrganization.every(
    (t) => y(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => tb(t)
  )) && (typeof e.period > "u" || D(e.period)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "proposed" || e.status === "suspended") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function rb(n) {
  const e = n;
  return p(e) && y(e.item) && (e.relationtype === "triggers" || e.relationtype === "is-replaced-by") && (typeof e._relationtype > "u" || r(e._relationtype));
}
function ga(n) {
  const e = n;
  return b(e) && e.resourceType === "CatalogEntry" && (typeof e.additionalCharacteristic > "u" || Array.isArray(e.additionalCharacteristic) && e.additionalCharacteristic.every(
    (t) => u(t)
  )) && (typeof e.additionalClassification > "u" || Array.isArray(e.additionalClassification) && e.additionalClassification.every(
    (t) => u(t)
  )) && (typeof e.additionalIdentifier > "u" || Array.isArray(e.additionalIdentifier) && e.additionalIdentifier.every(
    (t) => A(t)
  )) && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.lastUpdated > "u" || typeof e.lastUpdated == "string") && (typeof e._lastUpdated > "u" || r(e._lastUpdated)) && typeof e.orderable == "boolean" && (typeof e._orderable > "u" || r(e._orderable)) && y(e.referencedItem) && (typeof e.relatedEntry > "u" || Array.isArray(e.relatedEntry) && e.relatedEntry.every(
    (t) => rb(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.type > "u" || u(e.type)) && (typeof e.validityPeriod > "u" || D(e.validityPeriod)) && (typeof e.validTo > "u" || typeof e.validTo == "string") && (typeof e._validTo > "u" || r(e._validTo));
}
function ob(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function));
}
function ma(n) {
  const e = n;
  return b(e) && e.resourceType === "ChargeItem" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => y(t)
  )) && (typeof e.bodysite > "u" || Array.isArray(e.bodysite) && e.bodysite.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.context > "u" || y(e.context)) && (typeof e.costCenter > "u" || y(e.costCenter)) && (typeof e.definitionCanonical > "u" || Array.isArray(e.definitionCanonical) && e.definitionCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._definitionCanonical > "u" || Array.isArray(e._definitionCanonical) && e._definitionCanonical.every(
    (t) => r(t)
  )) && (typeof e.definitionUri > "u" || Array.isArray(e.definitionUri) && e.definitionUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._definitionUri > "u" || Array.isArray(e._definitionUri) && e._definitionUri.every(
    (t) => r(t)
  )) && (typeof e.enteredDate > "u" || typeof e.enteredDate == "string") && (typeof e._enteredDate > "u" || r(e._enteredDate)) && (typeof e.enterer > "u" || y(e.enterer)) && (typeof e.factorOverride > "u" || typeof e.factorOverride == "number") && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.overrideReason > "u" || typeof e.overrideReason == "string") && (typeof e._overrideReason > "u" || r(e._overrideReason)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => ob(t)
  )) && (typeof e.performingOrganization > "u" || y(e.performingOrganization)) && (typeof e.priceOverride > "u" || L(e.priceOverride)) && (typeof e.productReference > "u" || y(e.productReference)) && (typeof e.productCodeableConcept > "u" || u(e.productCodeableConcept)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => u(t)
  )) && (typeof e.requestingOrganization > "u" || y(e.requestingOrganization)) && (typeof e.service > "u" || Array.isArray(e.service) && e.service.every(
    (t) => y(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "planned" || e.status === "billable" || e.status === "not-billable" || e.status === "aborted" || e.status === "billed") && (typeof e._status > "u" || r(e._status)) && y(e.subject) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => y(t)
  ));
}
function jc(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language));
}
function ib(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || L(e.amount)) && (typeof e.code > "u" || u(e.code)) && (typeof e.factor > "u" || typeof e.factor == "number") && (e.type === "base" || e.type === "surcharge" || e.type === "deduction" || e.type === "discount" || e.type === "tax" || e.type === "informational") && (typeof e._type > "u" || r(e._type));
}
function nb(n) {
  const e = n;
  return p(e) && (typeof e.applicability > "u" || Array.isArray(e.applicability) && e.applicability.every(
    (t) => jc(t)
  )) && (typeof e.priceComponent > "u" || Array.isArray(e.priceComponent) && e.priceComponent.every(
    (t) => ib(t)
  ));
}
function _a(n) {
  const e = n;
  return b(e) && e.resourceType === "ChargeItemDefinition" && (typeof e.applicability > "u" || Array.isArray(e.applicability) && e.applicability.every(
    (t) => jc(t)
  )) && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.code > "u" || u(e.code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.derivedFromUri > "u" || Array.isArray(e.derivedFromUri) && e.derivedFromUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._derivedFromUri > "u" || Array.isArray(e._derivedFromUri) && e._derivedFromUri.every(
    (t) => r(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => y(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => typeof t == "string"
  )) && (typeof e._partOf > "u" || Array.isArray(e._partOf) && e._partOf.every(
    (t) => r(t)
  )) && (typeof e.propertyGroup > "u" || Array.isArray(e.propertyGroup) && e.propertyGroup.every(
    (t) => nb(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => typeof t == "string"
  )) && (typeof e._replaces > "u" || Array.isArray(e._replaces) && e._replaces.every(
    (t) => r(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function ab(n) {
  const e = n;
  return p(e) && (typeof e.claim > "u" || y(e.claim)) && (typeof e.reference > "u" || A(e.reference)) && (typeof e.relationship > "u" || u(e.relationship));
}
function ub(n) {
  const e = n;
  return p(e) && (typeof e.party > "u" || y(e.party)) && u(e.type);
}
function yb(n) {
  const e = n;
  return p(e) && y(e.provider) && (typeof e.qualification > "u" || u(e.qualification)) && (typeof e.responsible > "u" || e.responsible === !1 || e.responsible === !0) && (typeof e._responsible > "u" || r(e._responsible)) && (typeof e.role > "u" || u(e.role)) && typeof e.sequence == "number";
}
function sb(n) {
  const e = n;
  return p(e) && u(e.category) && (typeof e.code > "u" || u(e.code)) && (typeof e.reason > "u" || u(e.reason)) && typeof e.sequence == "number" && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || r(e._timingDate)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function pb(n) {
  const e = n;
  return p(e) && (typeof e.diagnosisCodeableConcept > "u" || u(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || y(e.diagnosisReference)) && (typeof e.onAdmission > "u" || u(e.onAdmission)) && (typeof e.packageCode > "u" || u(e.packageCode)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function fb(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.procedureCodeableConcept > "u" || u(e.procedureCodeableConcept)) && (typeof e.procedureReference > "u" || y(e.procedureReference)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  ));
}
function cb(n) {
  const e = n;
  return p(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || r(e._businessArrangement)) && (typeof e.claimResponse > "u" || y(e.claimResponse)) && y(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || r(e._focal)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => r(t)
  )) && typeof e.sequence == "number";
}
function lb(n) {
  const e = n;
  return p(e) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.type > "u" || u(e.type));
}
function db(n) {
  const e = n;
  return p(e) && (typeof e.category > "u" || u(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function gb(n) {
  const e = n;
  return p(e) && (typeof e.category > "u" || u(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => db(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function mb(n) {
  const e = n;
  return p(e) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.careTeamSequence > "u" || Array.isArray(e.careTeamSequence) && e.careTeamSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => gb(t)
  )) && (typeof e.diagnosisSequence > "u" || Array.isArray(e.diagnosisSequence) && e.diagnosisSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => y(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.informationSequence > "u" || Array.isArray(e.informationSequence) && e.informationSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || u(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.procedureSequence > "u" || Array.isArray(e.procedureSequence) && e.procedureSequence.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => u(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function va(n) {
  const e = n;
  return b(e) && e.resourceType === "Claim" && (typeof e.accident > "u" || lb(e.accident)) && (typeof e.billablePeriod > "u" || D(e.billablePeriod)) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => yb(t)
  )) && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => pb(t)
  )) && (typeof e.enterer > "u" || y(e.enterer)) && (typeof e.facility > "u" || y(e.facility)) && (typeof e.fundsReserve > "u" || u(e.fundsReserve)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && Array.isArray(e.insurance) && e.insurance.every(
    (t) => cb(t)
  ) && (typeof e.insurer > "u" || y(e.insurer)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => mb(t)
  )) && (typeof e.originalPrescription > "u" || y(e.originalPrescription)) && y(e.patient) && (typeof e.payee > "u" || ub(e.payee)) && (typeof e.prescription > "u" || y(e.prescription)) && u(e.priority) && (typeof e.procedure > "u" || Array.isArray(e.procedure) && e.procedure.every(
    (t) => fb(t)
  )) && y(e.provider) && (typeof e.referral > "u" || y(e.referral)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => ab(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status)) && (typeof e.subType > "u" || u(e.subType)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => sb(t)
  )) && (typeof e.total > "u" || L(e.total)) && u(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || r(e._use));
}
function bo(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || L(e.amount)) && u(e.category) && (typeof e.reason > "u" || u(e.reason)) && (typeof e.value > "u" || typeof e.value == "number");
}
function _b(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  )) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && typeof e.subDetailSequence == "number";
}
function vb(n) {
  const e = n;
  return p(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  ) && typeof e.detailSequence == "number" && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => _b(t)
  ));
}
function Ab(n) {
  const e = n;
  return p(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  ) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => vb(t)
  )) && typeof e.itemSequence == "number" && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  ));
}
function hb(n) {
  const e = n;
  return p(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  ) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function bb(n) {
  const e = n;
  return p(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  ) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => hb(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function Cb(n) {
  const e = n;
  return p(e) && Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  ) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => bb(t)
  )) && (typeof e.detailSequence > "u" || Array.isArray(e.detailSequence) && e.detailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.itemSequence > "u" || Array.isArray(e.itemSequence) && e.itemSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || u(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.provider > "u" || Array.isArray(e.provider) && e.provider.every(
    (t) => y(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (typeof e.subdetailSequence > "u" || Array.isArray(e.subdetailSequence) && e.subdetailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => u(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function xb(n) {
  const e = n;
  return p(e) && L(e.amount) && u(e.category);
}
function Db(n) {
  const e = n;
  return p(e) && (typeof e.adjustment > "u" || L(e.adjustment)) && (typeof e.adjustmentReason > "u" || u(e.adjustmentReason)) && L(e.amount) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || A(e.identifier)) && u(e.type);
}
function Tb(n) {
  const e = n;
  return p(e) && (typeof e.language > "u" || u(e.language)) && (typeof e.number > "u" || typeof e.number == "number") && typeof e.text == "string" && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || r(e._type));
}
function Sb(n) {
  const e = n;
  return p(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || r(e._businessArrangement)) && (typeof e.claimResponse > "u" || y(e.claimResponse)) && y(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || r(e._focal)) && typeof e.sequence == "number";
}
function Rb(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.detailSequence > "u" || typeof e.detailSequence == "number") && (typeof e.itemSequence > "u" || typeof e.itemSequence == "number") && (typeof e.subDetailSequence > "u" || typeof e.subDetailSequence == "number");
}
function Aa(n) {
  const e = n;
  return b(e) && e.resourceType === "ClaimResponse" && (typeof e.addItem > "u" || Array.isArray(e.addItem) && e.addItem.every(
    (t) => Cb(t)
  )) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => bo(t)
  )) && (typeof e.communicationRequest > "u" || Array.isArray(e.communicationRequest) && e.communicationRequest.every(
    (t) => y(t)
  )) && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || r(e._disposition)) && (typeof e.error > "u" || Array.isArray(e.error) && e.error.every(
    (t) => Rb(t)
  )) && (typeof e.form > "u" || te(e.form)) && (typeof e.formCode > "u" || u(e.formCode)) && (typeof e.fundsReserve > "u" || u(e.fundsReserve)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => Sb(t)
  )) && y(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Ab(t)
  )) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || r(e._outcome)) && y(e.patient) && (typeof e.payeeType > "u" || u(e.payeeType)) && (typeof e.payment > "u" || Db(e.payment)) && (typeof e.preAuthPeriod > "u" || D(e.preAuthPeriod)) && (typeof e.preAuthRef > "u" || typeof e.preAuthRef == "string") && (typeof e._preAuthRef > "u" || r(e._preAuthRef)) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => Tb(t)
  )) && (typeof e.request > "u" || y(e.request)) && (typeof e.requestor > "u" || y(e.requestor)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status)) && (typeof e.subType > "u" || u(e.subType)) && (typeof e.total > "u" || Array.isArray(e.total) && e.total.every(
    (t) => xb(t)
  )) && u(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || r(e._use));
}
function wb(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => y(t)
  ));
}
function Ib(n) {
  const e = n;
  return p(e) && (typeof e.basis > "u" || typeof e.basis == "string") && (typeof e._basis > "u" || r(e._basis)) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || y(e.itemReference));
}
function ha(n) {
  const e = n;
  return b(e) && e.resourceType === "ClinicalImpression" && (typeof e.assessor > "u" || y(e.assessor)) && (typeof e.code > "u" || u(e.code)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || r(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.finding > "u" || Array.isArray(e.finding) && e.finding.every(
    (t) => Ib(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.investigation > "u" || Array.isArray(e.investigation) && e.investigation.every(
    (t) => wb(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.previous > "u" || y(e.previous)) && (typeof e.problem > "u" || Array.isArray(e.problem) && e.problem.every(
    (t) => y(t)
  )) && (typeof e.prognosisCodeableConcept > "u" || Array.isArray(e.prognosisCodeableConcept) && e.prognosisCodeableConcept.every(
    (t) => u(t)
  )) && (typeof e.prognosisReference > "u" || Array.isArray(e.prognosisReference) && e.prognosisReference.every(
    (t) => y(t)
  )) && (typeof e.protocol > "u" || Array.isArray(e.protocol) && e.protocol.every(
    (t) => typeof t == "string"
  )) && (typeof e._protocol > "u" || Array.isArray(e._protocol) && e._protocol.every(
    (t) => r(t)
  )) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && y(e.subject) && (typeof e.summary > "u" || typeof e.summary == "string") && (typeof e._summary > "u" || r(e._summary)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => y(t)
  ));
}
function Pb(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && Array.isArray(e.operator) && e.operator.every(
    (t) => t === "exists" || t === "in" || t === "=" || t === "is-a" || t === "descendent-of" || t === "is-not-a" || t === "regex" || t === "not-in" || t === "generalizes"
  ) && (typeof e._operator > "u" || Array.isArray(e._operator) && e._operator.every(
    (t) => r(t)
  )) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Ob(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (e.type === "string" || e.type === "boolean" || e.type === "code" || e.type === "Coding" || e.type === "integer" || e.type === "dateTime" || e.type === "decimal") && (typeof e._type > "u" || r(e._type)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || r(e._uri));
}
function qb(n) {
  const e = n;
  return p(e) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language)) && (typeof e.use > "u" || V(e.use)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Bb(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number");
}
function Wc(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => Wc(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => qb(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Bb(t)
  ));
}
function ba(n) {
  const e = n;
  return b(e) && e.resourceType === "CodeSystem" && (typeof e.caseSensitive > "u" || e.caseSensitive === !1 || e.caseSensitive === !0) && (typeof e._caseSensitive > "u" || r(e._caseSensitive)) && (typeof e.compositional > "u" || e.compositional === !1 || e.compositional === !0) && (typeof e._compositional > "u" || r(e._compositional)) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => Wc(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (e.content === "example" || e.content === "complete" || e.content === "not-present" || e.content === "fragment" || e.content === "supplement") && (typeof e._content > "u" || r(e._content)) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => Pb(t)
  )) && (typeof e.hierarchyMeaning > "u" || e.hierarchyMeaning === "is-a" || e.hierarchyMeaning === "grouped-by" || e.hierarchyMeaning === "part-of" || e.hierarchyMeaning === "classified-with") && (typeof e._hierarchyMeaning > "u" || r(e._hierarchyMeaning)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => Ob(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.supplements > "u" || typeof e.supplements == "string") && (typeof e._supplements > "u" || r(e._supplements)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.valueSet > "u" || typeof e.valueSet == "string") && (typeof e._valueSet > "u" || r(e._valueSet)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version)) && (typeof e.versionNeeded > "u" || e.versionNeeded === !1 || e.versionNeeded === !0) && (typeof e._versionNeeded > "u" || r(e._versionNeeded));
}
function Ub(n) {
  const e = n;
  return p(e) && (typeof e.contentString > "u" || typeof e.contentString == "string") && (typeof e._contentString > "u" || r(e._contentString)) && (typeof e.contentAttachment > "u" || te(e.contentAttachment)) && (typeof e.contentReference > "u" || y(e.contentReference));
}
function Ca(n) {
  const e = n;
  return b(e) && e.resourceType === "Communication" && (typeof e.about > "u" || Array.isArray(e.about) && e.about.every(
    (t) => y(t)
  )) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.inResponseTo > "u" || Array.isArray(e.inResponseTo) && e.inResponseTo.every(
    (t) => y(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.medium > "u" || Array.isArray(e.medium) && e.medium.every(
    (t) => u(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.payload > "u" || Array.isArray(e.payload) && e.payload.every(
    (t) => Ub(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.received > "u" || typeof e.received == "string") && (typeof e._received > "u" || r(e._received)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => y(t)
  )) && (typeof e.sender > "u" || y(e.sender)) && (typeof e.sent > "u" || typeof e.sent == "string") && (typeof e._sent > "u" || r(e._sent)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.topic > "u" || u(e.topic));
}
function Mb(n) {
  const e = n;
  return p(e) && (typeof e.contentString > "u" || typeof e.contentString == "string") && (typeof e._contentString > "u" || r(e._contentString)) && (typeof e.contentAttachment > "u" || te(e.contentAttachment)) && (typeof e.contentReference > "u" || y(e.contentReference));
}
function xa(n) {
  const e = n;
  return b(e) && e.resourceType === "CommunicationRequest" && (typeof e.about > "u" || Array.isArray(e.about) && e.about.every(
    (t) => y(t)
  )) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.groupIdentifier > "u" || A(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.medium > "u" || Array.isArray(e.medium) && e.medium.every(
    (t) => u(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.payload > "u" || Array.isArray(e.payload) && e.payload.every(
    (t) => Mb(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => y(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || y(e.requester)) && (typeof e.sender > "u" || y(e.sender)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && (typeof e.subject > "u" || y(e.subject));
}
function Eb(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.param > "u" || Array.isArray(e.param) && e.param.every(
    (t) => typeof t == "string"
  )) && (typeof e._param > "u" || Array.isArray(e._param) && e._param.every(
    (t) => r(t)
  ));
}
function Da(n) {
  const e = n;
  return b(e) && e.resourceType === "CompartmentDefinition" && (e.code === "Patient" || e.code === "Encounter" || e.code === "RelatedPerson" || e.code === "Practitioner" || e.code === "Device") && (typeof e._code > "u" || r(e._code)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => Eb(t)
  )) && typeof e.search == "boolean" && (typeof e._search > "u" || r(e._search)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function kb(n) {
  const e = n;
  return p(e) && (e.mode === "official" || e.mode === "personal" || e.mode === "professional" || e.mode === "legal") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.party > "u" || y(e.party)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || r(e._time));
}
function Vb(n) {
  const e = n;
  return p(e) && (e.code === "replaces" || e.code === "transforms" || e.code === "signs" || e.code === "appends") && (typeof e._code > "u" || r(e._code)) && (typeof e.targetIdentifier > "u" || A(e.targetIdentifier)) && (typeof e.targetReference > "u" || y(e.targetReference));
}
function Nb(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => y(t)
  )) && (typeof e.period > "u" || D(e.period));
}
function Hc(n) {
  const e = n;
  return p(e) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => y(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.emptyReason > "u" || u(e.emptyReason)) && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => y(t)
  )) && (typeof e.focus > "u" || y(e.focus)) && (typeof e.mode > "u" || e.mode === "working" || e.mode === "snapshot" || e.mode === "changes") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.orderedBy > "u" || u(e.orderedBy)) && (typeof e.section > "u" || Array.isArray(e.section) && e.section.every(
    (t) => Hc(t)
  )) && (typeof e.text > "u" || Vc(e.text)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title));
}
function Ta(n) {
  const e = n;
  return b(e) && e.resourceType === "Composition" && (typeof e.attester > "u" || Array.isArray(e.attester) && e.attester.every(
    (t) => kb(t)
  )) && Array.isArray(e.author) && e.author.every(
    (t) => y(t)
  ) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.confidentiality > "u" || typeof e.confidentiality == "string") && (typeof e._confidentiality > "u" || r(e._confidentiality)) && (typeof e.custodian > "u" || y(e.custodian)) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => Nb(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.relatesTo > "u" || Array.isArray(e.relatesTo) && e.relatesTo.every(
    (t) => Vb(t)
  )) && (typeof e.section > "u" || Array.isArray(e.section) && e.section.every(
    (t) => Hc(t)
  )) && (e.status === "entered-in-error" || e.status === "preliminary" || e.status === "final" || e.status === "amended") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && typeof e.title == "string" && (typeof e._title > "u" || r(e._title)) && u(e.type);
}
function Ic(n) {
  const e = n;
  return p(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && typeof e.property == "string" && (typeof e._property > "u" || r(e._property)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Lb(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.dependsOn > "u" || Array.isArray(e.dependsOn) && e.dependsOn.every(
    (t) => Ic(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (e.equivalence === "relatedto" || e.equivalence === "equivalent" || e.equivalence === "equal" || e.equivalence === "wider" || e.equivalence === "subsumes" || e.equivalence === "narrower" || e.equivalence === "specializes" || e.equivalence === "inexact" || e.equivalence === "unmatched" || e.equivalence === "disjoint") && (typeof e._equivalence > "u" || r(e._equivalence)) && (typeof e.product > "u" || Array.isArray(e.product) && e.product.every(
    (t) => Ic(t)
  ));
}
function Fb(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => Lb(t)
  ));
}
function $b(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (e.mode === "provided" || e.mode === "fixed" || e.mode === "other-map") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function jb(n) {
  const e = n;
  return p(e) && Array.isArray(e.element) && e.element.every(
    (t) => Fb(t)
  ) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || r(e._source)) && (typeof e.sourceVersion > "u" || typeof e.sourceVersion == "string") && (typeof e._sourceVersion > "u" || r(e._sourceVersion)) && (typeof e.target > "u" || typeof e.target == "string") && (typeof e._target > "u" || r(e._target)) && (typeof e.targetVersion > "u" || typeof e.targetVersion == "string") && (typeof e._targetVersion > "u" || r(e._targetVersion)) && (typeof e.unmapped > "u" || $b(e.unmapped));
}
function Sa(n) {
  const e = n;
  return b(e) && e.resourceType === "ConceptMap" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => jb(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.sourceUri > "u" || typeof e.sourceUri == "string") && (typeof e._sourceUri > "u" || r(e._sourceUri)) && (typeof e.sourceCanonical > "u" || typeof e.sourceCanonical == "string") && (typeof e._sourceCanonical > "u" || r(e._sourceCanonical)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.targetUri > "u" || typeof e.targetUri == "string") && (typeof e._targetUri > "u" || r(e._targetUri)) && (typeof e.targetCanonical > "u" || typeof e.targetCanonical == "string") && (typeof e._targetCanonical > "u" || r(e._targetCanonical)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Wb(n) {
  const e = n;
  return p(e) && (typeof e.assessment > "u" || Array.isArray(e.assessment) && e.assessment.every(
    (t) => y(t)
  )) && (typeof e.summary > "u" || u(e.summary)) && (typeof e.type > "u" || u(e.type));
}
function Hb(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => y(t)
  ));
}
function Ra(n) {
  const e = n;
  return b(e) && e.resourceType === "Condition" && (typeof e.abatementDateTime > "u" || typeof e.abatementDateTime == "string") && (typeof e._abatementDateTime > "u" || r(e._abatementDateTime)) && (typeof e.abatementAge > "u" || Le(e.abatementAge)) && (typeof e.abatementPeriod > "u" || D(e.abatementPeriod)) && (typeof e.abatementRange > "u" || K(e.abatementRange)) && (typeof e.abatementString > "u" || typeof e.abatementString == "string") && (typeof e._abatementString > "u" || r(e._abatementString)) && (typeof e.asserter > "u" || y(e.asserter)) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => u(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.clinicalStatus > "u" || u(e.clinicalStatus)) && (typeof e.code > "u" || u(e.code)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.evidence > "u" || Array.isArray(e.evidence) && e.evidence.every(
    (t) => Hb(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.onsetDateTime > "u" || typeof e.onsetDateTime == "string") && (typeof e._onsetDateTime > "u" || r(e._onsetDateTime)) && (typeof e.onsetAge > "u" || Le(e.onsetAge)) && (typeof e.onsetPeriod > "u" || D(e.onsetPeriod)) && (typeof e.onsetRange > "u" || K(e.onsetRange)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || r(e._onsetString)) && (typeof e.recordedDate > "u" || typeof e.recordedDate == "string") && (typeof e._recordedDate > "u" || r(e._recordedDate)) && (typeof e.recorder > "u" || y(e.recorder)) && (typeof e.severity > "u" || u(e.severity)) && (typeof e.stage > "u" || Array.isArray(e.stage) && e.stage.every(
    (t) => Wb(t)
  )) && y(e.subject) && (typeof e.verificationStatus > "u" || u(e.verificationStatus));
}
function Qb(n) {
  const e = n;
  return p(e) && (typeof e.authority > "u" || typeof e.authority == "string") && (typeof e._authority > "u" || r(e._authority)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || r(e._uri));
}
function zb(n) {
  const e = n;
  return p(e) && (typeof e.verificationDate > "u" || typeof e.verificationDate == "string") && (typeof e._verificationDate > "u" || r(e._verificationDate)) && typeof e.verified == "boolean" && (typeof e._verified > "u" || r(e._verified)) && (typeof e.verifiedWith > "u" || y(e.verifiedWith));
}
function Gb(n) {
  const e = n;
  return p(e) && y(e.reference) && u(e.role);
}
function Kb(n) {
  const e = n;
  return p(e) && (e.meaning === "instance" || e.meaning === "related" || e.meaning === "dependents" || e.meaning === "authoredby") && (typeof e._meaning > "u" || r(e._meaning)) && y(e.reference);
}
function Qc(n) {
  const e = n;
  return p(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => u(t)
  )) && (typeof e.actor > "u" || Array.isArray(e.actor) && e.actor.every(
    (t) => Gb(t)
  )) && (typeof e.class > "u" || Array.isArray(e.class) && e.class.every(
    (t) => V(t)
  )) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.data > "u" || Array.isArray(e.data) && e.data.every(
    (t) => Kb(t)
  )) && (typeof e.dataPeriod > "u" || D(e.dataPeriod)) && (typeof e.period > "u" || D(e.period)) && (typeof e.provision > "u" || Array.isArray(e.provision) && e.provision.every(
    (t) => Qc(t)
  )) && (typeof e.purpose > "u" || Array.isArray(e.purpose) && e.purpose.every(
    (t) => V(t)
  )) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => V(t)
  )) && (typeof e.type > "u" || e.type === "deny" || e.type === "permit") && (typeof e._type > "u" || r(e._type));
}
function wa(n) {
  const e = n;
  return b(e) && e.resourceType === "Consent" && Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  ) && (typeof e.dateTime > "u" || typeof e.dateTime == "string") && (typeof e._dateTime > "u" || r(e._dateTime)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.organization > "u" || Array.isArray(e.organization) && e.organization.every(
    (t) => y(t)
  )) && (typeof e.patient > "u" || y(e.patient)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => y(t)
  )) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => Qb(t)
  )) && (typeof e.policyRule > "u" || u(e.policyRule)) && (typeof e.provision > "u" || Qc(e.provision)) && u(e.scope) && (typeof e.sourceAttachment > "u" || te(e.sourceAttachment)) && (typeof e.sourceReference > "u" || y(e.sourceReference)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "draft" || e.status === "proposed" || e.status === "rejected") && (typeof e._status > "u" || r(e._status)) && (typeof e.verification > "u" || Array.isArray(e.verification) && e.verification.every(
    (t) => zb(t)
  ));
}
function Yb(n) {
  const e = n;
  return p(e) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.publicationDate > "u" || typeof e.publicationDate == "string") && (typeof e._publicationDate > "u" || r(e._publicationDate)) && (e.publicationStatus === "entered-in-error" || e.publicationStatus === "cancelled" || e.publicationStatus === "revoked" || e.publicationStatus === "amended" || e.publicationStatus === "rejected" || e.publicationStatus === "appended" || e.publicationStatus === "disputed" || e.publicationStatus === "executable" || e.publicationStatus === "executed" || e.publicationStatus === "negotiable" || e.publicationStatus === "offered" || e.publicationStatus === "policy" || e.publicationStatus === "renewed" || e.publicationStatus === "resolved" || e.publicationStatus === "terminated") && (typeof e._publicationStatus > "u" || r(e._publicationStatus)) && (typeof e.publisher > "u" || y(e.publisher)) && (typeof e.subType > "u" || u(e.subType)) && u(e.type);
}
function Jb(n) {
  const e = n;
  return p(e) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => V(t)
  )) && V(e.classification) && (typeof e.control > "u" || Array.isArray(e.control) && e.control.every(
    (t) => V(t)
  )) && (typeof e.number > "u" || Array.isArray(e.number) && e.number.every(
    (t) => typeof t == "number"
  ));
}
function Zb(n) {
  const e = n;
  return p(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => y(t)
  ) && u(e.role);
}
function zc(n) {
  const e = n;
  return p(e) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function Xb(n) {
  const e = n;
  return p(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => zc(t)
  )) && (typeof e.decision > "u" || u(e.decision)) && (typeof e.decisionMode > "u" || Array.isArray(e.decisionMode) && e.decisionMode.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => r(t)
  )) && (typeof e.party > "u" || Array.isArray(e.party) && e.party.every(
    (t) => Zb(t)
  )) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.topic > "u" || y(e.topic)) && (typeof e.type > "u" || u(e.type));
}
function eC(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.reference > "u" || y(e.reference)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text));
}
function tC(n) {
  const e = n;
  return p(e) && (typeof e.effectiveTime > "u" || typeof e.effectiveTime == "string") && (typeof e._effectiveTime > "u" || r(e._effectiveTime)) && (typeof e.entityCodeableConcept > "u" || u(e.entityCodeableConcept)) && (typeof e.entityReference > "u" || y(e.entityReference)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => r(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.payment > "u" || typeof e.payment == "string") && (typeof e._payment > "u" || r(e._payment)) && (typeof e.paymentDate > "u" || typeof e.paymentDate == "string") && (typeof e._paymentDate > "u" || r(e._paymentDate)) && (typeof e.points > "u" || typeof e.points == "number") && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.recipient > "u" || y(e.recipient)) && (typeof e.responsible > "u" || y(e.responsible)) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function rC(n) {
  const e = n;
  return p(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => zc(t)
  )) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || r(e._condition)) && (typeof e.context > "u" || Array.isArray(e.context) && e.context.every(
    (t) => eC(t)
  )) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => r(t)
  )) && (typeof e.period > "u" || Array.isArray(e.period) && e.period.every(
    (t) => D(t)
  )) && (typeof e.periodType > "u" || Array.isArray(e.periodType) && e.periodType.every(
    (t) => u(t)
  )) && (typeof e.relationship > "u" || V(e.relationship)) && (typeof e.scope > "u" || u(e.scope)) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => u(t)
  )) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  )) && (typeof e.typeReference > "u" || Array.isArray(e.typeReference) && e.typeReference.every(
    (t) => y(t)
  )) && (typeof e.usePeriod > "u" || Array.isArray(e.usePeriod) && e.usePeriod.every(
    (t) => D(t)
  )) && (typeof e.valuedItem > "u" || Array.isArray(e.valuedItem) && e.valuedItem.every(
    (t) => tC(t)
  ));
}
function oC(n) {
  const e = n;
  return p(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => y(t)
  ) && (typeof e.role > "u" || u(e.role));
}
function iC(n) {
  const e = n;
  return p(e) && (typeof e.context > "u" || y(e.context)) && (typeof e.contextLinkId > "u" || Array.isArray(e.contextLinkId) && e.contextLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._contextLinkId > "u" || Array.isArray(e._contextLinkId) && e._contextLinkId.every(
    (t) => r(t)
  )) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && u(e.intent) && (typeof e.linkId > "u" || Array.isArray(e.linkId) && e.linkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._linkId > "u" || Array.isArray(e._linkId) && e._linkId.every(
    (t) => r(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.performerLinkId > "u" || Array.isArray(e.performerLinkId) && e.performerLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._performerLinkId > "u" || Array.isArray(e._performerLinkId) && e._performerLinkId.every(
    (t) => r(t)
  )) && (typeof e.performerRole > "u" || u(e.performerRole)) && (typeof e.performerType > "u" || Array.isArray(e.performerType) && e.performerType.every(
    (t) => u(t)
  )) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => typeof t == "string"
  )) && (typeof e._reason > "u" || Array.isArray(e._reason) && e._reason.every(
    (t) => r(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonLinkId > "u" || Array.isArray(e.reasonLinkId) && e.reasonLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._reasonLinkId > "u" || Array.isArray(e._reasonLinkId) && e._reasonLinkId.every(
    (t) => r(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || Array.isArray(e.requester) && e.requester.every(
    (t) => y(t)
  )) && (typeof e.requesterLinkId > "u" || Array.isArray(e.requesterLinkId) && e.requesterLinkId.every(
    (t) => typeof t == "string"
  )) && (typeof e._requesterLinkId > "u" || Array.isArray(e._requesterLinkId) && e._requesterLinkId.every(
    (t) => r(t)
  )) && (typeof e.securityLabelNumber > "u" || Array.isArray(e.securityLabelNumber) && e.securityLabelNumber.every(
    (t) => typeof t == "number"
  )) && u(e.status) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => oC(t)
  )) && u(e.type);
}
function Gc(n) {
  const e = n;
  return p(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => iC(t)
  )) && (typeof e.applies > "u" || D(e.applies)) && (typeof e.asset > "u" || Array.isArray(e.asset) && e.asset.every(
    (t) => rC(t)
  )) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => Gc(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && Xb(e.offer) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => Jb(t)
  )) && (typeof e.subType > "u" || u(e.subType)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.topicCodeableConcept > "u" || u(e.topicCodeableConcept)) && (typeof e.topicReference > "u" || y(e.topicReference)) && (typeof e.type > "u" || u(e.type));
}
function nC(n) {
  const e = n;
  return p(e) && y(e.party) && Array.isArray(e.signature) && e.signature.every(
    (t) => ut(t)
  ) && V(e.type);
}
function aC(n) {
  const e = n;
  return p(e) && (typeof e.contentAttachment > "u" || te(e.contentAttachment)) && (typeof e.contentReference > "u" || y(e.contentReference));
}
function uC(n) {
  const e = n;
  return p(e) && (typeof e.contentAttachment > "u" || te(e.contentAttachment)) && (typeof e.contentReference > "u" || y(e.contentReference));
}
function yC(n) {
  const e = n;
  return p(e) && (typeof e.contentAttachment > "u" || te(e.contentAttachment)) && (typeof e.contentReference > "u" || y(e.contentReference));
}
function Ia(n) {
  const e = n;
  return b(e) && e.resourceType === "Contract" && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => r(t)
  )) && (typeof e.applies > "u" || D(e.applies)) && (typeof e.author > "u" || y(e.author)) && (typeof e.authority > "u" || Array.isArray(e.authority) && e.authority.every(
    (t) => y(t)
  )) && (typeof e.contentDefinition > "u" || Yb(e.contentDefinition)) && (typeof e.contentDerivative > "u" || u(e.contentDerivative)) && (typeof e.domain > "u" || Array.isArray(e.domain) && e.domain.every(
    (t) => y(t)
  )) && (typeof e.expirationType > "u" || u(e.expirationType)) && (typeof e.friendly > "u" || Array.isArray(e.friendly) && e.friendly.every(
    (t) => aC(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || y(e.instantiatesCanonical)) && (typeof e.instantiatesUri > "u" || typeof e.instantiatesUri == "string") && (typeof e._instantiatesUri > "u" || r(e._instantiatesUri)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && (typeof e.legal > "u" || Array.isArray(e.legal) && e.legal.every(
    (t) => uC(t)
  )) && (typeof e.legallyBindingAttachment > "u" || te(e.legallyBindingAttachment)) && (typeof e.legallyBindingReference > "u" || y(e.legallyBindingReference)) && (typeof e.legalState > "u" || u(e.legalState)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => y(t)
  )) && (typeof e.rule > "u" || Array.isArray(e.rule) && e.rule.every(
    (t) => yC(t)
  )) && (typeof e.scope > "u" || u(e.scope)) && (typeof e.signer > "u" || Array.isArray(e.signer) && e.signer.every(
    (t) => nC(t)
  )) && (typeof e.site > "u" || Array.isArray(e.site) && e.site.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "revoked" || e.status === "amended" || e.status === "rejected" || e.status === "appended" || e.status === "disputed" || e.status === "executable" || e.status === "executed" || e.status === "negotiable" || e.status === "offered" || e.status === "policy" || e.status === "renewed" || e.status === "resolved" || e.status === "terminated") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.subType > "u" || Array.isArray(e.subType) && e.subType.every(
    (t) => u(t)
  )) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => y(t)
  )) && (typeof e.term > "u" || Array.isArray(e.term) && e.term.every(
    (t) => Gc(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topicCodeableConcept > "u" || u(e.topicCodeableConcept)) && (typeof e.topicReference > "u" || y(e.topicReference)) && (typeof e.type > "u" || u(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function sC(n) {
  const e = n;
  return p(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && u(e.type) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function pC(n) {
  const e = n;
  return p(e) && (typeof e.period > "u" || D(e.period)) && u(e.type);
}
function fC(n) {
  const e = n;
  return p(e) && (typeof e.exception > "u" || Array.isArray(e.exception) && e.exception.every(
    (t) => pC(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueMoney > "u" || L(e.valueMoney));
}
function Pa(n) {
  const e = n;
  return b(e) && e.resourceType === "Coverage" && y(e.beneficiary) && (typeof e.class > "u" || Array.isArray(e.class) && e.class.every(
    (t) => sC(t)
  )) && (typeof e.contract > "u" || Array.isArray(e.contract) && e.contract.every(
    (t) => y(t)
  )) && (typeof e.costToBeneficiary > "u" || Array.isArray(e.costToBeneficiary) && e.costToBeneficiary.every(
    (t) => fC(t)
  )) && (typeof e.dependent > "u" || typeof e.dependent == "string") && (typeof e._dependent > "u" || r(e._dependent)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.network > "u" || typeof e.network == "string") && (typeof e._network > "u" || r(e._network)) && (typeof e.order > "u" || typeof e.order == "number") && Array.isArray(e.payor) && e.payor.every(
    (t) => y(t)
  ) && (typeof e.period > "u" || D(e.period)) && (typeof e.policyHolder > "u" || y(e.policyHolder)) && (typeof e.relationship > "u" || u(e.relationship)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status)) && (typeof e.subrogation > "u" || e.subrogation === !1 || e.subrogation === !0) && (typeof e._subrogation > "u" || r(e._subrogation)) && (typeof e.subscriber > "u" || y(e.subscriber)) && (typeof e.subscriberId > "u" || typeof e.subscriberId == "string") && (typeof e._subscriberId > "u" || r(e._subscriberId)) && (typeof e.type > "u" || u(e.type));
}
function cC(n) {
  const e = n;
  return p(e) && (typeof e.appliesToAll > "u" || e.appliesToAll === !1 || e.appliesToAll === !0) && (typeof e._appliesToAll > "u" || r(e._appliesToAll)) && y(e.information) && typeof e.sequence == "number";
}
function lC(n) {
  const e = n;
  return p(e) && (typeof e.businessArrangement > "u" || typeof e.businessArrangement == "string") && (typeof e._businessArrangement > "u" || r(e._businessArrangement)) && y(e.coverage) && (typeof e.focal > "u" || e.focal === !1 || e.focal === !0) && (typeof e._focal > "u" || r(e._focal));
}
function dC(n) {
  const e = n;
  return p(e) && (typeof e.diagnosisCodeableConcept > "u" || u(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || y(e.diagnosisReference));
}
function gC(n) {
  const e = n;
  return p(e) && (typeof e.category > "u" || u(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => y(t)
  )) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => dC(t)
  )) && (typeof e.facility > "u" || y(e.facility)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.productOrService > "u" || u(e.productOrService)) && (typeof e.provider > "u" || y(e.provider)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.supportingInfoSequence > "u" || Array.isArray(e.supportingInfoSequence) && e.supportingInfoSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function Oa(n) {
  const e = n;
  return b(e) && e.resourceType === "CoverageEligibilityRequest" && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.enterer > "u" || y(e.enterer)) && (typeof e.facility > "u" || y(e.facility)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => lC(t)
  )) && y(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => gC(t)
  )) && y(e.patient) && (typeof e.priority > "u" || u(e.priority)) && (typeof e.provider > "u" || y(e.provider)) && Array.isArray(e.purpose) && e.purpose.every(
    (t) => t === "auth-requirements" || t === "benefits" || t === "discovery" || t === "validation"
  ) && (typeof e._purpose > "u" || Array.isArray(e._purpose) && e._purpose.every(
    (t) => r(t)
  )) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => cC(t)
  ));
}
function mC(n) {
  const e = n;
  return p(e) && (typeof e.allowedUnsignedInt > "u" || typeof e.allowedUnsignedInt == "number") && (typeof e.allowedString > "u" || typeof e.allowedString == "string") && (typeof e._allowedString > "u" || r(e._allowedString)) && (typeof e.allowedMoney > "u" || L(e.allowedMoney)) && u(e.type) && (typeof e.usedUnsignedInt > "u" || typeof e.usedUnsignedInt == "number") && (typeof e.usedString > "u" || typeof e.usedString == "string") && (typeof e._usedString > "u" || r(e._usedString)) && (typeof e.usedMoney > "u" || L(e.usedMoney));
}
function _C(n) {
  const e = n;
  return p(e) && (typeof e.authorizationRequired > "u" || e.authorizationRequired === !1 || e.authorizationRequired === !0) && (typeof e._authorizationRequired > "u" || r(e._authorizationRequired)) && (typeof e.authorizationSupporting > "u" || Array.isArray(e.authorizationSupporting) && e.authorizationSupporting.every(
    (t) => u(t)
  )) && (typeof e.authorizationUrl > "u" || typeof e.authorizationUrl == "string") && (typeof e._authorizationUrl > "u" || r(e._authorizationUrl)) && (typeof e.benefit > "u" || Array.isArray(e.benefit) && e.benefit.every(
    (t) => mC(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.excluded > "u" || e.excluded === !1 || e.excluded === !0) && (typeof e._excluded > "u" || r(e._excluded)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.network > "u" || u(e.network)) && (typeof e.productOrService > "u" || u(e.productOrService)) && (typeof e.provider > "u" || y(e.provider)) && (typeof e.term > "u" || u(e.term)) && (typeof e.unit > "u" || u(e.unit));
}
function vC(n) {
  const e = n;
  return p(e) && (typeof e.benefitPeriod > "u" || D(e.benefitPeriod)) && y(e.coverage) && (typeof e.inforce > "u" || e.inforce === !1 || e.inforce === !0) && (typeof e._inforce > "u" || r(e._inforce)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => _C(t)
  ));
}
function AC(n) {
  const e = n;
  return p(e) && u(e.code);
}
function qa(n) {
  const e = n;
  return b(e) && e.resourceType === "CoverageEligibilityResponse" && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || r(e._disposition)) && (typeof e.error > "u" || Array.isArray(e.error) && e.error.every(
    (t) => AC(t)
  )) && (typeof e.form > "u" || u(e.form)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => vC(t)
  )) && y(e.insurer) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || r(e._outcome)) && y(e.patient) && (typeof e.preAuthRef > "u" || typeof e.preAuthRef == "string") && (typeof e._preAuthRef > "u" || r(e._preAuthRef)) && Array.isArray(e.purpose) && e.purpose.every(
    (t) => t === "auth-requirements" || t === "benefits" || t === "discovery" || t === "validation"
  ) && (typeof e._purpose > "u" || Array.isArray(e._purpose) && e._purpose.every(
    (t) => r(t)
  )) && y(e.request) && (typeof e.requestor > "u" || y(e.requestor)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function hC(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => y(t)
  ));
}
function bC(n) {
  const e = n;
  return p(e) && u(e.action) && (typeof e.author > "u" || y(e.author)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date));
}
function Ba(n) {
  const e = n;
  return b(e) && e.resourceType === "DetectedIssue" && (typeof e.author > "u" || y(e.author)) && (typeof e.code > "u" || u(e.code)) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || r(e._detail)) && (typeof e.evidence > "u" || Array.isArray(e.evidence) && e.evidence.every(
    (t) => hC(t)
  )) && (typeof e.identifiedDateTime > "u" || typeof e.identifiedDateTime == "string") && (typeof e._identifiedDateTime > "u" || r(e._identifiedDateTime)) && (typeof e.identifiedPeriod > "u" || D(e.identifiedPeriod)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.implicated > "u" || Array.isArray(e.implicated) && e.implicated.every(
    (t) => y(t)
  )) && (typeof e.mitigation > "u" || Array.isArray(e.mitigation) && e.mitigation.every(
    (t) => bC(t)
  )) && (typeof e.patient > "u" || y(e.patient)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || r(e._reference)) && (typeof e.severity > "u" || e.severity === "moderate" || e.severity === "low" || e.severity === "high") && (typeof e._severity > "u" || r(e._severity)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || r(e._status));
}
function CC(n) {
  const e = n;
  return p(e) && (typeof e.carrierAIDC > "u" || typeof e.carrierAIDC == "string") && (typeof e._carrierAIDC > "u" || r(e._carrierAIDC)) && (typeof e.carrierHRF > "u" || typeof e.carrierHRF == "string") && (typeof e._carrierHRF > "u" || r(e._carrierHRF)) && (typeof e.deviceIdentifier > "u" || typeof e.deviceIdentifier == "string") && (typeof e._deviceIdentifier > "u" || r(e._deviceIdentifier)) && (typeof e.entryType > "u" || e.entryType === "unknown" || e.entryType === "barcode" || e.entryType === "rfid" || e.entryType === "manual" || e.entryType === "card" || e.entryType === "self-reported") && (typeof e._entryType > "u" || r(e._entryType)) && (typeof e.issuer > "u" || typeof e.issuer == "string") && (typeof e._issuer > "u" || r(e._issuer)) && (typeof e.jurisdiction > "u" || typeof e.jurisdiction == "string") && (typeof e._jurisdiction > "u" || r(e._jurisdiction));
}
function xC(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (e.type === "other" || e.type === "udi-label-name" || e.type === "user-friendly-name" || e.type === "patient-reported-name" || e.type === "manufacturer-name" || e.type === "model-name") && (typeof e._type > "u" || r(e._type));
}
function DC(n) {
  const e = n;
  return p(e) && u(e.systemType) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function TC(n) {
  const e = n;
  return p(e) && (typeof e.component > "u" || A(e.component)) && (typeof e.type > "u" || u(e.type)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function SC(n) {
  const e = n;
  return p(e) && u(e.type) && (typeof e.valueCode > "u" || Array.isArray(e.valueCode) && e.valueCode.every(
    (t) => u(t)
  )) && (typeof e.valueQuantity > "u" || Array.isArray(e.valueQuantity) && e.valueQuantity.every(
    (t) => S(t)
  ));
}
function Ua(n) {
  const e = n;
  return b(e) && e.resourceType === "Device" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => he(t)
  )) && (typeof e.definition > "u" || y(e.definition)) && (typeof e.deviceName > "u" || Array.isArray(e.deviceName) && e.deviceName.every(
    (t) => xC(t)
  )) && (typeof e.distinctIdentifier > "u" || typeof e.distinctIdentifier == "string") && (typeof e._distinctIdentifier > "u" || r(e._distinctIdentifier)) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || r(e._expirationDate)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || r(e._lotNumber)) && (typeof e.manufactureDate > "u" || typeof e.manufactureDate == "string") && (typeof e._manufactureDate > "u" || r(e._manufactureDate)) && (typeof e.manufacturer > "u" || typeof e.manufacturer == "string") && (typeof e._manufacturer > "u" || r(e._manufacturer)) && (typeof e.modelNumber > "u" || typeof e.modelNumber == "string") && (typeof e._modelNumber > "u" || r(e._modelNumber)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.owner > "u" || y(e.owner)) && (typeof e.parent > "u" || y(e.parent)) && (typeof e.partNumber > "u" || typeof e.partNumber == "string") && (typeof e._partNumber > "u" || r(e._partNumber)) && (typeof e.patient > "u" || y(e.patient)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => SC(t)
  )) && (typeof e.safety > "u" || Array.isArray(e.safety) && e.safety.every(
    (t) => u(t)
  )) && (typeof e.serialNumber > "u" || typeof e.serialNumber == "string") && (typeof e._serialNumber > "u" || r(e._serialNumber)) && (typeof e.specialization > "u" || Array.isArray(e.specialization) && e.specialization.every(
    (t) => DC(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error" || e.status === "unknown") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.udiCarrier > "u" || Array.isArray(e.udiCarrier) && e.udiCarrier.every(
    (t) => CC(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => TC(t)
  ));
}
function RC(n) {
  const e = n;
  return p(e) && typeof e.deviceIdentifier == "string" && (typeof e._deviceIdentifier > "u" || r(e._deviceIdentifier)) && typeof e.issuer == "string" && (typeof e._issuer > "u" || r(e._issuer)) && typeof e.jurisdiction == "string" && (typeof e._jurisdiction > "u" || r(e._jurisdiction));
}
function wC(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (e.type === "other" || e.type === "udi-label-name" || e.type === "user-friendly-name" || e.type === "patient-reported-name" || e.type === "manufacturer-name" || e.type === "model-name") && (typeof e._type > "u" || r(e._type));
}
function IC(n) {
  const e = n;
  return p(e) && typeof e.systemType == "string" && (typeof e._systemType > "u" || r(e._systemType)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function PC(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || Array.isArray(e.description) && e.description.every(
    (t) => u(t)
  )) && u(e.type);
}
function OC(n) {
  const e = n;
  return p(e) && u(e.type) && (typeof e.valueCode > "u" || Array.isArray(e.valueCode) && e.valueCode.every(
    (t) => u(t)
  )) && (typeof e.valueQuantity > "u" || Array.isArray(e.valueQuantity) && e.valueQuantity.every(
    (t) => S(t)
  ));
}
function qC(n) {
  const e = n;
  return p(e) && (typeof e.allergenicIndicator > "u" || e.allergenicIndicator === !1 || e.allergenicIndicator === !0) && (typeof e._allergenicIndicator > "u" || r(e._allergenicIndicator)) && (typeof e.alternate > "u" || e.alternate === !1 || e.alternate === !0) && (typeof e._alternate > "u" || r(e._alternate)) && u(e.substance);
}
function Ma(n) {
  const e = n;
  return b(e) && e.resourceType === "DeviceDefinition" && (typeof e.capability > "u" || Array.isArray(e.capability) && e.capability.every(
    (t) => PC(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => he(t)
  )) && (typeof e.deviceName > "u" || Array.isArray(e.deviceName) && e.deviceName.every(
    (t) => wC(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.languageCode > "u" || Array.isArray(e.languageCode) && e.languageCode.every(
    (t) => u(t)
  )) && (typeof e.manufacturerString > "u" || typeof e.manufacturerString == "string") && (typeof e._manufacturerString > "u" || r(e._manufacturerString)) && (typeof e.manufacturerReference > "u" || y(e.manufacturerReference)) && (typeof e.material > "u" || Array.isArray(e.material) && e.material.every(
    (t) => qC(t)
  )) && (typeof e.modelNumber > "u" || typeof e.modelNumber == "string") && (typeof e._modelNumber > "u" || r(e._modelNumber)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.onlineInformation > "u" || typeof e.onlineInformation == "string") && (typeof e._onlineInformation > "u" || r(e._onlineInformation)) && (typeof e.owner > "u" || y(e.owner)) && (typeof e.parentDevice > "u" || y(e.parentDevice)) && (typeof e.physicalCharacteristics > "u" || bp(e.physicalCharacteristics)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => OC(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.safety > "u" || Array.isArray(e.safety) && e.safety.every(
    (t) => u(t)
  )) && (typeof e.shelfLifeStorage > "u" || Array.isArray(e.shelfLifeStorage) && e.shelfLifeStorage.every(
    (t) => Nc(t)
  )) && (typeof e.specialization > "u" || Array.isArray(e.specialization) && e.specialization.every(
    (t) => IC(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.udiDeviceIdentifier > "u" || Array.isArray(e.udiDeviceIdentifier) && e.udiDeviceIdentifier.every(
    (t) => RC(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => typeof t == "string"
  )) && (typeof e._version > "u" || Array.isArray(e._version) && e._version.every(
    (t) => r(t)
  ));
}
function BC(n) {
  const e = n;
  return p(e) && (typeof e.state > "u" || e.state === "not-calibrated" || e.state === "calibration-required" || e.state === "calibrated" || e.state === "unspecified") && (typeof e._state > "u" || r(e._state)) && (typeof e.time > "u" || typeof e.time == "string") && (typeof e._time > "u" || r(e._time)) && (typeof e.type > "u" || e.type === "unspecified" || e.type === "offset" || e.type === "gain" || e.type === "two-point") && (typeof e._type > "u" || r(e._type));
}
function Ea(n) {
  const e = n;
  return b(e) && e.resourceType === "DeviceMetric" && (typeof e.calibration > "u" || Array.isArray(e.calibration) && e.calibration.every(
    (t) => BC(t)
  )) && (e.category === "unspecified" || e.category === "measurement" || e.category === "setting" || e.category === "calculation") && (typeof e._category > "u" || r(e._category)) && (typeof e.color > "u" || e.color === "black" || e.color === "red" || e.color === "green" || e.color === "yellow" || e.color === "blue" || e.color === "magenta" || e.color === "cyan" || e.color === "white") && (typeof e._color > "u" || r(e._color)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.measurementPeriod > "u" || le(e.measurementPeriod)) && (typeof e.operationalStatus > "u" || e.operationalStatus === "entered-in-error" || e.operationalStatus === "on" || e.operationalStatus === "off" || e.operationalStatus === "standby") && (typeof e._operationalStatus > "u" || r(e._operationalStatus)) && (typeof e.parent > "u" || y(e.parent)) && (typeof e.source > "u" || y(e.source)) && u(e.type) && (typeof e.unit > "u" || u(e.unit));
}
function UC(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean));
}
function ka(n) {
  const e = n;
  return b(e) && e.resourceType === "DeviceRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.codeReference > "u" || y(e.codeReference)) && (typeof e.codeCodeableConcept > "u" || u(e.codeCodeableConcept)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.groupIdentifier > "u" || A(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => y(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => UC(t)
  )) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.performerType > "u" || u(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.priorRequest > "u" || Array.isArray(e.priorRequest) && e.priorRequest.every(
    (t) => y(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || y(e.requester)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && y(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => y(t)
  ));
}
function Va(n) {
  const e = n;
  return b(e) && e.resourceType === "DeviceUseStatement" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => y(t)
  )) && y(e.device) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.recordedOn > "u" || typeof e.recordedOn == "string") && (typeof e._recordedOn > "u" || r(e._recordedOn)) && (typeof e.source > "u" || y(e.source)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "completed" || e.status === "stopped" || e.status === "intended") && (typeof e._status > "u" || r(e._status)) && y(e.subject) && (typeof e.timingTiming > "u" || le(e.timingTiming)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || r(e._timingDateTime));
}
function MC(n) {
  const e = n;
  return p(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && y(e.link);
}
function Na(n) {
  const e = n;
  return b(e) && e.resourceType === "DiagnosticReport" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.conclusion > "u" || typeof e.conclusion == "string") && (typeof e._conclusion > "u" || r(e._conclusion)) && (typeof e.conclusionCode > "u" || Array.isArray(e.conclusionCode) && e.conclusionCode.every(
    (t) => u(t)
  )) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || r(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.imagingStudy > "u" || Array.isArray(e.imagingStudy) && e.imagingStudy.every(
    (t) => y(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && (typeof e.media > "u" || Array.isArray(e.media) && e.media.every(
    (t) => MC(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => y(t)
  )) && (typeof e.presentedForm > "u" || Array.isArray(e.presentedForm) && e.presentedForm.every(
    (t) => te(t)
  )) && (typeof e.result > "u" || Array.isArray(e.result) && e.result.every(
    (t) => y(t)
  )) && (typeof e.resultsInterpreter > "u" || Array.isArray(e.resultsInterpreter) && e.resultsInterpreter.every(
    (t) => y(t)
  )) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => y(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "partial" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "appended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject));
}
function EC(n) {
  const e = n;
  return p(e) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.ref > "u" || y(e.ref));
}
function La(n) {
  const e = n;
  return b(e) && e.resourceType === "DocumentManifest" && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => y(t)
  )) && Array.isArray(e.content) && e.content.every(
    (t) => y(t)
  ) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.masterIdentifier > "u" || A(e.masterIdentifier)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => y(t)
  )) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => EC(t)
  )) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || r(e._source)) && (e.status === "entered-in-error" || e.status === "current" || e.status === "superseded") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.type > "u" || u(e.type));
}
function kC(n) {
  const e = n;
  return p(e) && (e.code === "replaces" || e.code === "transforms" || e.code === "signs" || e.code === "appends") && (typeof e._code > "u" || r(e._code)) && y(e.target);
}
function VC(n) {
  const e = n;
  return p(e) && te(e.attachment) && (typeof e.format > "u" || V(e.format));
}
function NC(n) {
  const e = n;
  return p(e) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => y(t)
  )) && (typeof e.event > "u" || Array.isArray(e.event) && e.event.every(
    (t) => u(t)
  )) && (typeof e.facilityType > "u" || u(e.facilityType)) && (typeof e.period > "u" || D(e.period)) && (typeof e.practiceSetting > "u" || u(e.practiceSetting)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => y(t)
  )) && (typeof e.sourcePatientInfo > "u" || y(e.sourcePatientInfo));
}
function Fa(n) {
  const e = n;
  return b(e) && e.resourceType === "DocumentReference" && (typeof e.authenticator > "u" || y(e.authenticator)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && Array.isArray(e.content) && e.content.every(
    (t) => VC(t)
  ) && (typeof e.context > "u" || NC(e.context)) && (typeof e.custodian > "u" || y(e.custodian)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.docStatus > "u" || e.docStatus === "entered-in-error" || e.docStatus === "preliminary" || e.docStatus === "final" || e.docStatus === "amended") && (typeof e._docStatus > "u" || r(e._docStatus)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.masterIdentifier > "u" || A(e.masterIdentifier)) && (typeof e.relatesTo > "u" || Array.isArray(e.relatesTo) && e.relatesTo.every(
    (t) => kC(t)
  )) && (typeof e.securityLabel > "u" || Array.isArray(e.securityLabel) && e.securityLabel.every(
    (t) => u(t)
  )) && (e.status === "entered-in-error" || e.status === "current" || e.status === "superseded") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.type > "u" || u(e.type));
}
function b(n) {
  const e = n;
  return sy(e) && typeof e.resourceType == "string" && (typeof e.contained > "u" || Array.isArray(e.contained) && e.contained.every(
    (t) => sw(t)
  )) && (typeof e.extension > "u" || Array.isArray(e.extension) && e.extension.every(
    (t) => Zn(t)
  )) && (typeof e.modifierExtension > "u" || Array.isArray(e.modifierExtension) && e.modifierExtension.every(
    (t) => Zn(t)
  )) && (typeof e.text > "u" || Vc(e.text));
}
function LC(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.numberOfParticipants > "u" || typeof e.numberOfParticipants == "number") && (typeof e.numberOfStudies > "u" || typeof e.numberOfStudies == "number");
}
function FC(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.exposureState > "u" || e.exposureState === "exposure" || e.exposureState === "exposure-alternative") && (typeof e._exposureState > "u" || r(e._exposureState)) && y(e.riskEvidenceSynthesis) && (typeof e.variantState > "u" || u(e.variantState));
}
function $C(n) {
  const e = n;
  return p(e) && (typeof e.from > "u" || typeof e.from == "number") && (typeof e.level > "u" || typeof e.level == "number") && (typeof e.to > "u" || typeof e.to == "number") && (typeof e.type > "u" || u(e.type));
}
function jC(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.precisionEstimate > "u" || Array.isArray(e.precisionEstimate) && e.precisionEstimate.every(
    (t) => $C(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.unitOfMeasure > "u" || u(e.unitOfMeasure)) && (typeof e.value > "u" || typeof e.value == "number") && (typeof e.variantState > "u" || u(e.variantState));
}
function WC(n) {
  const e = n;
  return p(e) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function HC(n) {
  const e = n;
  return p(e) && (typeof e.certaintySubcomponent > "u" || Array.isArray(e.certaintySubcomponent) && e.certaintySubcomponent.every(
    (t) => WC(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => u(t)
  ));
}
function $a(n) {
  const e = n;
  return b(e) && e.resourceType === "EffectEvidenceSynthesis" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.certainty > "u" || Array.isArray(e.certainty) && e.certainty.every(
    (t) => HC(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectEstimate > "u" || Array.isArray(e.effectEstimate) && e.effectEstimate.every(
    (t) => jC(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && y(e.exposure) && y(e.exposureAlternative) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && y(e.outcome) && y(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.resultsByExposure > "u" || Array.isArray(e.resultsByExposure) && e.resultsByExposure.every(
    (t) => FC(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.sampleSize > "u" || LC(e.sampleSize)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.studyType > "u" || u(e.studyType)) && (typeof e.synthesisType > "u" || u(e.synthesisType)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function QC(n) {
  const e = n;
  return p(e) && D(e.period) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "arrived" || e.status === "cancelled" || e.status === "in-progress" || e.status === "planned" || e.status === "triaged" || e.status === "onleave" || e.status === "finished") && (typeof e._status > "u" || r(e._status));
}
function zC(n) {
  const e = n;
  return p(e) && V(e.class) && D(e.period);
}
function GC(n) {
  const e = n;
  return p(e) && (typeof e.individual > "u" || y(e.individual)) && (typeof e.period > "u" || D(e.period)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function KC(n) {
  const e = n;
  return p(e) && y(e.condition) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.use > "u" || u(e.use));
}
function YC(n) {
  const e = n;
  return p(e) && (typeof e.admitSource > "u" || u(e.admitSource)) && (typeof e.destination > "u" || y(e.destination)) && (typeof e.dietPreference > "u" || Array.isArray(e.dietPreference) && e.dietPreference.every(
    (t) => u(t)
  )) && (typeof e.dischargeDisposition > "u" || u(e.dischargeDisposition)) && (typeof e.origin > "u" || y(e.origin)) && (typeof e.preAdmissionIdentifier > "u" || A(e.preAdmissionIdentifier)) && (typeof e.reAdmission > "u" || u(e.reAdmission)) && (typeof e.specialArrangement > "u" || Array.isArray(e.specialArrangement) && e.specialArrangement.every(
    (t) => u(t)
  )) && (typeof e.specialCourtesy > "u" || Array.isArray(e.specialCourtesy) && e.specialCourtesy.every(
    (t) => u(t)
  ));
}
function JC(n) {
  const e = n;
  return p(e) && y(e.location) && (typeof e.period > "u" || D(e.period)) && (typeof e.physicalType > "u" || u(e.physicalType)) && (typeof e.status > "u" || e.status === "active" || e.status === "completed" || e.status === "planned" || e.status === "reserved") && (typeof e._status > "u" || r(e._status));
}
function ja(n) {
  const e = n;
  return b(e) && e.resourceType === "Encounter" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => y(t)
  )) && (typeof e.appointment > "u" || Array.isArray(e.appointment) && e.appointment.every(
    (t) => y(t)
  )) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && V(e.class) && (typeof e.classHistory > "u" || Array.isArray(e.classHistory) && e.classHistory.every(
    (t) => zC(t)
  )) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => KC(t)
  )) && (typeof e.episodeOfCare > "u" || Array.isArray(e.episodeOfCare) && e.episodeOfCare.every(
    (t) => y(t)
  )) && (typeof e.hospitalization > "u" || YC(e.hospitalization)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.length > "u" || ue(e.length)) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => JC(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => GC(t)
  )) && (typeof e.partOf > "u" || y(e.partOf)) && (typeof e.period > "u" || D(e.period)) && (typeof e.priority > "u" || u(e.priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.serviceProvider > "u" || y(e.serviceProvider)) && (typeof e.serviceType > "u" || u(e.serviceType)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "arrived" || e.status === "cancelled" || e.status === "in-progress" || e.status === "planned" || e.status === "triaged" || e.status === "onleave" || e.status === "finished") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusHistory > "u" || Array.isArray(e.statusHistory) && e.statusHistory.every(
    (t) => QC(t)
  )) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function Wa(n) {
  const e = n;
  return b(e) && e.resourceType === "Endpoint" && typeof e.address == "string" && (typeof e._address > "u" || r(e._address)) && V(e.connectionType) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => he(t)
  )) && (typeof e.header > "u" || Array.isArray(e.header) && e.header.every(
    (t) => typeof t == "string"
  )) && (typeof e._header > "u" || Array.isArray(e._header) && e._header.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.managingOrganization > "u" || y(e.managingOrganization)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.payloadMimeType > "u" || Array.isArray(e.payloadMimeType) && e.payloadMimeType.every(
    (t) => typeof t == "string"
  )) && (typeof e._payloadMimeType > "u" || Array.isArray(e._payloadMimeType) && e._payloadMimeType.every(
    (t) => r(t)
  )) && Array.isArray(e.payloadType) && e.payloadType.every(
    (t) => u(t)
  ) && (typeof e.period > "u" || D(e.period)) && (e.status === "error" || e.status === "active" || e.status === "entered-in-error" || e.status === "suspended" || e.status === "off" || e.status === "test") && (typeof e._status > "u" || r(e._status));
}
function Ha(n) {
  const e = n;
  return b(e) && e.resourceType === "EnrollmentRequest" && (typeof e.candidate > "u" || y(e.candidate)) && (typeof e.coverage > "u" || y(e.coverage)) && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.insurer > "u" || y(e.insurer)) && (typeof e.provider > "u" || y(e.provider)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function Qa(n) {
  const e = n;
  return b(e) && e.resourceType === "EnrollmentResponse" && (typeof e.created > "u" || typeof e.created == "string") && (typeof e._created > "u" || r(e._created)) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || r(e._disposition)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.organization > "u" || y(e.organization)) && (typeof e.outcome > "u" || e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || r(e._outcome)) && (typeof e.request > "u" || y(e.request)) && (typeof e.requestProvider > "u" || y(e.requestProvider)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function ZC(n) {
  const e = n;
  return p(e) && D(e.period) && (e.status === "active" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "waitlist" || e.status === "planned" || e.status === "finished" || e.status === "onhold") && (typeof e._status > "u" || r(e._status));
}
function XC(n) {
  const e = n;
  return p(e) && y(e.condition) && (typeof e.rank > "u" || typeof e.rank == "number") && (typeof e.role > "u" || u(e.role));
}
function za(n) {
  const e = n;
  return b(e) && e.resourceType === "EpisodeOfCare" && (typeof e.account > "u" || Array.isArray(e.account) && e.account.every(
    (t) => y(t)
  )) && (typeof e.careManager > "u" || y(e.careManager)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => XC(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.managingOrganization > "u" || y(e.managingOrganization)) && y(e.patient) && (typeof e.period > "u" || D(e.period)) && (typeof e.referralRequest > "u" || Array.isArray(e.referralRequest) && e.referralRequest.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "cancelled" || e.status === "waitlist" || e.status === "planned" || e.status === "finished" || e.status === "onhold") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusHistory > "u" || Array.isArray(e.statusHistory) && e.statusHistory.every(
    (t) => ZC(t)
  )) && (typeof e.team > "u" || Array.isArray(e.team) && e.team.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function Ga(n) {
  const e = n;
  return b(e) && e.resourceType === "EventDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && Array.isArray(e.trigger) && e.trigger.every(
    (t) => Ft(t)
  ) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Ka(n) {
  const e = n;
  return b(e) && e.resourceType === "Evidence" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && y(e.exposureBackground) && (typeof e.exposureVariant > "u" || Array.isArray(e.exposureVariant) && e.exposureVariant.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.outcome > "u" || Array.isArray(e.outcome) && e.outcome.every(
    (t) => y(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || r(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function ex(n) {
  const e = n;
  return p(e) && (typeof e.definitionReference > "u" || y(e.definitionReference)) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || r(e._definitionCanonical)) && (typeof e.definitionCodeableConcept > "u" || u(e.definitionCodeableConcept)) && (typeof e.definitionExpression > "u" || ke(e.definitionExpression)) && (typeof e.definitionDataRequirement > "u" || Ye(e.definitionDataRequirement)) && (typeof e.definitionTriggerDefinition > "u" || Ft(e.definitionTriggerDefinition)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.exclude > "u" || e.exclude === !1 || e.exclude === !0) && (typeof e._exclude > "u" || r(e._exclude)) && (typeof e.groupMeasure > "u" || e.groupMeasure === "mean" || e.groupMeasure === "median" || e.groupMeasure === "mean-of-mean" || e.groupMeasure === "mean-of-median" || e.groupMeasure === "median-of-mean" || e.groupMeasure === "median-of-median") && (typeof e._groupMeasure > "u" || r(e._groupMeasure)) && (typeof e.participantEffectiveDateTime > "u" || typeof e.participantEffectiveDateTime == "string") && (typeof e._participantEffectiveDateTime > "u" || r(e._participantEffectiveDateTime)) && (typeof e.participantEffectivePeriod > "u" || D(e.participantEffectivePeriod)) && (typeof e.participantEffectiveDuration > "u" || ue(e.participantEffectiveDuration)) && (typeof e.participantEffectiveTiming > "u" || le(e.participantEffectiveTiming)) && (typeof e.timeFromStart > "u" || ue(e.timeFromStart)) && (typeof e.usageContext > "u" || Array.isArray(e.usageContext) && e.usageContext.every(
    (t) => X(t)
  ));
}
function Ya(n) {
  const e = n;
  return b(e) && e.resourceType === "EvidenceVariable" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => ex(t)
  ) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || r(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || e.type === "dichotomous" || e.type === "continuous" || e.type === "descriptive") && (typeof e._type > "u" || r(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function tx(n) {
  const e = n;
  return p(e) && typeof e.actorId == "string" && (typeof e._actorId > "u" || r(e._actorId)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (e.type === "person" || e.type === "entity") && (typeof e._type > "u" || r(e._type));
}
function rx(n) {
  const e = n;
  return p(e) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && typeof e.versionId == "string" && (typeof e._versionId > "u" || r(e._versionId));
}
function mp(n) {
  const e = n;
  return p(e) && typeof e.resourceId == "string" && (typeof e._resourceId > "u" || r(e._resourceId)) && (typeof e.versionId > "u" || typeof e.versionId == "string") && (typeof e._versionId > "u" || r(e._versionId));
}
function ox(n) {
  const e = n;
  return p(e) && (typeof e.containedInstance > "u" || Array.isArray(e.containedInstance) && e.containedInstance.every(
    (t) => mp(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && typeof e.resourceId == "string" && (typeof e._resourceId > "u" || r(e._resourceId)) && typeof e.resourceType == "string" && (typeof e._resourceType > "u" || r(e._resourceType)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => rx(t)
  ));
}
function ix(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.initiator > "u" || typeof e.initiator == "string") && (typeof e._initiator > "u" || r(e._initiator)) && (typeof e.initiatorActive > "u" || e.initiatorActive === !1 || e.initiatorActive === !0) && (typeof e._initiatorActive > "u" || r(e._initiatorActive)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && typeof e.number == "string" && (typeof e._number > "u" || r(e._number)) && (typeof e.receiver > "u" || typeof e.receiver == "string") && (typeof e._receiver > "u" || r(e._receiver)) && (typeof e.receiverActive > "u" || e.receiverActive === !1 || e.receiverActive === !0) && (typeof e._receiverActive > "u" || r(e._receiverActive)) && (typeof e.request > "u" || mp(e.request)) && (typeof e.response > "u" || mp(e.response)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type));
}
function nx(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.step > "u" || Array.isArray(e.step) && e.step.every(
    (t) => Kc(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || r(e._title));
}
function Kc(n) {
  const e = n;
  return p(e) && (typeof e.alternative > "u" || Array.isArray(e.alternative) && e.alternative.every(
    (t) => nx(t)
  )) && (typeof e.operation > "u" || ix(e.operation)) && (typeof e.pause > "u" || e.pause === !1 || e.pause === !0) && (typeof e._pause > "u" || r(e._pause)) && (typeof e.process > "u" || Array.isArray(e.process) && e.process.every(
    (t) => Yc(t)
  ));
}
function Yc(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.postConditions > "u" || typeof e.postConditions == "string") && (typeof e._postConditions > "u" || r(e._postConditions)) && (typeof e.preConditions > "u" || typeof e.preConditions == "string") && (typeof e._preConditions > "u" || r(e._preConditions)) && (typeof e.step > "u" || Array.isArray(e.step) && e.step.every(
    (t) => Kc(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || r(e._title));
}
function Ja(n) {
  const e = n;
  return b(e) && e.resourceType === "ExampleScenario" && (typeof e.actor > "u" || Array.isArray(e.actor) && e.actor.every(
    (t) => tx(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => ox(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.process > "u" || Array.isArray(e.process) && e.process.every(
    (t) => Yc(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version)) && (typeof e.workflow > "u" || Array.isArray(e.workflow) && e.workflow.every(
    (t) => typeof t == "string"
  )) && (typeof e._workflow > "u" || Array.isArray(e._workflow) && e._workflow.every(
    (t) => r(t)
  ));
}
function ax(n) {
  const e = n;
  return p(e) && (typeof e.claim > "u" || y(e.claim)) && (typeof e.reference > "u" || A(e.reference)) && (typeof e.relationship > "u" || u(e.relationship));
}
function ux(n) {
  const e = n;
  return p(e) && (typeof e.party > "u" || y(e.party)) && (typeof e.type > "u" || u(e.type));
}
function yx(n) {
  const e = n;
  return p(e) && y(e.provider) && (typeof e.qualification > "u" || u(e.qualification)) && (typeof e.responsible > "u" || e.responsible === !1 || e.responsible === !0) && (typeof e._responsible > "u" || r(e._responsible)) && (typeof e.role > "u" || u(e.role)) && typeof e.sequence == "number";
}
function sx(n) {
  const e = n;
  return p(e) && u(e.category) && (typeof e.code > "u" || u(e.code)) && (typeof e.reason > "u" || V(e.reason)) && typeof e.sequence == "number" && (typeof e.timingDate > "u" || typeof e.timingDate == "string") && (typeof e._timingDate > "u" || r(e._timingDate)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function px(n) {
  const e = n;
  return p(e) && (typeof e.diagnosisCodeableConcept > "u" || u(e.diagnosisCodeableConcept)) && (typeof e.diagnosisReference > "u" || y(e.diagnosisReference)) && (typeof e.onAdmission > "u" || u(e.onAdmission)) && (typeof e.packageCode > "u" || u(e.packageCode)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function fx(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.procedureCodeableConcept > "u" || u(e.procedureCodeableConcept)) && (typeof e.procedureReference > "u" || y(e.procedureReference)) && typeof e.sequence == "number" && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  ));
}
function cx(n) {
  const e = n;
  return p(e) && y(e.coverage) && typeof e.focal == "boolean" && (typeof e._focal > "u" || r(e._focal)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => r(t)
  ));
}
function lx(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.type > "u" || u(e.type));
}
function Co(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || L(e.amount)) && u(e.category) && (typeof e.reason > "u" || u(e.reason)) && (typeof e.value > "u" || typeof e.value == "number");
}
function dx(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function gx(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => dx(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function mx(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.careTeamSequence > "u" || Array.isArray(e.careTeamSequence) && e.careTeamSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => gx(t)
  )) && (typeof e.diagnosisSequence > "u" || Array.isArray(e.diagnosisSequence) && e.diagnosisSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.encounter > "u" || Array.isArray(e.encounter) && e.encounter.every(
    (t) => y(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.informationSequence > "u" || Array.isArray(e.informationSequence) && e.informationSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || u(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && (typeof e.procedureSequence > "u" || Array.isArray(e.procedureSequence) && e.procedureSequence.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.revenue > "u" || u(e.revenue)) && typeof e.sequence == "number" && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => u(t)
  )) && (typeof e.udi > "u" || Array.isArray(e.udi) && e.udi.every(
    (t) => y(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function _x(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function vx(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.subDetail > "u" || Array.isArray(e.subDetail) && e.subDetail.every(
    (t) => _x(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function Ax(n) {
  const e = n;
  return p(e) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => vx(t)
  )) && (typeof e.detailSequence > "u" || Array.isArray(e.detailSequence) && e.detailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.factor > "u" || typeof e.factor == "number") && (typeof e.itemSequence > "u" || Array.isArray(e.itemSequence) && e.itemSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.locationCodeableConcept > "u" || u(e.locationCodeableConcept)) && (typeof e.locationAddress > "u" || Te(e.locationAddress)) && (typeof e.locationReference > "u" || y(e.locationReference)) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => u(t)
  )) && (typeof e.net > "u" || L(e.net)) && (typeof e.noteNumber > "u" || Array.isArray(e.noteNumber) && e.noteNumber.every(
    (t) => typeof t == "number"
  )) && u(e.productOrService) && (typeof e.programCode > "u" || Array.isArray(e.programCode) && e.programCode.every(
    (t) => u(t)
  )) && (typeof e.provider > "u" || Array.isArray(e.provider) && e.provider.every(
    (t) => y(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.servicedDate > "u" || typeof e.servicedDate == "string") && (typeof e._servicedDate > "u" || r(e._servicedDate)) && (typeof e.servicedPeriod > "u" || D(e.servicedPeriod)) && (typeof e.subDetailSequence > "u" || Array.isArray(e.subDetailSequence) && e.subDetailSequence.every(
    (t) => typeof t == "number"
  )) && (typeof e.subSite > "u" || Array.isArray(e.subSite) && e.subSite.every(
    (t) => u(t)
  )) && (typeof e.unitPrice > "u" || L(e.unitPrice));
}
function hx(n) {
  const e = n;
  return p(e) && L(e.amount) && u(e.category);
}
function bx(n) {
  const e = n;
  return p(e) && (typeof e.adjustment > "u" || L(e.adjustment)) && (typeof e.adjustmentReason > "u" || u(e.adjustmentReason)) && (typeof e.amount > "u" || L(e.amount)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.type > "u" || u(e.type));
}
function Cx(n) {
  const e = n;
  return p(e) && (typeof e.language > "u" || u(e.language)) && (typeof e.number > "u" || typeof e.number == "number") && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || r(e._type));
}
function xx(n) {
  const e = n;
  return p(e) && (typeof e.allowedUnsignedInt > "u" || typeof e.allowedUnsignedInt == "number") && (typeof e.allowedString > "u" || typeof e.allowedString == "string") && (typeof e._allowedString > "u" || r(e._allowedString)) && (typeof e.allowedMoney > "u" || L(e.allowedMoney)) && u(e.type) && (typeof e.usedUnsignedInt > "u" || typeof e.usedUnsignedInt == "number") && (typeof e.usedMoney > "u" || L(e.usedMoney));
}
function Dx(n) {
  const e = n;
  return p(e) && u(e.category) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.excluded > "u" || e.excluded === !1 || e.excluded === !0) && (typeof e._excluded > "u" || r(e._excluded)) && (typeof e.financial > "u" || Array.isArray(e.financial) && e.financial.every(
    (t) => xx(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.network > "u" || u(e.network)) && (typeof e.term > "u" || u(e.term)) && (typeof e.unit > "u" || u(e.unit));
}
function Za(n) {
  const e = n;
  return b(e) && e.resourceType === "ExplanationOfBenefit" && (typeof e.accident > "u" || lx(e.accident)) && (typeof e.addItem > "u" || Array.isArray(e.addItem) && e.addItem.every(
    (t) => Ax(t)
  )) && (typeof e.adjudication > "u" || Array.isArray(e.adjudication) && e.adjudication.every(
    (t) => Co(t)
  )) && (typeof e.benefitBalance > "u" || Array.isArray(e.benefitBalance) && e.benefitBalance.every(
    (t) => Dx(t)
  )) && (typeof e.benefitPeriod > "u" || D(e.benefitPeriod)) && (typeof e.billablePeriod > "u" || D(e.billablePeriod)) && (typeof e.careTeam > "u" || Array.isArray(e.careTeam) && e.careTeam.every(
    (t) => yx(t)
  )) && (typeof e.claim > "u" || y(e.claim)) && (typeof e.claimResponse > "u" || y(e.claimResponse)) && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.diagnosis > "u" || Array.isArray(e.diagnosis) && e.diagnosis.every(
    (t) => px(t)
  )) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || r(e._disposition)) && (typeof e.enterer > "u" || y(e.enterer)) && (typeof e.facility > "u" || y(e.facility)) && (typeof e.form > "u" || te(e.form)) && (typeof e.formCode > "u" || u(e.formCode)) && (typeof e.fundsReserve > "u" || u(e.fundsReserve)) && (typeof e.fundsReserveRequested > "u" || u(e.fundsReserveRequested)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && Array.isArray(e.insurance) && e.insurance.every(
    (t) => cx(t)
  ) && y(e.insurer) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => mx(t)
  )) && (typeof e.originalPrescription > "u" || y(e.originalPrescription)) && (e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || r(e._outcome)) && y(e.patient) && (typeof e.payee > "u" || ux(e.payee)) && (typeof e.payment > "u" || bx(e.payment)) && (typeof e.preAuthRef > "u" || Array.isArray(e.preAuthRef) && e.preAuthRef.every(
    (t) => typeof t == "string"
  )) && (typeof e._preAuthRef > "u" || Array.isArray(e._preAuthRef) && e._preAuthRef.every(
    (t) => r(t)
  )) && (typeof e.preAuthRefPeriod > "u" || Array.isArray(e.preAuthRefPeriod) && e.preAuthRefPeriod.every(
    (t) => D(t)
  )) && (typeof e.precedence > "u" || typeof e.precedence == "number") && (typeof e.prescription > "u" || y(e.prescription)) && (typeof e.priority > "u" || u(e.priority)) && (typeof e.procedure > "u" || Array.isArray(e.procedure) && e.procedure.every(
    (t) => fx(t)
  )) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => Cx(t)
  )) && y(e.provider) && (typeof e.referral > "u" || y(e.referral)) && (typeof e.related > "u" || Array.isArray(e.related) && e.related.every(
    (t) => ax(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status)) && (typeof e.subType > "u" || u(e.subType)) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => sx(t)
  )) && (typeof e.total > "u" || Array.isArray(e.total) && e.total.every(
    (t) => hx(t)
  )) && u(e.type) && (e.use === "claim" || e.use === "preauthorization" || e.use === "predetermination") && (typeof e._use > "u" || r(e._use));
}
function Tx(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.contributedToDeath > "u" || e.contributedToDeath === !1 || e.contributedToDeath === !0) && (typeof e._contributedToDeath > "u" || r(e._contributedToDeath)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.onsetAge > "u" || Le(e.onsetAge)) && (typeof e.onsetRange > "u" || K(e.onsetRange)) && (typeof e.onsetPeriod > "u" || D(e.onsetPeriod)) && (typeof e.onsetString > "u" || typeof e.onsetString == "string") && (typeof e._onsetString > "u" || r(e._onsetString)) && (typeof e.outcome > "u" || u(e.outcome));
}
function Xa(n) {
  const e = n;
  return b(e) && e.resourceType === "FamilyMemberHistory" && (typeof e.ageAge > "u" || Le(e.ageAge)) && (typeof e.ageRange > "u" || K(e.ageRange)) && (typeof e.ageString > "u" || typeof e.ageString == "string") && (typeof e._ageString > "u" || r(e._ageString)) && (typeof e.bornPeriod > "u" || D(e.bornPeriod)) && (typeof e.bornDate > "u" || typeof e.bornDate == "string") && (typeof e._bornDate > "u" || r(e._bornDate)) && (typeof e.bornString > "u" || typeof e.bornString == "string") && (typeof e._bornString > "u" || r(e._bornString)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => Tx(t)
  )) && (typeof e.dataAbsentReason > "u" || u(e.dataAbsentReason)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.deceasedBoolean > "u" || e.deceasedBoolean === !1 || e.deceasedBoolean === !0) && (typeof e._deceasedBoolean > "u" || r(e._deceasedBoolean)) && (typeof e.deceasedAge > "u" || Le(e.deceasedAge)) && (typeof e.deceasedRange > "u" || K(e.deceasedRange)) && (typeof e.deceasedDate > "u" || typeof e.deceasedDate == "string") && (typeof e._deceasedDate > "u" || r(e._deceasedDate)) && (typeof e.deceasedString > "u" || typeof e.deceasedString == "string") && (typeof e._deceasedString > "u" || r(e._deceasedString)) && (typeof e.estimatedAge > "u" || e.estimatedAge === !1 || e.estimatedAge === !0) && (typeof e._estimatedAge > "u" || r(e._estimatedAge)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && y(e.patient) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && u(e.relationship) && (typeof e.sex > "u" || u(e.sex)) && (e.status === "entered-in-error" || e.status === "completed" || e.status === "partial" || e.status === "health-unknown") && (typeof e._status > "u" || r(e._status));
}
function eu(n) {
  const e = n;
  return b(e) && e.resourceType === "Flag" && (typeof e.author > "u" || y(e.author)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.period > "u" || D(e.period)) && (e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || r(e._status)) && y(e.subject);
}
function Sx(n) {
  const e = n;
  return p(e) && (typeof e.detailQuantity > "u" || S(e.detailQuantity)) && (typeof e.detailRange > "u" || K(e.detailRange)) && (typeof e.detailCodeableConcept > "u" || u(e.detailCodeableConcept)) && (typeof e.detailString > "u" || typeof e.detailString == "string") && (typeof e._detailString > "u" || r(e._detailString)) && (typeof e.detailBoolean > "u" || e.detailBoolean === !1 || e.detailBoolean === !0) && (typeof e._detailBoolean > "u" || r(e._detailBoolean)) && (typeof e.detailInteger > "u" || typeof e.detailInteger == "number") && (typeof e.detailRatio > "u" || ge(e.detailRatio)) && (typeof e.dueDate > "u" || typeof e.dueDate == "string") && (typeof e._dueDate > "u" || r(e._dueDate)) && (typeof e.dueDuration > "u" || ue(e.dueDuration)) && (typeof e.measure > "u" || u(e.measure));
}
function tu(n) {
  const e = n;
  return b(e) && e.resourceType === "Goal" && (typeof e.achievementStatus > "u" || u(e.achievementStatus)) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.description) && (typeof e.expressedBy > "u" || y(e.expressedBy)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (e.lifecycleStatus === "active" || e.lifecycleStatus === "entered-in-error" || e.lifecycleStatus === "on-hold" || e.lifecycleStatus === "accepted" || e.lifecycleStatus === "proposed" || e.lifecycleStatus === "cancelled" || e.lifecycleStatus === "completed" || e.lifecycleStatus === "planned" || e.lifecycleStatus === "rejected") && (typeof e._lifecycleStatus > "u" || r(e._lifecycleStatus)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.outcomeCode > "u" || Array.isArray(e.outcomeCode) && e.outcomeCode.every(
    (t) => u(t)
  )) && (typeof e.outcomeReference > "u" || Array.isArray(e.outcomeReference) && e.outcomeReference.every(
    (t) => y(t)
  )) && (typeof e.priority > "u" || u(e.priority)) && (typeof e.startDate > "u" || typeof e.startDate == "string") && (typeof e._startDate > "u" || r(e._startDate)) && (typeof e.startCodeableConcept > "u" || u(e.startCodeableConcept)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || r(e._statusDate)) && (typeof e.statusReason > "u" || typeof e.statusReason == "string") && (typeof e._statusReason > "u" || r(e._statusReason)) && y(e.subject) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => Sx(t)
  ));
}
function Rx(n) {
  const e = n;
  return p(e) && (e.code === "Patient" || e.code === "Encounter" || e.code === "RelatedPerson" || e.code === "Practitioner" || e.code === "Device") && (typeof e._code > "u" || r(e._code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && (e.rule === "identical" || e.rule === "matching" || e.rule === "different" || e.rule === "custom") && (typeof e._rule > "u" || r(e._rule)) && (e.use === "condition" || e.use === "requirement") && (typeof e._use > "u" || r(e._use));
}
function wx(n) {
  const e = n;
  return p(e) && (typeof e.compartment > "u" || Array.isArray(e.compartment) && e.compartment.every(
    (t) => Rx(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Jc(t)
  )) && (typeof e.params > "u" || typeof e.params == "string") && (typeof e._params > "u" || r(e._params)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type));
}
function Jc(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || r(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path)) && (typeof e.sliceName > "u" || typeof e.sliceName == "string") && (typeof e._sliceName > "u" || r(e._sliceName)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => wx(t)
  ));
}
function ru(n) {
  const e = n;
  return b(e) && e.resourceType === "GraphDefinition" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => Jc(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && typeof e.start == "string" && (typeof e._start > "u" || r(e._start)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Ix(n) {
  const e = n;
  return p(e) && u(e.code) && typeof e.exclude == "boolean" && (typeof e._exclude > "u" || r(e._exclude)) && (typeof e.period > "u" || D(e.period)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function Px(n) {
  const e = n;
  return p(e) && y(e.entity) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || r(e._inactive)) && (typeof e.period > "u" || D(e.period));
}
function ou(n) {
  const e = n;
  return b(e) && e.resourceType === "Group" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && typeof e.actual == "boolean" && (typeof e._actual > "u" || r(e._actual)) && (typeof e.characteristic > "u" || Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => Ix(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.managingEntity > "u" || y(e.managingEntity)) && (typeof e.member > "u" || Array.isArray(e.member) && e.member.every(
    (t) => Px(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.quantity > "u" || typeof e.quantity == "number") && (e.type === "practitioner" || e.type === "device" || e.type === "medication" || e.type === "person" || e.type === "animal" || e.type === "substance") && (typeof e._type > "u" || r(e._type));
}
function iu(n) {
  const e = n;
  return b(e) && e.resourceType === "GuidanceResponse" && (typeof e.dataRequirement > "u" || Array.isArray(e.dataRequirement) && e.dataRequirement.every(
    (t) => Ye(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.evaluationMessage > "u" || Array.isArray(e.evaluationMessage) && e.evaluationMessage.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.moduleUri > "u" || typeof e.moduleUri == "string") && (typeof e._moduleUri > "u" || r(e._moduleUri)) && (typeof e.moduleCanonical > "u" || typeof e.moduleCanonical == "string") && (typeof e._moduleCanonical > "u" || r(e._moduleCanonical)) && (typeof e.moduleCodeableConcept > "u" || u(e.moduleCodeableConcept)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.outputParameters > "u" || y(e.outputParameters)) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.requestIdentifier > "u" || A(e.requestIdentifier)) && (typeof e.result > "u" || y(e.result)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "success" || e.status === "data-requested" || e.status === "data-required" || e.status === "failure") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject));
}
function Ox(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment));
}
function qx(n) {
  const e = n;
  return p(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || r(e._allDay)) && (typeof e.availableEndTime > "u" || typeof e.availableEndTime == "string") && (typeof e._availableEndTime > "u" || r(e._availableEndTime)) && (typeof e.availableStartTime > "u" || typeof e.availableStartTime == "string") && (typeof e._availableStartTime > "u" || r(e._availableStartTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => r(t)
  ));
}
function Bx(n) {
  const e = n;
  return p(e) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && (typeof e.during > "u" || D(e.during));
}
function nu(n) {
  const e = n;
  return b(e) && e.resourceType === "HealthcareService" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.appointmentRequired > "u" || e.appointmentRequired === !1 || e.appointmentRequired === !0) && (typeof e._appointmentRequired > "u" || r(e._appointmentRequired)) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || r(e._availabilityExceptions)) && (typeof e.availableTime > "u" || Array.isArray(e.availableTime) && e.availableTime.every(
    (t) => qx(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.characteristic > "u" || Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => u(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => u(t)
  )) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => y(t)
  )) && (typeof e.eligibility > "u" || Array.isArray(e.eligibility) && e.eligibility.every(
    (t) => Ox(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.extraDetails > "u" || typeof e.extraDetails == "string") && (typeof e._extraDetails > "u" || r(e._extraDetails)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => y(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.notAvailable > "u" || Array.isArray(e.notAvailable) && e.notAvailable.every(
    (t) => Bx(t)
  )) && (typeof e.photo > "u" || te(e.photo)) && (typeof e.program > "u" || Array.isArray(e.program) && e.program.every(
    (t) => u(t)
  )) && (typeof e.providedBy > "u" || y(e.providedBy)) && (typeof e.referralMethod > "u" || Array.isArray(e.referralMethod) && e.referralMethod.every(
    (t) => u(t)
  )) && (typeof e.serviceProvisionCode > "u" || Array.isArray(e.serviceProvisionCode) && e.serviceProvisionCode.every(
    (t) => u(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function Ux(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function));
}
function Mx(n) {
  const e = n;
  return p(e) && (typeof e.number > "u" || typeof e.number == "number") && V(e.sopClass) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.uid == "string" && (typeof e._uid > "u" || r(e._uid));
}
function Ex(n) {
  const e = n;
  return p(e) && (typeof e.bodySite > "u" || V(e.bodySite)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => Mx(t)
  )) && (typeof e.laterality > "u" || V(e.laterality)) && V(e.modality) && (typeof e.number > "u" || typeof e.number == "number") && (typeof e.numberOfInstances > "u" || typeof e.numberOfInstances == "number") && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => Ux(t)
  )) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => y(t)
  )) && (typeof e.started > "u" || typeof e.started == "string") && (typeof e._started > "u" || r(e._started)) && typeof e.uid == "string" && (typeof e._uid > "u" || r(e._uid));
}
function au(n) {
  const e = n;
  return b(e) && e.resourceType === "ImagingStudy" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.interpreter > "u" || Array.isArray(e.interpreter) && e.interpreter.every(
    (t) => y(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.modality > "u" || Array.isArray(e.modality) && e.modality.every(
    (t) => V(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.numberOfInstances > "u" || typeof e.numberOfInstances == "number") && (typeof e.numberOfSeries > "u" || typeof e.numberOfSeries == "number") && (typeof e.procedureCode > "u" || Array.isArray(e.procedureCode) && e.procedureCode.every(
    (t) => u(t)
  )) && (typeof e.procedureReference > "u" || y(e.procedureReference)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.referrer > "u" || y(e.referrer)) && (typeof e.series > "u" || Array.isArray(e.series) && e.series.every(
    (t) => Ex(t)
  )) && (typeof e.started > "u" || typeof e.started == "string") && (typeof e._started > "u" || r(e._started)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "available" || e.status === "registered") && (typeof e._status > "u" || r(e._status)) && y(e.subject);
}
function kx(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function));
}
function Vx(n) {
  const e = n;
  return p(e) && (typeof e.documentType > "u" || typeof e.documentType == "string") && (typeof e._documentType > "u" || r(e._documentType)) && (typeof e.presentationDate > "u" || typeof e.presentationDate == "string") && (typeof e._presentationDate > "u" || r(e._presentationDate)) && (typeof e.publicationDate > "u" || typeof e.publicationDate == "string") && (typeof e._publicationDate > "u" || r(e._publicationDate)) && (typeof e.reference > "u" || typeof e.reference == "string") && (typeof e._reference > "u" || r(e._reference));
}
function Nx(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.detail > "u" || y(e.detail)) && (typeof e.reported > "u" || e.reported === !1 || e.reported === !0) && (typeof e._reported > "u" || r(e._reported));
}
function Lx(n) {
  const e = n;
  return p(e) && (typeof e.authority > "u" || y(e.authority)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || r(e._doseNumberString)) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || r(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || r(e._seriesDosesString)) && (typeof e.targetDisease > "u" || Array.isArray(e.targetDisease) && e.targetDisease.every(
    (t) => u(t)
  ));
}
function uu(n) {
  const e = n;
  return b(e) && e.resourceType === "Immunization" && (typeof e.doseQuantity > "u" || S(e.doseQuantity)) && (typeof e.education > "u" || Array.isArray(e.education) && e.education.every(
    (t) => Vx(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || r(e._expirationDate)) && (typeof e.fundingSource > "u" || u(e.fundingSource)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.isSubpotent > "u" || e.isSubpotent === !1 || e.isSubpotent === !0) && (typeof e._isSubpotent > "u" || r(e._isSubpotent)) && (typeof e.location > "u" || y(e.location)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || r(e._lotNumber)) && (typeof e.manufacturer > "u" || y(e.manufacturer)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrenceString > "u" || typeof e.occurrenceString == "string") && (typeof e._occurrenceString > "u" || r(e._occurrenceString)) && y(e.patient) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => kx(t)
  )) && (typeof e.primarySource > "u" || e.primarySource === !1 || e.primarySource === !0) && (typeof e._primarySource > "u" || r(e._primarySource)) && (typeof e.programEligibility > "u" || Array.isArray(e.programEligibility) && e.programEligibility.every(
    (t) => u(t)
  )) && (typeof e.protocolApplied > "u" || Array.isArray(e.protocolApplied) && e.protocolApplied.every(
    (t) => Lx(t)
  )) && (typeof e.reaction > "u" || Array.isArray(e.reaction) && e.reaction.every(
    (t) => Nx(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.recorded > "u" || typeof e.recorded == "string") && (typeof e._recorded > "u" || r(e._recorded)) && (typeof e.reportOrigin > "u" || u(e.reportOrigin)) && (typeof e.route > "u" || u(e.route)) && (typeof e.site > "u" || u(e.site)) && (e.status === "entered-in-error" || e.status === "completed" || e.status === "not-done") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && (typeof e.subpotentReason > "u" || Array.isArray(e.subpotentReason) && e.subpotentReason.every(
    (t) => u(t)
  )) && u(e.vaccineCode);
}
function yu(n) {
  const e = n;
  return b(e) && e.resourceType === "ImmunizationEvaluation" && (typeof e.authority > "u" || y(e.authority)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || r(e._doseNumberString)) && u(e.doseStatus) && (typeof e.doseStatusReason > "u" || Array.isArray(e.doseStatusReason) && e.doseStatusReason.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && y(e.immunizationEvent) && y(e.patient) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || r(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || r(e._seriesDosesString)) && (e.status === "entered-in-error" || e.status === "completed") && (typeof e._status > "u" || r(e._status)) && u(e.targetDisease);
}
function Fx(n) {
  const e = n;
  return p(e) && u(e.code) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function $x(n) {
  const e = n;
  return p(e) && (typeof e.contraindicatedVaccineCode > "u" || Array.isArray(e.contraindicatedVaccineCode) && e.contraindicatedVaccineCode.every(
    (t) => u(t)
  )) && (typeof e.dateCriterion > "u" || Array.isArray(e.dateCriterion) && e.dateCriterion.every(
    (t) => Fx(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.doseNumberPositiveInt > "u" || typeof e.doseNumberPositiveInt == "number") && (typeof e.doseNumberString > "u" || typeof e.doseNumberString == "string") && (typeof e._doseNumberString > "u" || r(e._doseNumberString)) && (typeof e.forecastReason > "u" || Array.isArray(e.forecastReason) && e.forecastReason.every(
    (t) => u(t)
  )) && u(e.forecastStatus) && (typeof e.series > "u" || typeof e.series == "string") && (typeof e._series > "u" || r(e._series)) && (typeof e.seriesDosesPositiveInt > "u" || typeof e.seriesDosesPositiveInt == "number") && (typeof e.seriesDosesString > "u" || typeof e.seriesDosesString == "string") && (typeof e._seriesDosesString > "u" || r(e._seriesDosesString)) && (typeof e.supportingImmunization > "u" || Array.isArray(e.supportingImmunization) && e.supportingImmunization.every(
    (t) => y(t)
  )) && (typeof e.supportingPatientInformation > "u" || Array.isArray(e.supportingPatientInformation) && e.supportingPatientInformation.every(
    (t) => y(t)
  )) && (typeof e.targetDisease > "u" || u(e.targetDisease)) && (typeof e.vaccineCode > "u" || Array.isArray(e.vaccineCode) && e.vaccineCode.every(
    (t) => u(t)
  ));
}
function su(n) {
  const e = n;
  return b(e) && e.resourceType === "ImmunizationRecommendation" && (typeof e.authority > "u" || y(e.authority)) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && y(e.patient) && Array.isArray(e.recommendation) && e.recommendation.every(
    (t) => $x(t)
  );
}
function jx(n) {
  const e = n;
  return p(e) && (typeof e.packageId > "u" || typeof e.packageId == "string") && (typeof e._packageId > "u" || r(e._packageId)) && typeof e.uri == "string" && (typeof e._uri > "u" || r(e._uri)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Wx(n) {
  const e = n;
  return p(e) && typeof e.profile == "string" && (typeof e._profile > "u" || r(e._profile)) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type));
}
function Hx(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name));
}
function Qx(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.exampleBoolean > "u" || e.exampleBoolean === !1 || e.exampleBoolean === !0) && (typeof e._exampleBoolean > "u" || r(e._exampleBoolean)) && (typeof e.exampleCanonical > "u" || typeof e.exampleCanonical == "string") && (typeof e._exampleCanonical > "u" || r(e._exampleCanonical)) && (typeof e.fhirVersion > "u" || Array.isArray(e.fhirVersion) && e.fhirVersion.every(
    (t) => typeof t == "string"
  )) && (typeof e._fhirVersion > "u" || Array.isArray(e._fhirVersion) && e._fhirVersion.every(
    (t) => r(t)
  )) && (typeof e.groupingId > "u" || typeof e.groupingId == "string") && (typeof e._groupingId > "u" || r(e._groupingId)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && y(e.reference);
}
function Zc(n) {
  const e = n;
  return p(e) && (e.generation === "generated" || e.generation === "html" || e.generation === "markdown" || e.generation === "xml") && (typeof e._generation > "u" || r(e._generation)) && (typeof e.nameUrl > "u" || typeof e.nameUrl == "string") && (typeof e._nameUrl > "u" || r(e._nameUrl)) && (typeof e.nameReference > "u" || y(e.nameReference)) && (typeof e.page > "u" || Array.isArray(e.page) && e.page.every(
    (t) => Zc(t)
  )) && typeof e.title == "string" && (typeof e._title > "u" || r(e._title));
}
function zx(n) {
  const e = n;
  return p(e) && (e.code === "apply" || e.code === "path-resource" || e.code === "path-pages" || e.code === "path-tx-cache" || e.code === "expansion-parameter" || e.code === "rule-broken-links" || e.code === "generate-xml" || e.code === "generate-json" || e.code === "generate-turtle" || e.code === "html-template") && (typeof e._code > "u" || r(e._code)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Gx(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.scope > "u" || typeof e.scope == "string") && (typeof e._scope > "u" || r(e._scope)) && typeof e.source == "string" && (typeof e._source > "u" || r(e._source));
}
function Kx(n) {
  const e = n;
  return p(e) && (typeof e.grouping > "u" || Array.isArray(e.grouping) && e.grouping.every(
    (t) => Hx(t)
  )) && (typeof e.page > "u" || Zc(e.page)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => zx(t)
  )) && Array.isArray(e.resource) && e.resource.every(
    (t) => Qx(t)
  ) && (typeof e.template > "u" || Array.isArray(e.template) && e.template.every(
    (t) => Gx(t)
  ));
}
function Yx(n) {
  const e = n;
  return p(e) && (typeof e.exampleBoolean > "u" || e.exampleBoolean === !1 || e.exampleBoolean === !0) && (typeof e._exampleBoolean > "u" || r(e._exampleBoolean)) && (typeof e.exampleCanonical > "u" || typeof e.exampleCanonical == "string") && (typeof e._exampleCanonical > "u" || r(e._exampleCanonical)) && y(e.reference) && (typeof e.relativePath > "u" || typeof e.relativePath == "string") && (typeof e._relativePath > "u" || r(e._relativePath));
}
function Jx(n) {
  const e = n;
  return p(e) && (typeof e.anchor > "u" || Array.isArray(e.anchor) && e.anchor.every(
    (t) => typeof t == "string"
  )) && (typeof e._anchor > "u" || Array.isArray(e._anchor) && e._anchor.every(
    (t) => r(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title));
}
function Zx(n) {
  const e = n;
  return p(e) && (typeof e.image > "u" || Array.isArray(e.image) && e.image.every(
    (t) => typeof t == "string"
  )) && (typeof e._image > "u" || Array.isArray(e._image) && e._image.every(
    (t) => r(t)
  )) && (typeof e.other > "u" || Array.isArray(e.other) && e.other.every(
    (t) => typeof t == "string"
  )) && (typeof e._other > "u" || Array.isArray(e._other) && e._other.every(
    (t) => r(t)
  )) && (typeof e.page > "u" || Array.isArray(e.page) && e.page.every(
    (t) => Jx(t)
  )) && (typeof e.rendering > "u" || typeof e.rendering == "string") && (typeof e._rendering > "u" || r(e._rendering)) && Array.isArray(e.resource) && e.resource.every(
    (t) => Yx(t)
  );
}
function pu(n) {
  const e = n;
  return b(e) && e.resourceType === "ImplementationGuide" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.definition > "u" || Kx(e.definition)) && (typeof e.dependsOn > "u" || Array.isArray(e.dependsOn) && e.dependsOn.every(
    (t) => jx(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && Array.isArray(e.fhirVersion) && e.fhirVersion.every(
    (t) => typeof t == "string"
  ) && (typeof e._fhirVersion > "u" || Array.isArray(e._fhirVersion) && e._fhirVersion.every(
    (t) => r(t)
  )) && (typeof e.global > "u" || Array.isArray(e.global) && e.global.every(
    (t) => Wx(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.license > "u" || typeof e.license == "string") && (typeof e._license > "u" || r(e._license)) && (typeof e.manifest > "u" || Zx(e.manifest)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && typeof e.packageId == "string" && (typeof e._packageId > "u" || r(e._packageId)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function Xx(n) {
  const e = n;
  return p(e) && (typeof e.address > "u" || Te(e.address)) && (typeof e.name > "u" || Je(e.name)) && (typeof e.purpose > "u" || u(e.purpose)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function eD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.value > "u" || S(e.value));
}
function tD(n) {
  const e = n;
  return p(e) && (typeof e.limit > "u" || Array.isArray(e.limit) && e.limit.every(
    (t) => eD(t)
  )) && (typeof e.requirement > "u" || typeof e.requirement == "string") && (typeof e._requirement > "u" || r(e._requirement)) && u(e.type);
}
function rD(n) {
  const e = n;
  return p(e) && Array.isArray(e.benefit) && e.benefit.every(
    (t) => tD(t)
  ) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => y(t)
  )) && u(e.type);
}
function oD(n) {
  const e = n;
  return p(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.cost > "u" || L(e.cost)) && (typeof e.groupSize > "u" || typeof e.groupSize == "number") && (typeof e.type > "u" || u(e.type));
}
function iD(n) {
  const e = n;
  return p(e) && (typeof e.applicability > "u" || u(e.applicability)) && (typeof e.qualifiers > "u" || Array.isArray(e.qualifiers) && e.qualifiers.every(
    (t) => u(t)
  )) && u(e.type) && (typeof e.value > "u" || S(e.value));
}
function nD(n) {
  const e = n;
  return p(e) && (typeof e.cost > "u" || Array.isArray(e.cost) && e.cost.every(
    (t) => iD(t)
  )) && u(e.type);
}
function aD(n) {
  const e = n;
  return p(e) && (typeof e.benefit > "u" || Array.isArray(e.benefit) && e.benefit.every(
    (t) => nD(t)
  )) && u(e.category);
}
function uD(n) {
  const e = n;
  return p(e) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => y(t)
  )) && (typeof e.generalCost > "u" || Array.isArray(e.generalCost) && e.generalCost.every(
    (t) => oD(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => y(t)
  )) && (typeof e.specificCost > "u" || Array.isArray(e.specificCost) && e.specificCost.every(
    (t) => aD(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function fu(n) {
  const e = n;
  return b(e) && e.resourceType === "InsurancePlan" && (typeof e.administeredBy > "u" || y(e.administeredBy)) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => r(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => Xx(t)
  )) && (typeof e.coverage > "u" || Array.isArray(e.coverage) && e.coverage.every(
    (t) => rD(t)
  )) && (typeof e.coverageArea > "u" || Array.isArray(e.coverageArea) && e.coverageArea.every(
    (t) => y(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => y(t)
  )) && (typeof e.ownedBy > "u" || y(e.ownedBy)) && (typeof e.period > "u" || D(e.period)) && (typeof e.plan > "u" || Array.isArray(e.plan) && e.plan.every(
    (t) => uD(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function yD(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.role > "u" || u(e.role));
}
function Xc(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || L(e.amount)) && (typeof e.code > "u" || u(e.code)) && (typeof e.factor > "u" || typeof e.factor == "number") && (e.type === "base" || e.type === "surcharge" || e.type === "deduction" || e.type === "discount" || e.type === "tax" || e.type === "informational") && (typeof e._type > "u" || r(e._type));
}
function sD(n) {
  const e = n;
  return p(e) && (typeof e.chargeItemReference > "u" || y(e.chargeItemReference)) && (typeof e.chargeItemCodeableConcept > "u" || u(e.chargeItemCodeableConcept)) && (typeof e.priceComponent > "u" || Array.isArray(e.priceComponent) && e.priceComponent.every(
    (t) => Xc(t)
  )) && (typeof e.sequence > "u" || typeof e.sequence == "number");
}
function cu(n) {
  const e = n;
  return b(e) && e.resourceType === "Invoice" && (typeof e.account > "u" || y(e.account)) && (typeof e.cancelledReason > "u" || typeof e.cancelledReason == "string") && (typeof e._cancelledReason > "u" || r(e._cancelledReason)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.issuer > "u" || y(e.issuer)) && (typeof e.lineItem > "u" || Array.isArray(e.lineItem) && e.lineItem.every(
    (t) => sD(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => yD(t)
  )) && (typeof e.paymentTerms > "u" || typeof e.paymentTerms == "string") && (typeof e._paymentTerms > "u" || r(e._paymentTerms)) && (typeof e.recipient > "u" || y(e.recipient)) && (e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled" || e.status === "issued" || e.status === "balanced") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.totalGross > "u" || L(e.totalGross)) && (typeof e.totalNet > "u" || L(e.totalNet)) && (typeof e.totalPriceComponent > "u" || Array.isArray(e.totalPriceComponent) && e.totalPriceComponent.every(
    (t) => Xc(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function lu(n) {
  const e = n;
  return b(e) && e.resourceType === "Library" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.content > "u" || Array.isArray(e.content) && e.content.every(
    (t) => te(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.dataRequirement > "u" || Array.isArray(e.dataRequirement) && e.dataRequirement.every(
    (t) => Ye(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => _r(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && u(e.type) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function pD(n) {
  const e = n;
  return p(e) && y(e.resource) && (e.type === "source" || e.type === "alternate" || e.type === "historical") && (typeof e._type > "u" || r(e._type));
}
function du(n) {
  const e = n;
  return b(e) && e.resourceType === "Linkage" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.author > "u" || y(e.author)) && Array.isArray(e.item) && e.item.every(
    (t) => pD(t)
  );
}
function fD(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.deleted > "u" || e.deleted === !1 || e.deleted === !0) && (typeof e._deleted > "u" || r(e._deleted)) && (typeof e.flag > "u" || u(e.flag)) && y(e.item);
}
function gu(n) {
  const e = n;
  return b(e) && e.resourceType === "List" && (typeof e.code > "u" || u(e.code)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.emptyReason > "u" || u(e.emptyReason)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.entry > "u" || Array.isArray(e.entry) && e.entry.every(
    (t) => fD(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (e.mode === "working" || e.mode === "snapshot" || e.mode === "changes") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.orderedBy > "u" || u(e.orderedBy)) && (typeof e.source > "u" || y(e.source)) && (e.status === "entered-in-error" || e.status === "retired" || e.status === "current") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title));
}
function cD(n) {
  const e = n;
  return p(e) && (typeof e.altitude > "u" || typeof e.altitude == "number") && typeof e.latitude == "number" && typeof e.longitude == "number";
}
function lD(n) {
  const e = n;
  return p(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || r(e._allDay)) && (typeof e.closingTime > "u" || typeof e.closingTime == "string") && (typeof e._closingTime > "u" || r(e._closingTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => r(t)
  )) && (typeof e.openingTime > "u" || typeof e.openingTime == "string") && (typeof e._openingTime > "u" || r(e._openingTime));
}
function mu(n) {
  const e = n;
  return b(e) && e.resourceType === "Location" && (typeof e.address > "u" || Te(e.address)) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => r(t)
  )) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || r(e._availabilityExceptions)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.hoursOfOperation > "u" || Array.isArray(e.hoursOfOperation) && e.hoursOfOperation.every(
    (t) => lD(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.managingOrganization > "u" || y(e.managingOrganization)) && (typeof e.mode > "u" || e.mode === "instance" || e.mode === "kind") && (typeof e._mode > "u" || r(e._mode)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.operationalStatus > "u" || V(e.operationalStatus)) && (typeof e.partOf > "u" || y(e.partOf)) && (typeof e.physicalType > "u" || u(e.physicalType)) && (typeof e.position > "u" || cD(e.position)) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "suspended") && (typeof e._status > "u" || r(e._status)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function dD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && ke(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description));
}
function gD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && ke(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description));
}
function mD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => gD(t)
  )) && (typeof e.criteria > "u" || ke(e.criteria)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description));
}
function _D(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => dD(t)
  )) && (typeof e.stratifier > "u" || Array.isArray(e.stratifier) && e.stratifier.every(
    (t) => mD(t)
  ));
}
function vD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && ke(e.criteria) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.usage > "u" || Array.isArray(e.usage) && e.usage.every(
    (t) => u(t)
  ));
}
function _u(n) {
  const e = n;
  return b(e) && e.resourceType === "Measure" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.clinicalRecommendationStatement > "u" || typeof e.clinicalRecommendationStatement == "string") && (typeof e._clinicalRecommendationStatement > "u" || r(e._clinicalRecommendationStatement)) && (typeof e.compositeScoring > "u" || u(e.compositeScoring)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.definition > "u" || Array.isArray(e.definition) && e.definition.every(
    (t) => typeof t == "string"
  )) && (typeof e._definition > "u" || Array.isArray(e._definition) && e._definition.every(
    (t) => r(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.disclaimer > "u" || typeof e.disclaimer == "string") && (typeof e._disclaimer > "u" || r(e._disclaimer)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => _D(t)
  )) && (typeof e.guidance > "u" || typeof e.guidance == "string") && (typeof e._guidance > "u" || r(e._guidance)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.improvementNotation > "u" || u(e.improvementNotation)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.rateAggregation > "u" || typeof e.rateAggregation == "string") && (typeof e._rateAggregation > "u" || r(e._rateAggregation)) && (typeof e.rationale > "u" || typeof e.rationale == "string") && (typeof e._rationale > "u" || r(e._rationale)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.riskAdjustment > "u" || typeof e.riskAdjustment == "string") && (typeof e._riskAdjustment > "u" || r(e._riskAdjustment)) && (typeof e.scoring > "u" || u(e.scoring)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.supplementalData > "u" || Array.isArray(e.supplementalData) && e.supplementalData.every(
    (t) => vD(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function AD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.subjectResults > "u" || y(e.subjectResults));
}
function hD(n) {
  const e = n;
  return p(e) && u(e.code) && u(e.value);
}
function bD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.count > "u" || typeof e.count == "number") && (typeof e.subjectResults > "u" || y(e.subjectResults));
}
function CD(n) {
  const e = n;
  return p(e) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => hD(t)
  )) && (typeof e.measureScore > "u" || S(e.measureScore)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => bD(t)
  )) && (typeof e.value > "u" || u(e.value));
}
function xD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.stratum > "u" || Array.isArray(e.stratum) && e.stratum.every(
    (t) => CD(t)
  ));
}
function DD(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.measureScore > "u" || S(e.measureScore)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => AD(t)
  )) && (typeof e.stratifier > "u" || Array.isArray(e.stratifier) && e.stratifier.every(
    (t) => xD(t)
  ));
}
function vu(n) {
  const e = n;
  return b(e) && e.resourceType === "MeasureReport" && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.evaluatedResource > "u" || Array.isArray(e.evaluatedResource) && e.evaluatedResource.every(
    (t) => y(t)
  )) && (typeof e.group > "u" || Array.isArray(e.group) && e.group.every(
    (t) => DD(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.improvementNotation > "u" || u(e.improvementNotation)) && typeof e.measure == "string" && (typeof e._measure > "u" || r(e._measure)) && D(e.period) && (typeof e.reporter > "u" || y(e.reporter)) && (e.status === "error" || e.status === "pending" || e.status === "complete") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (e.type === "individual" || e.type === "subject-list" || e.type === "summary" || e.type === "data-collection") && (typeof e._type > "u" || r(e._type));
}
function Au(n) {
  const e = n;
  return b(e) && e.resourceType === "Media" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.bodySite > "u" || u(e.bodySite)) && te(e.content) && (typeof e.createdDateTime > "u" || typeof e.createdDateTime == "string") && (typeof e._createdDateTime > "u" || r(e._createdDateTime)) && (typeof e.createdPeriod > "u" || D(e.createdPeriod)) && (typeof e.device > "u" || y(e.device)) && (typeof e.deviceName > "u" || typeof e.deviceName == "string") && (typeof e._deviceName > "u" || r(e._deviceName)) && (typeof e.duration > "u" || typeof e.duration == "number") && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.frames > "u" || typeof e.frames == "number") && (typeof e.height > "u" || typeof e.height == "number") && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && (typeof e.modality > "u" || u(e.modality)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.operator > "u" || y(e.operator)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.type > "u" || u(e.type)) && (typeof e.view > "u" || u(e.view)) && (typeof e.width > "u" || typeof e.width == "number");
}
function TD(n) {
  const e = n;
  return p(e) && (typeof e.isActive > "u" || e.isActive === !1 || e.isActive === !0) && (typeof e._isActive > "u" || r(e._isActive)) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || y(e.itemReference)) && (typeof e.strength > "u" || ge(e.strength));
}
function SD(n) {
  const e = n;
  return p(e) && (typeof e.expirationDate > "u" || typeof e.expirationDate == "string") && (typeof e._expirationDate > "u" || r(e._expirationDate)) && (typeof e.lotNumber > "u" || typeof e.lotNumber == "string") && (typeof e._lotNumber > "u" || r(e._lotNumber));
}
function hu(n) {
  const e = n;
  return b(e) && e.resourceType === "Medication" && (typeof e.amount > "u" || ge(e.amount)) && (typeof e.batch > "u" || SD(e.batch)) && (typeof e.code > "u" || u(e.code)) && (typeof e.form > "u" || u(e.form)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => TD(t)
  )) && (typeof e.manufacturer > "u" || y(e.manufacturer)) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || r(e._status));
}
function RD(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function));
}
function wD(n) {
  const e = n;
  return p(e) && (typeof e.dose > "u" || S(e.dose)) && (typeof e.method > "u" || u(e.method)) && (typeof e.rateRatio > "u" || ge(e.rateRatio)) && (typeof e.rateQuantity > "u" || S(e.rateQuantity)) && (typeof e.route > "u" || u(e.route)) && (typeof e.site > "u" || u(e.site)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text));
}
function bu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicationAdministration" && (typeof e.category > "u" || u(e.category)) && (typeof e.context > "u" || y(e.context)) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => y(t)
  )) && (typeof e.dosage > "u" || wD(e.dosage)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || r(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => r(t)
  )) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => RD(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.request > "u" || y(e.request)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "not-done") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => u(t)
  )) && y(e.subject) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => y(t)
  ));
}
function ID(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function));
}
function PD(n) {
  const e = n;
  return p(e) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => u(t)
  )) && (typeof e.responsibleParty > "u" || Array.isArray(e.responsibleParty) && e.responsibleParty.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || u(e.type)) && typeof e.wasSubstituted == "boolean" && (typeof e._wasSubstituted > "u" || r(e._wasSubstituted));
}
function Cu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicationDispense" && (typeof e.authorizingPrescription > "u" || Array.isArray(e.authorizingPrescription) && e.authorizingPrescription.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.context > "u" || y(e.context)) && (typeof e.daysSupply > "u" || S(e.daysSupply)) && (typeof e.destination > "u" || y(e.destination)) && (typeof e.detectedIssue > "u" || Array.isArray(e.detectedIssue) && e.detectedIssue.every(
    (t) => y(t)
  )) && (typeof e.dosageInstruction > "u" || Array.isArray(e.dosageInstruction) && e.dosageInstruction.every(
    (t) => ht(t)
  )) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => ID(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.receiver > "u" || Array.isArray(e.receiver) && e.receiver.every(
    (t) => y(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "declined" || e.status === "cancelled" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReasonCodeableConcept > "u" || u(e.statusReasonCodeableConcept)) && (typeof e.statusReasonReference > "u" || y(e.statusReasonReference)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.substitution > "u" || PD(e.substitution)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.whenHandedOver > "u" || typeof e.whenHandedOver == "string") && (typeof e._whenHandedOver > "u" || r(e._whenHandedOver)) && (typeof e.whenPrepared > "u" || typeof e.whenPrepared == "string") && (typeof e._whenPrepared > "u" || r(e._whenPrepared));
}
function OD(n) {
  const e = n;
  return p(e) && Array.isArray(e.reference) && e.reference.every(
    (t) => y(t)
  ) && u(e.type);
}
function qD(n) {
  const e = n;
  return p(e) && (typeof e.source > "u" || y(e.source)) && (typeof e.type > "u" || u(e.type));
}
function BD(n) {
  const e = n;
  return p(e) && (typeof e.isActive > "u" || e.isActive === !1 || e.isActive === !0) && (typeof e._isActive > "u" || r(e._isActive)) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || y(e.itemReference)) && (typeof e.strength > "u" || ge(e.strength));
}
function UD(n) {
  const e = n;
  return p(e) && L(e.cost) && (typeof e.source > "u" || typeof e.source == "string") && (typeof e._source > "u" || r(e._source)) && u(e.type);
}
function MD(n) {
  const e = n;
  return p(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.type > "u" || u(e.type));
}
function ED(n) {
  const e = n;
  return p(e) && Array.isArray(e.dosage) && e.dosage.every(
    (t) => ht(t)
  ) && u(e.type);
}
function kD(n) {
  const e = n;
  return p(e) && (typeof e.characteristicCodeableConcept > "u" || u(e.characteristicCodeableConcept)) && (typeof e.characteristicQuantity > "u" || S(e.characteristicQuantity)) && (typeof e.value > "u" || Array.isArray(e.value) && e.value.every(
    (t) => typeof t == "string"
  )) && (typeof e._value > "u" || Array.isArray(e._value) && e._value.every(
    (t) => r(t)
  ));
}
function VD(n) {
  const e = n;
  return p(e) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => ED(t)
  )) && (typeof e.indicationCodeableConcept > "u" || u(e.indicationCodeableConcept)) && (typeof e.indicationReference > "u" || y(e.indicationReference)) && (typeof e.patientCharacteristics > "u" || Array.isArray(e.patientCharacteristics) && e.patientCharacteristics.every(
    (t) => kD(t)
  ));
}
function ND(n) {
  const e = n;
  return p(e) && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => u(t)
  )) && u(e.type);
}
function LD(n) {
  const e = n;
  return p(e) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.type > "u" || u(e.type));
}
function FD(n) {
  const e = n;
  return p(e) && (typeof e.type > "u" || u(e.type)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary));
}
function $D(n) {
  const e = n;
  return p(e) && typeof e.allowed == "boolean" && (typeof e._allowed > "u" || r(e._allowed)) && u(e.type);
}
function jD(n) {
  const e = n;
  return p(e) && u(e.schedule);
}
function WD(n) {
  const e = n;
  return p(e) && (typeof e.period > "u" || ue(e.period)) && S(e.quantity);
}
function HD(n) {
  const e = n;
  return p(e) && (typeof e.maxDispense > "u" || WD(e.maxDispense)) && y(e.regulatoryAuthority) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => jD(t)
  )) && (typeof e.substitution > "u" || Array.isArray(e.substitution) && e.substitution.every(
    (t) => $D(t)
  ));
}
function QD(n) {
  const e = n;
  return p(e) && (typeof e.areaUnderCurve > "u" || Array.isArray(e.areaUnderCurve) && e.areaUnderCurve.every(
    (t) => S(t)
  )) && (typeof e.halfLifePeriod > "u" || ue(e.halfLifePeriod)) && (typeof e.lethalDose50 > "u" || Array.isArray(e.lethalDose50) && e.lethalDose50.every(
    (t) => S(t)
  ));
}
function xu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicationKnowledge" && (typeof e.administrationGuidelines > "u" || Array.isArray(e.administrationGuidelines) && e.administrationGuidelines.every(
    (t) => VD(t)
  )) && (typeof e.amount > "u" || S(e.amount)) && (typeof e.associatedMedication > "u" || Array.isArray(e.associatedMedication) && e.associatedMedication.every(
    (t) => y(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.contraindication > "u" || Array.isArray(e.contraindication) && e.contraindication.every(
    (t) => y(t)
  )) && (typeof e.cost > "u" || Array.isArray(e.cost) && e.cost.every(
    (t) => UD(t)
  )) && (typeof e.doseForm > "u" || u(e.doseForm)) && (typeof e.drugCharacteristic > "u" || Array.isArray(e.drugCharacteristic) && e.drugCharacteristic.every(
    (t) => FD(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => BD(t)
  )) && (typeof e.intendedRoute > "u" || Array.isArray(e.intendedRoute) && e.intendedRoute.every(
    (t) => u(t)
  )) && (typeof e.kinetics > "u" || Array.isArray(e.kinetics) && e.kinetics.every(
    (t) => QD(t)
  )) && (typeof e.manufacturer > "u" || y(e.manufacturer)) && (typeof e.medicineClassification > "u" || Array.isArray(e.medicineClassification) && e.medicineClassification.every(
    (t) => ND(t)
  )) && (typeof e.monitoringProgram > "u" || Array.isArray(e.monitoringProgram) && e.monitoringProgram.every(
    (t) => MD(t)
  )) && (typeof e.monograph > "u" || Array.isArray(e.monograph) && e.monograph.every(
    (t) => qD(t)
  )) && (typeof e.packaging > "u" || LD(e.packaging)) && (typeof e.preparationInstruction > "u" || typeof e.preparationInstruction == "string") && (typeof e._preparationInstruction > "u" || r(e._preparationInstruction)) && (typeof e.productType > "u" || Array.isArray(e.productType) && e.productType.every(
    (t) => u(t)
  )) && (typeof e.regulatory > "u" || Array.isArray(e.regulatory) && e.regulatory.every(
    (t) => HD(t)
  )) && (typeof e.relatedMedicationKnowledge > "u" || Array.isArray(e.relatedMedicationKnowledge) && e.relatedMedicationKnowledge.every(
    (t) => OD(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || r(e._status)) && (typeof e.synonym > "u" || Array.isArray(e.synonym) && e.synonym.every(
    (t) => typeof t == "string"
  )) && (typeof e._synonym > "u" || Array.isArray(e._synonym) && e._synonym.every(
    (t) => r(t)
  ));
}
function zD(n) {
  const e = n;
  return p(e) && (typeof e.duration > "u" || ue(e.duration)) && (typeof e.quantity > "u" || S(e.quantity));
}
function GD(n) {
  const e = n;
  return p(e) && (typeof e.dispenseInterval > "u" || ue(e.dispenseInterval)) && (typeof e.expectedSupplyDuration > "u" || ue(e.expectedSupplyDuration)) && (typeof e.initialFill > "u" || zD(e.initialFill)) && (typeof e.numberOfRepeatsAllowed > "u" || typeof e.numberOfRepeatsAllowed == "number") && (typeof e.performer > "u" || y(e.performer)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.validityPeriod > "u" || D(e.validityPeriod));
}
function KD(n) {
  const e = n;
  return p(e) && (typeof e.allowedBoolean > "u" || e.allowedBoolean === !1 || e.allowedBoolean === !0) && (typeof e._allowedBoolean > "u" || r(e._allowedBoolean)) && (typeof e.allowedCodeableConcept > "u" || u(e.allowedCodeableConcept)) && (typeof e.reason > "u" || u(e.reason));
}
function Du(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicationRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.courseOfTherapyType > "u" || u(e.courseOfTherapyType)) && (typeof e.detectedIssue > "u" || Array.isArray(e.detectedIssue) && e.detectedIssue.every(
    (t) => y(t)
  )) && (typeof e.dispenseRequest > "u" || GD(e.dispenseRequest)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && (typeof e.dosageInstruction > "u" || Array.isArray(e.dosageInstruction) && e.dosageInstruction.every(
    (t) => ht(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.eventHistory > "u" || Array.isArray(e.eventHistory) && e.eventHistory.every(
    (t) => y(t)
  )) && (typeof e.groupIdentifier > "u" || A(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => y(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.performerType > "u" || u(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.priorPrescription > "u" || y(e.priorPrescription)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.recorder > "u" || y(e.recorder)) && (typeof e.reportedBoolean > "u" || e.reportedBoolean === !1 || e.reportedBoolean === !0) && (typeof e._reportedBoolean > "u" || r(e._reportedBoolean)) && (typeof e.reportedReference > "u" || y(e.reportedReference)) && (typeof e.requester > "u" || y(e.requester)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "cancelled" || e.status === "completed" || e.status === "stopped") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && y(e.subject) && (typeof e.substitution > "u" || KD(e.substitution)) && (typeof e.supportingInformation > "u" || Array.isArray(e.supportingInformation) && e.supportingInformation.every(
    (t) => y(t)
  ));
}
function Tu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicationStatement" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.context > "u" || y(e.context)) && (typeof e.dateAsserted > "u" || typeof e.dateAsserted == "string") && (typeof e._dateAsserted > "u" || r(e._dateAsserted)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => y(t)
  )) && (typeof e.dosage > "u" || Array.isArray(e.dosage) && e.dosage.every(
    (t) => ht(t)
  )) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || r(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.informationSource > "u" || y(e.informationSource)) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "completed" || e.status === "stopped" || e.status === "intended" || e.status === "not-taken") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || Array.isArray(e.statusReason) && e.statusReason.every(
    (t) => u(t)
  )) && y(e.subject);
}
function YD(n) {
  const e = n;
  return p(e) && typeof e.part == "string" && (typeof e._part > "u" || r(e._part)) && V(e.type);
}
function JD(n) {
  const e = n;
  return p(e) && u(e.country) && (typeof e.jurisdiction > "u" || u(e.jurisdiction)) && u(e.language);
}
function ZD(n) {
  const e = n;
  return p(e) && (typeof e.countryLanguage > "u" || Array.isArray(e.countryLanguage) && e.countryLanguage.every(
    (t) => JD(t)
  )) && (typeof e.namePart > "u" || Array.isArray(e.namePart) && e.namePart.every(
    (t) => YD(t)
  )) && typeof e.productName == "string" && (typeof e._productName > "u" || r(e._productName));
}
function XD(n) {
  const e = n;
  return p(e) && (typeof e.authorisationReferenceNumber > "u" || A(e.authorisationReferenceNumber)) && (typeof e.confidentialityIndicator > "u" || u(e.confidentialityIndicator)) && (typeof e.effectiveDate > "u" || typeof e.effectiveDate == "string") && (typeof e._effectiveDate > "u" || r(e._effectiveDate)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => y(t)
  )) && (typeof e.operationType > "u" || u(e.operationType)) && (typeof e.regulator > "u" || y(e.regulator));
}
function eT(n) {
  const e = n;
  return p(e) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.indicationCodeableConcept > "u" || u(e.indicationCodeableConcept)) && (typeof e.indicationReference > "u" || y(e.indicationReference)) && (typeof e.intendedUse > "u" || u(e.intendedUse)) && (typeof e.species > "u" || u(e.species)) && (typeof e.status > "u" || u(e.status)) && (typeof e.type > "u" || u(e.type));
}
function Su(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProduct" && (typeof e.additionalMonitoringIndicator > "u" || u(e.additionalMonitoringIndicator)) && (typeof e.attachedDocument > "u" || Array.isArray(e.attachedDocument) && e.attachedDocument.every(
    (t) => y(t)
  )) && (typeof e.clinicalTrial > "u" || Array.isArray(e.clinicalTrial) && e.clinicalTrial.every(
    (t) => y(t)
  )) && (typeof e.combinedPharmaceuticalDoseForm > "u" || u(e.combinedPharmaceuticalDoseForm)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => y(t)
  )) && (typeof e.crossReference > "u" || Array.isArray(e.crossReference) && e.crossReference.every(
    (t) => A(t)
  )) && (typeof e.domain > "u" || V(e.domain)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.legalStatusOfSupply > "u" || u(e.legalStatusOfSupply)) && (typeof e.manufacturingBusinessOperation > "u" || Array.isArray(e.manufacturingBusinessOperation) && e.manufacturingBusinessOperation.every(
    (t) => XD(t)
  )) && (typeof e.marketingStatus > "u" || Array.isArray(e.marketingStatus) && e.marketingStatus.every(
    (t) => kc(t)
  )) && (typeof e.masterFile > "u" || Array.isArray(e.masterFile) && e.masterFile.every(
    (t) => y(t)
  )) && Array.isArray(e.name) && e.name.every(
    (t) => ZD(t)
  ) && (typeof e.packagedMedicinalProduct > "u" || Array.isArray(e.packagedMedicinalProduct) && e.packagedMedicinalProduct.every(
    (t) => y(t)
  )) && (typeof e.paediatricUseIndicator > "u" || u(e.paediatricUseIndicator)) && (typeof e.pharmaceuticalProduct > "u" || Array.isArray(e.pharmaceuticalProduct) && e.pharmaceuticalProduct.every(
    (t) => y(t)
  )) && (typeof e.productClassification > "u" || Array.isArray(e.productClassification) && e.productClassification.every(
    (t) => u(t)
  )) && (typeof e.specialDesignation > "u" || Array.isArray(e.specialDesignation) && e.specialDesignation.every(
    (t) => eT(t)
  )) && (typeof e.specialMeasures > "u" || Array.isArray(e.specialMeasures) && e.specialMeasures.every(
    (t) => typeof t == "string"
  )) && (typeof e._specialMeasures > "u" || Array.isArray(e._specialMeasures) && e._specialMeasures.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function tT(n) {
  const e = n;
  return p(e) && (typeof e.country > "u" || u(e.country)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.legalStatusOfSupply > "u" || u(e.legalStatusOfSupply)) && (typeof e.validityPeriod > "u" || D(e.validityPeriod));
}
function el(n) {
  const e = n;
  return p(e) && (typeof e.application > "u" || Array.isArray(e.application) && e.application.every(
    (t) => el(t)
  )) && (typeof e.datePeriod > "u" || D(e.datePeriod)) && (typeof e.dateDateTime > "u" || typeof e.dateDateTime == "string") && (typeof e._dateDateTime > "u" || r(e._dateDateTime)) && (typeof e.identifier > "u" || A(e.identifier)) && u(e.type);
}
function Ru(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductAuthorization" && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => u(t)
  )) && (typeof e.dataExclusivityPeriod > "u" || D(e.dataExclusivityPeriod)) && (typeof e.dateOfFirstAuthorization > "u" || typeof e.dateOfFirstAuthorization == "string") && (typeof e._dateOfFirstAuthorization > "u" || r(e._dateOfFirstAuthorization)) && (typeof e.holder > "u" || y(e.holder)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.internationalBirthDate > "u" || typeof e.internationalBirthDate == "string") && (typeof e._internationalBirthDate > "u" || r(e._internationalBirthDate)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.jurisdictionalAuthorization > "u" || Array.isArray(e.jurisdictionalAuthorization) && e.jurisdictionalAuthorization.every(
    (t) => tT(t)
  )) && (typeof e.legalBasis > "u" || u(e.legalBasis)) && (typeof e.procedure > "u" || el(e.procedure)) && (typeof e.regulator > "u" || y(e.regulator)) && (typeof e.restoreDate > "u" || typeof e.restoreDate == "string") && (typeof e._restoreDate > "u" || r(e._restoreDate)) && (typeof e.status > "u" || u(e.status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || r(e._statusDate)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.validityPeriod > "u" || D(e.validityPeriod));
}
function rT(n) {
  const e = n;
  return p(e) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && u(e.therapyRelationshipType);
}
function wu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductContraindication" && (typeof e.comorbidity > "u" || Array.isArray(e.comorbidity) && e.comorbidity.every(
    (t) => u(t)
  )) && (typeof e.disease > "u" || u(e.disease)) && (typeof e.diseaseStatus > "u" || u(e.diseaseStatus)) && (typeof e.otherTherapy > "u" || Array.isArray(e.otherTherapy) && e.otherTherapy.every(
    (t) => rT(t)
  )) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => hp(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.therapeuticIndication > "u" || Array.isArray(e.therapeuticIndication) && e.therapeuticIndication.every(
    (t) => y(t)
  ));
}
function oT(n) {
  const e = n;
  return p(e) && (typeof e.medicationCodeableConcept > "u" || u(e.medicationCodeableConcept)) && (typeof e.medicationReference > "u" || y(e.medicationReference)) && u(e.therapyRelationshipType);
}
function Iu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductIndication" && (typeof e.comorbidity > "u" || Array.isArray(e.comorbidity) && e.comorbidity.every(
    (t) => u(t)
  )) && (typeof e.diseaseStatus > "u" || u(e.diseaseStatus)) && (typeof e.diseaseSymptomProcedure > "u" || u(e.diseaseSymptomProcedure)) && (typeof e.duration > "u" || S(e.duration)) && (typeof e.intendedEffect > "u" || u(e.intendedEffect)) && (typeof e.otherTherapy > "u" || Array.isArray(e.otherTherapy) && e.otherTherapy.every(
    (t) => oT(t)
  )) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => hp(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.undesirableEffect > "u" || Array.isArray(e.undesirableEffect) && e.undesirableEffect.every(
    (t) => y(t)
  ));
}
function iT(n) {
  const e = n;
  return p(e) && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => u(t)
  )) && (typeof e.measurementPoint > "u" || typeof e.measurementPoint == "string") && (typeof e._measurementPoint > "u" || r(e._measurementPoint)) && ge(e.strength) && (typeof e.strengthLowLimit > "u" || ge(e.strengthLowLimit)) && (typeof e.substance > "u" || u(e.substance));
}
function tl(n) {
  const e = n;
  return p(e) && (typeof e.concentration > "u" || ge(e.concentration)) && (typeof e.concentrationLowLimit > "u" || ge(e.concentrationLowLimit)) && (typeof e.country > "u" || Array.isArray(e.country) && e.country.every(
    (t) => u(t)
  )) && (typeof e.measurementPoint > "u" || typeof e.measurementPoint == "string") && (typeof e._measurementPoint > "u" || r(e._measurementPoint)) && ge(e.presentation) && (typeof e.presentationLowLimit > "u" || ge(e.presentationLowLimit)) && (typeof e.referenceStrength > "u" || Array.isArray(e.referenceStrength) && e.referenceStrength.every(
    (t) => iT(t)
  ));
}
function nT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.confidentiality > "u" || u(e.confidentiality)) && u(e.group) && (typeof e.strength > "u" || Array.isArray(e.strength) && e.strength.every(
    (t) => tl(t)
  ));
}
function aT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.strength > "u" || Array.isArray(e.strength) && e.strength.every(
    (t) => tl(t)
  ));
}
function Pu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductIngredient" && (typeof e.allergenicIndicator > "u" || e.allergenicIndicator === !1 || e.allergenicIndicator === !0) && (typeof e._allergenicIndicator > "u" || r(e._allergenicIndicator)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => y(t)
  )) && u(e.role) && (typeof e.specifiedSubstance > "u" || Array.isArray(e.specifiedSubstance) && e.specifiedSubstance.every(
    (t) => nT(t)
  )) && (typeof e.substance > "u" || aT(e.substance));
}
function uT(n) {
  const e = n;
  return p(e) && (typeof e.itemReference > "u" || y(e.itemReference)) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept));
}
function Ou(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductInteraction" && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.effect > "u" || u(e.effect)) && (typeof e.incidence > "u" || u(e.incidence)) && (typeof e.interactant > "u" || Array.isArray(e.interactant) && e.interactant.every(
    (t) => uT(t)
  )) && (typeof e.management > "u" || u(e.management)) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function qu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductManufactured" && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => y(t)
  )) && u(e.manufacturedDoseForm) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => y(t)
  )) && (typeof e.otherCharacteristics > "u" || Array.isArray(e.otherCharacteristics) && e.otherCharacteristics.every(
    (t) => u(t)
  )) && (typeof e.physicalCharacteristics > "u" || bp(e.physicalCharacteristics)) && S(e.quantity) && (typeof e.unitOfPresentation > "u" || u(e.unitOfPresentation));
}
function yT(n) {
  const e = n;
  return p(e) && (typeof e.immediatePackaging > "u" || A(e.immediatePackaging)) && A(e.outerPackaging);
}
function rl(n) {
  const e = n;
  return p(e) && (typeof e.alternateMaterial > "u" || Array.isArray(e.alternateMaterial) && e.alternateMaterial.every(
    (t) => u(t)
  )) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.manufacturedItem > "u" || Array.isArray(e.manufacturedItem) && e.manufacturedItem.every(
    (t) => y(t)
  )) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => y(t)
  )) && (typeof e.material > "u" || Array.isArray(e.material) && e.material.every(
    (t) => u(t)
  )) && (typeof e.otherCharacteristics > "u" || Array.isArray(e.otherCharacteristics) && e.otherCharacteristics.every(
    (t) => u(t)
  )) && (typeof e.packageItem > "u" || Array.isArray(e.packageItem) && e.packageItem.every(
    (t) => rl(t)
  )) && (typeof e.physicalCharacteristics > "u" || bp(e.physicalCharacteristics)) && S(e.quantity) && (typeof e.shelfLifeStorage > "u" || Array.isArray(e.shelfLifeStorage) && e.shelfLifeStorage.every(
    (t) => Nc(t)
  )) && u(e.type);
}
function Bu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductPackaged" && (typeof e.batchIdentifier > "u" || Array.isArray(e.batchIdentifier) && e.batchIdentifier.every(
    (t) => yT(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.legalStatusOfSupply > "u" || u(e.legalStatusOfSupply)) && (typeof e.manufacturer > "u" || Array.isArray(e.manufacturer) && e.manufacturer.every(
    (t) => y(t)
  )) && (typeof e.marketingAuthorization > "u" || y(e.marketingAuthorization)) && (typeof e.marketingStatus > "u" || Array.isArray(e.marketingStatus) && e.marketingStatus.every(
    (t) => kc(t)
  )) && Array.isArray(e.packageItem) && e.packageItem.every(
    (t) => rl(t)
  ) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  ));
}
function sT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.status > "u" || u(e.status));
}
function pT(n) {
  const e = n;
  return p(e) && (typeof e.supportingInformation > "u" || typeof e.supportingInformation == "string") && (typeof e._supportingInformation > "u" || r(e._supportingInformation)) && u(e.tissue) && S(e.value);
}
function fT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.withdrawalPeriod > "u" || Array.isArray(e.withdrawalPeriod) && e.withdrawalPeriod.every(
    (t) => pT(t)
  ));
}
function cT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.firstDose > "u" || S(e.firstDose)) && (typeof e.maxDosePerDay > "u" || S(e.maxDosePerDay)) && (typeof e.maxDosePerTreatmentPeriod > "u" || ge(e.maxDosePerTreatmentPeriod)) && (typeof e.maxSingleDose > "u" || S(e.maxSingleDose)) && (typeof e.maxTreatmentPeriod > "u" || ue(e.maxTreatmentPeriod)) && (typeof e.targetSpecies > "u" || Array.isArray(e.targetSpecies) && e.targetSpecies.every(
    (t) => fT(t)
  ));
}
function Uu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductPharmaceutical" && u(e.administrableDoseForm) && (typeof e.characteristics > "u" || Array.isArray(e.characteristics) && e.characteristics.every(
    (t) => sT(t)
  )) && (typeof e.device > "u" || Array.isArray(e.device) && e.device.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => y(t)
  )) && Array.isArray(e.routeOfAdministration) && e.routeOfAdministration.every(
    (t) => cT(t)
  ) && (typeof e.unitOfPresentation > "u" || u(e.unitOfPresentation));
}
function Mu(n) {
  const e = n;
  return b(e) && e.resourceType === "MedicinalProductUndesirableEffect" && (typeof e.classification > "u" || u(e.classification)) && (typeof e.frequencyOfOccurrence > "u" || u(e.frequencyOfOccurrence)) && (typeof e.population > "u" || Array.isArray(e.population) && e.population.every(
    (t) => hp(t)
  )) && (typeof e.subject > "u" || Array.isArray(e.subject) && e.subject.every(
    (t) => y(t)
  )) && (typeof e.symptomConditionEffect > "u" || u(e.symptomConditionEffect));
}
function lT(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || r(e._max)) && typeof e.min == "number" && (typeof e.profile > "u" || typeof e.profile == "string") && (typeof e._profile > "u" || r(e._profile));
}
function dT(n) {
  const e = n;
  return p(e) && typeof e.message == "string" && (typeof e._message > "u" || r(e._message)) && (typeof e.situation > "u" || typeof e.situation == "string") && (typeof e._situation > "u" || r(e._situation));
}
function Eu(n) {
  const e = n;
  return b(e) && e.resourceType === "MessageDefinition" && (typeof e.allowedResponse > "u" || Array.isArray(e.allowedResponse) && e.allowedResponse.every(
    (t) => dT(t)
  )) && (typeof e.base > "u" || typeof e.base == "string") && (typeof e._base > "u" || r(e._base)) && (typeof e.category > "u" || e.category === "consequence" || e.category === "currency" || e.category === "notification") && (typeof e._category > "u" || r(e._category)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.eventCoding > "u" || V(e.eventCoding)) && (typeof e.eventUri > "u" || typeof e.eventUri == "string") && (typeof e._eventUri > "u" || r(e._eventUri)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => lT(t)
  )) && (typeof e.graph > "u" || Array.isArray(e.graph) && e.graph.every(
    (t) => typeof t == "string"
  )) && (typeof e._graph > "u" || Array.isArray(e._graph) && e._graph.every(
    (t) => r(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => typeof t == "string"
  )) && (typeof e._parent > "u" || Array.isArray(e._parent) && e._parent.every(
    (t) => r(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => typeof t == "string"
  )) && (typeof e._replaces > "u" || Array.isArray(e._replaces) && e._replaces.every(
    (t) => r(t)
  )) && (typeof e.responseRequired > "u" || e.responseRequired === "always" || e.responseRequired === "on-error" || e.responseRequired === "never" || e.responseRequired === "on-success") && (typeof e._responseRequired > "u" || r(e._responseRequired)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function gT(n) {
  const e = n;
  return p(e) && typeof e.endpoint == "string" && (typeof e._endpoint > "u" || r(e._endpoint)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.receiver > "u" || y(e.receiver)) && (typeof e.target > "u" || y(e.target));
}
function mT(n) {
  const e = n;
  return p(e) && (typeof e.contact > "u" || he(e.contact)) && typeof e.endpoint == "string" && (typeof e._endpoint > "u" || r(e._endpoint)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.software > "u" || typeof e.software == "string") && (typeof e._software > "u" || r(e._software)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function _T(n) {
  const e = n;
  return p(e) && (e.code === "ok" || e.code === "transient-error" || e.code === "fatal-error") && (typeof e._code > "u" || r(e._code)) && (typeof e.details > "u" || y(e.details)) && typeof e.identifier == "string" && (typeof e._identifier > "u" || r(e._identifier));
}
function ku(n) {
  const e = n;
  return b(e) && e.resourceType === "MessageHeader" && (typeof e.author > "u" || y(e.author)) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.destination > "u" || Array.isArray(e.destination) && e.destination.every(
    (t) => gT(t)
  )) && (typeof e.enterer > "u" || y(e.enterer)) && (typeof e.eventCoding > "u" || V(e.eventCoding)) && (typeof e.eventUri > "u" || typeof e.eventUri == "string") && (typeof e._eventUri > "u" || r(e._eventUri)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => y(t)
  )) && (typeof e.reason > "u" || u(e.reason)) && (typeof e.response > "u" || _T(e.response)) && (typeof e.responsible > "u" || y(e.responsible)) && (typeof e.sender > "u" || y(e.sender)) && mT(e.source);
}
function vT(n) {
  const e = n;
  return p(e) && (typeof e.chromosome > "u" || u(e.chromosome)) && (typeof e.genomeBuild > "u" || typeof e.genomeBuild == "string") && (typeof e._genomeBuild > "u" || r(e._genomeBuild)) && (typeof e.orientation > "u" || e.orientation === "sense" || e.orientation === "antisense") && (typeof e._orientation > "u" || r(e._orientation)) && (typeof e.referenceSeqId > "u" || u(e.referenceSeqId)) && (typeof e.referenceSeqPointer > "u" || y(e.referenceSeqPointer)) && (typeof e.referenceSeqString > "u" || typeof e.referenceSeqString == "string") && (typeof e._referenceSeqString > "u" || r(e._referenceSeqString)) && (typeof e.strand > "u" || e.strand === "watson" || e.strand === "crick") && (typeof e._strand > "u" || r(e._strand)) && (typeof e.windowEnd > "u" || typeof e.windowEnd == "number") && (typeof e.windowStart > "u" || typeof e.windowStart == "number");
}
function AT(n) {
  const e = n;
  return p(e) && (typeof e.cigar > "u" || typeof e.cigar == "string") && (typeof e._cigar > "u" || r(e._cigar)) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.observedAllele > "u" || typeof e.observedAllele == "string") && (typeof e._observedAllele > "u" || r(e._observedAllele)) && (typeof e.referenceAllele > "u" || typeof e.referenceAllele == "string") && (typeof e._referenceAllele > "u" || r(e._referenceAllele)) && (typeof e.start > "u" || typeof e.start == "number") && (typeof e.variantPointer > "u" || y(e.variantPointer));
}
function hT(n) {
  const e = n;
  return p(e) && (typeof e.fMeasure > "u" || Array.isArray(e.fMeasure) && e.fMeasure.every(
    (t) => typeof t == "number"
  )) && (typeof e.numFN > "u" || Array.isArray(e.numFN) && e.numFN.every(
    (t) => typeof t == "number"
  )) && (typeof e.numFP > "u" || Array.isArray(e.numFP) && e.numFP.every(
    (t) => typeof t == "number"
  )) && (typeof e.numTP > "u" || Array.isArray(e.numTP) && e.numTP.every(
    (t) => typeof t == "number"
  )) && (typeof e.precision > "u" || Array.isArray(e.precision) && e.precision.every(
    (t) => typeof t == "number"
  )) && (typeof e.score > "u" || Array.isArray(e.score) && e.score.every(
    (t) => typeof t == "number"
  )) && (typeof e.sensitivity > "u" || Array.isArray(e.sensitivity) && e.sensitivity.every(
    (t) => typeof t == "number"
  ));
}
function bT(n) {
  const e = n;
  return p(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.fScore > "u" || typeof e.fScore == "number") && (typeof e.gtFP > "u" || typeof e.gtFP == "number") && (typeof e.method > "u" || u(e.method)) && (typeof e.precision > "u" || typeof e.precision == "number") && (typeof e.queryFP > "u" || typeof e.queryFP == "number") && (typeof e.queryTP > "u" || typeof e.queryTP == "number") && (typeof e.recall > "u" || typeof e.recall == "number") && (typeof e.roc > "u" || hT(e.roc)) && (typeof e.score > "u" || S(e.score)) && (typeof e.standardSequence > "u" || u(e.standardSequence)) && (typeof e.start > "u" || typeof e.start == "number") && (typeof e.truthFN > "u" || typeof e.truthFN == "number") && (typeof e.truthTP > "u" || typeof e.truthTP == "number") && (e.type === "unknown" || e.type === "indel" || e.type === "snp") && (typeof e._type > "u" || r(e._type));
}
function CT(n) {
  const e = n;
  return p(e) && (typeof e.datasetId > "u" || typeof e.datasetId == "string") && (typeof e._datasetId > "u" || r(e._datasetId)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.readsetId > "u" || typeof e.readsetId == "string") && (typeof e._readsetId > "u" || r(e._readsetId)) && (e.type === "other" || e.type === "directlink" || e.type === "openapi" || e.type === "login" || e.type === "oauth") && (typeof e._type > "u" || r(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.variantsetId > "u" || typeof e.variantsetId == "string") && (typeof e._variantsetId > "u" || r(e._variantsetId));
}
function xT(n) {
  const e = n;
  return p(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.start > "u" || typeof e.start == "number");
}
function DT(n) {
  const e = n;
  return p(e) && (typeof e.end > "u" || typeof e.end == "number") && (typeof e.start > "u" || typeof e.start == "number");
}
function TT(n) {
  const e = n;
  return p(e) && (typeof e.exact > "u" || e.exact === !1 || e.exact === !0) && (typeof e._exact > "u" || r(e._exact)) && (typeof e.inner > "u" || DT(e.inner)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.outer > "u" || xT(e.outer)) && (typeof e.variantType > "u" || u(e.variantType));
}
function Vu(n) {
  const e = n;
  return b(e) && e.resourceType === "MolecularSequence" && typeof e.coordinateSystem == "number" && (typeof e.device > "u" || y(e.device)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.observedSeq > "u" || typeof e.observedSeq == "string") && (typeof e._observedSeq > "u" || r(e._observedSeq)) && (typeof e.patient > "u" || y(e.patient)) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.pointer > "u" || Array.isArray(e.pointer) && e.pointer.every(
    (t) => y(t)
  )) && (typeof e.quality > "u" || Array.isArray(e.quality) && e.quality.every(
    (t) => bT(t)
  )) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.readCoverage > "u" || typeof e.readCoverage == "number") && (typeof e.referenceSeq > "u" || vT(e.referenceSeq)) && (typeof e.repository > "u" || Array.isArray(e.repository) && e.repository.every(
    (t) => CT(t)
  )) && (typeof e.specimen > "u" || y(e.specimen)) && (typeof e.structureVariant > "u" || Array.isArray(e.structureVariant) && e.structureVariant.every(
    (t) => TT(t)
  )) && (typeof e.type > "u" || e.type === "aa" || e.type === "dna" || e.type === "rna") && (typeof e._type > "u" || r(e._type)) && (typeof e.variant > "u" || Array.isArray(e.variant) && e.variant.every(
    (t) => AT(t)
  ));
}
function ST(n) {
  const e = n;
  return p(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.period > "u" || D(e.period)) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || r(e._preferred)) && (e.type === "other" || e.type === "uri" || e.type === "oid" || e.type === "uuid") && (typeof e._type > "u" || r(e._type)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Nu(n) {
  const e = n;
  return b(e) && e.resourceType === "NamingSystem" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (e.kind === "codesystem" || e.kind === "identifier" || e.kind === "root") && (typeof e._kind > "u" || r(e._kind)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.responsible > "u" || typeof e.responsible == "string") && (typeof e._responsible > "u" || r(e._responsible)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.type > "u" || u(e.type)) && Array.isArray(e.uniqueId) && e.uniqueId.every(
    (t) => ST(t)
  ) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  ));
}
function RT(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || S(e.amount)) && (typeof e.modifier > "u" || u(e.modifier));
}
function wT(n) {
  const e = n;
  return p(e) && (typeof e.foodType > "u" || u(e.foodType)) && (typeof e.modifier > "u" || u(e.modifier));
}
function IT(n) {
  const e = n;
  return p(e) && (typeof e.fluidConsistencyType > "u" || Array.isArray(e.fluidConsistencyType) && e.fluidConsistencyType.every(
    (t) => u(t)
  )) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || r(e._instruction)) && (typeof e.nutrient > "u" || Array.isArray(e.nutrient) && e.nutrient.every(
    (t) => RT(t)
  )) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => le(t)
  )) && (typeof e.texture > "u" || Array.isArray(e.texture) && e.texture.every(
    (t) => wT(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function PT(n) {
  const e = n;
  return p(e) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || r(e._instruction)) && (typeof e.productName > "u" || typeof e.productName == "string") && (typeof e._productName > "u" || r(e._productName)) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.schedule > "u" || Array.isArray(e.schedule) && e.schedule.every(
    (t) => le(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function OT(n) {
  const e = n;
  return p(e) && (typeof e.quantity > "u" || S(e.quantity)) && (typeof e.rateQuantity > "u" || S(e.rateQuantity)) && (typeof e.rateRatio > "u" || ge(e.rateRatio)) && (typeof e.schedule > "u" || le(e.schedule));
}
function qT(n) {
  const e = n;
  return p(e) && (typeof e.additiveProductName > "u" || typeof e.additiveProductName == "string") && (typeof e._additiveProductName > "u" || r(e._additiveProductName)) && (typeof e.additiveType > "u" || u(e.additiveType)) && (typeof e.administration > "u" || Array.isArray(e.administration) && e.administration.every(
    (t) => OT(t)
  )) && (typeof e.administrationInstruction > "u" || typeof e.administrationInstruction == "string") && (typeof e._administrationInstruction > "u" || r(e._administrationInstruction)) && (typeof e.baseFormulaProductName > "u" || typeof e.baseFormulaProductName == "string") && (typeof e._baseFormulaProductName > "u" || r(e._baseFormulaProductName)) && (typeof e.baseFormulaType > "u" || u(e.baseFormulaType)) && (typeof e.caloricDensity > "u" || S(e.caloricDensity)) && (typeof e.maxVolumeToDeliver > "u" || S(e.maxVolumeToDeliver)) && (typeof e.routeofAdministration > "u" || u(e.routeofAdministration));
}
function Lu(n) {
  const e = n;
  return b(e) && e.resourceType === "NutritionOrder" && (typeof e.allergyIntolerance > "u" || Array.isArray(e.allergyIntolerance) && e.allergyIntolerance.every(
    (t) => y(t)
  )) && typeof e.dateTime == "string" && (typeof e._dateTime > "u" || r(e._dateTime)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.enteralFormula > "u" || qT(e.enteralFormula)) && (typeof e.excludeFoodModifier > "u" || Array.isArray(e.excludeFoodModifier) && e.excludeFoodModifier.every(
    (t) => u(t)
  )) && (typeof e.foodPreferenceModifier > "u" || Array.isArray(e.foodPreferenceModifier) && e.foodPreferenceModifier.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiates > "u" || Array.isArray(e.instantiates) && e.instantiates.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiates > "u" || Array.isArray(e._instantiates) && e._instantiates.every(
    (t) => r(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.oralDiet > "u" || IT(e.oralDiet)) && (typeof e.orderer > "u" || y(e.orderer)) && y(e.patient) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && (typeof e.supplement > "u" || Array.isArray(e.supplement) && e.supplement.every(
    (t) => PT(t)
  ));
}
function ol(n) {
  const e = n;
  return p(e) && (typeof e.age > "u" || K(e.age)) && (typeof e.appliesTo > "u" || Array.isArray(e.appliesTo) && e.appliesTo.every(
    (t) => u(t)
  )) && (typeof e.high > "u" || S(e.high)) && (typeof e.low > "u" || S(e.low)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || u(e.type));
}
function BT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.dataAbsentReason > "u" || u(e.dataAbsentReason)) && (typeof e.interpretation > "u" || Array.isArray(e.interpretation) && e.interpretation.every(
    (t) => u(t)
  )) && (typeof e.referenceRange > "u" || Array.isArray(e.referenceRange) && e.referenceRange.every(
    (t) => ol(t)
  )) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod));
}
function Fu(n) {
  const e = n;
  return b(e) && e.resourceType === "Observation" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => BT(t)
  )) && (typeof e.dataAbsentReason > "u" || u(e.dataAbsentReason)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => y(t)
  )) && (typeof e.device > "u" || y(e.device)) && (typeof e.effectiveDateTime > "u" || typeof e.effectiveDateTime == "string") && (typeof e._effectiveDateTime > "u" || r(e._effectiveDateTime)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.effectiveTiming > "u" || le(e.effectiveTiming)) && (typeof e.effectiveInstant > "u" || typeof e.effectiveInstant == "string") && (typeof e._effectiveInstant > "u" || r(e._effectiveInstant)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => y(t)
  )) && (typeof e.hasMember > "u" || Array.isArray(e.hasMember) && e.hasMember.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.interpretation > "u" || Array.isArray(e.interpretation) && e.interpretation.every(
    (t) => u(t)
  )) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && (typeof e.method > "u" || u(e.method)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => y(t)
  )) && (typeof e.referenceRange > "u" || Array.isArray(e.referenceRange) && e.referenceRange.every(
    (t) => ol(t)
  )) && (typeof e.specimen > "u" || y(e.specimen)) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod));
}
function UT(n) {
  const e = n;
  return p(e) && (typeof e.conversionFactor > "u" || typeof e.conversionFactor == "number") && (typeof e.customaryUnit > "u" || u(e.customaryUnit)) && (typeof e.decimalPrecision > "u" || typeof e.decimalPrecision == "number") && (typeof e.unit > "u" || u(e.unit));
}
function MT(n) {
  const e = n;
  return p(e) && (typeof e.age > "u" || K(e.age)) && (typeof e.appliesTo > "u" || Array.isArray(e.appliesTo) && e.appliesTo.every(
    (t) => u(t)
  )) && (typeof e.category > "u" || e.category === "reference" || e.category === "critical" || e.category === "absolute") && (typeof e._category > "u" || r(e._category)) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || r(e._condition)) && (typeof e.context > "u" || u(e.context)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.gestationalAge > "u" || K(e.gestationalAge)) && (typeof e.range > "u" || K(e.range));
}
function $u(n) {
  const e = n;
  return b(e) && e.resourceType === "ObservationDefinition" && (typeof e.abnormalCodedValueSet > "u" || y(e.abnormalCodedValueSet)) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.criticalCodedValueSet > "u" || y(e.criticalCodedValueSet)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.method > "u" || u(e.method)) && (typeof e.multipleResultsAllowed > "u" || e.multipleResultsAllowed === !1 || e.multipleResultsAllowed === !0) && (typeof e._multipleResultsAllowed > "u" || r(e._multipleResultsAllowed)) && (typeof e.normalCodedValueSet > "u" || y(e.normalCodedValueSet)) && (typeof e.permittedDataType > "u" || Array.isArray(e.permittedDataType) && e.permittedDataType.every(
    (t) => t === "string" || t === "boolean" || t === "integer" || t === "dateTime" || t === "Quantity" || t === "CodeableConcept" || t === "Range" || t === "Ratio" || t === "SampledData" || t === "time" || t === "Period"
  )) && (typeof e._permittedDataType > "u" || Array.isArray(e._permittedDataType) && e._permittedDataType.every(
    (t) => r(t)
  )) && (typeof e.preferredReportName > "u" || typeof e.preferredReportName == "string") && (typeof e._preferredReportName > "u" || r(e._preferredReportName)) && (typeof e.qualifiedInterval > "u" || Array.isArray(e.qualifiedInterval) && e.qualifiedInterval.every(
    (t) => MT(t)
  )) && (typeof e.quantitativeDetails > "u" || UT(e.quantitativeDetails)) && (typeof e.validCodedValueSet > "u" || y(e.validCodedValueSet));
}
function ET(n) {
  const e = n;
  return p(e) && (e.strength === "required" || e.strength === "extensible" || e.strength === "preferred" || e.strength === "example") && (typeof e._strength > "u" || r(e._strength)) && typeof e.valueSet == "string" && (typeof e._valueSet > "u" || r(e._valueSet));
}
function kT(n) {
  const e = n;
  return p(e) && typeof e.source == "string" && (typeof e._source > "u" || r(e._source)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || r(e._sourceId));
}
function il(n) {
  const e = n;
  return p(e) && (typeof e.binding > "u" || ET(e.binding)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && typeof e.max == "string" && (typeof e._max > "u" || r(e._max)) && typeof e.min == "number" && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.part > "u" || Array.isArray(e.part) && e.part.every(
    (t) => il(t)
  )) && (typeof e.referencedFrom > "u" || Array.isArray(e.referencedFrom) && e.referencedFrom.every(
    (t) => kT(t)
  )) && (typeof e.searchType > "u" || e.searchType === "string" || e.searchType === "number" || e.searchType === "date" || e.searchType === "token" || e.searchType === "reference" || e.searchType === "composite" || e.searchType === "quantity" || e.searchType === "uri" || e.searchType === "special") && (typeof e._searchType > "u" || r(e._searchType)) && (typeof e.targetProfile > "u" || Array.isArray(e.targetProfile) && e.targetProfile.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetProfile > "u" || Array.isArray(e._targetProfile) && e._targetProfile.every(
    (t) => r(t)
  )) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type)) && (e.use === "in" || e.use === "out") && (typeof e._use > "u" || r(e._use));
}
function VT(n) {
  const e = n;
  return p(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.parameterName > "u" || Array.isArray(e.parameterName) && e.parameterName.every(
    (t) => typeof t == "string"
  )) && (typeof e._parameterName > "u" || Array.isArray(e._parameterName) && e._parameterName.every(
    (t) => r(t)
  ));
}
function ju(n) {
  const e = n;
  return b(e) && e.resourceType === "OperationDefinition" && (typeof e.affectsState > "u" || e.affectsState === !1 || e.affectsState === !0) && (typeof e._affectsState > "u" || r(e._affectsState)) && (typeof e.base > "u" || typeof e.base == "string") && (typeof e._base > "u" || r(e._base)) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.inputProfile > "u" || typeof e.inputProfile == "string") && (typeof e._inputProfile > "u" || r(e._inputProfile)) && typeof e.instance == "boolean" && (typeof e._instance > "u" || r(e._instance)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (e.kind === "operation" || e.kind === "query") && (typeof e._kind > "u" || r(e._kind)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.outputProfile > "u" || typeof e.outputProfile == "string") && (typeof e._outputProfile > "u" || r(e._outputProfile)) && (typeof e.overload > "u" || Array.isArray(e.overload) && e.overload.every(
    (t) => VT(t)
  )) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => il(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.resource > "u" || Array.isArray(e.resource) && e.resource.every(
    (t) => typeof t == "string"
  )) && (typeof e._resource > "u" || Array.isArray(e._resource) && e._resource.every(
    (t) => r(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && typeof e.system == "boolean" && (typeof e._system > "u" || r(e._system)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.type == "boolean" && (typeof e._type > "u" || r(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function NT(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.details > "u" || u(e.details)) && (typeof e.diagnostics > "u" || typeof e.diagnostics == "string") && (typeof e._diagnostics > "u" || r(e._diagnostics)) && (typeof e.expression > "u" || Array.isArray(e.expression) && e.expression.every(
    (t) => typeof t == "string"
  )) && (typeof e._expression > "u" || Array.isArray(e._expression) && e._expression.every(
    (t) => r(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => typeof t == "string"
  )) && (typeof e._location > "u" || Array.isArray(e._location) && e._location.every(
    (t) => r(t)
  )) && (e.severity === "error" || e.severity === "warning" || e.severity === "fatal" || e.severity === "information") && (typeof e._severity > "u" || r(e._severity));
}
function Wu(n) {
  const e = n;
  return b(e) && e.resourceType === "OperationOutcome" && Array.isArray(e.issue) && e.issue.every(
    (t) => NT(t)
  );
}
function LT(n) {
  const e = n;
  return p(e) && (typeof e.address > "u" || Te(e.address)) && (typeof e.name > "u" || Je(e.name)) && (typeof e.purpose > "u" || u(e.purpose)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function Hu(n) {
  const e = n;
  return b(e) && e.resourceType === "Organization" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => Te(t)
  )) && (typeof e.alias > "u" || Array.isArray(e.alias) && e.alias.every(
    (t) => typeof t == "string"
  )) && (typeof e._alias > "u" || Array.isArray(e._alias) && e._alias.every(
    (t) => r(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => LT(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.partOf > "u" || y(e.partOf)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  ));
}
function Qu(n) {
  const e = n;
  return b(e) && e.resourceType === "OrganizationAffiliation" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.healthcareService > "u" || Array.isArray(e.healthcareService) && e.healthcareService.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => y(t)
  )) && (typeof e.network > "u" || Array.isArray(e.network) && e.network.every(
    (t) => y(t)
  )) && (typeof e.organization > "u" || y(e.organization)) && (typeof e.participatingOrganization > "u" || y(e.participatingOrganization)) && (typeof e.period > "u" || D(e.period)) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function nl(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.part > "u" || Array.isArray(e.part) && e.part.every(
    (t) => nl(t)
  )) && (typeof e.resource > "u" || ea(e.resource) || ta(e.resource) || ra(e.resource) || oa(e.resource) || ia(e.resource) || na(e.resource) || aa(e.resource) || ua(e.resource) || ya(e.resource) || sa(e.resource) || pa(e.resource) || fa(e.resource) || ca(e.resource) || la(e.resource) || da(e.resource) || ga(e.resource) || ma(e.resource) || _a(e.resource) || va(e.resource) || Aa(e.resource) || ha(e.resource) || ba(e.resource) || Ca(e.resource) || xa(e.resource) || Da(e.resource) || Ta(e.resource) || Sa(e.resource) || Ra(e.resource) || wa(e.resource) || Ia(e.resource) || Pa(e.resource) || Oa(e.resource) || qa(e.resource) || Ba(e.resource) || Ua(e.resource) || Ma(e.resource) || Ea(e.resource) || ka(e.resource) || Va(e.resource) || Na(e.resource) || La(e.resource) || Fa(e.resource) || $a(e.resource) || ja(e.resource) || Wa(e.resource) || Ha(e.resource) || Qa(e.resource) || za(e.resource) || Ga(e.resource) || Ka(e.resource) || Ya(e.resource) || Ja(e.resource) || Za(e.resource) || Xa(e.resource) || eu(e.resource) || tu(e.resource) || ru(e.resource) || ou(e.resource) || iu(e.resource) || nu(e.resource) || au(e.resource) || uu(e.resource) || yu(e.resource) || su(e.resource) || pu(e.resource) || fu(e.resource) || cu(e.resource) || lu(e.resource) || du(e.resource) || gu(e.resource) || mu(e.resource) || _u(e.resource) || vu(e.resource) || Au(e.resource) || hu(e.resource) || bu(e.resource) || Cu(e.resource) || xu(e.resource) || Du(e.resource) || Tu(e.resource) || Su(e.resource) || Ru(e.resource) || wu(e.resource) || Iu(e.resource) || Pu(e.resource) || Ou(e.resource) || qu(e.resource) || Bu(e.resource) || Uu(e.resource) || Mu(e.resource) || Eu(e.resource) || ku(e.resource) || Vu(e.resource) || Nu(e.resource) || Lu(e.resource) || Fu(e.resource) || $u(e.resource) || ju(e.resource) || Wu(e.resource) || Hu(e.resource) || Qu(e.resource) || zu(e.resource) || Gu(e.resource) || Ku(e.resource) || Yu(e.resource) || Ju(e.resource) || Zu(e.resource) || Xu(e.resource) || ey(e.resource) || ty(e.resource) || ry(e.resource) || qi(e.resource) || Bi(e.resource) || oy(e.resource) || iy(e.resource) || ny(e.resource) || ay(e.resource) || uy(e.resource) || yy(e.resource) || py(e.resource) || fy(e.resource) || cy(e.resource) || ly(e.resource) || dy(e.resource) || gy(e.resource) || my(e.resource) || _y(e.resource) || vy(e.resource) || Ay(e.resource) || hy(e.resource) || by(e.resource) || Cy(e.resource) || xy(e.resource) || Dy(e.resource) || Ty(e.resource) || Sy(e.resource) || Ry(e.resource) || wy(e.resource) || Iy(e.resource) || Py(e.resource) || Oy(e.resource) || qy(e.resource) || By(e.resource) || Uy(e.resource) || My(e.resource) || Ey(e.resource)) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || r(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || r(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || r(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || r(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || r(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || r(e._valueUuid)) && (typeof e.valueAddress > "u" || Te(e.valueAddress)) && (typeof e.valueAge > "u" || Le(e.valueAge)) && (typeof e.valueAnnotation > "u" || $(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueContactPoint > "u" || he(e.valueContactPoint)) && (typeof e.valueCount > "u" || Mr(e.valueCount)) && (typeof e.valueDistance > "u" || Er(e.valueDistance)) && (typeof e.valueDuration > "u" || ue(e.valueDuration)) && (typeof e.valueHumanName > "u" || Je(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || A(e.valueIdentifier)) && (typeof e.valueMoney > "u" || L(e.valueMoney)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueReference > "u" || y(e.valueReference)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueSignature > "u" || ut(e.valueSignature)) && (typeof e.valueTiming > "u" || le(e.valueTiming)) && (typeof e.valueContactDetail > "u" || B(e.valueContactDetail)) && (typeof e.valueContributor > "u" || Ur(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || Ye(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || ke(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || _r(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || Se(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || Ft(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || X(e.valueUsageContext)) && (typeof e.valueDosage > "u" || ht(e.valueDosage)) && (typeof e.valueMeta > "u" || mr(e.valueMeta));
}
function zu(n) {
  const e = n;
  return sy(e) && e.resourceType === "Parameters" && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => nl(t)
  ));
}
function FT(n) {
  const e = n;
  return p(e) && (typeof e.address > "u" || Te(e.address)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.name > "u" || Je(e.name)) && (typeof e.organization > "u" || y(e.organization)) && (typeof e.period > "u" || D(e.period)) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => u(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function $T(n) {
  const e = n;
  return p(e) && u(e.language) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || r(e._preferred));
}
function jT(n) {
  const e = n;
  return p(e) && y(e.other) && (e.type === "replaces" || e.type === "replaced-by" || e.type === "refer" || e.type === "seealso") && (typeof e._type > "u" || r(e._type));
}
function Gu(n) {
  const e = n;
  return b(e) && e.resourceType === "Patient" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => Te(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || r(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => $T(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => FT(t)
  )) && (typeof e.deceasedBoolean > "u" || e.deceasedBoolean === !1 || e.deceasedBoolean === !0) && (typeof e._deceasedBoolean > "u" || r(e._deceasedBoolean)) && (typeof e.deceasedDateTime > "u" || typeof e.deceasedDateTime == "string") && (typeof e._deceasedDateTime > "u" || r(e._deceasedDateTime)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.generalPractitioner > "u" || Array.isArray(e.generalPractitioner) && e.generalPractitioner.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => jT(t)
  )) && (typeof e.managingOrganization > "u" || y(e.managingOrganization)) && (typeof e.maritalStatus > "u" || u(e.maritalStatus)) && (typeof e.multipleBirthBoolean > "u" || e.multipleBirthBoolean === !1 || e.multipleBirthBoolean === !0) && (typeof e._multipleBirthBoolean > "u" || r(e._multipleBirthBoolean)) && (typeof e.multipleBirthInteger > "u" || typeof e.multipleBirthInteger == "number") && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => Je(t)
  )) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => te(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function Ku(n) {
  const e = n;
  return b(e) && e.resourceType === "PaymentNotice" && L(e.amount) && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.payee > "u" || y(e.payee)) && y(e.payment) && (typeof e.paymentDate > "u" || typeof e.paymentDate == "string") && (typeof e._paymentDate > "u" || r(e._paymentDate)) && (typeof e.paymentStatus > "u" || u(e.paymentStatus)) && (typeof e.provider > "u" || y(e.provider)) && y(e.recipient) && (typeof e.request > "u" || y(e.request)) && (typeof e.response > "u" || y(e.response)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function WT(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || L(e.amount)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.payee > "u" || y(e.payee)) && (typeof e.predecessor > "u" || A(e.predecessor)) && (typeof e.request > "u" || y(e.request)) && (typeof e.response > "u" || y(e.response)) && (typeof e.responsible > "u" || y(e.responsible)) && (typeof e.submitter > "u" || y(e.submitter)) && u(e.type);
}
function HT(n) {
  const e = n;
  return p(e) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (typeof e.type > "u" || e.type === "display" || e.type === "print" || e.type === "printoper") && (typeof e._type > "u" || r(e._type));
}
function Yu(n) {
  const e = n;
  return b(e) && e.resourceType === "PaymentReconciliation" && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && (typeof e.detail > "u" || Array.isArray(e.detail) && e.detail.every(
    (t) => WT(t)
  )) && (typeof e.disposition > "u" || typeof e.disposition == "string") && (typeof e._disposition > "u" || r(e._disposition)) && (typeof e.formCode > "u" || u(e.formCode)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.outcome > "u" || e.outcome === "error" || e.outcome === "queued" || e.outcome === "complete" || e.outcome === "partial") && (typeof e._outcome > "u" || r(e._outcome)) && L(e.paymentAmount) && typeof e.paymentDate == "string" && (typeof e._paymentDate > "u" || r(e._paymentDate)) && (typeof e.paymentIdentifier > "u" || A(e.paymentIdentifier)) && (typeof e.paymentIssuer > "u" || y(e.paymentIssuer)) && (typeof e.period > "u" || D(e.period)) && (typeof e.processNote > "u" || Array.isArray(e.processNote) && e.processNote.every(
    (t) => HT(t)
  )) && (typeof e.request > "u" || y(e.request)) && (typeof e.requestor > "u" || y(e.requestor)) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function QT(n) {
  const e = n;
  return p(e) && (typeof e.assurance > "u" || e.assurance === "level1" || e.assurance === "level2" || e.assurance === "level3" || e.assurance === "level4") && (typeof e._assurance > "u" || r(e._assurance)) && y(e.target);
}
function Ju(n) {
  const e = n;
  return b(e) && e.resourceType === "Person" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => Te(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || r(e._birthDate)) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => QT(t)
  )) && (typeof e.managingOrganization > "u" || y(e.managingOrganization)) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => Je(t)
  )) && (typeof e.photo > "u" || te(e.photo)) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function zT(n) {
  const e = n;
  return p(e) && (typeof e.detailQuantity > "u" || S(e.detailQuantity)) && (typeof e.detailRange > "u" || K(e.detailRange)) && (typeof e.detailCodeableConcept > "u" || u(e.detailCodeableConcept)) && (typeof e.due > "u" || ue(e.due)) && (typeof e.measure > "u" || u(e.measure));
}
function GT(n) {
  const e = n;
  return p(e) && (typeof e.addresses > "u" || Array.isArray(e.addresses) && e.addresses.every(
    (t) => u(t)
  )) && (typeof e.category > "u" || u(e.category)) && u(e.description) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => Se(t)
  )) && (typeof e.priority > "u" || u(e.priority)) && (typeof e.start > "u" || u(e.start)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => zT(t)
  ));
}
function KT(n) {
  const e = n;
  return p(e) && (typeof e.expression > "u" || ke(e.expression)) && (e.kind === "applicability" || e.kind === "start" || e.kind === "stop") && (typeof e._kind > "u" || r(e._kind));
}
function YT(n) {
  const e = n;
  return p(e) && typeof e.actionId == "string" && (typeof e._actionId > "u" || r(e._actionId)) && (typeof e.offsetDuration > "u" || ue(e.offsetDuration)) && (typeof e.offsetRange > "u" || K(e.offsetRange)) && (e.relationship === "before-start" || e.relationship === "before" || e.relationship === "before-end" || e.relationship === "concurrent-with-start" || e.relationship === "concurrent" || e.relationship === "concurrent-with-end" || e.relationship === "after-start" || e.relationship === "after" || e.relationship === "after-end") && (typeof e._relationship > "u" || r(e._relationship));
}
function JT(n) {
  const e = n;
  return p(e) && (typeof e.role > "u" || u(e.role)) && (e.type === "patient" || e.type === "practitioner" || e.type === "related-person" || e.type === "device") && (typeof e._type > "u" || r(e._type));
}
function ZT(n) {
  const e = n;
  return p(e) && (typeof e.expression > "u" || ke(e.expression)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path));
}
function al(n) {
  const e = n;
  return p(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => al(t)
  )) && (typeof e.cardinalityBehavior > "u" || e.cardinalityBehavior === "single" || e.cardinalityBehavior === "multiple") && (typeof e._cardinalityBehavior > "u" || r(e._cardinalityBehavior)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => KT(t)
  )) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || r(e._definitionCanonical)) && (typeof e.definitionUri > "u" || typeof e.definitionUri == "string") && (typeof e._definitionUri > "u" || r(e._definitionUri)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => Se(t)
  )) && (typeof e.dynamicValue > "u" || Array.isArray(e.dynamicValue) && e.dynamicValue.every(
    (t) => ZT(t)
  )) && (typeof e.goalId > "u" || Array.isArray(e.goalId) && e.goalId.every(
    (t) => typeof t == "string"
  )) && (typeof e._goalId > "u" || Array.isArray(e._goalId) && e._goalId.every(
    (t) => r(t)
  )) && (typeof e.groupingBehavior > "u" || e.groupingBehavior === "visual-group" || e.groupingBehavior === "logical-group" || e.groupingBehavior === "sentence-group") && (typeof e._groupingBehavior > "u" || r(e._groupingBehavior)) && (typeof e.input > "u" || Array.isArray(e.input) && e.input.every(
    (t) => Ye(t)
  )) && (typeof e.output > "u" || Array.isArray(e.output) && e.output.every(
    (t) => Ye(t)
  )) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => JT(t)
  )) && (typeof e.precheckBehavior > "u" || e.precheckBehavior === "yes" || e.precheckBehavior === "no") && (typeof e._precheckBehavior > "u" || r(e._precheckBehavior)) && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || r(e._prefix)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => u(t)
  )) && (typeof e.relatedAction > "u" || Array.isArray(e.relatedAction) && e.relatedAction.every(
    (t) => YT(t)
  )) && (typeof e.requiredBehavior > "u" || e.requiredBehavior === "must" || e.requiredBehavior === "could" || e.requiredBehavior === "must-unless-documented") && (typeof e._requiredBehavior > "u" || r(e._requiredBehavior)) && (typeof e.selectionBehavior > "u" || e.selectionBehavior === "any" || e.selectionBehavior === "all" || e.selectionBehavior === "all-or-none" || e.selectionBehavior === "exactly-one" || e.selectionBehavior === "at-most-one" || e.selectionBehavior === "one-or-more") && (typeof e._selectionBehavior > "u" || r(e._selectionBehavior)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.textEquivalent > "u" || typeof e.textEquivalent == "string") && (typeof e._textEquivalent > "u" || r(e._textEquivalent)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || r(e._timingDateTime)) && (typeof e.timingAge > "u" || Le(e.timingAge)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.timingDuration > "u" || ue(e.timingDuration)) && (typeof e.timingRange > "u" || K(e.timingRange)) && (typeof e.timingTiming > "u" || le(e.timingTiming)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.transform > "u" || typeof e.transform == "string") && (typeof e._transform > "u" || r(e._transform)) && (typeof e.trigger > "u" || Array.isArray(e.trigger) && e.trigger.every(
    (t) => Ft(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function Zu(n) {
  const e = n;
  return b(e) && e.resourceType === "PlanDefinition" && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => al(t)
  )) && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.goal > "u" || Array.isArray(e.goal) && e.goal.every(
    (t) => GT(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function XT(n) {
  const e = n;
  return p(e) && u(e.code) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.issuer > "u" || y(e.issuer)) && (typeof e.period > "u" || D(e.period));
}
function Xu(n) {
  const e = n;
  return b(e) && e.resourceType === "Practitioner" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => Te(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || r(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => u(t)
  )) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => Je(t)
  )) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => te(t)
  )) && (typeof e.qualification > "u" || Array.isArray(e.qualification) && e.qualification.every(
    (t) => XT(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function eS(n) {
  const e = n;
  return p(e) && (typeof e.allDay > "u" || e.allDay === !1 || e.allDay === !0) && (typeof e._allDay > "u" || r(e._allDay)) && (typeof e.availableEndTime > "u" || typeof e.availableEndTime == "string") && (typeof e._availableEndTime > "u" || r(e._availableEndTime)) && (typeof e.availableStartTime > "u" || typeof e.availableStartTime == "string") && (typeof e._availableStartTime > "u" || r(e._availableStartTime)) && (typeof e.daysOfWeek > "u" || Array.isArray(e.daysOfWeek) && e.daysOfWeek.every(
    (t) => t === "mon" || t === "tue" || t === "wed" || t === "thu" || t === "fri" || t === "sat" || t === "sun"
  )) && (typeof e._daysOfWeek > "u" || Array.isArray(e._daysOfWeek) && e._daysOfWeek.every(
    (t) => r(t)
  ));
}
function tS(n) {
  const e = n;
  return p(e) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && (typeof e.during > "u" || D(e.during));
}
function ey(n) {
  const e = n;
  return b(e) && e.resourceType === "PractitionerRole" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.availabilityExceptions > "u" || typeof e.availabilityExceptions == "string") && (typeof e._availabilityExceptions > "u" || r(e._availabilityExceptions)) && (typeof e.availableTime > "u" || Array.isArray(e.availableTime) && e.availableTime.every(
    (t) => eS(t)
  )) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.endpoint > "u" || Array.isArray(e.endpoint) && e.endpoint.every(
    (t) => y(t)
  )) && (typeof e.healthcareService > "u" || Array.isArray(e.healthcareService) && e.healthcareService.every(
    (t) => y(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => y(t)
  )) && (typeof e.notAvailable > "u" || Array.isArray(e.notAvailable) && e.notAvailable.every(
    (t) => tS(t)
  )) && (typeof e.organization > "u" || y(e.organization)) && (typeof e.period > "u" || D(e.period)) && (typeof e.practitioner > "u" || y(e.practitioner)) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function rS(n) {
  const e = n;
  return p(e) && y(e.actor) && (typeof e.function > "u" || u(e.function)) && (typeof e.onBehalfOf > "u" || y(e.onBehalfOf));
}
function oS(n) {
  const e = n;
  return p(e) && (typeof e.action > "u" || u(e.action)) && y(e.manipulated);
}
function ty(n) {
  const e = n;
  return b(e) && e.resourceType === "Procedure" && (typeof e.asserter > "u" || y(e.asserter)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => u(t)
  )) && (typeof e.category > "u" || u(e.category)) && (typeof e.code > "u" || u(e.code)) && (typeof e.complication > "u" || Array.isArray(e.complication) && e.complication.every(
    (t) => u(t)
  )) && (typeof e.complicationDetail > "u" || Array.isArray(e.complicationDetail) && e.complicationDetail.every(
    (t) => y(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.focalDevice > "u" || Array.isArray(e.focalDevice) && e.focalDevice.every(
    (t) => oS(t)
  )) && (typeof e.followUp > "u" || Array.isArray(e.followUp) && e.followUp.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.outcome > "u" || u(e.outcome)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performedDateTime > "u" || typeof e.performedDateTime == "string") && (typeof e._performedDateTime > "u" || r(e._performedDateTime)) && (typeof e.performedPeriod > "u" || D(e.performedPeriod)) && (typeof e.performedString > "u" || typeof e.performedString == "string") && (typeof e._performedString > "u" || r(e._performedString)) && (typeof e.performedAge > "u" || Le(e.performedAge)) && (typeof e.performedRange > "u" || K(e.performedRange)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => rS(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.recorder > "u" || y(e.recorder)) && (typeof e.report > "u" || Array.isArray(e.report) && e.report.every(
    (t) => y(t)
  )) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "preparation" || e.status === "not-done") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason)) && y(e.subject) && (typeof e.usedCode > "u" || Array.isArray(e.usedCode) && e.usedCode.every(
    (t) => u(t)
  )) && (typeof e.usedReference > "u" || Array.isArray(e.usedReference) && e.usedReference.every(
    (t) => y(t)
  ));
}
function ul(n) {
  const e = n;
  return p(e) && (typeof e.onBehalfOf > "u" || y(e.onBehalfOf)) && (typeof e.role > "u" || Array.isArray(e.role) && e.role.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type)) && y(e.who);
}
function iS(n) {
  const e = n;
  return p(e) && (typeof e.agent > "u" || Array.isArray(e.agent) && e.agent.every(
    (t) => ul(t)
  )) && (e.role === "source" || e.role === "derivation" || e.role === "revision" || e.role === "quotation" || e.role === "removal") && (typeof e._role > "u" || r(e._role)) && y(e.what);
}
function ry(n) {
  const e = n;
  return b(e) && e.resourceType === "Provenance" && (typeof e.activity > "u" || u(e.activity)) && Array.isArray(e.agent) && e.agent.every(
    (t) => ul(t)
  ) && (typeof e.entity > "u" || Array.isArray(e.entity) && e.entity.every(
    (t) => iS(t)
  )) && (typeof e.location > "u" || y(e.location)) && (typeof e.occurredPeriod > "u" || D(e.occurredPeriod)) && (typeof e.occurredDateTime > "u" || typeof e.occurredDateTime == "string") && (typeof e._occurredDateTime > "u" || r(e._occurredDateTime)) && (typeof e.policy > "u" || Array.isArray(e.policy) && e.policy.every(
    (t) => typeof t == "string"
  )) && (typeof e._policy > "u" || Array.isArray(e._policy) && e._policy.every(
    (t) => r(t)
  )) && (typeof e.reason > "u" || Array.isArray(e.reason) && e.reason.every(
    (t) => u(t)
  )) && typeof e.recorded == "string" && (typeof e._recorded > "u" || r(e._recorded)) && (typeof e.signature > "u" || Array.isArray(e.signature) && e.signature.every(
    (t) => ut(t)
  )) && Array.isArray(e.target) && e.target.every(
    (t) => y(t)
  );
}
function nS(n) {
  const e = n;
  return p(e) && (typeof e.answerBoolean > "u" || e.answerBoolean === !1 || e.answerBoolean === !0) && (typeof e._answerBoolean > "u" || r(e._answerBoolean)) && (typeof e.answerDecimal > "u" || typeof e.answerDecimal == "number") && (typeof e.answerInteger > "u" || typeof e.answerInteger == "number") && (typeof e.answerDate > "u" || typeof e.answerDate == "string") && (typeof e._answerDate > "u" || r(e._answerDate)) && (typeof e.answerDateTime > "u" || typeof e.answerDateTime == "string") && (typeof e._answerDateTime > "u" || r(e._answerDateTime)) && (typeof e.answerTime > "u" || typeof e.answerTime == "string") && (typeof e._answerTime > "u" || r(e._answerTime)) && (typeof e.answerString > "u" || typeof e.answerString == "string") && (typeof e._answerString > "u" || r(e._answerString)) && (typeof e.answerCoding > "u" || V(e.answerCoding)) && (typeof e.answerQuantity > "u" || S(e.answerQuantity)) && (typeof e.answerReference > "u" || y(e.answerReference)) && (e.operator === "exists" || e.operator === "<" || e.operator === "<=" || e.operator === ">=" || e.operator === ">" || e.operator === "=" || e.operator === "!=") && (typeof e._operator > "u" || r(e._operator)) && typeof e.question == "string" && (typeof e._question > "u" || r(e._question));
}
function aS(n) {
  const e = n;
  return p(e) && (typeof e.initialSelected > "u" || e.initialSelected === !1 || e.initialSelected === !0) && (typeof e._initialSelected > "u" || r(e._initialSelected)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function uS(n) {
  const e = n;
  return p(e) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function xp(n) {
  const e = n;
  return p(e) && (typeof e.answerOption > "u" || Array.isArray(e.answerOption) && e.answerOption.every(
    (t) => aS(t)
  )) && (typeof e.answerValueSet > "u" || typeof e.answerValueSet == "string") && (typeof e._answerValueSet > "u" || r(e._answerValueSet)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => V(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.enableBehavior > "u" || e.enableBehavior === "any" || e.enableBehavior === "all") && (typeof e._enableBehavior > "u" || r(e._enableBehavior)) && (typeof e.enableWhen > "u" || Array.isArray(e.enableWhen) && e.enableWhen.every(
    (t) => nS(t)
  )) && (typeof e.initial > "u" || Array.isArray(e.initial) && e.initial.every(
    (t) => uS(t)
  )) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => xp(t)
  )) && typeof e.linkId == "string" && (typeof e._linkId > "u" || r(e._linkId)) && (typeof e.maxLength > "u" || typeof e.maxLength == "number") && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || r(e._prefix)) && (typeof e.readOnly > "u" || e.readOnly === !1 || e.readOnly === !0) && (typeof e._readOnly > "u" || r(e._readOnly)) && (typeof e.repeats > "u" || e.repeats === !1 || e.repeats === !0) && (typeof e._repeats > "u" || r(e._repeats)) && (typeof e.required > "u" || e.required === !1 || e.required === !0) && (typeof e._required > "u" || r(e._required)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text)) && (e.type === "string" || e.type === "boolean" || e.type === "url" || e.type === "date" || e.type === "reference" || e.type === "quantity" || e.type === "display" || e.type === "integer" || e.type === "dateTime" || e.type === "decimal" || e.type === "time" || e.type === "group" || e.type === "question" || e.type === "text" || e.type === "choice" || e.type === "open-choice" || e.type === "attachment") && (typeof e._type > "u" || r(e._type));
}
function qi(n) {
  const e = n;
  return b(e) && e.resourceType === "Questionnaire" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => V(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.derivedFrom > "u" || Array.isArray(e.derivedFrom) && e.derivedFrom.every(
    (t) => typeof t == "string"
  )) && (typeof e._derivedFrom > "u" || Array.isArray(e._derivedFrom) && e._derivedFrom.every(
    (t) => r(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => xp(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectType > "u" || Array.isArray(e.subjectType) && e.subjectType.every(
    (t) => typeof t == "string"
  )) && (typeof e._subjectType > "u" || Array.isArray(e._subjectType) && e._subjectType.every(
    (t) => r(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function yS(n) {
  const e = n;
  return p(e) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Dp(t)
  )) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueReference > "u" || y(e.valueReference));
}
function Dp(n) {
  const e = n;
  return p(e) && (typeof e.answer > "u" || Array.isArray(e.answer) && e.answer.every(
    (t) => yS(t)
  )) && (typeof e.definition > "u" || typeof e.definition == "string") && (typeof e._definition > "u" || r(e._definition)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Dp(t)
  )) && typeof e.linkId == "string" && (typeof e._linkId > "u" || r(e._linkId)) && (typeof e.text > "u" || typeof e.text == "string") && (typeof e._text > "u" || r(e._text));
}
function Bi(n) {
  const e = n;
  return b(e) && e.resourceType === "QuestionnaireResponse" && (typeof e.author > "u" || y(e.author)) && (typeof e.authored > "u" || typeof e.authored == "string") && (typeof e._authored > "u" || r(e._authored)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.item > "u" || Array.isArray(e.item) && e.item.every(
    (t) => Dp(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.questionnaire > "u" || typeof e.questionnaire == "string") && (typeof e._questionnaire > "u" || r(e._questionnaire)) && (typeof e.source > "u" || y(e.source)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "amended") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject));
}
function sS(n) {
  const e = n;
  return p(e) && u(e.language) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || r(e._preferred));
}
function oy(n) {
  const e = n;
  return b(e) && e.resourceType === "RelatedPerson" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && (typeof e.address > "u" || Array.isArray(e.address) && e.address.every(
    (t) => Te(t)
  )) && (typeof e.birthDate > "u" || typeof e.birthDate == "string") && (typeof e._birthDate > "u" || r(e._birthDate)) && (typeof e.communication > "u" || Array.isArray(e.communication) && e.communication.every(
    (t) => sS(t)
  )) && (typeof e.gender > "u" || e.gender === "other" || e.gender === "unknown" || e.gender === "male" || e.gender === "female") && (typeof e._gender > "u" || r(e._gender)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => Je(t)
  )) && y(e.patient) && (typeof e.period > "u" || D(e.period)) && (typeof e.photo > "u" || Array.isArray(e.photo) && e.photo.every(
    (t) => te(t)
  )) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => u(t)
  )) && (typeof e.telecom > "u" || Array.isArray(e.telecom) && e.telecom.every(
    (t) => he(t)
  ));
}
function pS(n) {
  const e = n;
  return p(e) && (typeof e.expression > "u" || ke(e.expression)) && (e.kind === "applicability" || e.kind === "start" || e.kind === "stop") && (typeof e._kind > "u" || r(e._kind));
}
function fS(n) {
  const e = n;
  return p(e) && typeof e.actionId == "string" && (typeof e._actionId > "u" || r(e._actionId)) && (typeof e.offsetDuration > "u" || ue(e.offsetDuration)) && (typeof e.offsetRange > "u" || K(e.offsetRange)) && (e.relationship === "before-start" || e.relationship === "before" || e.relationship === "before-end" || e.relationship === "concurrent-with-start" || e.relationship === "concurrent" || e.relationship === "concurrent-with-end" || e.relationship === "after-start" || e.relationship === "after" || e.relationship === "after-end") && (typeof e._relationship > "u" || r(e._relationship));
}
function yl(n) {
  const e = n;
  return p(e) && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => yl(t)
  )) && (typeof e.cardinalityBehavior > "u" || e.cardinalityBehavior === "single" || e.cardinalityBehavior === "multiple") && (typeof e._cardinalityBehavior > "u" || r(e._cardinalityBehavior)) && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => u(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => pS(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.documentation > "u" || Array.isArray(e.documentation) && e.documentation.every(
    (t) => Se(t)
  )) && (typeof e.groupingBehavior > "u" || e.groupingBehavior === "visual-group" || e.groupingBehavior === "logical-group" || e.groupingBehavior === "sentence-group") && (typeof e._groupingBehavior > "u" || r(e._groupingBehavior)) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => y(t)
  )) && (typeof e.precheckBehavior > "u" || e.precheckBehavior === "yes" || e.precheckBehavior === "no") && (typeof e._precheckBehavior > "u" || r(e._precheckBehavior)) && (typeof e.prefix > "u" || typeof e.prefix == "string") && (typeof e._prefix > "u" || r(e._prefix)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.relatedAction > "u" || Array.isArray(e.relatedAction) && e.relatedAction.every(
    (t) => fS(t)
  )) && (typeof e.requiredBehavior > "u" || e.requiredBehavior === "must" || e.requiredBehavior === "could" || e.requiredBehavior === "must-unless-documented") && (typeof e._requiredBehavior > "u" || r(e._requiredBehavior)) && (typeof e.resource > "u" || y(e.resource)) && (typeof e.selectionBehavior > "u" || e.selectionBehavior === "any" || e.selectionBehavior === "all" || e.selectionBehavior === "all-or-none" || e.selectionBehavior === "exactly-one" || e.selectionBehavior === "at-most-one" || e.selectionBehavior === "one-or-more") && (typeof e._selectionBehavior > "u" || r(e._selectionBehavior)) && (typeof e.textEquivalent > "u" || typeof e.textEquivalent == "string") && (typeof e._textEquivalent > "u" || r(e._textEquivalent)) && (typeof e.timingDateTime > "u" || typeof e.timingDateTime == "string") && (typeof e._timingDateTime > "u" || r(e._timingDateTime)) && (typeof e.timingAge > "u" || Le(e.timingAge)) && (typeof e.timingPeriod > "u" || D(e.timingPeriod)) && (typeof e.timingDuration > "u" || ue(e.timingDuration)) && (typeof e.timingRange > "u" || K(e.timingRange)) && (typeof e.timingTiming > "u" || le(e.timingTiming)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.type > "u" || u(e.type));
}
function iy(n) {
  const e = n;
  return b(e) && e.resourceType === "RequestGroup" && (typeof e.action > "u" || Array.isArray(e.action) && e.action.every(
    (t) => yl(t)
  )) && (typeof e.author > "u" || y(e.author)) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.groupIdentifier > "u" || A(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject));
}
function ny(n) {
  const e = n;
  return b(e) && e.resourceType === "ResearchDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.comment > "u" || Array.isArray(e.comment) && e.comment.every(
    (t) => typeof t == "string"
  )) && (typeof e._comment > "u" || Array.isArray(e._comment) && e._comment.every(
    (t) => r(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.exposure > "u" || y(e.exposure)) && (typeof e.exposureAlternative > "u" || y(e.exposureAlternative)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.outcome > "u" || y(e.outcome)) && y(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || r(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function cS(n) {
  const e = n;
  return p(e) && (typeof e.definitionCodeableConcept > "u" || u(e.definitionCodeableConcept)) && (typeof e.definitionCanonical > "u" || typeof e.definitionCanonical == "string") && (typeof e._definitionCanonical > "u" || r(e._definitionCanonical)) && (typeof e.definitionExpression > "u" || ke(e.definitionExpression)) && (typeof e.definitionDataRequirement > "u" || Ye(e.definitionDataRequirement)) && (typeof e.exclude > "u" || e.exclude === !1 || e.exclude === !0) && (typeof e._exclude > "u" || r(e._exclude)) && (typeof e.participantEffectiveDateTime > "u" || typeof e.participantEffectiveDateTime == "string") && (typeof e._participantEffectiveDateTime > "u" || r(e._participantEffectiveDateTime)) && (typeof e.participantEffectivePeriod > "u" || D(e.participantEffectivePeriod)) && (typeof e.participantEffectiveDuration > "u" || ue(e.participantEffectiveDuration)) && (typeof e.participantEffectiveTiming > "u" || le(e.participantEffectiveTiming)) && (typeof e.participantEffectiveDescription > "u" || typeof e.participantEffectiveDescription == "string") && (typeof e._participantEffectiveDescription > "u" || r(e._participantEffectiveDescription)) && (typeof e.participantEffectiveGroupMeasure > "u" || e.participantEffectiveGroupMeasure === "mean" || e.participantEffectiveGroupMeasure === "median" || e.participantEffectiveGroupMeasure === "mean-of-mean" || e.participantEffectiveGroupMeasure === "mean-of-median" || e.participantEffectiveGroupMeasure === "median-of-mean" || e.participantEffectiveGroupMeasure === "median-of-median") && (typeof e._participantEffectiveGroupMeasure > "u" || r(e._participantEffectiveGroupMeasure)) && (typeof e.participantEffectiveTimeFromStart > "u" || ue(e.participantEffectiveTimeFromStart)) && (typeof e.studyEffectiveDateTime > "u" || typeof e.studyEffectiveDateTime == "string") && (typeof e._studyEffectiveDateTime > "u" || r(e._studyEffectiveDateTime)) && (typeof e.studyEffectivePeriod > "u" || D(e.studyEffectivePeriod)) && (typeof e.studyEffectiveDuration > "u" || ue(e.studyEffectiveDuration)) && (typeof e.studyEffectiveTiming > "u" || le(e.studyEffectiveTiming)) && (typeof e.studyEffectiveDescription > "u" || typeof e.studyEffectiveDescription == "string") && (typeof e._studyEffectiveDescription > "u" || r(e._studyEffectiveDescription)) && (typeof e.studyEffectiveGroupMeasure > "u" || e.studyEffectiveGroupMeasure === "mean" || e.studyEffectiveGroupMeasure === "median" || e.studyEffectiveGroupMeasure === "mean-of-mean" || e.studyEffectiveGroupMeasure === "mean-of-median" || e.studyEffectiveGroupMeasure === "median-of-mean" || e.studyEffectiveGroupMeasure === "median-of-median") && (typeof e._studyEffectiveGroupMeasure > "u" || r(e._studyEffectiveGroupMeasure)) && (typeof e.studyEffectiveTimeFromStart > "u" || ue(e.studyEffectiveTimeFromStart)) && (typeof e.unitOfMeasure > "u" || u(e.unitOfMeasure)) && (typeof e.usageContext > "u" || Array.isArray(e.usageContext) && e.usageContext.every(
    (t) => X(t)
  ));
}
function ay(n) {
  const e = n;
  return b(e) && e.resourceType === "ResearchElementDefinition" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && Array.isArray(e.characteristic) && e.characteristic.every(
    (t) => cS(t)
  ) && (typeof e.comment > "u" || Array.isArray(e.comment) && e.comment.every(
    (t) => typeof t == "string"
  )) && (typeof e._comment > "u" || Array.isArray(e._comment) && e._comment.every(
    (t) => r(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.library > "u" || Array.isArray(e.library) && e.library.every(
    (t) => typeof t == "string"
  )) && (typeof e._library > "u" || Array.isArray(e._library) && e._library.every(
    (t) => r(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.shortTitle > "u" || typeof e.shortTitle == "string") && (typeof e._shortTitle > "u" || r(e._shortTitle)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.subjectCodeableConcept > "u" || u(e.subjectCodeableConcept)) && (typeof e.subjectReference > "u" || y(e.subjectReference)) && (typeof e.subtitle > "u" || typeof e.subtitle == "string") && (typeof e._subtitle > "u" || r(e._subtitle)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (e.type === "outcome" || e.type === "exposure" || e.type === "population") && (typeof e._type > "u" || r(e._type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.usage > "u" || typeof e.usage == "string") && (typeof e._usage > "u" || r(e._usage)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.variableType > "u" || e.variableType === "dichotomous" || e.variableType === "continuous" || e.variableType === "descriptive") && (typeof e._variableType > "u" || r(e._variableType)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function lS(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.type > "u" || u(e.type));
}
function dS(n) {
  const e = n;
  return p(e) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.type > "u" || u(e.type));
}
function uy(n) {
  const e = n;
  return b(e) && e.resourceType === "ResearchStudy" && (typeof e.arm > "u" || Array.isArray(e.arm) && e.arm.every(
    (t) => lS(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => u(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.enrollment > "u" || Array.isArray(e.enrollment) && e.enrollment.every(
    (t) => y(t)
  )) && (typeof e.focus > "u" || Array.isArray(e.focus) && e.focus.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.keyword > "u" || Array.isArray(e.keyword) && e.keyword.every(
    (t) => u(t)
  )) && (typeof e.location > "u" || Array.isArray(e.location) && e.location.every(
    (t) => u(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.objective > "u" || Array.isArray(e.objective) && e.objective.every(
    (t) => dS(t)
  )) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.period > "u" || D(e.period)) && (typeof e.phase > "u" || u(e.phase)) && (typeof e.primaryPurposeType > "u" || u(e.primaryPurposeType)) && (typeof e.principalInvestigator > "u" || y(e.principalInvestigator)) && (typeof e.protocol > "u" || Array.isArray(e.protocol) && e.protocol.every(
    (t) => y(t)
  )) && (typeof e.reasonStopped > "u" || u(e.reasonStopped)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.site > "u" || Array.isArray(e.site) && e.site.every(
    (t) => y(t)
  )) && (typeof e.sponsor > "u" || y(e.sponsor)) && (e.status === "active" || e.status === "completed" || e.status === "administratively-completed" || e.status === "approved" || e.status === "closed-to-accrual" || e.status === "closed-to-accrual-and-intervention" || e.status === "disapproved" || e.status === "in-review" || e.status === "temporarily-closed-to-accrual" || e.status === "temporarily-closed-to-accrual-and-intervention" || e.status === "withdrawn") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title));
}
function yy(n) {
  const e = n;
  return b(e) && e.resourceType === "ResearchSubject" && (typeof e.actualArm > "u" || typeof e.actualArm == "string") && (typeof e._actualArm > "u" || r(e._actualArm)) && (typeof e.assignedArm > "u" || typeof e.assignedArm == "string") && (typeof e._assignedArm > "u" || r(e._assignedArm)) && (typeof e.consent > "u" || y(e.consent)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && y(e.individual) && (typeof e.period > "u" || D(e.period)) && (e.status === "withdrawn" || e.status === "candidate" || e.status === "eligible" || e.status === "follow-up" || e.status === "ineligible" || e.status === "not-registered" || e.status === "off-study" || e.status === "on-study" || e.status === "on-study-intervention" || e.status === "on-study-observation" || e.status === "pending-on-study" || e.status === "potential-candidate" || e.status === "screening") && (typeof e._status > "u" || r(e._status)) && y(e.study);
}
function sy(n) {
  const e = n;
  return (e !== null && typeof e == "object" || typeof e == "function") && typeof e.resourceType == "string" && (typeof e.id > "u" || typeof e.id == "string") && (typeof e._id > "u" || r(e._id)) && (typeof e.implicitRules > "u" || typeof e.implicitRules == "string") && (typeof e._implicitRules > "u" || r(e._implicitRules)) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language)) && (typeof e.meta > "u" || mr(e.meta));
}
function gS(n) {
  const e = n;
  return p(e) && (typeof e.outcome > "u" || u(e.outcome)) && (typeof e.probabilityDecimal > "u" || typeof e.probabilityDecimal == "number") && (typeof e.probabilityRange > "u" || K(e.probabilityRange)) && (typeof e.qualitativeRisk > "u" || u(e.qualitativeRisk)) && (typeof e.rationale > "u" || typeof e.rationale == "string") && (typeof e._rationale > "u" || r(e._rationale)) && (typeof e.relativeRisk > "u" || typeof e.relativeRisk == "number") && (typeof e.whenPeriod > "u" || D(e.whenPeriod)) && (typeof e.whenRange > "u" || K(e.whenRange));
}
function py(n) {
  const e = n;
  return b(e) && e.resourceType === "RiskAssessment" && (typeof e.basedOn > "u" || y(e.basedOn)) && (typeof e.basis > "u" || Array.isArray(e.basis) && e.basis.every(
    (t) => y(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.condition > "u" || y(e.condition)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.method > "u" || u(e.method)) && (typeof e.mitigation > "u" || typeof e.mitigation == "string") && (typeof e._mitigation > "u" || r(e._mitigation)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.parent > "u" || y(e.parent)) && (typeof e.performer > "u" || y(e.performer)) && (typeof e.prediction > "u" || Array.isArray(e.prediction) && e.prediction.every(
    (t) => gS(t)
  )) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (e.status === "entered-in-error" || e.status === "unknown" || e.status === "cancelled" || e.status === "preliminary" || e.status === "final" || e.status === "amended" || e.status === "registered" || e.status === "corrected") && (typeof e._status > "u" || r(e._status)) && y(e.subject);
}
function mS(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.numberOfParticipants > "u" || typeof e.numberOfParticipants == "number") && (typeof e.numberOfStudies > "u" || typeof e.numberOfStudies == "number");
}
function _S(n) {
  const e = n;
  return p(e) && (typeof e.from > "u" || typeof e.from == "number") && (typeof e.level > "u" || typeof e.level == "number") && (typeof e.to > "u" || typeof e.to == "number") && (typeof e.type > "u" || u(e.type));
}
function vS(n) {
  const e = n;
  return p(e) && (typeof e.denominatorCount > "u" || typeof e.denominatorCount == "number") && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.numeratorCount > "u" || typeof e.numeratorCount == "number") && (typeof e.precisionEstimate > "u" || Array.isArray(e.precisionEstimate) && e.precisionEstimate.every(
    (t) => _S(t)
  )) && (typeof e.type > "u" || u(e.type)) && (typeof e.unitOfMeasure > "u" || u(e.unitOfMeasure)) && (typeof e.value > "u" || typeof e.value == "number");
}
function AS(n) {
  const e = n;
  return p(e) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function hS(n) {
  const e = n;
  return p(e) && (typeof e.certaintySubcomponent > "u" || Array.isArray(e.certaintySubcomponent) && e.certaintySubcomponent.every(
    (t) => AS(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.rating > "u" || Array.isArray(e.rating) && e.rating.every(
    (t) => u(t)
  ));
}
function fy(n) {
  const e = n;
  return b(e) && e.resourceType === "RiskEvidenceSynthesis" && (typeof e.approvalDate > "u" || typeof e.approvalDate == "string") && (typeof e._approvalDate > "u" || r(e._approvalDate)) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => B(t)
  )) && (typeof e.certainty > "u" || Array.isArray(e.certainty) && e.certainty.every(
    (t) => hS(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.editor > "u" || Array.isArray(e.editor) && e.editor.every(
    (t) => B(t)
  )) && (typeof e.effectivePeriod > "u" || D(e.effectivePeriod)) && (typeof e.endorser > "u" || Array.isArray(e.endorser) && e.endorser.every(
    (t) => B(t)
  )) && (typeof e.exposure > "u" || y(e.exposure)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.lastReviewDate > "u" || typeof e.lastReviewDate == "string") && (typeof e._lastReviewDate > "u" || r(e._lastReviewDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && y(e.outcome) && y(e.population) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.relatedArtifact > "u" || Array.isArray(e.relatedArtifact) && e.relatedArtifact.every(
    (t) => Se(t)
  )) && (typeof e.reviewer > "u" || Array.isArray(e.reviewer) && e.reviewer.every(
    (t) => B(t)
  )) && (typeof e.riskEstimate > "u" || vS(e.riskEstimate)) && (typeof e.sampleSize > "u" || mS(e.sampleSize)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.studyType > "u" || u(e.studyType)) && (typeof e.synthesisType > "u" || u(e.synthesisType)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.topic > "u" || Array.isArray(e.topic) && e.topic.every(
    (t) => u(t)
  )) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function cy(n) {
  const e = n;
  return b(e) && e.resourceType === "Schedule" && (typeof e.active > "u" || e.active === !1 || e.active === !0) && (typeof e._active > "u" || r(e._active)) && Array.isArray(e.actor) && e.actor.every(
    (t) => y(t)
  ) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.planningHorizon > "u" || D(e.planningHorizon)) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => u(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => u(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  ));
}
function bS(n) {
  const e = n;
  return p(e) && typeof e.definition == "string" && (typeof e._definition > "u" || r(e._definition)) && typeof e.expression == "string" && (typeof e._expression > "u" || r(e._expression));
}
function ly(n) {
  const e = n;
  return b(e) && e.resourceType === "SearchParameter" && Array.isArray(e.base) && e.base.every(
    (t) => typeof t == "string"
  ) && (typeof e._base > "u" || Array.isArray(e._base) && e._base.every(
    (t) => r(t)
  )) && (typeof e.chain > "u" || Array.isArray(e.chain) && e.chain.every(
    (t) => typeof t == "string"
  )) && (typeof e._chain > "u" || Array.isArray(e._chain) && e._chain.every(
    (t) => r(t)
  )) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.comparator > "u" || Array.isArray(e.comparator) && e.comparator.every(
    (t) => t === "eq" || t === "ne" || t === "gt" || t === "lt" || t === "ge" || t === "le" || t === "sa" || t === "eb" || t === "ap"
  )) && (typeof e._comparator > "u" || Array.isArray(e._comparator) && e._comparator.every(
    (t) => r(t)
  )) && (typeof e.component > "u" || Array.isArray(e.component) && e.component.every(
    (t) => bS(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.derivedFrom > "u" || typeof e.derivedFrom == "string") && (typeof e._derivedFrom > "u" || r(e._derivedFrom)) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.modifier > "u" || Array.isArray(e.modifier) && e.modifier.every(
    (t) => t === "type" || t === "in" || t === "not-in" || t === "identifier" || t === "text" || t === "missing" || t === "exact" || t === "contains" || t === "not" || t === "below" || t === "above" || t === "ofType"
  )) && (typeof e._modifier > "u" || Array.isArray(e._modifier) && e._modifier.every(
    (t) => r(t)
  )) && (typeof e.multipleAnd > "u" || e.multipleAnd === !1 || e.multipleAnd === !0) && (typeof e._multipleAnd > "u" || r(e._multipleAnd)) && (typeof e.multipleOr > "u" || e.multipleOr === !1 || e.multipleOr === !0) && (typeof e._multipleOr > "u" || r(e._multipleOr)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => typeof t == "string"
  )) && (typeof e._target > "u" || Array.isArray(e._target) && e._target.every(
    (t) => r(t)
  )) && (e.type === "string" || e.type === "number" || e.type === "date" || e.type === "token" || e.type === "reference" || e.type === "composite" || e.type === "quantity" || e.type === "uri" || e.type === "special") && (typeof e._type > "u" || r(e._type)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version)) && (typeof e.xpath > "u" || typeof e.xpath == "string") && (typeof e._xpath > "u" || r(e._xpath)) && (typeof e.xpathUsage > "u" || e.xpathUsage === "other" || e.xpathUsage === "normal" || e.xpathUsage === "phonetic" || e.xpathUsage === "nearby" || e.xpathUsage === "distance") && (typeof e._xpathUsage > "u" || r(e._xpathUsage));
}
function dy(n) {
  const e = n;
  return b(e) && e.resourceType === "ServiceRequest" && (typeof e.asNeededBoolean > "u" || e.asNeededBoolean === !1 || e.asNeededBoolean === !0) && (typeof e._asNeededBoolean > "u" || r(e._asNeededBoolean)) && (typeof e.asNeededCodeableConcept > "u" || u(e.asNeededCodeableConcept)) && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.bodySite > "u" || Array.isArray(e.bodySite) && e.bodySite.every(
    (t) => u(t)
  )) && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && (typeof e.code > "u" || u(e.code)) && (typeof e.doNotPerform > "u" || e.doNotPerform === !1 || e.doNotPerform === !0) && (typeof e._doNotPerform > "u" || r(e._doNotPerform)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.instantiatesCanonical > "u" || Array.isArray(e.instantiatesCanonical) && e.instantiatesCanonical.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesCanonical > "u" || Array.isArray(e._instantiatesCanonical) && e._instantiatesCanonical.every(
    (t) => r(t)
  )) && (typeof e.instantiatesUri > "u" || Array.isArray(e.instantiatesUri) && e.instantiatesUri.every(
    (t) => typeof t == "string"
  )) && (typeof e._instantiatesUri > "u" || Array.isArray(e._instantiatesUri) && e._instantiatesUri.every(
    (t) => r(t)
  )) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => y(t)
  )) && (e.intent === "proposal" || e.intent === "plan" || e.intent === "directive" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.locationCode > "u" || Array.isArray(e.locationCode) && e.locationCode.every(
    (t) => u(t)
  )) && (typeof e.locationReference > "u" || Array.isArray(e.locationReference) && e.locationReference.every(
    (t) => y(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.orderDetail > "u" || Array.isArray(e.orderDetail) && e.orderDetail.every(
    (t) => u(t)
  )) && (typeof e.patientInstruction > "u" || typeof e.patientInstruction == "string") && (typeof e._patientInstruction > "u" || r(e._patientInstruction)) && (typeof e.performer > "u" || Array.isArray(e.performer) && e.performer.every(
    (t) => y(t)
  )) && (typeof e.performerType > "u" || u(e.performerType)) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.quantityQuantity > "u" || S(e.quantityQuantity)) && (typeof e.quantityRatio > "u" || ge(e.quantityRatio)) && (typeof e.quantityRange > "u" || K(e.quantityRange)) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => y(t)
  )) && (typeof e.replaces > "u" || Array.isArray(e.replaces) && e.replaces.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || y(e.requester)) && (typeof e.requisition > "u" || A(e.requisition)) && (typeof e.specimen > "u" || Array.isArray(e.specimen) && e.specimen.every(
    (t) => y(t)
  )) && (e.status === "active" || e.status === "entered-in-error" || e.status === "on-hold" || e.status === "unknown" || e.status === "draft" || e.status === "completed" || e.status === "revoked") && (typeof e._status > "u" || r(e._status)) && y(e.subject) && (typeof e.supportingInfo > "u" || Array.isArray(e.supportingInfo) && e.supportingInfo.every(
    (t) => y(t)
  ));
}
function gy(n) {
  const e = n;
  return b(e) && e.resourceType === "Slot" && (typeof e.appointmentType > "u" || u(e.appointmentType)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && typeof e.end == "string" && (typeof e._end > "u" || r(e._end)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.overbooked > "u" || e.overbooked === !1 || e.overbooked === !0) && (typeof e._overbooked > "u" || r(e._overbooked)) && y(e.schedule) && (typeof e.serviceCategory > "u" || Array.isArray(e.serviceCategory) && e.serviceCategory.every(
    (t) => u(t)
  )) && (typeof e.serviceType > "u" || Array.isArray(e.serviceType) && e.serviceType.every(
    (t) => u(t)
  )) && (typeof e.specialty > "u" || Array.isArray(e.specialty) && e.specialty.every(
    (t) => u(t)
  )) && typeof e.start == "string" && (typeof e._start > "u" || r(e._start)) && (e.status === "entered-in-error" || e.status === "busy" || e.status === "free" || e.status === "busy-unavailable" || e.status === "busy-tentative") && (typeof e._status > "u" || r(e._status));
}
function CS(n) {
  const e = n;
  return p(e) && (typeof e.bodySite > "u" || u(e.bodySite)) && (typeof e.collectedDateTime > "u" || typeof e.collectedDateTime == "string") && (typeof e._collectedDateTime > "u" || r(e._collectedDateTime)) && (typeof e.collectedPeriod > "u" || D(e.collectedPeriod)) && (typeof e.collector > "u" || y(e.collector)) && (typeof e.duration > "u" || ue(e.duration)) && (typeof e.fastingStatusCodeableConcept > "u" || u(e.fastingStatusCodeableConcept)) && (typeof e.fastingStatusDuration > "u" || ue(e.fastingStatusDuration)) && (typeof e.method > "u" || u(e.method)) && (typeof e.quantity > "u" || S(e.quantity));
}
function xS(n) {
  const e = n;
  return p(e) && (typeof e.additive > "u" || Array.isArray(e.additive) && e.additive.every(
    (t) => y(t)
  )) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.procedure > "u" || u(e.procedure)) && (typeof e.timeDateTime > "u" || typeof e.timeDateTime == "string") && (typeof e._timeDateTime > "u" || r(e._timeDateTime)) && (typeof e.timePeriod > "u" || D(e.timePeriod));
}
function DS(n) {
  const e = n;
  return p(e) && (typeof e.additiveCodeableConcept > "u" || u(e.additiveCodeableConcept)) && (typeof e.additiveReference > "u" || y(e.additiveReference)) && (typeof e.capacity > "u" || S(e.capacity)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.specimenQuantity > "u" || S(e.specimenQuantity)) && (typeof e.type > "u" || u(e.type));
}
function my(n) {
  const e = n;
  return b(e) && e.resourceType === "Specimen" && (typeof e.accessionIdentifier > "u" || A(e.accessionIdentifier)) && (typeof e.collection > "u" || CS(e.collection)) && (typeof e.condition > "u" || Array.isArray(e.condition) && e.condition.every(
    (t) => u(t)
  )) && (typeof e.container > "u" || Array.isArray(e.container) && e.container.every(
    (t) => DS(t)
  )) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.parent > "u" || Array.isArray(e.parent) && e.parent.every(
    (t) => y(t)
  )) && (typeof e.processing > "u" || Array.isArray(e.processing) && e.processing.every(
    (t) => xS(t)
  )) && (typeof e.receivedTime > "u" || typeof e.receivedTime == "string") && (typeof e._receivedTime > "u" || r(e._receivedTime)) && (typeof e.request > "u" || Array.isArray(e.request) && e.request.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "available" || e.status === "unavailable" || e.status === "unsatisfactory") && (typeof e._status > "u" || r(e._status)) && (typeof e.subject > "u" || y(e.subject)) && (typeof e.type > "u" || u(e.type));
}
function TS(n) {
  const e = n;
  return p(e) && (typeof e.additiveCodeableConcept > "u" || u(e.additiveCodeableConcept)) && (typeof e.additiveReference > "u" || y(e.additiveReference));
}
function SS(n) {
  const e = n;
  return p(e) && (typeof e.additive > "u" || Array.isArray(e.additive) && e.additive.every(
    (t) => TS(t)
  )) && (typeof e.cap > "u" || u(e.cap)) && (typeof e.capacity > "u" || S(e.capacity)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.material > "u" || u(e.material)) && (typeof e.minimumVolumeQuantity > "u" || S(e.minimumVolumeQuantity)) && (typeof e.minimumVolumeString > "u" || typeof e.minimumVolumeString == "string") && (typeof e._minimumVolumeString > "u" || r(e._minimumVolumeString)) && (typeof e.preparation > "u" || typeof e.preparation == "string") && (typeof e._preparation > "u" || r(e._preparation)) && (typeof e.type > "u" || u(e.type));
}
function RS(n) {
  const e = n;
  return p(e) && (typeof e.instruction > "u" || typeof e.instruction == "string") && (typeof e._instruction > "u" || r(e._instruction)) && (typeof e.maxDuration > "u" || ue(e.maxDuration)) && (typeof e.temperatureQualifier > "u" || u(e.temperatureQualifier)) && (typeof e.temperatureRange > "u" || K(e.temperatureRange));
}
function wS(n) {
  const e = n;
  return p(e) && (typeof e.container > "u" || SS(e.container)) && (typeof e.handling > "u" || Array.isArray(e.handling) && e.handling.every(
    (t) => RS(t)
  )) && (typeof e.isDerived > "u" || e.isDerived === !1 || e.isDerived === !0) && (typeof e._isDerived > "u" || r(e._isDerived)) && (e.preference === "preferred" || e.preference === "alternate") && (typeof e._preference > "u" || r(e._preference)) && (typeof e.rejectionCriterion > "u" || Array.isArray(e.rejectionCriterion) && e.rejectionCriterion.every(
    (t) => u(t)
  )) && (typeof e.requirement > "u" || typeof e.requirement == "string") && (typeof e._requirement > "u" || r(e._requirement)) && (typeof e.retentionTime > "u" || ue(e.retentionTime)) && (typeof e.type > "u" || u(e.type));
}
function _y(n) {
  const e = n;
  return b(e) && e.resourceType === "SpecimenDefinition" && (typeof e.collection > "u" || Array.isArray(e.collection) && e.collection.every(
    (t) => u(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.patientPreparation > "u" || Array.isArray(e.patientPreparation) && e.patientPreparation.every(
    (t) => u(t)
  )) && (typeof e.timeAspect > "u" || typeof e.timeAspect == "string") && (typeof e._timeAspect > "u" || r(e._timeAspect)) && (typeof e.typeCollected > "u" || u(e.typeCollected)) && (typeof e.typeTested > "u" || Array.isArray(e.typeTested) && e.typeTested.every(
    (t) => wS(t)
  ));
}
function IS(n) {
  const e = n;
  return p(e) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && typeof e.identity == "string" && (typeof e._identity > "u" || r(e._identity)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || r(e._uri));
}
function PS(n) {
  const e = n;
  return p(e) && typeof e.expression == "string" && (typeof e._expression > "u" || r(e._expression)) && (e.type === "fhirpath" || e.type === "element" || e.type === "extension") && (typeof e._type > "u" || r(e._type));
}
function OS(n) {
  const e = n;
  return p(e) && Array.isArray(e.element) && e.element.every(
    (t) => Ec(t)
  );
}
function qS(n) {
  const e = n;
  return p(e) && Array.isArray(e.element) && e.element.every(
    (t) => Ec(t)
  );
}
function vy(n) {
  const e = n;
  return b(e) && e.resourceType === "StructureDefinition" && typeof e.abstract == "boolean" && (typeof e._abstract > "u" || r(e._abstract)) && (typeof e.baseDefinition > "u" || typeof e.baseDefinition == "string") && (typeof e._baseDefinition > "u" || r(e._baseDefinition)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.context > "u" || Array.isArray(e.context) && e.context.every(
    (t) => PS(t)
  )) && (typeof e.contextInvariant > "u" || Array.isArray(e.contextInvariant) && e.contextInvariant.every(
    (t) => typeof t == "string"
  )) && (typeof e._contextInvariant > "u" || Array.isArray(e._contextInvariant) && e._contextInvariant.every(
    (t) => r(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.derivation > "u" || e.derivation === "specialization" || e.derivation === "constraint") && (typeof e._derivation > "u" || r(e._derivation)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.differential > "u" || qS(e.differential)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.fhirVersion > "u" || typeof e.fhirVersion == "string") && (typeof e._fhirVersion > "u" || r(e._fhirVersion)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.keyword > "u" || Array.isArray(e.keyword) && e.keyword.every(
    (t) => V(t)
  )) && (e.kind === "logical" || e.kind === "primitive-type" || e.kind === "complex-type" || e.kind === "resource") && (typeof e._kind > "u" || r(e._kind)) && (typeof e.mapping > "u" || Array.isArray(e.mapping) && e.mapping.every(
    (t) => IS(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.snapshot > "u" || OS(e.snapshot)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.type == "string" && (typeof e._type > "u" || r(e._type)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function BS(n) {
  const e = n;
  return p(e) && (typeof e.alias > "u" || typeof e.alias == "string") && (typeof e._alias > "u" || r(e._alias)) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (e.mode === "source" || e.mode === "queried" || e.mode === "target" || e.mode === "produced") && (typeof e._mode > "u" || r(e._mode)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url));
}
function US(n) {
  const e = n;
  return p(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (e.mode === "source" || e.mode === "target") && (typeof e._mode > "u" || r(e._mode)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type));
}
function MS(n) {
  const e = n;
  return p(e) && (typeof e.check > "u" || typeof e.check == "string") && (typeof e._check > "u" || r(e._check)) && (typeof e.condition > "u" || typeof e.condition == "string") && (typeof e._condition > "u" || r(e._condition)) && typeof e.context == "string" && (typeof e._context > "u" || r(e._context)) && (typeof e.defaultValueBase64Binary > "u" || typeof e.defaultValueBase64Binary == "string") && (typeof e._defaultValueBase64Binary > "u" || r(e._defaultValueBase64Binary)) && (typeof e.defaultValueBoolean > "u" || e.defaultValueBoolean === !1 || e.defaultValueBoolean === !0) && (typeof e._defaultValueBoolean > "u" || r(e._defaultValueBoolean)) && (typeof e.defaultValueCanonical > "u" || typeof e.defaultValueCanonical == "string") && (typeof e._defaultValueCanonical > "u" || r(e._defaultValueCanonical)) && (typeof e.defaultValueCode > "u" || typeof e.defaultValueCode == "string") && (typeof e._defaultValueCode > "u" || r(e._defaultValueCode)) && (typeof e.defaultValueDate > "u" || typeof e.defaultValueDate == "string") && (typeof e._defaultValueDate > "u" || r(e._defaultValueDate)) && (typeof e.defaultValueDateTime > "u" || typeof e.defaultValueDateTime == "string") && (typeof e._defaultValueDateTime > "u" || r(e._defaultValueDateTime)) && (typeof e.defaultValueDecimal > "u" || typeof e.defaultValueDecimal == "number") && (typeof e.defaultValueId > "u" || typeof e.defaultValueId == "string") && (typeof e._defaultValueId > "u" || r(e._defaultValueId)) && (typeof e.defaultValueInstant > "u" || typeof e.defaultValueInstant == "string") && (typeof e._defaultValueInstant > "u" || r(e._defaultValueInstant)) && (typeof e.defaultValueInteger > "u" || typeof e.defaultValueInteger == "number") && (typeof e.defaultValueMarkdown > "u" || typeof e.defaultValueMarkdown == "string") && (typeof e._defaultValueMarkdown > "u" || r(e._defaultValueMarkdown)) && (typeof e.defaultValueOid > "u" || typeof e.defaultValueOid == "string") && (typeof e._defaultValueOid > "u" || r(e._defaultValueOid)) && (typeof e.defaultValuePositiveInt > "u" || typeof e.defaultValuePositiveInt == "number") && (typeof e.defaultValueString > "u" || typeof e.defaultValueString == "string") && (typeof e._defaultValueString > "u" || r(e._defaultValueString)) && (typeof e.defaultValueTime > "u" || typeof e.defaultValueTime == "string") && (typeof e._defaultValueTime > "u" || r(e._defaultValueTime)) && (typeof e.defaultValueUnsignedInt > "u" || typeof e.defaultValueUnsignedInt == "number") && (typeof e.defaultValueUri > "u" || typeof e.defaultValueUri == "string") && (typeof e._defaultValueUri > "u" || r(e._defaultValueUri)) && (typeof e.defaultValueUrl > "u" || typeof e.defaultValueUrl == "string") && (typeof e._defaultValueUrl > "u" || r(e._defaultValueUrl)) && (typeof e.defaultValueUuid > "u" || typeof e.defaultValueUuid == "string") && (typeof e._defaultValueUuid > "u" || r(e._defaultValueUuid)) && (typeof e.defaultValueAddress > "u" || Te(e.defaultValueAddress)) && (typeof e.defaultValueAge > "u" || Le(e.defaultValueAge)) && (typeof e.defaultValueAnnotation > "u" || $(e.defaultValueAnnotation)) && (typeof e.defaultValueAttachment > "u" || te(e.defaultValueAttachment)) && (typeof e.defaultValueCodeableConcept > "u" || u(e.defaultValueCodeableConcept)) && (typeof e.defaultValueCoding > "u" || V(e.defaultValueCoding)) && (typeof e.defaultValueContactPoint > "u" || he(e.defaultValueContactPoint)) && (typeof e.defaultValueCount > "u" || Mr(e.defaultValueCount)) && (typeof e.defaultValueDistance > "u" || Er(e.defaultValueDistance)) && (typeof e.defaultValueDuration > "u" || ue(e.defaultValueDuration)) && (typeof e.defaultValueHumanName > "u" || Je(e.defaultValueHumanName)) && (typeof e.defaultValueIdentifier > "u" || A(e.defaultValueIdentifier)) && (typeof e.defaultValueMoney > "u" || L(e.defaultValueMoney)) && (typeof e.defaultValuePeriod > "u" || D(e.defaultValuePeriod)) && (typeof e.defaultValueQuantity > "u" || S(e.defaultValueQuantity)) && (typeof e.defaultValueRange > "u" || K(e.defaultValueRange)) && (typeof e.defaultValueRatio > "u" || ge(e.defaultValueRatio)) && (typeof e.defaultValueReference > "u" || y(e.defaultValueReference)) && (typeof e.defaultValueSampledData > "u" || rr(e.defaultValueSampledData)) && (typeof e.defaultValueSignature > "u" || ut(e.defaultValueSignature)) && (typeof e.defaultValueTiming > "u" || le(e.defaultValueTiming)) && (typeof e.defaultValueContactDetail > "u" || B(e.defaultValueContactDetail)) && (typeof e.defaultValueContributor > "u" || Ur(e.defaultValueContributor)) && (typeof e.defaultValueDataRequirement > "u" || Ye(e.defaultValueDataRequirement)) && (typeof e.defaultValueExpression > "u" || ke(e.defaultValueExpression)) && (typeof e.defaultValueParameterDefinition > "u" || _r(e.defaultValueParameterDefinition)) && (typeof e.defaultValueRelatedArtifact > "u" || Se(e.defaultValueRelatedArtifact)) && (typeof e.defaultValueTriggerDefinition > "u" || Ft(e.defaultValueTriggerDefinition)) && (typeof e.defaultValueUsageContext > "u" || X(e.defaultValueUsageContext)) && (typeof e.defaultValueDosage > "u" || ht(e.defaultValueDosage)) && (typeof e.defaultValueMeta > "u" || mr(e.defaultValueMeta)) && (typeof e.element > "u" || typeof e.element == "string") && (typeof e._element > "u" || r(e._element)) && (typeof e.listMode > "u" || e.listMode === "first" || e.listMode === "not_first" || e.listMode === "last" || e.listMode === "not_last" || e.listMode === "only_one") && (typeof e._listMode > "u" || r(e._listMode)) && (typeof e.logMessage > "u" || typeof e.logMessage == "string") && (typeof e._logMessage > "u" || r(e._logMessage)) && (typeof e.max > "u" || typeof e.max == "string") && (typeof e._max > "u" || r(e._max)) && (typeof e.min > "u" || typeof e.min == "number") && (typeof e.type > "u" || typeof e.type == "string") && (typeof e._type > "u" || r(e._type)) && (typeof e.variable > "u" || typeof e.variable == "string") && (typeof e._variable > "u" || r(e._variable));
}
function ES(n) {
  const e = n;
  return p(e) && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number");
}
function kS(n) {
  const e = n;
  return p(e) && (typeof e.context > "u" || typeof e.context == "string") && (typeof e._context > "u" || r(e._context)) && (typeof e.contextType > "u" || e.contextType === "type" || e.contextType === "variable") && (typeof e._contextType > "u" || r(e._contextType)) && (typeof e.element > "u" || typeof e.element == "string") && (typeof e._element > "u" || r(e._element)) && (typeof e.listMode > "u" || Array.isArray(e.listMode) && e.listMode.every(
    (t) => t === "first" || t === "last" || t === "share" || t === "collate"
  )) && (typeof e._listMode > "u" || Array.isArray(e._listMode) && e._listMode.every(
    (t) => r(t)
  )) && (typeof e.listRuleId > "u" || typeof e.listRuleId == "string") && (typeof e._listRuleId > "u" || r(e._listRuleId)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => ES(t)
  )) && (typeof e.transform > "u" || e.transform === "create" || e.transform === "reference" || e.transform === "uuid" || e.transform === "copy" || e.transform === "truncate" || e.transform === "escape" || e.transform === "cast" || e.transform === "append" || e.transform === "translate" || e.transform === "dateOp" || e.transform === "pointer" || e.transform === "evaluate" || e.transform === "cc" || e.transform === "c" || e.transform === "qty" || e.transform === "id" || e.transform === "cp") && (typeof e._transform > "u" || r(e._transform)) && (typeof e.variable > "u" || typeof e.variable == "string") && (typeof e._variable > "u" || r(e._variable));
}
function VS(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && Array.isArray(e.variable) && e.variable.every(
    (t) => typeof t == "string"
  ) && (typeof e._variable > "u" || Array.isArray(e._variable) && e._variable.every(
    (t) => r(t)
  ));
}
function sl(n) {
  const e = n;
  return p(e) && (typeof e.dependent > "u" || Array.isArray(e.dependent) && e.dependent.every(
    (t) => VS(t)
  )) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.rule > "u" || Array.isArray(e.rule) && e.rule.every(
    (t) => sl(t)
  )) && Array.isArray(e.source) && e.source.every(
    (t) => MS(t)
  ) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => kS(t)
  ));
}
function NS(n) {
  const e = n;
  return p(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && (typeof e.extends > "u" || typeof e.extends == "string") && (typeof e._extends > "u" || r(e._extends)) && Array.isArray(e.input) && e.input.every(
    (t) => US(t)
  ) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && Array.isArray(e.rule) && e.rule.every(
    (t) => sl(t)
  ) && (e.typeMode === "none" || e.typeMode === "types" || e.typeMode === "type-and-types") && (typeof e._typeMode > "u" || r(e._typeMode));
}
function Ay(n) {
  const e = n;
  return b(e) && e.resourceType === "StructureMap" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && Array.isArray(e.group) && e.group.every(
    (t) => NS(t)
  ) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.import > "u" || Array.isArray(e.import) && e.import.every(
    (t) => typeof t == "string"
  )) && (typeof e._import > "u" || Array.isArray(e._import) && e._import.every(
    (t) => r(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.structure > "u" || Array.isArray(e.structure) && e.structure.every(
    (t) => BS(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function LS(n) {
  const e = n;
  return p(e) && (typeof e.endpoint > "u" || typeof e.endpoint == "string") && (typeof e._endpoint > "u" || r(e._endpoint)) && (typeof e.header > "u" || Array.isArray(e.header) && e.header.every(
    (t) => typeof t == "string"
  )) && (typeof e._header > "u" || Array.isArray(e._header) && e._header.every(
    (t) => r(t)
  )) && (typeof e.payload > "u" || typeof e.payload == "string") && (typeof e._payload > "u" || r(e._payload)) && (e.type === "email" || e.type === "sms" || e.type === "message" || e.type === "rest-hook" || e.type === "websocket") && (typeof e._type > "u" || r(e._type));
}
function hy(n) {
  const e = n;
  return b(e) && e.resourceType === "Subscription" && LS(e.channel) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => he(t)
  )) && typeof e.criteria == "string" && (typeof e._criteria > "u" || r(e._criteria)) && (typeof e.end > "u" || typeof e.end == "string") && (typeof e._end > "u" || r(e._end)) && (typeof e.error > "u" || typeof e.error == "string") && (typeof e._error > "u" || r(e._error)) && typeof e.reason == "string" && (typeof e._reason > "u" || r(e._reason)) && (e.status === "error" || e.status === "active" || e.status === "off" || e.status === "requested") && (typeof e._status > "u" || r(e._status));
}
function FS(n) {
  const e = n;
  return p(e) && (typeof e.expiry > "u" || typeof e.expiry == "string") && (typeof e._expiry > "u" || r(e._expiry)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.quantity > "u" || S(e.quantity));
}
function $S(n) {
  const e = n;
  return p(e) && (typeof e.quantity > "u" || ge(e.quantity)) && (typeof e.substanceCodeableConcept > "u" || u(e.substanceCodeableConcept)) && (typeof e.substanceReference > "u" || y(e.substanceReference));
}
function by(n) {
  const e = n;
  return b(e) && e.resourceType === "Substance" && (typeof e.category > "u" || Array.isArray(e.category) && e.category.every(
    (t) => u(t)
  )) && u(e.code) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.ingredient > "u" || Array.isArray(e.ingredient) && e.ingredient.every(
    (t) => $S(t)
  )) && (typeof e.instance > "u" || Array.isArray(e.instance) && e.instance.every(
    (t) => FS(t)
  )) && (typeof e.status > "u" || e.status === "active" || e.status === "inactive" || e.status === "entered-in-error") && (typeof e._status > "u" || r(e._status));
}
function jS(n) {
  const e = n;
  return p(e) && (typeof e.connectivity > "u" || typeof e.connectivity == "string") && (typeof e._connectivity > "u" || r(e._connectivity)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.residueSite > "u" || typeof e.residueSite == "string") && (typeof e._residueSite > "u" || r(e._residueSite));
}
function WS(n) {
  const e = n;
  return p(e) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.residueSite > "u" || typeof e.residueSite == "string") && (typeof e._residueSite > "u" || r(e._residueSite));
}
function HS(n) {
  const e = n;
  return p(e) && (typeof e.fivePrime > "u" || u(e.fivePrime)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.linkage > "u" || Array.isArray(e.linkage) && e.linkage.every(
    (t) => jS(t)
  )) && (typeof e.sequence > "u" || typeof e.sequence == "string") && (typeof e._sequence > "u" || r(e._sequence)) && (typeof e.sequenceAttachment > "u" || te(e.sequenceAttachment)) && (typeof e.subunit > "u" || typeof e.subunit == "number") && (typeof e.sugar > "u" || Array.isArray(e.sugar) && e.sugar.every(
    (t) => WS(t)
  )) && (typeof e.threePrime > "u" || u(e.threePrime));
}
function Cy(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstanceNucleicAcid" && (typeof e.areaOfHybridisation > "u" || typeof e.areaOfHybridisation == "string") && (typeof e._areaOfHybridisation > "u" || r(e._areaOfHybridisation)) && (typeof e.numberOfSubunits > "u" || typeof e.numberOfSubunits == "number") && (typeof e.oligoNucleotideType > "u" || u(e.oligoNucleotideType)) && (typeof e.sequenceType > "u" || u(e.sequenceType)) && (typeof e.subunit > "u" || Array.isArray(e.subunit) && e.subunit.every(
    (t) => HS(t)
  ));
}
function QS(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || Cp(e.amount)) && (typeof e.isDefining > "u" || e.isDefining === !1 || e.isDefining === !0) && (typeof e._isDefining > "u" || r(e._isDefining)) && (typeof e.material > "u" || u(e.material)) && (typeof e.type > "u" || u(e.type));
}
function zS(n) {
  const e = n;
  return p(e) && (typeof e.ratioType > "u" || u(e.ratioType)) && (typeof e.startingMaterial > "u" || Array.isArray(e.startingMaterial) && e.startingMaterial.every(
    (t) => QS(t)
  ));
}
function GS(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || Cp(e.amount)) && (typeof e.degree > "u" || u(e.degree));
}
function KS(n) {
  const e = n;
  return p(e) && (typeof e.attachment > "u" || te(e.attachment)) && (typeof e.representation > "u" || typeof e.representation == "string") && (typeof e._representation > "u" || r(e._representation)) && (typeof e.type > "u" || u(e.type));
}
function YS(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || Cp(e.amount)) && (typeof e.degreeOfPolymerisation > "u" || Array.isArray(e.degreeOfPolymerisation) && e.degreeOfPolymerisation.every(
    (t) => GS(t)
  )) && (typeof e.orientationOfPolymerisation > "u" || u(e.orientationOfPolymerisation)) && (typeof e.repeatUnit > "u" || typeof e.repeatUnit == "string") && (typeof e._repeatUnit > "u" || r(e._repeatUnit)) && (typeof e.structuralRepresentation > "u" || Array.isArray(e.structuralRepresentation) && e.structuralRepresentation.every(
    (t) => KS(t)
  ));
}
function JS(n) {
  const e = n;
  return p(e) && (typeof e.averageMolecularFormula > "u" || typeof e.averageMolecularFormula == "string") && (typeof e._averageMolecularFormula > "u" || r(e._averageMolecularFormula)) && (typeof e.numberOfUnits > "u" || typeof e.numberOfUnits == "number") && (typeof e.repeatUnit > "u" || Array.isArray(e.repeatUnit) && e.repeatUnit.every(
    (t) => YS(t)
  )) && (typeof e.repeatUnitAmountType > "u" || u(e.repeatUnitAmountType));
}
function xy(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstancePolymer" && (typeof e.class > "u" || u(e.class)) && (typeof e.copolymerConnectivity > "u" || Array.isArray(e.copolymerConnectivity) && e.copolymerConnectivity.every(
    (t) => u(t)
  )) && (typeof e.geometry > "u" || u(e.geometry)) && (typeof e.modification > "u" || Array.isArray(e.modification) && e.modification.every(
    (t) => typeof t == "string"
  )) && (typeof e._modification > "u" || Array.isArray(e._modification) && e._modification.every(
    (t) => r(t)
  )) && (typeof e.monomerSet > "u" || Array.isArray(e.monomerSet) && e.monomerSet.every(
    (t) => zS(t)
  )) && (typeof e.repeat > "u" || Array.isArray(e.repeat) && e.repeat.every(
    (t) => JS(t)
  ));
}
function ZS(n) {
  const e = n;
  return p(e) && (typeof e.cTerminalModification > "u" || typeof e.cTerminalModification == "string") && (typeof e._cTerminalModification > "u" || r(e._cTerminalModification)) && (typeof e.cTerminalModificationId > "u" || A(e.cTerminalModificationId)) && (typeof e.length > "u" || typeof e.length == "number") && (typeof e.nTerminalModification > "u" || typeof e.nTerminalModification == "string") && (typeof e._nTerminalModification > "u" || r(e._nTerminalModification)) && (typeof e.nTerminalModificationId > "u" || A(e.nTerminalModificationId)) && (typeof e.sequence > "u" || typeof e.sequence == "string") && (typeof e._sequence > "u" || r(e._sequence)) && (typeof e.sequenceAttachment > "u" || te(e.sequenceAttachment)) && (typeof e.subunit > "u" || typeof e.subunit == "number");
}
function Dy(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstanceProtein" && (typeof e.disulfideLinkage > "u" || Array.isArray(e.disulfideLinkage) && e.disulfideLinkage.every(
    (t) => typeof t == "string"
  )) && (typeof e._disulfideLinkage > "u" || Array.isArray(e._disulfideLinkage) && e._disulfideLinkage.every(
    (t) => r(t)
  )) && (typeof e.numberOfSubunits > "u" || typeof e.numberOfSubunits == "number") && (typeof e.sequenceType > "u" || u(e.sequenceType)) && (typeof e.subunit > "u" || Array.isArray(e.subunit) && e.subunit.every(
    (t) => ZS(t)
  ));
}
function XS(n) {
  const e = n;
  return p(e) && (typeof e.gene > "u" || u(e.gene)) && (typeof e.geneSequenceOrigin > "u" || u(e.geneSequenceOrigin)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  ));
}
function eR(n) {
  const e = n;
  return p(e) && (typeof e.element > "u" || A(e.element)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function tR(n) {
  const e = n;
  return p(e) && (typeof e.classification > "u" || u(e.classification)) && (typeof e.domain > "u" || u(e.domain)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.subtype > "u" || Array.isArray(e.subtype) && e.subtype.every(
    (t) => u(t)
  ));
}
function rR(n) {
  const e = n;
  return p(e) && (typeof e.amountQuantity > "u" || S(e.amountQuantity)) && (typeof e.amountRange > "u" || K(e.amountRange)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || r(e._amountString)) && (typeof e.amountType > "u" || u(e.amountType)) && (typeof e.interaction > "u" || u(e.interaction)) && (typeof e.organism > "u" || u(e.organism)) && (typeof e.organismType > "u" || u(e.organismType)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.target > "u" || A(e.target)) && (typeof e.type > "u" || u(e.type));
}
function Ty(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstanceReferenceInformation" && (typeof e.classification > "u" || Array.isArray(e.classification) && e.classification.every(
    (t) => tR(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.gene > "u" || Array.isArray(e.gene) && e.gene.every(
    (t) => XS(t)
  )) && (typeof e.geneElement > "u" || Array.isArray(e.geneElement) && e.geneElement.every(
    (t) => eR(t)
  )) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => rR(t)
  ));
}
function oR(n) {
  const e = n;
  return p(e) && (typeof e.fraction > "u" || typeof e.fraction == "string") && (typeof e._fraction > "u" || r(e._fraction)) && (typeof e.materialType > "u" || u(e.materialType));
}
function iR(n) {
  const e = n;
  return p(e) && (typeof e.authorDescription > "u" || typeof e.authorDescription == "string") && (typeof e._authorDescription > "u" || r(e._authorDescription)) && (typeof e.authorType > "u" || u(e.authorType));
}
function nR(n) {
  const e = n;
  return p(e) && (typeof e.hybridType > "u" || u(e.hybridType)) && (typeof e.maternalOrganismId > "u" || typeof e.maternalOrganismId == "string") && (typeof e._maternalOrganismId > "u" || r(e._maternalOrganismId)) && (typeof e.maternalOrganismName > "u" || typeof e.maternalOrganismName == "string") && (typeof e._maternalOrganismName > "u" || r(e._maternalOrganismName)) && (typeof e.paternalOrganismId > "u" || typeof e.paternalOrganismId == "string") && (typeof e._paternalOrganismId > "u" || r(e._paternalOrganismId)) && (typeof e.paternalOrganismName > "u" || typeof e.paternalOrganismName == "string") && (typeof e._paternalOrganismName > "u" || r(e._paternalOrganismName));
}
function aR(n) {
  const e = n;
  return p(e) && (typeof e.class > "u" || u(e.class)) && (typeof e.kingdom > "u" || u(e.kingdom)) && (typeof e.order > "u" || u(e.order)) && (typeof e.phylum > "u" || u(e.phylum));
}
function uR(n) {
  const e = n;
  return p(e) && (typeof e.author > "u" || Array.isArray(e.author) && e.author.every(
    (t) => iR(t)
  )) && (typeof e.family > "u" || u(e.family)) && (typeof e.genus > "u" || u(e.genus)) && (typeof e.hybrid > "u" || nR(e.hybrid)) && (typeof e.intraspecificDescription > "u" || typeof e.intraspecificDescription == "string") && (typeof e._intraspecificDescription > "u" || r(e._intraspecificDescription)) && (typeof e.intraspecificType > "u" || u(e.intraspecificType)) && (typeof e.organismGeneral > "u" || aR(e.organismGeneral)) && (typeof e.species > "u" || u(e.species));
}
function yR(n) {
  const e = n;
  return p(e) && (typeof e.part > "u" || u(e.part)) && (typeof e.partLocation > "u" || u(e.partLocation));
}
function Sy(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstanceSourceMaterial" && (typeof e.countryOfOrigin > "u" || Array.isArray(e.countryOfOrigin) && e.countryOfOrigin.every(
    (t) => u(t)
  )) && (typeof e.developmentStage > "u" || u(e.developmentStage)) && (typeof e.fractionDescription > "u" || Array.isArray(e.fractionDescription) && e.fractionDescription.every(
    (t) => oR(t)
  )) && (typeof e.geographicalLocation > "u" || Array.isArray(e.geographicalLocation) && e.geographicalLocation.every(
    (t) => typeof t == "string"
  )) && (typeof e._geographicalLocation > "u" || Array.isArray(e._geographicalLocation) && e._geographicalLocation.every(
    (t) => r(t)
  )) && (typeof e.organism > "u" || uR(e.organism)) && (typeof e.organismId > "u" || A(e.organismId)) && (typeof e.organismName > "u" || typeof e.organismName == "string") && (typeof e._organismName > "u" || r(e._organismName)) && (typeof e.parentSubstanceId > "u" || Array.isArray(e.parentSubstanceId) && e.parentSubstanceId.every(
    (t) => A(t)
  )) && (typeof e.parentSubstanceName > "u" || Array.isArray(e.parentSubstanceName) && e.parentSubstanceName.every(
    (t) => typeof t == "string"
  )) && (typeof e._parentSubstanceName > "u" || Array.isArray(e._parentSubstanceName) && e._parentSubstanceName.every(
    (t) => r(t)
  )) && (typeof e.partDescription > "u" || Array.isArray(e.partDescription) && e.partDescription.every(
    (t) => yR(t)
  )) && (typeof e.sourceMaterialClass > "u" || u(e.sourceMaterialClass)) && (typeof e.sourceMaterialState > "u" || u(e.sourceMaterialState)) && (typeof e.sourceMaterialType > "u" || u(e.sourceMaterialType));
}
function sR(n) {
  const e = n;
  return p(e) && (typeof e.amountQuantity > "u" || S(e.amountQuantity)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || r(e._amountString)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.molecularFormula > "u" || typeof e.molecularFormula == "string") && (typeof e._molecularFormula > "u" || r(e._molecularFormula)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.opticalActivity > "u" || u(e.opticalActivity)) && (typeof e.role > "u" || u(e.role)) && (typeof e.stereochemistry > "u" || u(e.stereochemistry));
}
function pR(n) {
  const e = n;
  return p(e) && (typeof e.amountQuantity > "u" || S(e.amountQuantity)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || r(e._amountString)) && (typeof e.category > "u" || u(e.category)) && (typeof e.code > "u" || u(e.code)) && (typeof e.definingSubstanceReference > "u" || y(e.definingSubstanceReference)) && (typeof e.definingSubstanceCodeableConcept > "u" || u(e.definingSubstanceCodeableConcept)) && (typeof e.parameters > "u" || typeof e.parameters == "string") && (typeof e._parameters > "u" || r(e._parameters));
}
function Tp(n) {
  const e = n;
  return p(e) && (typeof e.amount > "u" || S(e.amount)) && (typeof e.method > "u" || u(e.method)) && (typeof e.type > "u" || u(e.type));
}
function fR(n) {
  const e = n;
  return p(e) && (typeof e.halfLife > "u" || S(e.halfLife)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.molecularWeight > "u" || Tp(e.molecularWeight)) && (typeof e.name > "u" || u(e.name)) && (typeof e.substitution > "u" || u(e.substitution));
}
function cR(n) {
  const e = n;
  return p(e) && (typeof e.attachment > "u" || te(e.attachment)) && (typeof e.representation > "u" || typeof e.representation == "string") && (typeof e._representation > "u" || r(e._representation)) && (typeof e.type > "u" || u(e.type));
}
function lR(n) {
  const e = n;
  return p(e) && (typeof e.isotope > "u" || Array.isArray(e.isotope) && e.isotope.every(
    (t) => fR(t)
  )) && (typeof e.molecularFormula > "u" || typeof e.molecularFormula == "string") && (typeof e._molecularFormula > "u" || r(e._molecularFormula)) && (typeof e.molecularFormulaByMoiety > "u" || typeof e.molecularFormulaByMoiety == "string") && (typeof e._molecularFormulaByMoiety > "u" || r(e._molecularFormulaByMoiety)) && (typeof e.molecularWeight > "u" || Tp(e.molecularWeight)) && (typeof e.opticalActivity > "u" || u(e.opticalActivity)) && (typeof e.representation > "u" || Array.isArray(e.representation) && e.representation.every(
    (t) => cR(t)
  )) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.stereochemistry > "u" || u(e.stereochemistry));
}
function dR(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || u(e.status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || r(e._statusDate));
}
function gR(n) {
  const e = n;
  return p(e) && (typeof e.authority > "u" || u(e.authority)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.status > "u" || u(e.status));
}
function _p(n) {
  const e = n;
  return p(e) && (typeof e.domain > "u" || Array.isArray(e.domain) && e.domain.every(
    (t) => u(t)
  )) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.language > "u" || Array.isArray(e.language) && e.language.every(
    (t) => u(t)
  )) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.official > "u" || Array.isArray(e.official) && e.official.every(
    (t) => gR(t)
  )) && (typeof e.preferred > "u" || e.preferred === !1 || e.preferred === !0) && (typeof e._preferred > "u" || r(e._preferred)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || u(e.status)) && (typeof e.synonym > "u" || Array.isArray(e.synonym) && e.synonym.every(
    (t) => _p(t)
  )) && (typeof e.translation > "u" || Array.isArray(e.translation) && e.translation.every(
    (t) => _p(t)
  )) && (typeof e.type > "u" || u(e.type));
}
function mR(n) {
  const e = n;
  return p(e) && (typeof e.amountQuantity > "u" || S(e.amountQuantity)) && (typeof e.amountRange > "u" || K(e.amountRange)) && (typeof e.amountRatio > "u" || ge(e.amountRatio)) && (typeof e.amountString > "u" || typeof e.amountString == "string") && (typeof e._amountString > "u" || r(e._amountString)) && (typeof e.amountRatioLowLimit > "u" || ge(e.amountRatioLowLimit)) && (typeof e.amountType > "u" || u(e.amountType)) && (typeof e.isDefining > "u" || e.isDefining === !1 || e.isDefining === !0) && (typeof e._isDefining > "u" || r(e._isDefining)) && (typeof e.relationship > "u" || u(e.relationship)) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.substanceReference > "u" || y(e.substanceReference)) && (typeof e.substanceCodeableConcept > "u" || u(e.substanceCodeableConcept));
}
function Ry(n) {
  const e = n;
  return b(e) && e.resourceType === "SubstanceSpecification" && (typeof e.code > "u" || Array.isArray(e.code) && e.code.every(
    (t) => dR(t)
  )) && (typeof e.comment > "u" || typeof e.comment == "string") && (typeof e._comment > "u" || r(e._comment)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.domain > "u" || u(e.domain)) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.moiety > "u" || Array.isArray(e.moiety) && e.moiety.every(
    (t) => sR(t)
  )) && (typeof e.molecularWeight > "u" || Array.isArray(e.molecularWeight) && e.molecularWeight.every(
    (t) => Tp(t)
  )) && (typeof e.name > "u" || Array.isArray(e.name) && e.name.every(
    (t) => _p(t)
  )) && (typeof e.nucleicAcid > "u" || y(e.nucleicAcid)) && (typeof e.polymer > "u" || y(e.polymer)) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => pR(t)
  )) && (typeof e.protein > "u" || y(e.protein)) && (typeof e.referenceInformation > "u" || y(e.referenceInformation)) && (typeof e.relationship > "u" || Array.isArray(e.relationship) && e.relationship.every(
    (t) => mR(t)
  )) && (typeof e.source > "u" || Array.isArray(e.source) && e.source.every(
    (t) => y(t)
  )) && (typeof e.sourceMaterial > "u" || y(e.sourceMaterial)) && (typeof e.status > "u" || u(e.status)) && (typeof e.structure > "u" || lR(e.structure)) && (typeof e.type > "u" || u(e.type));
}
function _R(n) {
  const e = n;
  return p(e) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || y(e.itemReference)) && (typeof e.quantity > "u" || S(e.quantity));
}
function wy(n) {
  const e = n;
  return b(e) && e.resourceType === "SupplyDelivery" && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.destination > "u" || y(e.destination)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.patient > "u" || y(e.patient)) && (typeof e.receiver > "u" || Array.isArray(e.receiver) && e.receiver.every(
    (t) => y(t)
  )) && (typeof e.status > "u" || e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "abandoned") && (typeof e._status > "u" || r(e._status)) && (typeof e.suppliedItem > "u" || _R(e.suppliedItem)) && (typeof e.supplier > "u" || y(e.supplier)) && (typeof e.type > "u" || u(e.type));
}
function vR(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || u(e.code)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean));
}
function Iy(n) {
  const e = n;
  return b(e) && e.resourceType === "SupplyRequest" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.category > "u" || u(e.category)) && (typeof e.deliverFrom > "u" || y(e.deliverFrom)) && (typeof e.deliverTo > "u" || y(e.deliverTo)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.itemCodeableConcept > "u" || u(e.itemCodeableConcept)) && (typeof e.itemReference > "u" || y(e.itemReference)) && (typeof e.occurrenceDateTime > "u" || typeof e.occurrenceDateTime == "string") && (typeof e._occurrenceDateTime > "u" || r(e._occurrenceDateTime)) && (typeof e.occurrencePeriod > "u" || D(e.occurrencePeriod)) && (typeof e.occurrenceTiming > "u" || le(e.occurrenceTiming)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => vR(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && S(e.quantity) && (typeof e.reasonCode > "u" || Array.isArray(e.reasonCode) && e.reasonCode.every(
    (t) => u(t)
  )) && (typeof e.reasonReference > "u" || Array.isArray(e.reasonReference) && e.reasonReference.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || y(e.requester)) && (typeof e.status > "u" || e.status === "active" || e.status === "entered-in-error" || e.status === "unknown" || e.status === "draft" || e.status === "cancelled" || e.status === "completed" || e.status === "suspended") && (typeof e._status > "u" || r(e._status)) && (typeof e.supplier > "u" || Array.isArray(e.supplier) && e.supplier.every(
    (t) => y(t)
  ));
}
function AR(n) {
  const e = n;
  return p(e) && (typeof e.period > "u" || D(e.period)) && (typeof e.recipient > "u" || Array.isArray(e.recipient) && e.recipient.every(
    (t) => y(t)
  )) && (typeof e.repetitions > "u" || typeof e.repetitions == "number");
}
function hR(n) {
  const e = n;
  return p(e) && u(e.type) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || r(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || r(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || r(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || r(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || r(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || r(e._valueUuid)) && (typeof e.valueAddress > "u" || Te(e.valueAddress)) && (typeof e.valueAge > "u" || Le(e.valueAge)) && (typeof e.valueAnnotation > "u" || $(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueContactPoint > "u" || he(e.valueContactPoint)) && (typeof e.valueCount > "u" || Mr(e.valueCount)) && (typeof e.valueDistance > "u" || Er(e.valueDistance)) && (typeof e.valueDuration > "u" || ue(e.valueDuration)) && (typeof e.valueHumanName > "u" || Je(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || A(e.valueIdentifier)) && (typeof e.valueMoney > "u" || L(e.valueMoney)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueReference > "u" || y(e.valueReference)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueSignature > "u" || ut(e.valueSignature)) && (typeof e.valueTiming > "u" || le(e.valueTiming)) && (typeof e.valueContactDetail > "u" || B(e.valueContactDetail)) && (typeof e.valueContributor > "u" || Ur(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || Ye(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || ke(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || _r(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || Se(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || Ft(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || X(e.valueUsageContext)) && (typeof e.valueDosage > "u" || ht(e.valueDosage)) && (typeof e.valueMeta > "u" || mr(e.valueMeta));
}
function bR(n) {
  const e = n;
  return p(e) && u(e.type) && (typeof e.valueBase64Binary > "u" || typeof e.valueBase64Binary == "string") && (typeof e._valueBase64Binary > "u" || r(e._valueBase64Binary)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueCanonical > "u" || typeof e.valueCanonical == "string") && (typeof e._valueCanonical > "u" || r(e._valueCanonical)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDate > "u" || typeof e.valueDate == "string") && (typeof e._valueDate > "u" || r(e._valueDate)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime)) && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueId > "u" || typeof e.valueId == "string") && (typeof e._valueId > "u" || r(e._valueId)) && (typeof e.valueInstant > "u" || typeof e.valueInstant == "string") && (typeof e._valueInstant > "u" || r(e._valueInstant)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueMarkdown > "u" || typeof e.valueMarkdown == "string") && (typeof e._valueMarkdown > "u" || r(e._valueMarkdown)) && (typeof e.valueOid > "u" || typeof e.valueOid == "string") && (typeof e._valueOid > "u" || r(e._valueOid)) && (typeof e.valuePositiveInt > "u" || typeof e.valuePositiveInt == "number") && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueTime > "u" || typeof e.valueTime == "string") && (typeof e._valueTime > "u" || r(e._valueTime)) && (typeof e.valueUnsignedInt > "u" || typeof e.valueUnsignedInt == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueUrl > "u" || typeof e.valueUrl == "string") && (typeof e._valueUrl > "u" || r(e._valueUrl)) && (typeof e.valueUuid > "u" || typeof e.valueUuid == "string") && (typeof e._valueUuid > "u" || r(e._valueUuid)) && (typeof e.valueAddress > "u" || Te(e.valueAddress)) && (typeof e.valueAge > "u" || Le(e.valueAge)) && (typeof e.valueAnnotation > "u" || $(e.valueAnnotation)) && (typeof e.valueAttachment > "u" || te(e.valueAttachment)) && (typeof e.valueCodeableConcept > "u" || u(e.valueCodeableConcept)) && (typeof e.valueCoding > "u" || V(e.valueCoding)) && (typeof e.valueContactPoint > "u" || he(e.valueContactPoint)) && (typeof e.valueCount > "u" || Mr(e.valueCount)) && (typeof e.valueDistance > "u" || Er(e.valueDistance)) && (typeof e.valueDuration > "u" || ue(e.valueDuration)) && (typeof e.valueHumanName > "u" || Je(e.valueHumanName)) && (typeof e.valueIdentifier > "u" || A(e.valueIdentifier)) && (typeof e.valueMoney > "u" || L(e.valueMoney)) && (typeof e.valuePeriod > "u" || D(e.valuePeriod)) && (typeof e.valueQuantity > "u" || S(e.valueQuantity)) && (typeof e.valueRange > "u" || K(e.valueRange)) && (typeof e.valueRatio > "u" || ge(e.valueRatio)) && (typeof e.valueReference > "u" || y(e.valueReference)) && (typeof e.valueSampledData > "u" || rr(e.valueSampledData)) && (typeof e.valueSignature > "u" || ut(e.valueSignature)) && (typeof e.valueTiming > "u" || le(e.valueTiming)) && (typeof e.valueContactDetail > "u" || B(e.valueContactDetail)) && (typeof e.valueContributor > "u" || Ur(e.valueContributor)) && (typeof e.valueDataRequirement > "u" || Ye(e.valueDataRequirement)) && (typeof e.valueExpression > "u" || ke(e.valueExpression)) && (typeof e.valueParameterDefinition > "u" || _r(e.valueParameterDefinition)) && (typeof e.valueRelatedArtifact > "u" || Se(e.valueRelatedArtifact)) && (typeof e.valueTriggerDefinition > "u" || Ft(e.valueTriggerDefinition)) && (typeof e.valueUsageContext > "u" || X(e.valueUsageContext)) && (typeof e.valueDosage > "u" || ht(e.valueDosage)) && (typeof e.valueMeta > "u" || mr(e.valueMeta));
}
function Py(n) {
  const e = n;
  return b(e) && e.resourceType === "Task" && (typeof e.authoredOn > "u" || typeof e.authoredOn == "string") && (typeof e._authoredOn > "u" || r(e._authoredOn)) && (typeof e.basedOn > "u" || Array.isArray(e.basedOn) && e.basedOn.every(
    (t) => y(t)
  )) && (typeof e.businessStatus > "u" || u(e.businessStatus)) && (typeof e.code > "u" || u(e.code)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.executionPeriod > "u" || D(e.executionPeriod)) && (typeof e.focus > "u" || y(e.focus)) && (typeof e.for > "u" || y(e.for)) && (typeof e.groupIdentifier > "u" || A(e.groupIdentifier)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.input > "u" || Array.isArray(e.input) && e.input.every(
    (t) => hR(t)
  )) && (typeof e.instantiatesCanonical > "u" || typeof e.instantiatesCanonical == "string") && (typeof e._instantiatesCanonical > "u" || r(e._instantiatesCanonical)) && (typeof e.instantiatesUri > "u" || typeof e.instantiatesUri == "string") && (typeof e._instantiatesUri > "u" || r(e._instantiatesUri)) && (typeof e.insurance > "u" || Array.isArray(e.insurance) && e.insurance.every(
    (t) => y(t)
  )) && (e.intent === "unknown" || e.intent === "proposal" || e.intent === "plan" || e.intent === "order" || e.intent === "original-order" || e.intent === "reflex-order" || e.intent === "filler-order" || e.intent === "instance-order" || e.intent === "option") && (typeof e._intent > "u" || r(e._intent)) && (typeof e.lastModified > "u" || typeof e.lastModified == "string") && (typeof e._lastModified > "u" || r(e._lastModified)) && (typeof e.location > "u" || y(e.location)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.output > "u" || Array.isArray(e.output) && e.output.every(
    (t) => bR(t)
  )) && (typeof e.owner > "u" || y(e.owner)) && (typeof e.partOf > "u" || Array.isArray(e.partOf) && e.partOf.every(
    (t) => y(t)
  )) && (typeof e.performerType > "u" || Array.isArray(e.performerType) && e.performerType.every(
    (t) => u(t)
  )) && (typeof e.priority > "u" || e.priority === "routine" || e.priority === "urgent" || e.priority === "asap" || e.priority === "stat") && (typeof e._priority > "u" || r(e._priority)) && (typeof e.reasonCode > "u" || u(e.reasonCode)) && (typeof e.reasonReference > "u" || y(e.reasonReference)) && (typeof e.relevantHistory > "u" || Array.isArray(e.relevantHistory) && e.relevantHistory.every(
    (t) => y(t)
  )) && (typeof e.requester > "u" || y(e.requester)) && (typeof e.restriction > "u" || AR(e.restriction)) && (e.status === "entered-in-error" || e.status === "on-hold" || e.status === "draft" || e.status === "accepted" || e.status === "cancelled" || e.status === "in-progress" || e.status === "completed" || e.status === "rejected" || e.status === "requested" || e.status === "received" || e.status === "ready" || e.status === "failed") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusReason > "u" || u(e.statusReason));
}
function CR(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function xR(n) {
  const e = n;
  return p(e) && typeof e.description == "string" && (typeof e._description > "u" || r(e._description)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function DR(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && Array.isArray(e.op) && e.op.every(
    (t) => typeof t == "string"
  ) && (typeof e._op > "u" || Array.isArray(e._op) && e._op.every(
    (t) => r(t)
  ));
}
function TR(n) {
  const e = n;
  return p(e) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.compositional > "u" || e.compositional === !1 || e.compositional === !0) && (typeof e._compositional > "u" || r(e._compositional)) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => DR(t)
  )) && (typeof e.isDefault > "u" || e.isDefault === !1 || e.isDefault === !0) && (typeof e._isDefault > "u" || r(e._isDefault)) && (typeof e.language > "u" || Array.isArray(e.language) && e.language.every(
    (t) => typeof t == "string"
  )) && (typeof e._language > "u" || Array.isArray(e._language) && e._language.every(
    (t) => r(t)
  )) && (typeof e.property > "u" || Array.isArray(e.property) && e.property.every(
    (t) => typeof t == "string"
  )) && (typeof e._property > "u" || Array.isArray(e._property) && e._property.every(
    (t) => r(t)
  ));
}
function SR(n) {
  const e = n;
  return p(e) && (typeof e.subsumption > "u" || e.subsumption === !1 || e.subsumption === !0) && (typeof e._subsumption > "u" || r(e._subsumption)) && (typeof e.uri > "u" || typeof e.uri == "string") && (typeof e._uri > "u" || r(e._uri)) && (typeof e.version > "u" || Array.isArray(e.version) && e.version.every(
    (t) => TR(t)
  ));
}
function RR(n) {
  const e = n;
  return p(e) && (typeof e.documentation > "u" || typeof e.documentation == "string") && (typeof e._documentation > "u" || r(e._documentation)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name));
}
function wR(n) {
  const e = n;
  return p(e) && (typeof e.hierarchical > "u" || e.hierarchical === !1 || e.hierarchical === !0) && (typeof e._hierarchical > "u" || r(e._hierarchical)) && (typeof e.incomplete > "u" || e.incomplete === !1 || e.incomplete === !0) && (typeof e._incomplete > "u" || r(e._incomplete)) && (typeof e.paging > "u" || e.paging === !1 || e.paging === !0) && (typeof e._paging > "u" || r(e._paging)) && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => RR(t)
  )) && (typeof e.textFilter > "u" || typeof e.textFilter == "string") && (typeof e._textFilter > "u" || r(e._textFilter));
}
function IR(n) {
  const e = n;
  return p(e) && typeof e.translations == "boolean" && (typeof e._translations > "u" || r(e._translations));
}
function PR(n) {
  const e = n;
  return p(e) && typeof e.needsMap == "boolean" && (typeof e._needsMap > "u" || r(e._needsMap));
}
function OR(n) {
  const e = n;
  return p(e) && (typeof e.translation > "u" || e.translation === !1 || e.translation === !0) && (typeof e._translation > "u" || r(e._translation));
}
function Oy(n) {
  const e = n;
  return b(e) && e.resourceType === "TerminologyCapabilities" && (typeof e.closure > "u" || OR(e.closure)) && (typeof e.codeSearch > "u" || e.codeSearch === "all" || e.codeSearch === "explicit") && (typeof e._codeSearch > "u" || r(e._codeSearch)) && (typeof e.codeSystem > "u" || Array.isArray(e.codeSystem) && e.codeSystem.every(
    (t) => SR(t)
  )) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && typeof e.date == "string" && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expansion > "u" || wR(e.expansion)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.implementation > "u" || xR(e.implementation)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (e.kind === "instance" || e.kind === "capability" || e.kind === "requirements") && (typeof e._kind > "u" || r(e._kind)) && (typeof e.lockedDate > "u" || e.lockedDate === !1 || e.lockedDate === !0) && (typeof e._lockedDate > "u" || r(e._lockedDate)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.software > "u" || CR(e.software)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.translation > "u" || PR(e.translation)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.validateCode > "u" || IR(e.validateCode)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function qR(n) {
  const e = n;
  return p(e) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (e.type === "client" || e.type === "server" || e.type === "test-engine") && (typeof e._type > "u" || r(e._type)) && typeof e.uri == "string" && (typeof e._uri > "u" || r(e._uri));
}
function Sp(n) {
  const e = n;
  return p(e) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || r(e._detail)) && (typeof e.message > "u" || typeof e.message == "string") && (typeof e._message > "u" || r(e._message)) && (e.result === "error" || e.result === "warning" || e.result === "pass" || e.result === "skip" || e.result === "fail") && (typeof e._result > "u" || r(e._result));
}
function pl(n) {
  const e = n;
  return p(e) && (typeof e.detail > "u" || typeof e.detail == "string") && (typeof e._detail > "u" || r(e._detail)) && (typeof e.message > "u" || typeof e.message == "string") && (typeof e._message > "u" || r(e._message)) && (e.result === "error" || e.result === "warning" || e.result === "pass" || e.result === "skip" || e.result === "fail") && (typeof e._result > "u" || r(e._result));
}
function BR(n) {
  const e = n;
  return p(e) && (typeof e.assert > "u" || pl(e.assert)) && (typeof e.operation > "u" || Sp(e.operation));
}
function UR(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => BR(t)
  );
}
function MR(n) {
  const e = n;
  return p(e) && (typeof e.assert > "u" || pl(e.assert)) && (typeof e.operation > "u" || Sp(e.operation));
}
function ER(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => MR(t)
  ) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name));
}
function kR(n) {
  const e = n;
  return p(e) && Sp(e.operation);
}
function VR(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => kR(t)
  );
}
function qy(n) {
  const e = n;
  return b(e) && e.resourceType === "TestReport" && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.issued > "u" || typeof e.issued == "string") && (typeof e._issued > "u" || r(e._issued)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.participant > "u" || Array.isArray(e.participant) && e.participant.every(
    (t) => qR(t)
  )) && (e.result === "pending" || e.result === "pass" || e.result === "fail") && (typeof e._result > "u" || r(e._result)) && (typeof e.score > "u" || typeof e.score == "number") && (typeof e.setup > "u" || UR(e.setup)) && (e.status === "entered-in-error" || e.status === "in-progress" || e.status === "completed" || e.status === "stopped" || e.status === "waiting") && (typeof e._status > "u" || r(e._status)) && (typeof e.teardown > "u" || VR(e.teardown)) && (typeof e.test > "u" || Array.isArray(e.test) && e.test.every(
    (t) => ER(t)
  )) && (typeof e.tester > "u" || typeof e.tester == "string") && (typeof e._tester > "u" || r(e._tester)) && y(e.testScript);
}
function NR(n) {
  const e = n;
  return p(e) && typeof e.index == "number" && V(e.profile);
}
function LR(n) {
  const e = n;
  return p(e) && typeof e.index == "number" && V(e.profile);
}
function FR(n) {
  const e = n;
  return p(e) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url));
}
function $R(n) {
  const e = n;
  return p(e) && typeof e.capabilities == "string" && (typeof e._capabilities > "u" || r(e._capabilities)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.destination > "u" || typeof e.destination == "number") && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => typeof t == "string"
  )) && (typeof e._link > "u" || Array.isArray(e._link) && e._link.every(
    (t) => r(t)
  )) && (typeof e.origin > "u" || Array.isArray(e.origin) && e.origin.every(
    (t) => typeof t == "number"
  )) && typeof e.required == "boolean" && (typeof e._required > "u" || r(e._required)) && typeof e.validated == "boolean" && (typeof e._validated > "u" || r(e._validated));
}
function jR(n) {
  const e = n;
  return p(e) && Array.isArray(e.capability) && e.capability.every(
    (t) => $R(t)
  ) && (typeof e.link > "u" || Array.isArray(e.link) && e.link.every(
    (t) => FR(t)
  ));
}
function WR(n) {
  const e = n;
  return p(e) && typeof e.autocreate == "boolean" && (typeof e._autocreate > "u" || r(e._autocreate)) && typeof e.autodelete == "boolean" && (typeof e._autodelete > "u" || r(e._autodelete)) && (typeof e.resource > "u" || y(e.resource));
}
function HR(n) {
  const e = n;
  return p(e) && (typeof e.defaultValue > "u" || typeof e.defaultValue == "string") && (typeof e._defaultValue > "u" || r(e._defaultValue)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && (typeof e.headerField > "u" || typeof e.headerField == "string") && (typeof e._headerField > "u" || r(e._headerField)) && (typeof e.hint > "u" || typeof e.hint == "string") && (typeof e._hint > "u" || r(e._hint)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || r(e._sourceId));
}
function QR(n) {
  const e = n;
  return p(e) && typeof e.field == "string" && (typeof e._field > "u" || r(e._field)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Rp(n) {
  const e = n;
  return p(e) && (typeof e.accept > "u" || typeof e.accept == "string") && (typeof e._accept > "u" || r(e._accept)) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || r(e._contentType)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.destination > "u" || typeof e.destination == "number") && typeof e.encodeRequestUrl == "boolean" && (typeof e._encodeRequestUrl > "u" || r(e._encodeRequestUrl)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || r(e._label)) && (typeof e.method > "u" || e.method === "patch" || e.method === "delete" || e.method === "get" || e.method === "options" || e.method === "post" || e.method === "put" || e.method === "head") && (typeof e._method > "u" || r(e._method)) && (typeof e.origin > "u" || typeof e.origin == "number") && (typeof e.params > "u" || typeof e.params == "string") && (typeof e._params > "u" || r(e._params)) && (typeof e.requestHeader > "u" || Array.isArray(e.requestHeader) && e.requestHeader.every(
    (t) => QR(t)
  )) && (typeof e.requestId > "u" || typeof e.requestId == "string") && (typeof e._requestId > "u" || r(e._requestId)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || r(e._resource)) && (typeof e.responseId > "u" || typeof e.responseId == "string") && (typeof e._responseId > "u" || r(e._responseId)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || r(e._sourceId)) && (typeof e.targetId > "u" || typeof e.targetId == "string") && (typeof e._targetId > "u" || r(e._targetId)) && (typeof e.type > "u" || V(e.type)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url));
}
function fl(n) {
  const e = n;
  return p(e) && (typeof e.compareToSourceExpression > "u" || typeof e.compareToSourceExpression == "string") && (typeof e._compareToSourceExpression > "u" || r(e._compareToSourceExpression)) && (typeof e.compareToSourceId > "u" || typeof e.compareToSourceId == "string") && (typeof e._compareToSourceId > "u" || r(e._compareToSourceId)) && (typeof e.compareToSourcePath > "u" || typeof e.compareToSourcePath == "string") && (typeof e._compareToSourcePath > "u" || r(e._compareToSourcePath)) && (typeof e.contentType > "u" || typeof e.contentType == "string") && (typeof e._contentType > "u" || r(e._contentType)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.direction > "u" || e.direction === "response" || e.direction === "request") && (typeof e._direction > "u" || r(e._direction)) && (typeof e.expression > "u" || typeof e.expression == "string") && (typeof e._expression > "u" || r(e._expression)) && (typeof e.headerField > "u" || typeof e.headerField == "string") && (typeof e._headerField > "u" || r(e._headerField)) && (typeof e.label > "u" || typeof e.label == "string") && (typeof e._label > "u" || r(e._label)) && (typeof e.minimumId > "u" || typeof e.minimumId == "string") && (typeof e._minimumId > "u" || r(e._minimumId)) && (typeof e.navigationLinks > "u" || e.navigationLinks === !1 || e.navigationLinks === !0) && (typeof e._navigationLinks > "u" || r(e._navigationLinks)) && (typeof e.operator > "u" || e.operator === "empty" || e.operator === "in" || e.operator === "contains" || e.operator === "equals" || e.operator === "notEquals" || e.operator === "notIn" || e.operator === "greaterThan" || e.operator === "lessThan" || e.operator === "notEmpty" || e.operator === "notContains" || e.operator === "eval") && (typeof e._operator > "u" || r(e._operator)) && (typeof e.path > "u" || typeof e.path == "string") && (typeof e._path > "u" || r(e._path)) && (typeof e.requestMethod > "u" || e.requestMethod === "patch" || e.requestMethod === "delete" || e.requestMethod === "get" || e.requestMethod === "options" || e.requestMethod === "post" || e.requestMethod === "put" || e.requestMethod === "head") && (typeof e._requestMethod > "u" || r(e._requestMethod)) && (typeof e.requestURL > "u" || typeof e.requestURL == "string") && (typeof e._requestURL > "u" || r(e._requestURL)) && (typeof e.resource > "u" || typeof e.resource == "string") && (typeof e._resource > "u" || r(e._resource)) && (typeof e.response > "u" || e.response === "okay" || e.response === "created" || e.response === "noContent" || e.response === "notModified" || e.response === "bad" || e.response === "forbidden" || e.response === "notFound" || e.response === "methodNotAllowed" || e.response === "conflict" || e.response === "gone" || e.response === "preconditionFailed" || e.response === "unprocessable") && (typeof e._response > "u" || r(e._response)) && (typeof e.responseCode > "u" || typeof e.responseCode == "string") && (typeof e._responseCode > "u" || r(e._responseCode)) && (typeof e.sourceId > "u" || typeof e.sourceId == "string") && (typeof e._sourceId > "u" || r(e._sourceId)) && (typeof e.validateProfileId > "u" || typeof e.validateProfileId == "string") && (typeof e._validateProfileId > "u" || r(e._validateProfileId)) && (typeof e.value > "u" || typeof e.value == "string") && (typeof e._value > "u" || r(e._value)) && typeof e.warningOnly == "boolean" && (typeof e._warningOnly > "u" || r(e._warningOnly));
}
function zR(n) {
  const e = n;
  return p(e) && (typeof e.assert > "u" || fl(e.assert)) && (typeof e.operation > "u" || Rp(e.operation));
}
function GR(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => zR(t)
  );
}
function KR(n) {
  const e = n;
  return p(e) && (typeof e.assert > "u" || fl(e.assert)) && (typeof e.operation > "u" || Rp(e.operation));
}
function YR(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => KR(t)
  ) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name));
}
function JR(n) {
  const e = n;
  return p(e) && Rp(e.operation);
}
function ZR(n) {
  const e = n;
  return p(e) && Array.isArray(e.action) && e.action.every(
    (t) => JR(t)
  );
}
function By(n) {
  const e = n;
  return b(e) && e.resourceType === "TestScript" && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.destination > "u" || Array.isArray(e.destination) && e.destination.every(
    (t) => LR(t)
  )) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.fixture > "u" || Array.isArray(e.fixture) && e.fixture.every(
    (t) => WR(t)
  )) && (typeof e.identifier > "u" || A(e.identifier)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.metadata > "u" || jR(e.metadata)) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.origin > "u" || Array.isArray(e.origin) && e.origin.every(
    (t) => NR(t)
  )) && (typeof e.profile > "u" || Array.isArray(e.profile) && e.profile.every(
    (t) => y(t)
  )) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (typeof e.setup > "u" || GR(e.setup)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.teardown > "u" || ZR(e.teardown)) && (typeof e.test > "u" || Array.isArray(e.test) && e.test.every(
    (t) => YR(t)
  )) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && typeof e.url == "string" && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.variable > "u" || Array.isArray(e.variable) && e.variable.every(
    (t) => HR(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function cl(n) {
  const e = n;
  return p(e) && (typeof e.language > "u" || typeof e.language == "string") && (typeof e._language > "u" || r(e._language)) && (typeof e.use > "u" || V(e.use)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function XR(n) {
  const e = n;
  return p(e) && typeof e.code == "string" && (typeof e._code > "u" || r(e._code)) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => cl(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display));
}
function ew(n) {
  const e = n;
  return p(e) && (e.op === "exists" || e.op === "in" || e.op === "=" || e.op === "is-a" || e.op === "descendent-of" || e.op === "is-not-a" || e.op === "regex" || e.op === "not-in" || e.op === "generalizes") && (typeof e._op > "u" || r(e._op)) && typeof e.property == "string" && (typeof e._property > "u" || r(e._property)) && typeof e.value == "string" && (typeof e._value > "u" || r(e._value));
}
function Pc(n) {
  const e = n;
  return p(e) && (typeof e.concept > "u" || Array.isArray(e.concept) && e.concept.every(
    (t) => XR(t)
  )) && (typeof e.filter > "u" || Array.isArray(e.filter) && e.filter.every(
    (t) => ew(t)
  )) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && (typeof e.valueSet > "u" || Array.isArray(e.valueSet) && e.valueSet.every(
    (t) => typeof t == "string"
  )) && (typeof e._valueSet > "u" || Array.isArray(e._valueSet) && e._valueSet.every(
    (t) => r(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function tw(n) {
  const e = n;
  return p(e) && (typeof e.exclude > "u" || Array.isArray(e.exclude) && e.exclude.every(
    (t) => Pc(t)
  )) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || r(e._inactive)) && Array.isArray(e.include) && e.include.every(
    (t) => Pc(t)
  ) && (typeof e.lockedDate > "u" || typeof e.lockedDate == "string") && (typeof e._lockedDate > "u" || r(e._lockedDate));
}
function rw(n) {
  const e = n;
  return p(e) && typeof e.name == "string" && (typeof e._name > "u" || r(e._name)) && (typeof e.valueString > "u" || typeof e.valueString == "string") && (typeof e._valueString > "u" || r(e._valueString)) && (typeof e.valueBoolean > "u" || e.valueBoolean === !1 || e.valueBoolean === !0) && (typeof e._valueBoolean > "u" || r(e._valueBoolean)) && (typeof e.valueInteger > "u" || typeof e.valueInteger == "number") && (typeof e.valueDecimal > "u" || typeof e.valueDecimal == "number") && (typeof e.valueUri > "u" || typeof e.valueUri == "string") && (typeof e._valueUri > "u" || r(e._valueUri)) && (typeof e.valueCode > "u" || typeof e.valueCode == "string") && (typeof e._valueCode > "u" || r(e._valueCode)) && (typeof e.valueDateTime > "u" || typeof e.valueDateTime == "string") && (typeof e._valueDateTime > "u" || r(e._valueDateTime));
}
function ll(n) {
  const e = n;
  return p(e) && (typeof e.abstract > "u" || e.abstract === !1 || e.abstract === !0) && (typeof e._abstract > "u" || r(e._abstract)) && (typeof e.code > "u" || typeof e.code == "string") && (typeof e._code > "u" || r(e._code)) && (typeof e.contains > "u" || Array.isArray(e.contains) && e.contains.every(
    (t) => ll(t)
  )) && (typeof e.designation > "u" || Array.isArray(e.designation) && e.designation.every(
    (t) => cl(t)
  )) && (typeof e.display > "u" || typeof e.display == "string") && (typeof e._display > "u" || r(e._display)) && (typeof e.inactive > "u" || e.inactive === !1 || e.inactive === !0) && (typeof e._inactive > "u" || r(e._inactive)) && (typeof e.system > "u" || typeof e.system == "string") && (typeof e._system > "u" || r(e._system)) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function ow(n) {
  const e = n;
  return p(e) && (typeof e.contains > "u" || Array.isArray(e.contains) && e.contains.every(
    (t) => ll(t)
  )) && (typeof e.identifier > "u" || typeof e.identifier == "string") && (typeof e._identifier > "u" || r(e._identifier)) && (typeof e.offset > "u" || typeof e.offset == "number") && (typeof e.parameter > "u" || Array.isArray(e.parameter) && e.parameter.every(
    (t) => rw(t)
  )) && typeof e.timestamp == "string" && (typeof e._timestamp > "u" || r(e._timestamp)) && (typeof e.total > "u" || typeof e.total == "number");
}
function Uy(n) {
  const e = n;
  return b(e) && e.resourceType === "ValueSet" && (typeof e.compose > "u" || tw(e.compose)) && (typeof e.contact > "u" || Array.isArray(e.contact) && e.contact.every(
    (t) => B(t)
  )) && (typeof e.copyright > "u" || typeof e.copyright == "string") && (typeof e._copyright > "u" || r(e._copyright)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.description > "u" || typeof e.description == "string") && (typeof e._description > "u" || r(e._description)) && (typeof e.expansion > "u" || ow(e.expansion)) && (typeof e.experimental > "u" || e.experimental === !1 || e.experimental === !0) && (typeof e._experimental > "u" || r(e._experimental)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && (typeof e.immutable > "u" || e.immutable === !1 || e.immutable === !0) && (typeof e._immutable > "u" || r(e._immutable)) && (typeof e.jurisdiction > "u" || Array.isArray(e.jurisdiction) && e.jurisdiction.every(
    (t) => u(t)
  )) && (typeof e.name > "u" || typeof e.name == "string") && (typeof e._name > "u" || r(e._name)) && (typeof e.publisher > "u" || typeof e.publisher == "string") && (typeof e._publisher > "u" || r(e._publisher)) && (typeof e.purpose > "u" || typeof e.purpose == "string") && (typeof e._purpose > "u" || r(e._purpose)) && (e.status === "active" || e.status === "unknown" || e.status === "draft" || e.status === "retired") && (typeof e._status > "u" || r(e._status)) && (typeof e.title > "u" || typeof e.title == "string") && (typeof e._title > "u" || r(e._title)) && (typeof e.url > "u" || typeof e.url == "string") && (typeof e._url > "u" || r(e._url)) && (typeof e.useContext > "u" || Array.isArray(e.useContext) && e.useContext.every(
    (t) => X(t)
  )) && (typeof e.version > "u" || typeof e.version == "string") && (typeof e._version > "u" || r(e._version));
}
function iw(n) {
  const e = n;
  return p(e) && (typeof e.canPushUpdates > "u" || u(e.canPushUpdates)) && (typeof e.communicationMethod > "u" || Array.isArray(e.communicationMethod) && e.communicationMethod.every(
    (t) => u(t)
  )) && (typeof e.pushTypeAvailable > "u" || Array.isArray(e.pushTypeAvailable) && e.pushTypeAvailable.every(
    (t) => u(t)
  )) && (typeof e.type > "u" || Array.isArray(e.type) && e.type.every(
    (t) => u(t)
  )) && (typeof e.validationDate > "u" || typeof e.validationDate == "string") && (typeof e._validationDate > "u" || r(e._validationDate)) && (typeof e.validationStatus > "u" || u(e.validationStatus)) && (typeof e.who > "u" || y(e.who));
}
function nw(n) {
  const e = n;
  return p(e) && (typeof e.communicationMethod > "u" || u(e.communicationMethod)) && (typeof e.date > "u" || typeof e.date == "string") && (typeof e._date > "u" || r(e._date)) && (typeof e.onBehalfOf > "u" || y(e.onBehalfOf)) && (typeof e.proxyIdentityCertificate > "u" || typeof e.proxyIdentityCertificate == "string") && (typeof e._proxyIdentityCertificate > "u" || r(e._proxyIdentityCertificate)) && (typeof e.proxySignature > "u" || ut(e.proxySignature)) && (typeof e.sourceIdentityCertificate > "u" || typeof e.sourceIdentityCertificate == "string") && (typeof e._sourceIdentityCertificate > "u" || r(e._sourceIdentityCertificate)) && (typeof e.sourceSignature > "u" || ut(e.sourceSignature)) && (typeof e.who > "u" || y(e.who));
}
function aw(n) {
  const e = n;
  return p(e) && (typeof e.attestationSignature > "u" || ut(e.attestationSignature)) && (typeof e.identityCertificate > "u" || typeof e.identityCertificate == "string") && (typeof e._identityCertificate > "u" || r(e._identityCertificate)) && y(e.organization);
}
function My(n) {
  const e = n;
  return b(e) && e.resourceType === "VerificationResult" && (typeof e.attestation > "u" || nw(e.attestation)) && (typeof e.failureAction > "u" || u(e.failureAction)) && (typeof e.frequency > "u" || le(e.frequency)) && (typeof e.lastPerformed > "u" || typeof e.lastPerformed == "string") && (typeof e._lastPerformed > "u" || r(e._lastPerformed)) && (typeof e.need > "u" || u(e.need)) && (typeof e.nextScheduled > "u" || typeof e.nextScheduled == "string") && (typeof e._nextScheduled > "u" || r(e._nextScheduled)) && (typeof e.primarySource > "u" || Array.isArray(e.primarySource) && e.primarySource.every(
    (t) => iw(t)
  )) && (e.status === "attested" || e.status === "validated" || e.status === "in-process" || e.status === "req-revalid" || e.status === "val-fail" || e.status === "reval-fail") && (typeof e._status > "u" || r(e._status)) && (typeof e.statusDate > "u" || typeof e.statusDate == "string") && (typeof e._statusDate > "u" || r(e._statusDate)) && (typeof e.target > "u" || Array.isArray(e.target) && e.target.every(
    (t) => y(t)
  )) && (typeof e.targetLocation > "u" || Array.isArray(e.targetLocation) && e.targetLocation.every(
    (t) => typeof t == "string"
  )) && (typeof e._targetLocation > "u" || Array.isArray(e._targetLocation) && e._targetLocation.every(
    (t) => r(t)
  )) && (typeof e.validationProcess > "u" || Array.isArray(e.validationProcess) && e.validationProcess.every(
    (t) => u(t)
  )) && (typeof e.validationType > "u" || u(e.validationType)) && (typeof e.validator > "u" || Array.isArray(e.validator) && e.validator.every(
    (t) => aw(t)
  ));
}
function uw(n) {
  const e = n;
  return p(e) && typeof e.amount == "number" && (e.base === "in" || e.base === "out" || e.base === "up" || e.base === "down") && (typeof e._base > "u" || r(e._base));
}
function yw(n) {
  const e = n;
  return p(e) && (typeof e.add > "u" || typeof e.add == "number") && (typeof e.axis > "u" || typeof e.axis == "number") && (typeof e.backCurve > "u" || typeof e.backCurve == "number") && (typeof e.brand > "u" || typeof e.brand == "string") && (typeof e._brand > "u" || r(e._brand)) && (typeof e.color > "u" || typeof e.color == "string") && (typeof e._color > "u" || r(e._color)) && (typeof e.cylinder > "u" || typeof e.cylinder == "number") && (typeof e.diameter > "u" || typeof e.diameter == "number") && (typeof e.duration > "u" || S(e.duration)) && (e.eye === "right" || e.eye === "left") && (typeof e._eye > "u" || r(e._eye)) && (typeof e.note > "u" || Array.isArray(e.note) && e.note.every(
    (t) => $(t)
  )) && (typeof e.power > "u" || typeof e.power == "number") && (typeof e.prism > "u" || Array.isArray(e.prism) && e.prism.every(
    (t) => uw(t)
  )) && u(e.product) && (typeof e.sphere > "u" || typeof e.sphere == "number");
}
function Ey(n) {
  const e = n;
  return b(e) && e.resourceType === "VisionPrescription" && typeof e.created == "string" && (typeof e._created > "u" || r(e._created)) && typeof e.dateWritten == "string" && (typeof e._dateWritten > "u" || r(e._dateWritten)) && (typeof e.encounter > "u" || y(e.encounter)) && (typeof e.identifier > "u" || Array.isArray(e.identifier) && e.identifier.every(
    (t) => A(t)
  )) && Array.isArray(e.lensSpecification) && e.lensSpecification.every(
    (t) => yw(t)
  ) && y(e.patient) && y(e.prescriber) && (e.status === "active" || e.status === "entered-in-error" || e.status === "draft" || e.status === "cancelled") && (typeof e._status > "u" || r(e._status));
}
function sw(n) {
  const e = n;
  return ea(e) || ta(e) || ra(e) || oa(e) || ia(e) || na(e) || aa(e) || ua(e) || ya(e) || sa(e) || pa(e) || fa(e) || ca(e) || la(e) || da(e) || ga(e) || ma(e) || _a(e) || va(e) || Aa(e) || ha(e) || ba(e) || Ca(e) || xa(e) || Da(e) || Ta(e) || Sa(e) || Ra(e) || wa(e) || Ia(e) || Pa(e) || Oa(e) || qa(e) || Ba(e) || Ua(e) || Ma(e) || Ea(e) || ka(e) || Va(e) || Na(e) || La(e) || Fa(e) || $a(e) || ja(e) || Wa(e) || Ha(e) || Qa(e) || za(e) || Ga(e) || Ka(e) || Ya(e) || Ja(e) || Za(e) || Xa(e) || eu(e) || tu(e) || ru(e) || ou(e) || iu(e) || nu(e) || au(e) || uu(e) || yu(e) || su(e) || pu(e) || fu(e) || cu(e) || lu(e) || du(e) || gu(e) || mu(e) || _u(e) || vu(e) || Au(e) || hu(e) || bu(e) || Cu(e) || xu(e) || Du(e) || Tu(e) || Su(e) || Ru(e) || wu(e) || Iu(e) || Pu(e) || Ou(e) || qu(e) || Bu(e) || Uu(e) || Mu(e) || Eu(e) || ku(e) || Vu(e) || Nu(e) || Lu(e) || Fu(e) || $u(e) || ju(e) || Wu(e) || Hu(e) || Qu(e) || zu(e) || Gu(e) || Ku(e) || Yu(e) || Ju(e) || Zu(e) || Xu(e) || ey(e) || ty(e) || ry(e) || qi(e) || Bi(e) || oy(e) || iy(e) || ny(e) || ay(e) || uy(e) || yy(e) || py(e) || fy(e) || cy(e) || ly(e) || dy(e) || gy(e) || my(e) || _y(e) || vy(e) || Ay(e) || hy(e) || by(e) || Cy(e) || xy(e) || Dy(e) || Ty(e) || Sy(e) || Ry(e) || wy(e) || Iy(e) || Py(e) || Oy(e) || qy(e) || By(e) || Uy(e) || My(e) || Ey(e);
}
const pw = (n) => {
  if (xp(n))
    return n;
  throw new Error("Invalid FHIR type");
}, fw = (n) => {
  if (qi(n))
    return n;
  throw new Error("Invalid FHIR type");
}, dl = (n) => {
  if (Bi(n))
    return n;
  throw new Error("Invalid FHIR type");
};
class gl {
  constructor() {
    Ee(this, "$registeredCallbacks");
    this.$registeredCallbacks = {};
  }
  on(e, t) {
    e in this.$registeredCallbacks || (this.$registeredCallbacks[e] = []), this.$registeredCallbacks[e].push(t);
  }
  off(e, t) {
    var O;
    (O = this.$registeredCallbacks[e]) == null || O.splice(
      this.$registeredCallbacks[e].indexOf(t),
      1
    );
  }
  $emit(e, t) {
    const O = this.$registeredCallbacks[e] || [];
    for (const q of O)
      q.bind(this)(t);
  }
}
class wp extends gl {
  constructor(t) {
    super();
    Ee(this, "$source");
    this.$source = t instanceof wp ? t.toJSON() : t;
  }
  $update(t) {
    this.$emit("update", {
      propertyName: t.name,
      previousValue: this[t.name],
      value: t.value
    }), this.$source[t.name] = t.value;
  }
  toJSON() {
    return ho(this.$source);
  }
  get resourceType() {
    return this.$source.resourceType;
  }
  get id() {
    return this.$source.id;
  }
  set id(t) {
    this.$update({ name: "id", value: t });
  }
  get _id() {
    return this.$source._id;
  }
  set _id(t) {
    this.$update({ name: "_id", value: t });
  }
  get implicitRules() {
    return this.$source.implicitRules;
  }
  set implicitRules(t) {
    this.$update({ name: "implicitRules", value: t });
  }
  get _implicitRules() {
    return this.$source._implicitRules;
  }
  set _implicitRules(t) {
    this.$update({ name: "_implicitRules", value: t });
  }
  get language() {
    return this.$source.language;
  }
  set language(t) {
    this.$update({ name: "language", value: t });
  }
  get _language() {
    return this.$source._language;
  }
  set _language(t) {
    this.$update({ name: "_language", value: t });
  }
  get meta() {
    return this.$source.meta;
  }
  set meta(t) {
    this.$update({ name: "meta", value: t });
  }
}
class ml extends wp {
  constructor(e) {
    super(e);
  }
  toJSON() {
    return ho(this.$source);
  }
  get contained() {
    return this.$source.contained;
  }
  set contained(e) {
    this.$update({ name: "contained", value: e });
  }
  get extension() {
    return this.$source.extension;
  }
  set extension(e) {
    this.$update({ name: "extension", value: e });
  }
  get modifierExtension() {
    return this.$source.modifierExtension;
  }
  set modifierExtension(e) {
    this.$update({ name: "modifierExtension", value: e });
  }
  get text() {
    return this.$source.text;
  }
  set text(e) {
    this.$update({ name: "text", value: e });
  }
}
class cw extends ml {
  constructor(e) {
    fw(e), super(e);
  }
  toJSON() {
    return ho(this.$source);
  }
  get approvalDate() {
    return this.$source.approvalDate;
  }
  set approvalDate(e) {
    this.$update({ name: "approvalDate", value: e });
  }
  get _approvalDate() {
    return this.$source._approvalDate;
  }
  set _approvalDate(e) {
    this.$update({ name: "_approvalDate", value: e });
  }
  get code() {
    return this.$source.code;
  }
  set code(e) {
    this.$update({ name: "code", value: e });
  }
  get contact() {
    return this.$source.contact;
  }
  set contact(e) {
    this.$update({ name: "contact", value: e });
  }
  get copyright() {
    return this.$source.copyright;
  }
  set copyright(e) {
    this.$update({ name: "copyright", value: e });
  }
  get _copyright() {
    return this.$source._copyright;
  }
  set _copyright(e) {
    this.$update({ name: "_copyright", value: e });
  }
  get date() {
    return this.$source.date;
  }
  set date(e) {
    this.$update({ name: "date", value: e });
  }
  get _date() {
    return this.$source._date;
  }
  set _date(e) {
    this.$update({ name: "_date", value: e });
  }
  get derivedFrom() {
    return this.$source.derivedFrom;
  }
  set derivedFrom(e) {
    this.$update({ name: "derivedFrom", value: e });
  }
  get _derivedFrom() {
    return this.$source._derivedFrom;
  }
  set _derivedFrom(e) {
    this.$update({ name: "_derivedFrom", value: e });
  }
  get description() {
    return this.$source.description;
  }
  set description(e) {
    this.$update({ name: "description", value: e });
  }
  get _description() {
    return this.$source._description;
  }
  set _description(e) {
    this.$update({ name: "_description", value: e });
  }
  get effectivePeriod() {
    return this.$source.effectivePeriod;
  }
  set effectivePeriod(e) {
    this.$update({ name: "effectivePeriod", value: e });
  }
  get experimental() {
    return this.$source.experimental;
  }
  set experimental(e) {
    this.$update({ name: "experimental", value: e });
  }
  get _experimental() {
    return this.$source._experimental;
  }
  set _experimental(e) {
    this.$update({ name: "_experimental", value: e });
  }
  get identifier() {
    return this.$source.identifier;
  }
  set identifier(e) {
    this.$update({ name: "identifier", value: e });
  }
  get item() {
    return this.$source.item;
  }
  set item(e) {
    this.$update({ name: "item", value: e });
  }
  get jurisdiction() {
    return this.$source.jurisdiction;
  }
  set jurisdiction(e) {
    this.$update({ name: "jurisdiction", value: e });
  }
  get lastReviewDate() {
    return this.$source.lastReviewDate;
  }
  set lastReviewDate(e) {
    this.$update({ name: "lastReviewDate", value: e });
  }
  get _lastReviewDate() {
    return this.$source._lastReviewDate;
  }
  set _lastReviewDate(e) {
    this.$update({ name: "_lastReviewDate", value: e });
  }
  get name() {
    return this.$source.name;
  }
  set name(e) {
    this.$update({ name: "name", value: e });
  }
  get _name() {
    return this.$source._name;
  }
  set _name(e) {
    this.$update({ name: "_name", value: e });
  }
  get publisher() {
    return this.$source.publisher;
  }
  set publisher(e) {
    this.$update({ name: "publisher", value: e });
  }
  get _publisher() {
    return this.$source._publisher;
  }
  set _publisher(e) {
    this.$update({ name: "_publisher", value: e });
  }
  get purpose() {
    return this.$source.purpose;
  }
  set purpose(e) {
    this.$update({ name: "purpose", value: e });
  }
  get _purpose() {
    return this.$source._purpose;
  }
  set _purpose(e) {
    this.$update({ name: "_purpose", value: e });
  }
  get status() {
    return this.$source.status;
  }
  set status(e) {
    this.$update({ name: "status", value: e });
  }
  get _status() {
    return this.$source._status;
  }
  set _status(e) {
    this.$update({ name: "_status", value: e });
  }
  get subjectType() {
    return this.$source.subjectType;
  }
  set subjectType(e) {
    this.$update({ name: "subjectType", value: e });
  }
  get _subjectType() {
    return this.$source._subjectType;
  }
  set _subjectType(e) {
    this.$update({ name: "_subjectType", value: e });
  }
  get title() {
    return this.$source.title;
  }
  set title(e) {
    this.$update({ name: "title", value: e });
  }
  get _title() {
    return this.$source._title;
  }
  set _title(e) {
    this.$update({ name: "_title", value: e });
  }
  get url() {
    return this.$source.url;
  }
  set url(e) {
    this.$update({ name: "url", value: e });
  }
  get _url() {
    return this.$source._url;
  }
  set _url(e) {
    this.$update({ name: "_url", value: e });
  }
  get useContext() {
    return this.$source.useContext;
  }
  set useContext(e) {
    this.$update({ name: "useContext", value: e });
  }
  get version() {
    return this.$source.version;
  }
  set version(e) {
    this.$update({ name: "version", value: e });
  }
  get _version() {
    return this.$source._version;
  }
  set _version(e) {
    this.$update({ name: "_version", value: e });
  }
  get implicitRules() {
    return this.$source.implicitRules;
  }
  set implicitRules(e) {
    this.$update({ name: "implicitRules", value: e });
  }
  get _implicitRules() {
    return this.$source._implicitRules;
  }
  set _implicitRules(e) {
    this.$update({ name: "_implicitRules", value: e });
  }
}
class Ip extends gl {
  constructor(t) {
    super();
    Ee(this, "$source");
    this.$source = t instanceof Ip ? t.toJSON() : t;
  }
  $update(t) {
    this.$emit("update", {
      propertyName: t.name,
      previousValue: this[t.name],
      value: t.value
    }), this.$source[t.name] = t.value;
  }
  toJSON() {
    return ho(this.$source);
  }
  get extension() {
    return this.$source.extension;
  }
  set extension(t) {
    this.$update({ name: "extension", value: t });
  }
  get id() {
    return this.$source.id;
  }
  set id(t) {
    this.$update({ name: "id", value: t });
  }
  get _id() {
    return this.$source._id;
  }
  set _id(t) {
    this.$update({ name: "_id", value: t });
  }
}
class lw extends Ip {
  constructor(e) {
    super(e);
  }
  toJSON() {
    return ho(this.$source);
  }
  get modifierExtension() {
    return this.$source.modifierExtension;
  }
  set modifierExtension(e) {
    this.$update({ name: "modifierExtension", value: e });
  }
}
class dw extends lw {
  constructor(e) {
    pw(e), super(e);
  }
  toJSON() {
    return ho(this.$source);
  }
  get answerOption() {
    return this.$source.answerOption;
  }
  set answerOption(e) {
    this.$update({ name: "answerOption", value: e });
  }
  get answerValueSet() {
    return this.$source.answerValueSet;
  }
  set answerValueSet(e) {
    this.$update({ name: "answerValueSet", value: e });
  }
  get _answerValueSet() {
    return this.$source._answerValueSet;
  }
  set _answerValueSet(e) {
    this.$update({ name: "_answerValueSet", value: e });
  }
  get code() {
    return this.$source.code;
  }
  set code(e) {
    this.$update({ name: "code", value: e });
  }
  get definition() {
    return this.$source.definition;
  }
  set definition(e) {
    this.$update({ name: "definition", value: e });
  }
  get _definition() {
    return this.$source._definition;
  }
  set _definition(e) {
    this.$update({ name: "_definition", value: e });
  }
  get enableBehavior() {
    return this.$source.enableBehavior;
  }
  set enableBehavior(e) {
    this.$update({ name: "enableBehavior", value: e });
  }
  get _enableBehavior() {
    return this.$source._enableBehavior;
  }
  set _enableBehavior(e) {
    this.$update({ name: "_enableBehavior", value: e });
  }
  get enableWhen() {
    return this.$source.enableWhen;
  }
  set enableWhen(e) {
    this.$update({ name: "enableWhen", value: e });
  }
  get initial() {
    return this.$source.initial;
  }
  set initial(e) {
    this.$update({ name: "initial", value: e });
  }
  get item() {
    return this.$source.item;
  }
  set item(e) {
    this.$update({ name: "item", value: e });
  }
  get linkId() {
    return this.$source.linkId;
  }
  set linkId(e) {
    this.$update({ name: "linkId", value: e });
  }
  get _linkId() {
    return this.$source._linkId;
  }
  set _linkId(e) {
    this.$update({ name: "_linkId", value: e });
  }
  get maxLength() {
    return this.$source.maxLength;
  }
  set maxLength(e) {
    this.$update({ name: "maxLength", value: e });
  }
  get prefix() {
    return this.$source.prefix;
  }
  set prefix(e) {
    this.$update({ name: "prefix", value: e });
  }
  get _prefix() {
    return this.$source._prefix;
  }
  set _prefix(e) {
    this.$update({ name: "_prefix", value: e });
  }
  get readOnly() {
    return this.$source.readOnly;
  }
  set readOnly(e) {
    this.$update({ name: "readOnly", value: e });
  }
  get _readOnly() {
    return this.$source._readOnly;
  }
  set _readOnly(e) {
    this.$update({ name: "_readOnly", value: e });
  }
  get repeats() {
    return this.$source.repeats;
  }
  set repeats(e) {
    this.$update({ name: "repeats", value: e });
  }
  get _repeats() {
    return this.$source._repeats;
  }
  set _repeats(e) {
    this.$update({ name: "_repeats", value: e });
  }
  get required() {
    return this.$source.required;
  }
  set required(e) {
    this.$update({ name: "required", value: e });
  }
  get _required() {
    return this.$source._required;
  }
  set _required(e) {
    this.$update({ name: "_required", value: e });
  }
  get text() {
    return this.$source.text;
  }
  set text(e) {
    this.$update({ name: "text", value: e });
  }
  get _text() {
    return this.$source._text;
  }
  set _text(e) {
    this.$update({ name: "_text", value: e });
  }
  get type() {
    return this.$source.type;
  }
  set type(e) {
    this.$update({ name: "type", value: e });
  }
  get _type() {
    return this.$source._type;
  }
  set _type(e) {
    this.$update({ name: "_type", value: e });
  }
}
class gw extends ml {
  constructor(e) {
    dl(e), super(e);
  }
  toJSON() {
    return ho(this.$source);
  }
  get author() {
    return this.$source.author;
  }
  set author(e) {
    this.$update({ name: "author", value: e });
  }
  get authored() {
    return this.$source.authored;
  }
  set authored(e) {
    this.$update({ name: "authored", value: e });
  }
  get _authored() {
    return this.$source._authored;
  }
  set _authored(e) {
    this.$update({ name: "_authored", value: e });
  }
  get basedOn() {
    return this.$source.basedOn;
  }
  set basedOn(e) {
    this.$update({ name: "basedOn", value: e });
  }
  get encounter() {
    return this.$source.encounter;
  }
  set encounter(e) {
    this.$update({ name: "encounter", value: e });
  }
  get identifier() {
    return this.$source.identifier;
  }
  set identifier(e) {
    this.$update({ name: "identifier", value: e });
  }
  get item() {
    return this.$source.item;
  }
  set item(e) {
    this.$update({ name: "item", value: e });
  }
  get partOf() {
    return this.$source.partOf;
  }
  set partOf(e) {
    this.$update({ name: "partOf", value: e });
  }
  get questionnaire() {
    return this.$source.questionnaire;
  }
  set questionnaire(e) {
    this.$update({ name: "questionnaire", value: e });
  }
  get _questionnaire() {
    return this.$source._questionnaire;
  }
  set _questionnaire(e) {
    this.$update({ name: "_questionnaire", value: e });
  }
  get source() {
    return this.$source.source;
  }
  set source(e) {
    this.$update({ name: "source", value: e });
  }
  get status() {
    return this.$source.status;
  }
  set status(e) {
    this.$update({ name: "status", value: e });
  }
  get _status() {
    return this.$source._status;
  }
  set _status(e) {
    this.$update({ name: "_status", value: e });
  }
  get subject() {
    return this.$source.subject;
  }
  set subject(e) {
    this.$update({ name: "subject", value: e });
  }
}
var Xn = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Xn.exports;
(function(n, e) {
  (function() {
    var t, O = "4.17.21", q = 200, re = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", F = "Expected a function", be = "Invalid `variable` option passed into `_.template`", me = "__lodash_hash_undefined__", xe = 500, Re = "__lodash_placeholder__", ye = 1, or = 2, $t = 4, jt = 1, kr = 2, De = 1, bt = 2, Ot = 4, Ze = 8, Wt = 16, je = 32, Ht = 64, yt = 128, st = 256, ir = 512, vr = 30, xo = "...", Kr = 800, Vr = 16, Do = 1, To = 2, So = 3, Qt = 1 / 0, qt = 9007199254740991, Yr = 17976931348623157e292, nr = 0 / 0, ze = 4294967295, Jr = ze - 1, Zr = ze >>> 1, ei = [
      ["ary", yt],
      ["bind", De],
      ["bindKey", bt],
      ["curry", Ze],
      ["curryRight", Wt],
      ["flip", ir],
      ["partial", je],
      ["partialRight", Ht],
      ["rearg", st]
    ], ar = "[object Arguments]", Nr = "[object Array]", ti = "[object AsyncFunction]", se = "[object Boolean]", ur = "[object Date]", ri = "[object DOMException]", Xe = "[object Error]", Ct = "[object Function]", xt = "[object GeneratorFunction]", et = "[object Map]", yr = "[object Number]", Bt = "[object Null]", pt = "[object Object]", Ro = "[object Promise]", wo = "[object Proxy]", Ar = "[object RegExp]", tt = "[object Set]", hr = "[object String]", br = "[object Symbol]", Xr = "[object Undefined]", sr = "[object WeakMap]", Io = "[object WeakSet]", Cr = "[object ArrayBuffer]", U = "[object DataView]", pe = "[object Float32Array]", Oe = "[object Float64Array]", pr = "[object Int8Array]", Po = "[object Int16Array]", Oo = "[object Int32Array]", Dt = "[object Uint8Array]", fr = "[object Uint8ClampedArray]", oi = "[object Uint16Array]", qo = "[object Uint32Array]", Ui = /\b__p \+= '';/g, ky = /\b(__p \+=) '' \+/g, Vy = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Mi = /&(?:amp|lt|gt|quot|#39);/g, Ei = /[&<>"']/g, Ny = RegExp(Mi.source), ii = RegExp(Ei.source), eo = /<%-([\s\S]+?)%>/g, ni = /<%([\s\S]+?)%>/g, Bo = /<%=([\s\S]+?)%>/g, ai = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, to = /^\w*$/, Ly = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ui = /[\\^$.*+?()[\]{}|]/g, Fy = RegExp(ui.source), yi = /^\s+/, $y = /\s/, Uo = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, si = /\{\n\/\* \[wrapped with (.+)\] \*/, ki = /,? & /, xr = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, jy = /[()=,{}\[\]\/\s]/, Wy = /\\(\\)?/g, Hy = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Vi = /\w*$/, Qy = /^[-+]0x[0-9a-f]+$/i, zt = /^0b[01]+$/i, zy = /^\[object .+?Constructor\]$/, Gy = /^0o[0-7]+$/i, Ky = /^(?:0|[1-9]\d*)$/, Yy = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Mo = /($^)/, Gt = /['\n\r\u2028\u2029\\]/g, Eo = "\\ud800-\\udfff", Jy = "\\u0300-\\u036f", Zy = "\\ufe20-\\ufe2f", Xy = "\\u20d0-\\u20ff", Ni = Jy + Zy + Xy, ro = "\\u2700-\\u27bf", Li = "a-z\\xdf-\\xf6\\xf8-\\xff", es = "\\xac\\xb1\\xd7\\xf7", Kt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", ts = "\\u2000-\\u206f", rs = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Fi = "A-Z\\xc0-\\xd6\\xd8-\\xde", $i = "\\ufe0e\\ufe0f", ji = es + Kt + ts + rs, pi = "['’]", ko = "[" + Eo + "]", Wi = "[" + ji + "]", Vo = "[" + Ni + "]", Hi = "\\d+", Qi = "[" + ro + "]", zi = "[" + Li + "]", Gi = "[^" + Eo + ji + Hi + ro + Li + Fi + "]", oo = "\\ud83c[\\udffb-\\udfff]", os = "(?:" + Vo + "|" + oo + ")", Ki = "[^" + Eo + "]", fi = "(?:\\ud83c[\\udde6-\\uddff]){2}", ci = "[\\ud800-\\udbff][\\udc00-\\udfff]", Lr = "[" + Fi + "]", Yi = "\\u200d", Ji = "(?:" + zi + "|" + Gi + ")", is = "(?:" + Lr + "|" + Gi + ")", Zi = "(?:" + pi + "(?:d|ll|m|re|s|t|ve))?", Xi = "(?:" + pi + "(?:D|LL|M|RE|S|T|VE))?", li = os + "?", en = "[" + $i + "]?", tn = "(?:" + Yi + "(?:" + [Ki, fi, ci].join("|") + ")" + en + li + ")*", ns = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", as = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", io = en + li + tn, us = "(?:" + [Qi, fi, ci].join("|") + ")" + io, Fr = "(?:" + [Ki + Vo + "?", Vo, fi, ci, ko].join("|") + ")", cr = RegExp(pi, "g"), ys = RegExp(Vo, "g"), No = RegExp(oo + "(?=" + oo + ")|" + Fr + io, "g"), Lo = RegExp([
      Lr + "?" + zi + "+" + Zi + "(?=" + [Wi, Lr, "$"].join("|") + ")",
      is + "+" + Xi + "(?=" + [Wi, Lr + Ji, "$"].join("|") + ")",
      Lr + "?" + Ji + "+" + Zi,
      Lr + "+" + Xi,
      as,
      ns,
      Hi,
      us
    ].join("|"), "g"), ss = RegExp("[" + Yi + Eo + Ni + $i + "]"), ps = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, fs = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], rn = -1, ve = {};
    ve[pe] = ve[Oe] = ve[pr] = ve[Po] = ve[Oo] = ve[Dt] = ve[fr] = ve[oi] = ve[qo] = !0, ve[ar] = ve[Nr] = ve[Cr] = ve[se] = ve[U] = ve[ur] = ve[Xe] = ve[Ct] = ve[et] = ve[yr] = ve[pt] = ve[Ar] = ve[tt] = ve[hr] = ve[sr] = !1;
    var Ae = {};
    Ae[ar] = Ae[Nr] = Ae[Cr] = Ae[U] = Ae[se] = Ae[ur] = Ae[pe] = Ae[Oe] = Ae[pr] = Ae[Po] = Ae[Oo] = Ae[et] = Ae[yr] = Ae[pt] = Ae[Ar] = Ae[tt] = Ae[hr] = Ae[br] = Ae[Dt] = Ae[fr] = Ae[oi] = Ae[qo] = !0, Ae[Xe] = Ae[Ct] = Ae[sr] = !1;
    var Fo = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Dr = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, di = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, on = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, nn = parseFloat, Yt = parseInt, gi = typeof Pt == "object" && Pt && Pt.Object === Object && Pt, cs = typeof self == "object" && self && self.Object === Object && self, qe = gi || cs || Function("return this")(), no = e && !e.nodeType && e, ft = no && !0 && n && !n.nodeType && n, ao = ft && ft.exports === no, uo = ao && gi.process, rt = function() {
      try {
        var v = ft && ft.require && ft.require("util").types;
        return v || uo && uo.binding && uo.binding("util");
      } catch {
      }
    }(), an = rt && rt.isArrayBuffer, un = rt && rt.isDate, yn = rt && rt.isMap, yo = rt && rt.isRegExp, sn = rt && rt.isSet, pn = rt && rt.isTypedArray;
    function ot(v, T, C) {
      switch (C.length) {
        case 0:
          return v.call(T);
        case 1:
          return v.call(T, C[0]);
        case 2:
          return v.call(T, C[0], C[1]);
        case 3:
          return v.call(T, C[0], C[1], C[2]);
      }
      return v.apply(T, C);
    }
    function c(v, T, C, E) {
      for (var G = -1, ce = v == null ? 0 : v.length; ++G < ce; ) {
        var Ve = v[G];
        T(E, Ve, C(Ve), v);
      }
      return E;
    }
    function g(v, T) {
      for (var C = -1, E = v == null ? 0 : v.length; ++C < E && T(v[C], C, v) !== !1; )
        ;
      return v;
    }
    function x(v, T) {
      for (var C = v == null ? 0 : v.length; C-- && T(v[C], C, v) !== !1; )
        ;
      return v;
    }
    function P(v, T) {
      for (var C = -1, E = v == null ? 0 : v.length; ++C < E; )
        if (!T(v[C], C, v))
          return !1;
      return !0;
    }
    function j(v, T) {
      for (var C = -1, E = v == null ? 0 : v.length, G = 0, ce = []; ++C < E; ) {
        var Ve = v[C];
        T(Ve, C, v) && (ce[G++] = Ve);
      }
      return ce;
    }
    function k(v, T) {
      var C = v == null ? 0 : v.length;
      return !!C && gt(v, T, 0) > -1;
    }
    function ie(v, T, C) {
      for (var E = -1, G = v == null ? 0 : v.length; ++E < G; )
        if (C(T, v[E]))
          return !0;
      return !1;
    }
    function W(v, T) {
      for (var C = -1, E = v == null ? 0 : v.length, G = Array(E); ++C < E; )
        G[C] = T(v[C], C, v);
      return G;
    }
    function fe(v, T) {
      for (var C = -1, E = T.length, G = v.length; ++C < E; )
        v[G + C] = T[C];
      return v;
    }
    function Ie(v, T, C, E) {
      var G = -1, ce = v == null ? 0 : v.length;
      for (E && ce && (C = v[++G]); ++G < ce; )
        C = T(C, v[G], G, v);
      return C;
    }
    function We(v, T, C, E) {
      var G = v == null ? 0 : v.length;
      for (E && G && (C = v[--G]); G--; )
        C = T(C, v[G], G, v);
      return C;
    }
    function Fe(v, T) {
      for (var C = -1, E = v == null ? 0 : v.length; ++C < E; )
        if (T(v[C], C, v))
          return !0;
      return !1;
    }
    var Me = ls("length");
    function ct(v) {
      return v.split("");
    }
    function lt(v) {
      return v.match(xr) || [];
    }
    function Jt(v, T, C) {
      var E;
      return C(v, function(G, ce, Ve) {
        if (T(G, ce, Ve))
          return E = ce, !1;
      }), E;
    }
    function dt(v, T, C, E) {
      for (var G = v.length, ce = C + (E ? 1 : -1); E ? ce-- : ++ce < G; )
        if (T(v[ce], ce, v))
          return ce;
      return -1;
    }
    function gt(v, T, C) {
      return T === T ? wl(v, T, C) : dt(v, so, C);
    }
    function fn(v, T, C, E) {
      for (var G = C - 1, ce = v.length; ++G < ce; )
        if (E(v[G], T))
          return G;
      return -1;
    }
    function so(v) {
      return v !== v;
    }
    function po(v, T) {
      var C = v == null ? 0 : v.length;
      return C ? gs(v, T) / C : nr;
    }
    function ls(v) {
      return function(T) {
        return T == null ? t : T[v];
      };
    }
    function ds(v) {
      return function(T) {
        return v == null ? t : v[T];
      };
    }
    function Op(v, T, C, E, G) {
      return G(v, function(ce, Ve, Ce) {
        C = E ? (E = !1, ce) : T(C, ce, Ve, Ce);
      }), C;
    }
    function vl(v, T) {
      var C = v.length;
      for (v.sort(T); C--; )
        v[C] = v[C].value;
      return v;
    }
    function gs(v, T) {
      for (var C, E = -1, G = v.length; ++E < G; ) {
        var ce = T(v[E]);
        ce !== t && (C = C === t ? ce : C + ce);
      }
      return C;
    }
    function ms(v, T) {
      for (var C = -1, E = Array(v); ++C < v; )
        E[C] = T(C);
      return E;
    }
    function Al(v, T) {
      return W(T, function(C) {
        return [C, v[C]];
      });
    }
    function qp(v) {
      return v && v.slice(0, Ep(v) + 1).replace(yi, "");
    }
    function Tt(v) {
      return function(T) {
        return v(T);
      };
    }
    function _s(v, T) {
      return W(T, function(C) {
        return v[C];
      });
    }
    function mi(v, T) {
      return v.has(T);
    }
    function Bp(v, T) {
      for (var C = -1, E = v.length; ++C < E && gt(T, v[C], 0) > -1; )
        ;
      return C;
    }
    function Up(v, T) {
      for (var C = v.length; C-- && gt(T, v[C], 0) > -1; )
        ;
      return C;
    }
    function hl(v, T) {
      for (var C = v.length, E = 0; C--; )
        v[C] === T && ++E;
      return E;
    }
    var bl = ds(Fo), Cl = ds(Dr);
    function xl(v) {
      return "\\" + on[v];
    }
    function Dl(v, T) {
      return v == null ? t : v[T];
    }
    function $o(v) {
      return ss.test(v);
    }
    function Tl(v) {
      return ps.test(v);
    }
    function Sl(v) {
      for (var T, C = []; !(T = v.next()).done; )
        C.push(T.value);
      return C;
    }
    function vs(v) {
      var T = -1, C = Array(v.size);
      return v.forEach(function(E, G) {
        C[++T] = [G, E];
      }), C;
    }
    function Mp(v, T) {
      return function(C) {
        return v(T(C));
      };
    }
    function $r(v, T) {
      for (var C = -1, E = v.length, G = 0, ce = []; ++C < E; ) {
        var Ve = v[C];
        (Ve === T || Ve === Re) && (v[C] = Re, ce[G++] = C);
      }
      return ce;
    }
    function cn(v) {
      var T = -1, C = Array(v.size);
      return v.forEach(function(E) {
        C[++T] = E;
      }), C;
    }
    function Rl(v) {
      var T = -1, C = Array(v.size);
      return v.forEach(function(E) {
        C[++T] = [E, E];
      }), C;
    }
    function wl(v, T, C) {
      for (var E = C - 1, G = v.length; ++E < G; )
        if (v[E] === T)
          return E;
      return -1;
    }
    function Il(v, T, C) {
      for (var E = C + 1; E--; )
        if (v[E] === T)
          return E;
      return E;
    }
    function jo(v) {
      return $o(v) ? Ol(v) : Me(v);
    }
    function Zt(v) {
      return $o(v) ? ql(v) : ct(v);
    }
    function Ep(v) {
      for (var T = v.length; T-- && $y.test(v.charAt(T)); )
        ;
      return T;
    }
    var Pl = ds(di);
    function Ol(v) {
      for (var T = No.lastIndex = 0; No.test(v); )
        ++T;
      return T;
    }
    function ql(v) {
      return v.match(No) || [];
    }
    function Bl(v) {
      return v.match(Lo) || [];
    }
    var Ul = function v(T) {
      T = T == null ? qe : Wo.defaults(qe.Object(), T, Wo.pick(qe, fs));
      var C = T.Array, E = T.Date, G = T.Error, ce = T.Function, Ve = T.Math, Ce = T.Object, As = T.RegExp, Ml = T.String, Ut = T.TypeError, ln = C.prototype, El = ce.prototype, Ho = Ce.prototype, dn = T["__core-js_shared__"], gn = El.toString, _e = Ho.hasOwnProperty, kl = 0, kp = function() {
        var o = /[^.]+$/.exec(dn && dn.keys && dn.keys.IE_PROTO || "");
        return o ? "Symbol(src)_1." + o : "";
      }(), mn = Ho.toString, Vl = gn.call(Ce), Nl = qe._, Ll = As(
        "^" + gn.call(_e).replace(ui, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), _n = ao ? T.Buffer : t, jr = T.Symbol, vn = T.Uint8Array, Vp = _n ? _n.allocUnsafe : t, An = Mp(Ce.getPrototypeOf, Ce), Np = Ce.create, Lp = Ho.propertyIsEnumerable, hn = ln.splice, Fp = jr ? jr.isConcatSpreadable : t, _i = jr ? jr.iterator : t, fo = jr ? jr.toStringTag : t, bn = function() {
        try {
          var o = _o(Ce, "defineProperty");
          return o({}, "", {}), o;
        } catch {
        }
      }(), Fl = T.clearTimeout !== qe.clearTimeout && T.clearTimeout, $l = E && E.now !== qe.Date.now && E.now, jl = T.setTimeout !== qe.setTimeout && T.setTimeout, Cn = Ve.ceil, xn = Ve.floor, hs = Ce.getOwnPropertySymbols, Wl = _n ? _n.isBuffer : t, $p = T.isFinite, Hl = ln.join, Ql = Mp(Ce.keys, Ce), Ne = Ve.max, Ge = Ve.min, zl = E.now, Gl = T.parseInt, jp = Ve.random, Kl = ln.reverse, bs = _o(T, "DataView"), vi = _o(T, "Map"), Cs = _o(T, "Promise"), Qo = _o(T, "Set"), Ai = _o(T, "WeakMap"), hi = _o(Ce, "create"), Dn = Ai && new Ai(), zo = {}, Yl = vo(bs), Jl = vo(vi), Zl = vo(Cs), Xl = vo(Qo), ed = vo(Ai), Tn = jr ? jr.prototype : t, bi = Tn ? Tn.valueOf : t, Wp = Tn ? Tn.toString : t;
      function l(o) {
        if (Pe(o) && !Y(o) && !(o instanceof ne)) {
          if (o instanceof Mt)
            return o;
          if (_e.call(o, "__wrapped__"))
            return Qf(o);
        }
        return new Mt(o);
      }
      var Go = function() {
        function o() {
        }
        return function(i) {
          if (!we(i))
            return {};
          if (Np)
            return Np(i);
          o.prototype = i;
          var a = new o();
          return o.prototype = t, a;
        };
      }();
      function Sn() {
      }
      function Mt(o, i) {
        this.__wrapped__ = o, this.__actions__ = [], this.__chain__ = !!i, this.__index__ = 0, this.__values__ = t;
      }
      l.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: eo,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: ni,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Bo,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: l
        }
      }, l.prototype = Sn.prototype, l.prototype.constructor = l, Mt.prototype = Go(Sn.prototype), Mt.prototype.constructor = Mt;
      function ne(o) {
        this.__wrapped__ = o, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ze, this.__views__ = [];
      }
      function td() {
        var o = new ne(this.__wrapped__);
        return o.__actions__ = mt(this.__actions__), o.__dir__ = this.__dir__, o.__filtered__ = this.__filtered__, o.__iteratees__ = mt(this.__iteratees__), o.__takeCount__ = this.__takeCount__, o.__views__ = mt(this.__views__), o;
      }
      function rd() {
        if (this.__filtered__) {
          var o = new ne(this);
          o.__dir__ = -1, o.__filtered__ = !0;
        } else
          o = this.clone(), o.__dir__ *= -1;
        return o;
      }
      function od() {
        var o = this.__wrapped__.value(), i = this.__dir__, a = Y(o), s = i < 0, f = a ? o.length : 0, d = gg(0, f, this.__views__), m = d.start, _ = d.end, h = _ - m, R = s ? _ : m - 1, w = this.__iteratees__, I = w.length, M = 0, N = Ge(h, this.__takeCount__);
        if (!a || !s && f == h && N == h)
          return gf(o, this.__actions__);
        var Q = [];
        e:
          for (; h-- && M < N; ) {
            R += i;
            for (var Z = -1, z = o[R]; ++Z < I; ) {
              var oe = w[Z], ae = oe.iteratee, wt = oe.type, at = ae(z);
              if (wt == To)
                z = at;
              else if (!at) {
                if (wt == Do)
                  continue e;
                break e;
              }
            }
            Q[M++] = z;
          }
        return Q;
      }
      ne.prototype = Go(Sn.prototype), ne.prototype.constructor = ne;
      function co(o) {
        var i = -1, a = o == null ? 0 : o.length;
        for (this.clear(); ++i < a; ) {
          var s = o[i];
          this.set(s[0], s[1]);
        }
      }
      function id() {
        this.__data__ = hi ? hi(null) : {}, this.size = 0;
      }
      function nd(o) {
        var i = this.has(o) && delete this.__data__[o];
        return this.size -= i ? 1 : 0, i;
      }
      function ad(o) {
        var i = this.__data__;
        if (hi) {
          var a = i[o];
          return a === me ? t : a;
        }
        return _e.call(i, o) ? i[o] : t;
      }
      function ud(o) {
        var i = this.__data__;
        return hi ? i[o] !== t : _e.call(i, o);
      }
      function yd(o, i) {
        var a = this.__data__;
        return this.size += this.has(o) ? 0 : 1, a[o] = hi && i === t ? me : i, this;
      }
      co.prototype.clear = id, co.prototype.delete = nd, co.prototype.get = ad, co.prototype.has = ud, co.prototype.set = yd;
      function Tr(o) {
        var i = -1, a = o == null ? 0 : o.length;
        for (this.clear(); ++i < a; ) {
          var s = o[i];
          this.set(s[0], s[1]);
        }
      }
      function sd() {
        this.__data__ = [], this.size = 0;
      }
      function pd(o) {
        var i = this.__data__, a = Rn(i, o);
        if (a < 0)
          return !1;
        var s = i.length - 1;
        return a == s ? i.pop() : hn.call(i, a, 1), --this.size, !0;
      }
      function fd(o) {
        var i = this.__data__, a = Rn(i, o);
        return a < 0 ? t : i[a][1];
      }
      function cd(o) {
        return Rn(this.__data__, o) > -1;
      }
      function ld(o, i) {
        var a = this.__data__, s = Rn(a, o);
        return s < 0 ? (++this.size, a.push([o, i])) : a[s][1] = i, this;
      }
      Tr.prototype.clear = sd, Tr.prototype.delete = pd, Tr.prototype.get = fd, Tr.prototype.has = cd, Tr.prototype.set = ld;
      function Sr(o) {
        var i = -1, a = o == null ? 0 : o.length;
        for (this.clear(); ++i < a; ) {
          var s = o[i];
          this.set(s[0], s[1]);
        }
      }
      function dd() {
        this.size = 0, this.__data__ = {
          hash: new co(),
          map: new (vi || Tr)(),
          string: new co()
        };
      }
      function gd(o) {
        var i = Nn(this, o).delete(o);
        return this.size -= i ? 1 : 0, i;
      }
      function md(o) {
        return Nn(this, o).get(o);
      }
      function _d(o) {
        return Nn(this, o).has(o);
      }
      function vd(o, i) {
        var a = Nn(this, o), s = a.size;
        return a.set(o, i), this.size += a.size == s ? 0 : 1, this;
      }
      Sr.prototype.clear = dd, Sr.prototype.delete = gd, Sr.prototype.get = md, Sr.prototype.has = _d, Sr.prototype.set = vd;
      function lo(o) {
        var i = -1, a = o == null ? 0 : o.length;
        for (this.__data__ = new Sr(); ++i < a; )
          this.add(o[i]);
      }
      function Ad(o) {
        return this.__data__.set(o, me), this;
      }
      function hd(o) {
        return this.__data__.has(o);
      }
      lo.prototype.add = lo.prototype.push = Ad, lo.prototype.has = hd;
      function Xt(o) {
        var i = this.__data__ = new Tr(o);
        this.size = i.size;
      }
      function bd() {
        this.__data__ = new Tr(), this.size = 0;
      }
      function Cd(o) {
        var i = this.__data__, a = i.delete(o);
        return this.size = i.size, a;
      }
      function xd(o) {
        return this.__data__.get(o);
      }
      function Dd(o) {
        return this.__data__.has(o);
      }
      function Td(o, i) {
        var a = this.__data__;
        if (a instanceof Tr) {
          var s = a.__data__;
          if (!vi || s.length < q - 1)
            return s.push([o, i]), this.size = ++a.size, this;
          a = this.__data__ = new Sr(s);
        }
        return a.set(o, i), this.size = a.size, this;
      }
      Xt.prototype.clear = bd, Xt.prototype.delete = Cd, Xt.prototype.get = xd, Xt.prototype.has = Dd, Xt.prototype.set = Td;
      function Hp(o, i) {
        var a = Y(o), s = !a && Ao(o), f = !a && !s && Gr(o), d = !a && !s && !f && Zo(o), m = a || s || f || d, _ = m ? ms(o.length, Ml) : [], h = _.length;
        for (var R in o)
          (i || _e.call(o, R)) && !(m && // Safari 9 has enumerable `arguments.length` in strict mode.
          (R == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          f && (R == "offset" || R == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          d && (R == "buffer" || R == "byteLength" || R == "byteOffset") || // Skip index properties.
          Pr(R, h))) && _.push(R);
        return _;
      }
      function Qp(o) {
        var i = o.length;
        return i ? o[Bs(0, i - 1)] : t;
      }
      function Sd(o, i) {
        return Ln(mt(o), go(i, 0, o.length));
      }
      function Rd(o) {
        return Ln(mt(o));
      }
      function xs(o, i, a) {
        (a !== t && !er(o[i], a) || a === t && !(i in o)) && Rr(o, i, a);
      }
      function Ci(o, i, a) {
        var s = o[i];
        (!(_e.call(o, i) && er(s, a)) || a === t && !(i in o)) && Rr(o, i, a);
      }
      function Rn(o, i) {
        for (var a = o.length; a--; )
          if (er(o[a][0], i))
            return a;
        return -1;
      }
      function wd(o, i, a, s) {
        return Wr(o, function(f, d, m) {
          i(s, f, a(f), m);
        }), s;
      }
      function zp(o, i) {
        return o && dr(i, $e(i), o);
      }
      function Id(o, i) {
        return o && dr(i, vt(i), o);
      }
      function Rr(o, i, a) {
        i == "__proto__" && bn ? bn(o, i, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : o[i] = a;
      }
      function Ds(o, i) {
        for (var a = -1, s = i.length, f = C(s), d = o == null; ++a < s; )
          f[a] = d ? t : ip(o, i[a]);
        return f;
      }
      function go(o, i, a) {
        return o === o && (a !== t && (o = o <= a ? o : a), i !== t && (o = o >= i ? o : i)), o;
      }
      function Et(o, i, a, s, f, d) {
        var m, _ = i & ye, h = i & or, R = i & $t;
        if (a && (m = f ? a(o, s, f, d) : a(o)), m !== t)
          return m;
        if (!we(o))
          return o;
        var w = Y(o);
        if (w) {
          if (m = _g(o), !_)
            return mt(o, m);
        } else {
          var I = Ke(o), M = I == Ct || I == xt;
          if (Gr(o))
            return vf(o, _);
          if (I == pt || I == ar || M && !f) {
            if (m = h || M ? {} : kf(o), !_)
              return h ? ag(o, Id(m, o)) : ng(o, zp(m, o));
          } else {
            if (!Ae[I])
              return f ? o : {};
            m = vg(o, I, _);
          }
        }
        d || (d = new Xt());
        var N = d.get(o);
        if (N)
          return N;
        d.set(o, m), cc(o) ? o.forEach(function(z) {
          m.add(Et(z, i, a, z, o, d));
        }) : pc(o) && o.forEach(function(z, oe) {
          m.set(oe, Et(z, i, a, oe, o, d));
        });
        var Q = R ? h ? Ws : js : h ? vt : $e, Z = w ? t : Q(o);
        return g(Z || o, function(z, oe) {
          Z && (oe = z, z = o[oe]), Ci(m, oe, Et(z, i, a, oe, o, d));
        }), m;
      }
      function Pd(o) {
        var i = $e(o);
        return function(a) {
          return Gp(a, o, i);
        };
      }
      function Gp(o, i, a) {
        var s = a.length;
        if (o == null)
          return !s;
        for (o = Ce(o); s--; ) {
          var f = a[s], d = i[f], m = o[f];
          if (m === t && !(f in o) || !d(m))
            return !1;
        }
        return !0;
      }
      function Kp(o, i, a) {
        if (typeof o != "function")
          throw new Ut(F);
        return Ii(function() {
          o.apply(t, a);
        }, i);
      }
      function xi(o, i, a, s) {
        var f = -1, d = k, m = !0, _ = o.length, h = [], R = i.length;
        if (!_)
          return h;
        a && (i = W(i, Tt(a))), s ? (d = ie, m = !1) : i.length >= q && (d = mi, m = !1, i = new lo(i));
        e:
          for (; ++f < _; ) {
            var w = o[f], I = a == null ? w : a(w);
            if (w = s || w !== 0 ? w : 0, m && I === I) {
              for (var M = R; M--; )
                if (i[M] === I)
                  continue e;
              h.push(w);
            } else
              d(i, I, s) || h.push(w);
          }
        return h;
      }
      var Wr = xf(lr), Yp = xf(Ss, !0);
      function Od(o, i) {
        var a = !0;
        return Wr(o, function(s, f, d) {
          return a = !!i(s, f, d), a;
        }), a;
      }
      function wn(o, i, a) {
        for (var s = -1, f = o.length; ++s < f; ) {
          var d = o[s], m = i(d);
          if (m != null && (_ === t ? m === m && !Rt(m) : a(m, _)))
            var _ = m, h = d;
        }
        return h;
      }
      function qd(o, i, a, s) {
        var f = o.length;
        for (a = J(a), a < 0 && (a = -a > f ? 0 : f + a), s = s === t || s > f ? f : J(s), s < 0 && (s += f), s = a > s ? 0 : dc(s); a < s; )
          o[a++] = i;
        return o;
      }
      function Jp(o, i) {
        var a = [];
        return Wr(o, function(s, f, d) {
          i(s, f, d) && a.push(s);
        }), a;
      }
      function He(o, i, a, s, f) {
        var d = -1, m = o.length;
        for (a || (a = hg), f || (f = []); ++d < m; ) {
          var _ = o[d];
          i > 0 && a(_) ? i > 1 ? He(_, i - 1, a, s, f) : fe(f, _) : s || (f[f.length] = _);
        }
        return f;
      }
      var Ts = Df(), Zp = Df(!0);
      function lr(o, i) {
        return o && Ts(o, i, $e);
      }
      function Ss(o, i) {
        return o && Zp(o, i, $e);
      }
      function In(o, i) {
        return j(i, function(a) {
          return Or(o[a]);
        });
      }
      function mo(o, i) {
        i = Qr(i, o);
        for (var a = 0, s = i.length; o != null && a < s; )
          o = o[gr(i[a++])];
        return a && a == s ? o : t;
      }
      function Xp(o, i, a) {
        var s = i(o);
        return Y(o) ? s : fe(s, a(o));
      }
      function it(o) {
        return o == null ? o === t ? Xr : Bt : fo && fo in Ce(o) ? dg(o) : Rg(o);
      }
      function Rs(o, i) {
        return o > i;
      }
      function Bd(o, i) {
        return o != null && _e.call(o, i);
      }
      function Ud(o, i) {
        return o != null && i in Ce(o);
      }
      function Md(o, i, a) {
        return o >= Ge(i, a) && o < Ne(i, a);
      }
      function ws(o, i, a) {
        for (var s = a ? ie : k, f = o[0].length, d = o.length, m = d, _ = C(d), h = 1 / 0, R = []; m--; ) {
          var w = o[m];
          m && i && (w = W(w, Tt(i))), h = Ge(w.length, h), _[m] = !a && (i || f >= 120 && w.length >= 120) ? new lo(m && w) : t;
        }
        w = o[0];
        var I = -1, M = _[0];
        e:
          for (; ++I < f && R.length < h; ) {
            var N = w[I], Q = i ? i(N) : N;
            if (N = a || N !== 0 ? N : 0, !(M ? mi(M, Q) : s(R, Q, a))) {
              for (m = d; --m; ) {
                var Z = _[m];
                if (!(Z ? mi(Z, Q) : s(o[m], Q, a)))
                  continue e;
              }
              M && M.push(Q), R.push(N);
            }
          }
        return R;
      }
      function Ed(o, i, a, s) {
        return lr(o, function(f, d, m) {
          i(s, a(f), d, m);
        }), s;
      }
      function Di(o, i, a) {
        i = Qr(i, o), o = Ff(o, i);
        var s = o == null ? o : o[gr(Vt(i))];
        return s == null ? t : ot(s, o, a);
      }
      function ef(o) {
        return Pe(o) && it(o) == ar;
      }
      function kd(o) {
        return Pe(o) && it(o) == Cr;
      }
      function Vd(o) {
        return Pe(o) && it(o) == ur;
      }
      function Ti(o, i, a, s, f) {
        return o === i ? !0 : o == null || i == null || !Pe(o) && !Pe(i) ? o !== o && i !== i : Nd(o, i, a, s, Ti, f);
      }
      function Nd(o, i, a, s, f, d) {
        var m = Y(o), _ = Y(i), h = m ? Nr : Ke(o), R = _ ? Nr : Ke(i);
        h = h == ar ? pt : h, R = R == ar ? pt : R;
        var w = h == pt, I = R == pt, M = h == R;
        if (M && Gr(o)) {
          if (!Gr(i))
            return !1;
          m = !0, w = !1;
        }
        if (M && !w)
          return d || (d = new Xt()), m || Zo(o) ? Uf(o, i, a, s, f, d) : cg(o, i, h, a, s, f, d);
        if (!(a & jt)) {
          var N = w && _e.call(o, "__wrapped__"), Q = I && _e.call(i, "__wrapped__");
          if (N || Q) {
            var Z = N ? o.value() : o, z = Q ? i.value() : i;
            return d || (d = new Xt()), f(Z, z, a, s, d);
          }
        }
        return M ? (d || (d = new Xt()), lg(o, i, a, s, f, d)) : !1;
      }
      function Ld(o) {
        return Pe(o) && Ke(o) == et;
      }
      function Is(o, i, a, s) {
        var f = a.length, d = f, m = !s;
        if (o == null)
          return !d;
        for (o = Ce(o); f--; ) {
          var _ = a[f];
          if (m && _[2] ? _[1] !== o[_[0]] : !(_[0] in o))
            return !1;
        }
        for (; ++f < d; ) {
          _ = a[f];
          var h = _[0], R = o[h], w = _[1];
          if (m && _[2]) {
            if (R === t && !(h in o))
              return !1;
          } else {
            var I = new Xt();
            if (s)
              var M = s(R, w, h, o, i, I);
            if (!(M === t ? Ti(w, R, jt | kr, s, I) : M))
              return !1;
          }
        }
        return !0;
      }
      function tf(o) {
        if (!we(o) || Cg(o))
          return !1;
        var i = Or(o) ? Ll : zy;
        return i.test(vo(o));
      }
      function Fd(o) {
        return Pe(o) && it(o) == Ar;
      }
      function $d(o) {
        return Pe(o) && Ke(o) == tt;
      }
      function jd(o) {
        return Pe(o) && Qn(o.length) && !!ve[it(o)];
      }
      function rf(o) {
        return typeof o == "function" ? o : o == null ? At : typeof o == "object" ? Y(o) ? af(o[0], o[1]) : nf(o) : Tc(o);
      }
      function Ps(o) {
        if (!wi(o))
          return Ql(o);
        var i = [];
        for (var a in Ce(o))
          _e.call(o, a) && a != "constructor" && i.push(a);
        return i;
      }
      function Wd(o) {
        if (!we(o))
          return Sg(o);
        var i = wi(o), a = [];
        for (var s in o)
          s == "constructor" && (i || !_e.call(o, s)) || a.push(s);
        return a;
      }
      function Os(o, i) {
        return o < i;
      }
      function of(o, i) {
        var a = -1, s = _t(o) ? C(o.length) : [];
        return Wr(o, function(f, d, m) {
          s[++a] = i(f, d, m);
        }), s;
      }
      function nf(o) {
        var i = Qs(o);
        return i.length == 1 && i[0][2] ? Nf(i[0][0], i[0][1]) : function(a) {
          return a === o || Is(a, o, i);
        };
      }
      function af(o, i) {
        return Gs(o) && Vf(i) ? Nf(gr(o), i) : function(a) {
          var s = ip(a, o);
          return s === t && s === i ? np(a, o) : Ti(i, s, jt | kr);
        };
      }
      function Pn(o, i, a, s, f) {
        o !== i && Ts(i, function(d, m) {
          if (f || (f = new Xt()), we(d))
            Hd(o, i, m, a, Pn, s, f);
          else {
            var _ = s ? s(Ys(o, m), d, m + "", o, i, f) : t;
            _ === t && (_ = d), xs(o, m, _);
          }
        }, vt);
      }
      function Hd(o, i, a, s, f, d, m) {
        var _ = Ys(o, a), h = Ys(i, a), R = m.get(h);
        if (R) {
          xs(o, a, R);
          return;
        }
        var w = d ? d(_, h, a + "", o, i, m) : t, I = w === t;
        if (I) {
          var M = Y(h), N = !M && Gr(h), Q = !M && !N && Zo(h);
          w = h, M || N || Q ? Y(_) ? w = _ : Be(_) ? w = mt(_) : N ? (I = !1, w = vf(h, !0)) : Q ? (I = !1, w = Af(h, !0)) : w = [] : Pi(h) || Ao(h) ? (w = _, Ao(_) ? w = gc(_) : (!we(_) || Or(_)) && (w = kf(h))) : I = !1;
        }
        I && (m.set(h, w), f(w, h, s, d, m), m.delete(h)), xs(o, a, w);
      }
      function uf(o, i) {
        var a = o.length;
        if (a)
          return i += i < 0 ? a : 0, Pr(i, a) ? o[i] : t;
      }
      function yf(o, i, a) {
        i.length ? i = W(i, function(d) {
          return Y(d) ? function(m) {
            return mo(m, d.length === 1 ? d[0] : d);
          } : d;
        }) : i = [At];
        var s = -1;
        i = W(i, Tt(H()));
        var f = of(o, function(d, m, _) {
          var h = W(i, function(R) {
            return R(d);
          });
          return { criteria: h, index: ++s, value: d };
        });
        return vl(f, function(d, m) {
          return ig(d, m, a);
        });
      }
      function Qd(o, i) {
        return sf(o, i, function(a, s) {
          return np(o, s);
        });
      }
      function sf(o, i, a) {
        for (var s = -1, f = i.length, d = {}; ++s < f; ) {
          var m = i[s], _ = mo(o, m);
          a(_, m) && Si(d, Qr(m, o), _);
        }
        return d;
      }
      function zd(o) {
        return function(i) {
          return mo(i, o);
        };
      }
      function qs(o, i, a, s) {
        var f = s ? fn : gt, d = -1, m = i.length, _ = o;
        for (o === i && (i = mt(i)), a && (_ = W(o, Tt(a))); ++d < m; )
          for (var h = 0, R = i[d], w = a ? a(R) : R; (h = f(_, w, h, s)) > -1; )
            _ !== o && hn.call(_, h, 1), hn.call(o, h, 1);
        return o;
      }
      function pf(o, i) {
        for (var a = o ? i.length : 0, s = a - 1; a--; ) {
          var f = i[a];
          if (a == s || f !== d) {
            var d = f;
            Pr(f) ? hn.call(o, f, 1) : Es(o, f);
          }
        }
        return o;
      }
      function Bs(o, i) {
        return o + xn(jp() * (i - o + 1));
      }
      function Gd(o, i, a, s) {
        for (var f = -1, d = Ne(Cn((i - o) / (a || 1)), 0), m = C(d); d--; )
          m[s ? d : ++f] = o, o += a;
        return m;
      }
      function Us(o, i) {
        var a = "";
        if (!o || i < 1 || i > qt)
          return a;
        do
          i % 2 && (a += o), i = xn(i / 2), i && (o += o);
        while (i);
        return a;
      }
      function ee(o, i) {
        return Js(Lf(o, i, At), o + "");
      }
      function Kd(o) {
        return Qp(Xo(o));
      }
      function Yd(o, i) {
        var a = Xo(o);
        return Ln(a, go(i, 0, a.length));
      }
      function Si(o, i, a, s) {
        if (!we(o))
          return o;
        i = Qr(i, o);
        for (var f = -1, d = i.length, m = d - 1, _ = o; _ != null && ++f < d; ) {
          var h = gr(i[f]), R = a;
          if (h === "__proto__" || h === "constructor" || h === "prototype")
            return o;
          if (f != m) {
            var w = _[h];
            R = s ? s(w, h, _) : t, R === t && (R = we(w) ? w : Pr(i[f + 1]) ? [] : {});
          }
          Ci(_, h, R), _ = _[h];
        }
        return o;
      }
      var ff = Dn ? function(o, i) {
        return Dn.set(o, i), o;
      } : At, Jd = bn ? function(o, i) {
        return bn(o, "toString", {
          configurable: !0,
          enumerable: !1,
          value: up(i),
          writable: !0
        });
      } : At;
      function Zd(o) {
        return Ln(Xo(o));
      }
      function kt(o, i, a) {
        var s = -1, f = o.length;
        i < 0 && (i = -i > f ? 0 : f + i), a = a > f ? f : a, a < 0 && (a += f), f = i > a ? 0 : a - i >>> 0, i >>>= 0;
        for (var d = C(f); ++s < f; )
          d[s] = o[s + i];
        return d;
      }
      function Xd(o, i) {
        var a;
        return Wr(o, function(s, f, d) {
          return a = i(s, f, d), !a;
        }), !!a;
      }
      function On(o, i, a) {
        var s = 0, f = o == null ? s : o.length;
        if (typeof i == "number" && i === i && f <= Zr) {
          for (; s < f; ) {
            var d = s + f >>> 1, m = o[d];
            m !== null && !Rt(m) && (a ? m <= i : m < i) ? s = d + 1 : f = d;
          }
          return f;
        }
        return Ms(o, i, At, a);
      }
      function Ms(o, i, a, s) {
        var f = 0, d = o == null ? 0 : o.length;
        if (d === 0)
          return 0;
        i = a(i);
        for (var m = i !== i, _ = i === null, h = Rt(i), R = i === t; f < d; ) {
          var w = xn((f + d) / 2), I = a(o[w]), M = I !== t, N = I === null, Q = I === I, Z = Rt(I);
          if (m)
            var z = s || Q;
          else
            R ? z = Q && (s || M) : _ ? z = Q && M && (s || !N) : h ? z = Q && M && !N && (s || !Z) : N || Z ? z = !1 : z = s ? I <= i : I < i;
          z ? f = w + 1 : d = w;
        }
        return Ge(d, Jr);
      }
      function cf(o, i) {
        for (var a = -1, s = o.length, f = 0, d = []; ++a < s; ) {
          var m = o[a], _ = i ? i(m) : m;
          if (!a || !er(_, h)) {
            var h = _;
            d[f++] = m === 0 ? 0 : m;
          }
        }
        return d;
      }
      function lf(o) {
        return typeof o == "number" ? o : Rt(o) ? nr : +o;
      }
      function St(o) {
        if (typeof o == "string")
          return o;
        if (Y(o))
          return W(o, St) + "";
        if (Rt(o))
          return Wp ? Wp.call(o) : "";
        var i = o + "";
        return i == "0" && 1 / o == -Qt ? "-0" : i;
      }
      function Hr(o, i, a) {
        var s = -1, f = k, d = o.length, m = !0, _ = [], h = _;
        if (a)
          m = !1, f = ie;
        else if (d >= q) {
          var R = i ? null : pg(o);
          if (R)
            return cn(R);
          m = !1, f = mi, h = new lo();
        } else
          h = i ? [] : _;
        e:
          for (; ++s < d; ) {
            var w = o[s], I = i ? i(w) : w;
            if (w = a || w !== 0 ? w : 0, m && I === I) {
              for (var M = h.length; M--; )
                if (h[M] === I)
                  continue e;
              i && h.push(I), _.push(w);
            } else
              f(h, I, a) || (h !== _ && h.push(I), _.push(w));
          }
        return _;
      }
      function Es(o, i) {
        return i = Qr(i, o), o = Ff(o, i), o == null || delete o[gr(Vt(i))];
      }
      function df(o, i, a, s) {
        return Si(o, i, a(mo(o, i)), s);
      }
      function qn(o, i, a, s) {
        for (var f = o.length, d = s ? f : -1; (s ? d-- : ++d < f) && i(o[d], d, o); )
          ;
        return a ? kt(o, s ? 0 : d, s ? d + 1 : f) : kt(o, s ? d + 1 : 0, s ? f : d);
      }
      function gf(o, i) {
        var a = o;
        return a instanceof ne && (a = a.value()), Ie(i, function(s, f) {
          return f.func.apply(f.thisArg, fe([s], f.args));
        }, a);
      }
      function ks(o, i, a) {
        var s = o.length;
        if (s < 2)
          return s ? Hr(o[0]) : [];
        for (var f = -1, d = C(s); ++f < s; )
          for (var m = o[f], _ = -1; ++_ < s; )
            _ != f && (d[f] = xi(d[f] || m, o[_], i, a));
        return Hr(He(d, 1), i, a);
      }
      function mf(o, i, a) {
        for (var s = -1, f = o.length, d = i.length, m = {}; ++s < f; ) {
          var _ = s < d ? i[s] : t;
          a(m, o[s], _);
        }
        return m;
      }
      function Vs(o) {
        return Be(o) ? o : [];
      }
      function Ns(o) {
        return typeof o == "function" ? o : At;
      }
      function Qr(o, i) {
        return Y(o) ? o : Gs(o, i) ? [o] : Hf(de(o));
      }
      var eg = ee;
      function zr(o, i, a) {
        var s = o.length;
        return a = a === t ? s : a, !i && a >= s ? o : kt(o, i, a);
      }
      var _f = Fl || function(o) {
        return qe.clearTimeout(o);
      };
      function vf(o, i) {
        if (i)
          return o.slice();
        var a = o.length, s = Vp ? Vp(a) : new o.constructor(a);
        return o.copy(s), s;
      }
      function Ls(o) {
        var i = new o.constructor(o.byteLength);
        return new vn(i).set(new vn(o)), i;
      }
      function tg(o, i) {
        var a = i ? Ls(o.buffer) : o.buffer;
        return new o.constructor(a, o.byteOffset, o.byteLength);
      }
      function rg(o) {
        var i = new o.constructor(o.source, Vi.exec(o));
        return i.lastIndex = o.lastIndex, i;
      }
      function og(o) {
        return bi ? Ce(bi.call(o)) : {};
      }
      function Af(o, i) {
        var a = i ? Ls(o.buffer) : o.buffer;
        return new o.constructor(a, o.byteOffset, o.length);
      }
      function hf(o, i) {
        if (o !== i) {
          var a = o !== t, s = o === null, f = o === o, d = Rt(o), m = i !== t, _ = i === null, h = i === i, R = Rt(i);
          if (!_ && !R && !d && o > i || d && m && h && !_ && !R || s && m && h || !a && h || !f)
            return 1;
          if (!s && !d && !R && o < i || R && a && f && !s && !d || _ && a && f || !m && f || !h)
            return -1;
        }
        return 0;
      }
      function ig(o, i, a) {
        for (var s = -1, f = o.criteria, d = i.criteria, m = f.length, _ = a.length; ++s < m; ) {
          var h = hf(f[s], d[s]);
          if (h) {
            if (s >= _)
              return h;
            var R = a[s];
            return h * (R == "desc" ? -1 : 1);
          }
        }
        return o.index - i.index;
      }
      function bf(o, i, a, s) {
        for (var f = -1, d = o.length, m = a.length, _ = -1, h = i.length, R = Ne(d - m, 0), w = C(h + R), I = !s; ++_ < h; )
          w[_] = i[_];
        for (; ++f < m; )
          (I || f < d) && (w[a[f]] = o[f]);
        for (; R--; )
          w[_++] = o[f++];
        return w;
      }
      function Cf(o, i, a, s) {
        for (var f = -1, d = o.length, m = -1, _ = a.length, h = -1, R = i.length, w = Ne(d - _, 0), I = C(w + R), M = !s; ++f < w; )
          I[f] = o[f];
        for (var N = f; ++h < R; )
          I[N + h] = i[h];
        for (; ++m < _; )
          (M || f < d) && (I[N + a[m]] = o[f++]);
        return I;
      }
      function mt(o, i) {
        var a = -1, s = o.length;
        for (i || (i = C(s)); ++a < s; )
          i[a] = o[a];
        return i;
      }
      function dr(o, i, a, s) {
        var f = !a;
        a || (a = {});
        for (var d = -1, m = i.length; ++d < m; ) {
          var _ = i[d], h = s ? s(a[_], o[_], _, a, o) : t;
          h === t && (h = o[_]), f ? Rr(a, _, h) : Ci(a, _, h);
        }
        return a;
      }
      function ng(o, i) {
        return dr(o, zs(o), i);
      }
      function ag(o, i) {
        return dr(o, Mf(o), i);
      }
      function Bn(o, i) {
        return function(a, s) {
          var f = Y(a) ? c : wd, d = i ? i() : {};
          return f(a, o, H(s, 2), d);
        };
      }
      function Ko(o) {
        return ee(function(i, a) {
          var s = -1, f = a.length, d = f > 1 ? a[f - 1] : t, m = f > 2 ? a[2] : t;
          for (d = o.length > 3 && typeof d == "function" ? (f--, d) : t, m && nt(a[0], a[1], m) && (d = f < 3 ? t : d, f = 1), i = Ce(i); ++s < f; ) {
            var _ = a[s];
            _ && o(i, _, s, d);
          }
          return i;
        });
      }
      function xf(o, i) {
        return function(a, s) {
          if (a == null)
            return a;
          if (!_t(a))
            return o(a, s);
          for (var f = a.length, d = i ? f : -1, m = Ce(a); (i ? d-- : ++d < f) && s(m[d], d, m) !== !1; )
            ;
          return a;
        };
      }
      function Df(o) {
        return function(i, a, s) {
          for (var f = -1, d = Ce(i), m = s(i), _ = m.length; _--; ) {
            var h = m[o ? _ : ++f];
            if (a(d[h], h, d) === !1)
              break;
          }
          return i;
        };
      }
      function ug(o, i, a) {
        var s = i & De, f = Ri(o);
        function d() {
          var m = this && this !== qe && this instanceof d ? f : o;
          return m.apply(s ? a : this, arguments);
        }
        return d;
      }
      function Tf(o) {
        return function(i) {
          i = de(i);
          var a = $o(i) ? Zt(i) : t, s = a ? a[0] : i.charAt(0), f = a ? zr(a, 1).join("") : i.slice(1);
          return s[o]() + f;
        };
      }
      function Yo(o) {
        return function(i) {
          return Ie(xc(Cc(i).replace(cr, "")), o, "");
        };
      }
      function Ri(o) {
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return new o();
            case 1:
              return new o(i[0]);
            case 2:
              return new o(i[0], i[1]);
            case 3:
              return new o(i[0], i[1], i[2]);
            case 4:
              return new o(i[0], i[1], i[2], i[3]);
            case 5:
              return new o(i[0], i[1], i[2], i[3], i[4]);
            case 6:
              return new o(i[0], i[1], i[2], i[3], i[4], i[5]);
            case 7:
              return new o(i[0], i[1], i[2], i[3], i[4], i[5], i[6]);
          }
          var a = Go(o.prototype), s = o.apply(a, i);
          return we(s) ? s : a;
        };
      }
      function yg(o, i, a) {
        var s = Ri(o);
        function f() {
          for (var d = arguments.length, m = C(d), _ = d, h = Jo(f); _--; )
            m[_] = arguments[_];
          var R = d < 3 && m[0] !== h && m[d - 1] !== h ? [] : $r(m, h);
          if (d -= R.length, d < a)
            return Pf(
              o,
              i,
              Un,
              f.placeholder,
              t,
              m,
              R,
              t,
              t,
              a - d
            );
          var w = this && this !== qe && this instanceof f ? s : o;
          return ot(w, this, m);
        }
        return f;
      }
      function Sf(o) {
        return function(i, a, s) {
          var f = Ce(i);
          if (!_t(i)) {
            var d = H(a, 3);
            i = $e(i), a = function(_) {
              return d(f[_], _, f);
            };
          }
          var m = o(i, a, s);
          return m > -1 ? f[d ? i[m] : m] : t;
        };
      }
      function Rf(o) {
        return Ir(function(i) {
          var a = i.length, s = a, f = Mt.prototype.thru;
          for (o && i.reverse(); s--; ) {
            var d = i[s];
            if (typeof d != "function")
              throw new Ut(F);
            if (f && !m && Vn(d) == "wrapper")
              var m = new Mt([], !0);
          }
          for (s = m ? s : a; ++s < a; ) {
            d = i[s];
            var _ = Vn(d), h = _ == "wrapper" ? Hs(d) : t;
            h && Ks(h[0]) && h[1] == (yt | Ze | je | st) && !h[4].length && h[9] == 1 ? m = m[Vn(h[0])].apply(m, h[3]) : m = d.length == 1 && Ks(d) ? m[_]() : m.thru(d);
          }
          return function() {
            var R = arguments, w = R[0];
            if (m && R.length == 1 && Y(w))
              return m.plant(w).value();
            for (var I = 0, M = a ? i[I].apply(this, R) : w; ++I < a; )
              M = i[I].call(this, M);
            return M;
          };
        });
      }
      function Un(o, i, a, s, f, d, m, _, h, R) {
        var w = i & yt, I = i & De, M = i & bt, N = i & (Ze | Wt), Q = i & ir, Z = M ? t : Ri(o);
        function z() {
          for (var oe = arguments.length, ae = C(oe), wt = oe; wt--; )
            ae[wt] = arguments[wt];
          if (N)
            var at = Jo(z), It = hl(ae, at);
          if (s && (ae = bf(ae, s, f, N)), d && (ae = Cf(ae, d, m, N)), oe -= It, N && oe < R) {
            var Ue = $r(ae, at);
            return Pf(
              o,
              i,
              Un,
              z.placeholder,
              a,
              ae,
              Ue,
              _,
              h,
              R - oe
            );
          }
          var tr = I ? a : this, Br = M ? tr[o] : o;
          return oe = ae.length, _ ? ae = wg(ae, _) : Q && oe > 1 && ae.reverse(), w && h < oe && (ae.length = h), this && this !== qe && this instanceof z && (Br = Z || Ri(Br)), Br.apply(tr, ae);
        }
        return z;
      }
      function wf(o, i) {
        return function(a, s) {
          return Ed(a, o, i(s), {});
        };
      }
      function Mn(o, i) {
        return function(a, s) {
          var f;
          if (a === t && s === t)
            return i;
          if (a !== t && (f = a), s !== t) {
            if (f === t)
              return s;
            typeof a == "string" || typeof s == "string" ? (a = St(a), s = St(s)) : (a = lf(a), s = lf(s)), f = o(a, s);
          }
          return f;
        };
      }
      function Fs(o) {
        return Ir(function(i) {
          return i = W(i, Tt(H())), ee(function(a) {
            var s = this;
            return o(i, function(f) {
              return ot(f, s, a);
            });
          });
        });
      }
      function En(o, i) {
        i = i === t ? " " : St(i);
        var a = i.length;
        if (a < 2)
          return a ? Us(i, o) : i;
        var s = Us(i, Cn(o / jo(i)));
        return $o(i) ? zr(Zt(s), 0, o).join("") : s.slice(0, o);
      }
      function sg(o, i, a, s) {
        var f = i & De, d = Ri(o);
        function m() {
          for (var _ = -1, h = arguments.length, R = -1, w = s.length, I = C(w + h), M = this && this !== qe && this instanceof m ? d : o; ++R < w; )
            I[R] = s[R];
          for (; h--; )
            I[R++] = arguments[++_];
          return ot(M, f ? a : this, I);
        }
        return m;
      }
      function If(o) {
        return function(i, a, s) {
          return s && typeof s != "number" && nt(i, a, s) && (a = s = t), i = qr(i), a === t ? (a = i, i = 0) : a = qr(a), s = s === t ? i < a ? 1 : -1 : qr(s), Gd(i, a, s, o);
        };
      }
      function kn(o) {
        return function(i, a) {
          return typeof i == "string" && typeof a == "string" || (i = Nt(i), a = Nt(a)), o(i, a);
        };
      }
      function Pf(o, i, a, s, f, d, m, _, h, R) {
        var w = i & Ze, I = w ? m : t, M = w ? t : m, N = w ? d : t, Q = w ? t : d;
        i |= w ? je : Ht, i &= ~(w ? Ht : je), i & Ot || (i &= ~(De | bt));
        var Z = [
          o,
          i,
          f,
          N,
          I,
          Q,
          M,
          _,
          h,
          R
        ], z = a.apply(t, Z);
        return Ks(o) && $f(z, Z), z.placeholder = s, jf(z, o, i);
      }
      function $s(o) {
        var i = Ve[o];
        return function(a, s) {
          if (a = Nt(a), s = s == null ? 0 : Ge(J(s), 292), s && $p(a)) {
            var f = (de(a) + "e").split("e"), d = i(f[0] + "e" + (+f[1] + s));
            return f = (de(d) + "e").split("e"), +(f[0] + "e" + (+f[1] - s));
          }
          return i(a);
        };
      }
      var pg = Qo && 1 / cn(new Qo([, -0]))[1] == Qt ? function(o) {
        return new Qo(o);
      } : pp;
      function Of(o) {
        return function(i) {
          var a = Ke(i);
          return a == et ? vs(i) : a == tt ? Rl(i) : Al(i, o(i));
        };
      }
      function wr(o, i, a, s, f, d, m, _) {
        var h = i & bt;
        if (!h && typeof o != "function")
          throw new Ut(F);
        var R = s ? s.length : 0;
        if (R || (i &= ~(je | Ht), s = f = t), m = m === t ? m : Ne(J(m), 0), _ = _ === t ? _ : J(_), R -= f ? f.length : 0, i & Ht) {
          var w = s, I = f;
          s = f = t;
        }
        var M = h ? t : Hs(o), N = [
          o,
          i,
          a,
          s,
          f,
          w,
          I,
          d,
          m,
          _
        ];
        if (M && Tg(N, M), o = N[0], i = N[1], a = N[2], s = N[3], f = N[4], _ = N[9] = N[9] === t ? h ? 0 : o.length : Ne(N[9] - R, 0), !_ && i & (Ze | Wt) && (i &= ~(Ze | Wt)), !i || i == De)
          var Q = ug(o, i, a);
        else
          i == Ze || i == Wt ? Q = yg(o, i, _) : (i == je || i == (De | je)) && !f.length ? Q = sg(o, i, a, s) : Q = Un.apply(t, N);
        var Z = M ? ff : $f;
        return jf(Z(Q, N), o, i);
      }
      function qf(o, i, a, s) {
        return o === t || er(o, Ho[a]) && !_e.call(s, a) ? i : o;
      }
      function Bf(o, i, a, s, f, d) {
        return we(o) && we(i) && (d.set(i, o), Pn(o, i, t, Bf, d), d.delete(i)), o;
      }
      function fg(o) {
        return Pi(o) ? t : o;
      }
      function Uf(o, i, a, s, f, d) {
        var m = a & jt, _ = o.length, h = i.length;
        if (_ != h && !(m && h > _))
          return !1;
        var R = d.get(o), w = d.get(i);
        if (R && w)
          return R == i && w == o;
        var I = -1, M = !0, N = a & kr ? new lo() : t;
        for (d.set(o, i), d.set(i, o); ++I < _; ) {
          var Q = o[I], Z = i[I];
          if (s)
            var z = m ? s(Z, Q, I, i, o, d) : s(Q, Z, I, o, i, d);
          if (z !== t) {
            if (z)
              continue;
            M = !1;
            break;
          }
          if (N) {
            if (!Fe(i, function(oe, ae) {
              if (!mi(N, ae) && (Q === oe || f(Q, oe, a, s, d)))
                return N.push(ae);
            })) {
              M = !1;
              break;
            }
          } else if (!(Q === Z || f(Q, Z, a, s, d))) {
            M = !1;
            break;
          }
        }
        return d.delete(o), d.delete(i), M;
      }
      function cg(o, i, a, s, f, d, m) {
        switch (a) {
          case U:
            if (o.byteLength != i.byteLength || o.byteOffset != i.byteOffset)
              return !1;
            o = o.buffer, i = i.buffer;
          case Cr:
            return !(o.byteLength != i.byteLength || !d(new vn(o), new vn(i)));
          case se:
          case ur:
          case yr:
            return er(+o, +i);
          case Xe:
            return o.name == i.name && o.message == i.message;
          case Ar:
          case hr:
            return o == i + "";
          case et:
            var _ = vs;
          case tt:
            var h = s & jt;
            if (_ || (_ = cn), o.size != i.size && !h)
              return !1;
            var R = m.get(o);
            if (R)
              return R == i;
            s |= kr, m.set(o, i);
            var w = Uf(_(o), _(i), s, f, d, m);
            return m.delete(o), w;
          case br:
            if (bi)
              return bi.call(o) == bi.call(i);
        }
        return !1;
      }
      function lg(o, i, a, s, f, d) {
        var m = a & jt, _ = js(o), h = _.length, R = js(i), w = R.length;
        if (h != w && !m)
          return !1;
        for (var I = h; I--; ) {
          var M = _[I];
          if (!(m ? M in i : _e.call(i, M)))
            return !1;
        }
        var N = d.get(o), Q = d.get(i);
        if (N && Q)
          return N == i && Q == o;
        var Z = !0;
        d.set(o, i), d.set(i, o);
        for (var z = m; ++I < h; ) {
          M = _[I];
          var oe = o[M], ae = i[M];
          if (s)
            var wt = m ? s(ae, oe, M, i, o, d) : s(oe, ae, M, o, i, d);
          if (!(wt === t ? oe === ae || f(oe, ae, a, s, d) : wt)) {
            Z = !1;
            break;
          }
          z || (z = M == "constructor");
        }
        if (Z && !z) {
          var at = o.constructor, It = i.constructor;
          at != It && "constructor" in o && "constructor" in i && !(typeof at == "function" && at instanceof at && typeof It == "function" && It instanceof It) && (Z = !1);
        }
        return d.delete(o), d.delete(i), Z;
      }
      function Ir(o) {
        return Js(Lf(o, t, Kf), o + "");
      }
      function js(o) {
        return Xp(o, $e, zs);
      }
      function Ws(o) {
        return Xp(o, vt, Mf);
      }
      var Hs = Dn ? function(o) {
        return Dn.get(o);
      } : pp;
      function Vn(o) {
        for (var i = o.name + "", a = zo[i], s = _e.call(zo, i) ? a.length : 0; s--; ) {
          var f = a[s], d = f.func;
          if (d == null || d == o)
            return f.name;
        }
        return i;
      }
      function Jo(o) {
        var i = _e.call(l, "placeholder") ? l : o;
        return i.placeholder;
      }
      function H() {
        var o = l.iteratee || yp;
        return o = o === yp ? rf : o, arguments.length ? o(arguments[0], arguments[1]) : o;
      }
      function Nn(o, i) {
        var a = o.__data__;
        return bg(i) ? a[typeof i == "string" ? "string" : "hash"] : a.map;
      }
      function Qs(o) {
        for (var i = $e(o), a = i.length; a--; ) {
          var s = i[a], f = o[s];
          i[a] = [s, f, Vf(f)];
        }
        return i;
      }
      function _o(o, i) {
        var a = Dl(o, i);
        return tf(a) ? a : t;
      }
      function dg(o) {
        var i = _e.call(o, fo), a = o[fo];
        try {
          o[fo] = t;
          var s = !0;
        } catch {
        }
        var f = mn.call(o);
        return s && (i ? o[fo] = a : delete o[fo]), f;
      }
      var zs = hs ? function(o) {
        return o == null ? [] : (o = Ce(o), j(hs(o), function(i) {
          return Lp.call(o, i);
        }));
      } : fp, Mf = hs ? function(o) {
        for (var i = []; o; )
          fe(i, zs(o)), o = An(o);
        return i;
      } : fp, Ke = it;
      (bs && Ke(new bs(new ArrayBuffer(1))) != U || vi && Ke(new vi()) != et || Cs && Ke(Cs.resolve()) != Ro || Qo && Ke(new Qo()) != tt || Ai && Ke(new Ai()) != sr) && (Ke = function(o) {
        var i = it(o), a = i == pt ? o.constructor : t, s = a ? vo(a) : "";
        if (s)
          switch (s) {
            case Yl:
              return U;
            case Jl:
              return et;
            case Zl:
              return Ro;
            case Xl:
              return tt;
            case ed:
              return sr;
          }
        return i;
      });
      function gg(o, i, a) {
        for (var s = -1, f = a.length; ++s < f; ) {
          var d = a[s], m = d.size;
          switch (d.type) {
            case "drop":
              o += m;
              break;
            case "dropRight":
              i -= m;
              break;
            case "take":
              i = Ge(i, o + m);
              break;
            case "takeRight":
              o = Ne(o, i - m);
              break;
          }
        }
        return { start: o, end: i };
      }
      function mg(o) {
        var i = o.match(si);
        return i ? i[1].split(ki) : [];
      }
      function Ef(o, i, a) {
        i = Qr(i, o);
        for (var s = -1, f = i.length, d = !1; ++s < f; ) {
          var m = gr(i[s]);
          if (!(d = o != null && a(o, m)))
            break;
          o = o[m];
        }
        return d || ++s != f ? d : (f = o == null ? 0 : o.length, !!f && Qn(f) && Pr(m, f) && (Y(o) || Ao(o)));
      }
      function _g(o) {
        var i = o.length, a = new o.constructor(i);
        return i && typeof o[0] == "string" && _e.call(o, "index") && (a.index = o.index, a.input = o.input), a;
      }
      function kf(o) {
        return typeof o.constructor == "function" && !wi(o) ? Go(An(o)) : {};
      }
      function vg(o, i, a) {
        var s = o.constructor;
        switch (i) {
          case Cr:
            return Ls(o);
          case se:
          case ur:
            return new s(+o);
          case U:
            return tg(o, a);
          case pe:
          case Oe:
          case pr:
          case Po:
          case Oo:
          case Dt:
          case fr:
          case oi:
          case qo:
            return Af(o, a);
          case et:
            return new s();
          case yr:
          case hr:
            return new s(o);
          case Ar:
            return rg(o);
          case tt:
            return new s();
          case br:
            return og(o);
        }
      }
      function Ag(o, i) {
        var a = i.length;
        if (!a)
          return o;
        var s = a - 1;
        return i[s] = (a > 1 ? "& " : "") + i[s], i = i.join(a > 2 ? ", " : " "), o.replace(Uo, `{
/* [wrapped with ` + i + `] */
`);
      }
      function hg(o) {
        return Y(o) || Ao(o) || !!(Fp && o && o[Fp]);
      }
      function Pr(o, i) {
        var a = typeof o;
        return i = i ?? qt, !!i && (a == "number" || a != "symbol" && Ky.test(o)) && o > -1 && o % 1 == 0 && o < i;
      }
      function nt(o, i, a) {
        if (!we(a))
          return !1;
        var s = typeof i;
        return (s == "number" ? _t(a) && Pr(i, a.length) : s == "string" && i in a) ? er(a[i], o) : !1;
      }
      function Gs(o, i) {
        if (Y(o))
          return !1;
        var a = typeof o;
        return a == "number" || a == "symbol" || a == "boolean" || o == null || Rt(o) ? !0 : to.test(o) || !ai.test(o) || i != null && o in Ce(i);
      }
      function bg(o) {
        var i = typeof o;
        return i == "string" || i == "number" || i == "symbol" || i == "boolean" ? o !== "__proto__" : o === null;
      }
      function Ks(o) {
        var i = Vn(o), a = l[i];
        if (typeof a != "function" || !(i in ne.prototype))
          return !1;
        if (o === a)
          return !0;
        var s = Hs(a);
        return !!s && o === s[0];
      }
      function Cg(o) {
        return !!kp && kp in o;
      }
      var xg = dn ? Or : cp;
      function wi(o) {
        var i = o && o.constructor, a = typeof i == "function" && i.prototype || Ho;
        return o === a;
      }
      function Vf(o) {
        return o === o && !we(o);
      }
      function Nf(o, i) {
        return function(a) {
          return a == null ? !1 : a[o] === i && (i !== t || o in Ce(a));
        };
      }
      function Dg(o) {
        var i = Wn(o, function(s) {
          return a.size === xe && a.clear(), s;
        }), a = i.cache;
        return i;
      }
      function Tg(o, i) {
        var a = o[1], s = i[1], f = a | s, d = f < (De | bt | yt), m = s == yt && a == Ze || s == yt && a == st && o[7].length <= i[8] || s == (yt | st) && i[7].length <= i[8] && a == Ze;
        if (!(d || m))
          return o;
        s & De && (o[2] = i[2], f |= a & De ? 0 : Ot);
        var _ = i[3];
        if (_) {
          var h = o[3];
          o[3] = h ? bf(h, _, i[4]) : _, o[4] = h ? $r(o[3], Re) : i[4];
        }
        return _ = i[5], _ && (h = o[5], o[5] = h ? Cf(h, _, i[6]) : _, o[6] = h ? $r(o[5], Re) : i[6]), _ = i[7], _ && (o[7] = _), s & yt && (o[8] = o[8] == null ? i[8] : Ge(o[8], i[8])), o[9] == null && (o[9] = i[9]), o[0] = i[0], o[1] = f, o;
      }
      function Sg(o) {
        var i = [];
        if (o != null)
          for (var a in Ce(o))
            i.push(a);
        return i;
      }
      function Rg(o) {
        return mn.call(o);
      }
      function Lf(o, i, a) {
        return i = Ne(i === t ? o.length - 1 : i, 0), function() {
          for (var s = arguments, f = -1, d = Ne(s.length - i, 0), m = C(d); ++f < d; )
            m[f] = s[i + f];
          f = -1;
          for (var _ = C(i + 1); ++f < i; )
            _[f] = s[f];
          return _[i] = a(m), ot(o, this, _);
        };
      }
      function Ff(o, i) {
        return i.length < 2 ? o : mo(o, kt(i, 0, -1));
      }
      function wg(o, i) {
        for (var a = o.length, s = Ge(i.length, a), f = mt(o); s--; ) {
          var d = i[s];
          o[s] = Pr(d, a) ? f[d] : t;
        }
        return o;
      }
      function Ys(o, i) {
        if (!(i === "constructor" && typeof o[i] == "function") && i != "__proto__")
          return o[i];
      }
      var $f = Wf(ff), Ii = jl || function(o, i) {
        return qe.setTimeout(o, i);
      }, Js = Wf(Jd);
      function jf(o, i, a) {
        var s = i + "";
        return Js(o, Ag(s, Ig(mg(s), a)));
      }
      function Wf(o) {
        var i = 0, a = 0;
        return function() {
          var s = zl(), f = Vr - (s - a);
          if (a = s, f > 0) {
            if (++i >= Kr)
              return arguments[0];
          } else
            i = 0;
          return o.apply(t, arguments);
        };
      }
      function Ln(o, i) {
        var a = -1, s = o.length, f = s - 1;
        for (i = i === t ? s : i; ++a < i; ) {
          var d = Bs(a, f), m = o[d];
          o[d] = o[a], o[a] = m;
        }
        return o.length = i, o;
      }
      var Hf = Dg(function(o) {
        var i = [];
        return o.charCodeAt(0) === 46 && i.push(""), o.replace(Ly, function(a, s, f, d) {
          i.push(f ? d.replace(Wy, "$1") : s || a);
        }), i;
      });
      function gr(o) {
        if (typeof o == "string" || Rt(o))
          return o;
        var i = o + "";
        return i == "0" && 1 / o == -Qt ? "-0" : i;
      }
      function vo(o) {
        if (o != null) {
          try {
            return gn.call(o);
          } catch {
          }
          try {
            return o + "";
          } catch {
          }
        }
        return "";
      }
      function Ig(o, i) {
        return g(ei, function(a) {
          var s = "_." + a[0];
          i & a[1] && !k(o, s) && o.push(s);
        }), o.sort();
      }
      function Qf(o) {
        if (o instanceof ne)
          return o.clone();
        var i = new Mt(o.__wrapped__, o.__chain__);
        return i.__actions__ = mt(o.__actions__), i.__index__ = o.__index__, i.__values__ = o.__values__, i;
      }
      function Pg(o, i, a) {
        (a ? nt(o, i, a) : i === t) ? i = 1 : i = Ne(J(i), 0);
        var s = o == null ? 0 : o.length;
        if (!s || i < 1)
          return [];
        for (var f = 0, d = 0, m = C(Cn(s / i)); f < s; )
          m[d++] = kt(o, f, f += i);
        return m;
      }
      function Og(o) {
        for (var i = -1, a = o == null ? 0 : o.length, s = 0, f = []; ++i < a; ) {
          var d = o[i];
          d && (f[s++] = d);
        }
        return f;
      }
      function qg() {
        var o = arguments.length;
        if (!o)
          return [];
        for (var i = C(o - 1), a = arguments[0], s = o; s--; )
          i[s - 1] = arguments[s];
        return fe(Y(a) ? mt(a) : [a], He(i, 1));
      }
      var Bg = ee(function(o, i) {
        return Be(o) ? xi(o, He(i, 1, Be, !0)) : [];
      }), Ug = ee(function(o, i) {
        var a = Vt(i);
        return Be(a) && (a = t), Be(o) ? xi(o, He(i, 1, Be, !0), H(a, 2)) : [];
      }), Mg = ee(function(o, i) {
        var a = Vt(i);
        return Be(a) && (a = t), Be(o) ? xi(o, He(i, 1, Be, !0), t, a) : [];
      });
      function Eg(o, i, a) {
        var s = o == null ? 0 : o.length;
        return s ? (i = a || i === t ? 1 : J(i), kt(o, i < 0 ? 0 : i, s)) : [];
      }
      function kg(o, i, a) {
        var s = o == null ? 0 : o.length;
        return s ? (i = a || i === t ? 1 : J(i), i = s - i, kt(o, 0, i < 0 ? 0 : i)) : [];
      }
      function Vg(o, i) {
        return o && o.length ? qn(o, H(i, 3), !0, !0) : [];
      }
      function Ng(o, i) {
        return o && o.length ? qn(o, H(i, 3), !0) : [];
      }
      function Lg(o, i, a, s) {
        var f = o == null ? 0 : o.length;
        return f ? (a && typeof a != "number" && nt(o, i, a) && (a = 0, s = f), qd(o, i, a, s)) : [];
      }
      function zf(o, i, a) {
        var s = o == null ? 0 : o.length;
        if (!s)
          return -1;
        var f = a == null ? 0 : J(a);
        return f < 0 && (f = Ne(s + f, 0)), dt(o, H(i, 3), f);
      }
      function Gf(o, i, a) {
        var s = o == null ? 0 : o.length;
        if (!s)
          return -1;
        var f = s - 1;
        return a !== t && (f = J(a), f = a < 0 ? Ne(s + f, 0) : Ge(f, s - 1)), dt(o, H(i, 3), f, !0);
      }
      function Kf(o) {
        var i = o == null ? 0 : o.length;
        return i ? He(o, 1) : [];
      }
      function Fg(o) {
        var i = o == null ? 0 : o.length;
        return i ? He(o, Qt) : [];
      }
      function $g(o, i) {
        var a = o == null ? 0 : o.length;
        return a ? (i = i === t ? 1 : J(i), He(o, i)) : [];
      }
      function jg(o) {
        for (var i = -1, a = o == null ? 0 : o.length, s = {}; ++i < a; ) {
          var f = o[i];
          s[f[0]] = f[1];
        }
        return s;
      }
      function Yf(o) {
        return o && o.length ? o[0] : t;
      }
      function Wg(o, i, a) {
        var s = o == null ? 0 : o.length;
        if (!s)
          return -1;
        var f = a == null ? 0 : J(a);
        return f < 0 && (f = Ne(s + f, 0)), gt(o, i, f);
      }
      function Hg(o) {
        var i = o == null ? 0 : o.length;
        return i ? kt(o, 0, -1) : [];
      }
      var Qg = ee(function(o) {
        var i = W(o, Vs);
        return i.length && i[0] === o[0] ? ws(i) : [];
      }), zg = ee(function(o) {
        var i = Vt(o), a = W(o, Vs);
        return i === Vt(a) ? i = t : a.pop(), a.length && a[0] === o[0] ? ws(a, H(i, 2)) : [];
      }), Gg = ee(function(o) {
        var i = Vt(o), a = W(o, Vs);
        return i = typeof i == "function" ? i : t, i && a.pop(), a.length && a[0] === o[0] ? ws(a, t, i) : [];
      });
      function Kg(o, i) {
        return o == null ? "" : Hl.call(o, i);
      }
      function Vt(o) {
        var i = o == null ? 0 : o.length;
        return i ? o[i - 1] : t;
      }
      function Yg(o, i, a) {
        var s = o == null ? 0 : o.length;
        if (!s)
          return -1;
        var f = s;
        return a !== t && (f = J(a), f = f < 0 ? Ne(s + f, 0) : Ge(f, s - 1)), i === i ? Il(o, i, f) : dt(o, so, f, !0);
      }
      function Jg(o, i) {
        return o && o.length ? uf(o, J(i)) : t;
      }
      var Zg = ee(Jf);
      function Jf(o, i) {
        return o && o.length && i && i.length ? qs(o, i) : o;
      }
      function Xg(o, i, a) {
        return o && o.length && i && i.length ? qs(o, i, H(a, 2)) : o;
      }
      function em(o, i, a) {
        return o && o.length && i && i.length ? qs(o, i, t, a) : o;
      }
      var tm = Ir(function(o, i) {
        var a = o == null ? 0 : o.length, s = Ds(o, i);
        return pf(o, W(i, function(f) {
          return Pr(f, a) ? +f : f;
        }).sort(hf)), s;
      });
      function rm(o, i) {
        var a = [];
        if (!(o && o.length))
          return a;
        var s = -1, f = [], d = o.length;
        for (i = H(i, 3); ++s < d; ) {
          var m = o[s];
          i(m, s, o) && (a.push(m), f.push(s));
        }
        return pf(o, f), a;
      }
      function Zs(o) {
        return o == null ? o : Kl.call(o);
      }
      function om(o, i, a) {
        var s = o == null ? 0 : o.length;
        return s ? (a && typeof a != "number" && nt(o, i, a) ? (i = 0, a = s) : (i = i == null ? 0 : J(i), a = a === t ? s : J(a)), kt(o, i, a)) : [];
      }
      function im(o, i) {
        return On(o, i);
      }
      function nm(o, i, a) {
        return Ms(o, i, H(a, 2));
      }
      function am(o, i) {
        var a = o == null ? 0 : o.length;
        if (a) {
          var s = On(o, i);
          if (s < a && er(o[s], i))
            return s;
        }
        return -1;
      }
      function um(o, i) {
        return On(o, i, !0);
      }
      function ym(o, i, a) {
        return Ms(o, i, H(a, 2), !0);
      }
      function sm(o, i) {
        var a = o == null ? 0 : o.length;
        if (a) {
          var s = On(o, i, !0) - 1;
          if (er(o[s], i))
            return s;
        }
        return -1;
      }
      function pm(o) {
        return o && o.length ? cf(o) : [];
      }
      function fm(o, i) {
        return o && o.length ? cf(o, H(i, 2)) : [];
      }
      function cm(o) {
        var i = o == null ? 0 : o.length;
        return i ? kt(o, 1, i) : [];
      }
      function lm(o, i, a) {
        return o && o.length ? (i = a || i === t ? 1 : J(i), kt(o, 0, i < 0 ? 0 : i)) : [];
      }
      function dm(o, i, a) {
        var s = o == null ? 0 : o.length;
        return s ? (i = a || i === t ? 1 : J(i), i = s - i, kt(o, i < 0 ? 0 : i, s)) : [];
      }
      function gm(o, i) {
        return o && o.length ? qn(o, H(i, 3), !1, !0) : [];
      }
      function mm(o, i) {
        return o && o.length ? qn(o, H(i, 3)) : [];
      }
      var _m = ee(function(o) {
        return Hr(He(o, 1, Be, !0));
      }), vm = ee(function(o) {
        var i = Vt(o);
        return Be(i) && (i = t), Hr(He(o, 1, Be, !0), H(i, 2));
      }), Am = ee(function(o) {
        var i = Vt(o);
        return i = typeof i == "function" ? i : t, Hr(He(o, 1, Be, !0), t, i);
      });
      function hm(o) {
        return o && o.length ? Hr(o) : [];
      }
      function bm(o, i) {
        return o && o.length ? Hr(o, H(i, 2)) : [];
      }
      function Cm(o, i) {
        return i = typeof i == "function" ? i : t, o && o.length ? Hr(o, t, i) : [];
      }
      function Xs(o) {
        if (!(o && o.length))
          return [];
        var i = 0;
        return o = j(o, function(a) {
          if (Be(a))
            return i = Ne(a.length, i), !0;
        }), ms(i, function(a) {
          return W(o, ls(a));
        });
      }
      function Zf(o, i) {
        if (!(o && o.length))
          return [];
        var a = Xs(o);
        return i == null ? a : W(a, function(s) {
          return ot(i, t, s);
        });
      }
      var xm = ee(function(o, i) {
        return Be(o) ? xi(o, i) : [];
      }), Dm = ee(function(o) {
        return ks(j(o, Be));
      }), Tm = ee(function(o) {
        var i = Vt(o);
        return Be(i) && (i = t), ks(j(o, Be), H(i, 2));
      }), Sm = ee(function(o) {
        var i = Vt(o);
        return i = typeof i == "function" ? i : t, ks(j(o, Be), t, i);
      }), Rm = ee(Xs);
      function wm(o, i) {
        return mf(o || [], i || [], Ci);
      }
      function Im(o, i) {
        return mf(o || [], i || [], Si);
      }
      var Pm = ee(function(o) {
        var i = o.length, a = i > 1 ? o[i - 1] : t;
        return a = typeof a == "function" ? (o.pop(), a) : t, Zf(o, a);
      });
      function Xf(o) {
        var i = l(o);
        return i.__chain__ = !0, i;
      }
      function Om(o, i) {
        return i(o), o;
      }
      function Fn(o, i) {
        return i(o);
      }
      var qm = Ir(function(o) {
        var i = o.length, a = i ? o[0] : 0, s = this.__wrapped__, f = function(d) {
          return Ds(d, o);
        };
        return i > 1 || this.__actions__.length || !(s instanceof ne) || !Pr(a) ? this.thru(f) : (s = s.slice(a, +a + (i ? 1 : 0)), s.__actions__.push({
          func: Fn,
          args: [f],
          thisArg: t
        }), new Mt(s, this.__chain__).thru(function(d) {
          return i && !d.length && d.push(t), d;
        }));
      });
      function Bm() {
        return Xf(this);
      }
      function Um() {
        return new Mt(this.value(), this.__chain__);
      }
      function Mm() {
        this.__values__ === t && (this.__values__ = lc(this.value()));
        var o = this.__index__ >= this.__values__.length, i = o ? t : this.__values__[this.__index__++];
        return { done: o, value: i };
      }
      function Em() {
        return this;
      }
      function km(o) {
        for (var i, a = this; a instanceof Sn; ) {
          var s = Qf(a);
          s.__index__ = 0, s.__values__ = t, i ? f.__wrapped__ = s : i = s;
          var f = s;
          a = a.__wrapped__;
        }
        return f.__wrapped__ = o, i;
      }
      function Vm() {
        var o = this.__wrapped__;
        if (o instanceof ne) {
          var i = o;
          return this.__actions__.length && (i = new ne(this)), i = i.reverse(), i.__actions__.push({
            func: Fn,
            args: [Zs],
            thisArg: t
          }), new Mt(i, this.__chain__);
        }
        return this.thru(Zs);
      }
      function Nm() {
        return gf(this.__wrapped__, this.__actions__);
      }
      var Lm = Bn(function(o, i, a) {
        _e.call(o, a) ? ++o[a] : Rr(o, a, 1);
      });
      function Fm(o, i, a) {
        var s = Y(o) ? P : Od;
        return a && nt(o, i, a) && (i = t), s(o, H(i, 3));
      }
      function $m(o, i) {
        var a = Y(o) ? j : Jp;
        return a(o, H(i, 3));
      }
      var jm = Sf(zf), Wm = Sf(Gf);
      function Hm(o, i) {
        return He($n(o, i), 1);
      }
      function Qm(o, i) {
        return He($n(o, i), Qt);
      }
      function zm(o, i, a) {
        return a = a === t ? 1 : J(a), He($n(o, i), a);
      }
      function ec(o, i) {
        var a = Y(o) ? g : Wr;
        return a(o, H(i, 3));
      }
      function tc(o, i) {
        var a = Y(o) ? x : Yp;
        return a(o, H(i, 3));
      }
      var Gm = Bn(function(o, i, a) {
        _e.call(o, a) ? o[a].push(i) : Rr(o, a, [i]);
      });
      function Km(o, i, a, s) {
        o = _t(o) ? o : Xo(o), a = a && !s ? J(a) : 0;
        var f = o.length;
        return a < 0 && (a = Ne(f + a, 0)), zn(o) ? a <= f && o.indexOf(i, a) > -1 : !!f && gt(o, i, a) > -1;
      }
      var Ym = ee(function(o, i, a) {
        var s = -1, f = typeof i == "function", d = _t(o) ? C(o.length) : [];
        return Wr(o, function(m) {
          d[++s] = f ? ot(i, m, a) : Di(m, i, a);
        }), d;
      }), Jm = Bn(function(o, i, a) {
        Rr(o, a, i);
      });
      function $n(o, i) {
        var a = Y(o) ? W : of;
        return a(o, H(i, 3));
      }
      function Zm(o, i, a, s) {
        return o == null ? [] : (Y(i) || (i = i == null ? [] : [i]), a = s ? t : a, Y(a) || (a = a == null ? [] : [a]), yf(o, i, a));
      }
      var Xm = Bn(function(o, i, a) {
        o[a ? 0 : 1].push(i);
      }, function() {
        return [[], []];
      });
      function e_(o, i, a) {
        var s = Y(o) ? Ie : Op, f = arguments.length < 3;
        return s(o, H(i, 4), a, f, Wr);
      }
      function t_(o, i, a) {
        var s = Y(o) ? We : Op, f = arguments.length < 3;
        return s(o, H(i, 4), a, f, Yp);
      }
      function r_(o, i) {
        var a = Y(o) ? j : Jp;
        return a(o, Hn(H(i, 3)));
      }
      function o_(o) {
        var i = Y(o) ? Qp : Kd;
        return i(o);
      }
      function i_(o, i, a) {
        (a ? nt(o, i, a) : i === t) ? i = 1 : i = J(i);
        var s = Y(o) ? Sd : Yd;
        return s(o, i);
      }
      function n_(o) {
        var i = Y(o) ? Rd : Zd;
        return i(o);
      }
      function a_(o) {
        if (o == null)
          return 0;
        if (_t(o))
          return zn(o) ? jo(o) : o.length;
        var i = Ke(o);
        return i == et || i == tt ? o.size : Ps(o).length;
      }
      function u_(o, i, a) {
        var s = Y(o) ? Fe : Xd;
        return a && nt(o, i, a) && (i = t), s(o, H(i, 3));
      }
      var y_ = ee(function(o, i) {
        if (o == null)
          return [];
        var a = i.length;
        return a > 1 && nt(o, i[0], i[1]) ? i = [] : a > 2 && nt(i[0], i[1], i[2]) && (i = [i[0]]), yf(o, He(i, 1), []);
      }), jn = $l || function() {
        return qe.Date.now();
      };
      function s_(o, i) {
        if (typeof i != "function")
          throw new Ut(F);
        return o = J(o), function() {
          if (--o < 1)
            return i.apply(this, arguments);
        };
      }
      function rc(o, i, a) {
        return i = a ? t : i, i = o && i == null ? o.length : i, wr(o, yt, t, t, t, t, i);
      }
      function oc(o, i) {
        var a;
        if (typeof i != "function")
          throw new Ut(F);
        return o = J(o), function() {
          return --o > 0 && (a = i.apply(this, arguments)), o <= 1 && (i = t), a;
        };
      }
      var ep = ee(function(o, i, a) {
        var s = De;
        if (a.length) {
          var f = $r(a, Jo(ep));
          s |= je;
        }
        return wr(o, s, i, a, f);
      }), ic = ee(function(o, i, a) {
        var s = De | bt;
        if (a.length) {
          var f = $r(a, Jo(ic));
          s |= je;
        }
        return wr(i, s, o, a, f);
      });
      function nc(o, i, a) {
        i = a ? t : i;
        var s = wr(o, Ze, t, t, t, t, t, i);
        return s.placeholder = nc.placeholder, s;
      }
      function ac(o, i, a) {
        i = a ? t : i;
        var s = wr(o, Wt, t, t, t, t, t, i);
        return s.placeholder = ac.placeholder, s;
      }
      function uc(o, i, a) {
        var s, f, d, m, _, h, R = 0, w = !1, I = !1, M = !0;
        if (typeof o != "function")
          throw new Ut(F);
        i = Nt(i) || 0, we(a) && (w = !!a.leading, I = "maxWait" in a, d = I ? Ne(Nt(a.maxWait) || 0, i) : d, M = "trailing" in a ? !!a.trailing : M);
        function N(Ue) {
          var tr = s, Br = f;
          return s = f = t, R = Ue, m = o.apply(Br, tr), m;
        }
        function Q(Ue) {
          return R = Ue, _ = Ii(oe, i), w ? N(Ue) : m;
        }
        function Z(Ue) {
          var tr = Ue - h, Br = Ue - R, Sc = i - tr;
          return I ? Ge(Sc, d - Br) : Sc;
        }
        function z(Ue) {
          var tr = Ue - h, Br = Ue - R;
          return h === t || tr >= i || tr < 0 || I && Br >= d;
        }
        function oe() {
          var Ue = jn();
          if (z(Ue))
            return ae(Ue);
          _ = Ii(oe, Z(Ue));
        }
        function ae(Ue) {
          return _ = t, M && s ? N(Ue) : (s = f = t, m);
        }
        function wt() {
          _ !== t && _f(_), R = 0, s = h = f = _ = t;
        }
        function at() {
          return _ === t ? m : ae(jn());
        }
        function It() {
          var Ue = jn(), tr = z(Ue);
          if (s = arguments, f = this, h = Ue, tr) {
            if (_ === t)
              return Q(h);
            if (I)
              return _f(_), _ = Ii(oe, i), N(h);
          }
          return _ === t && (_ = Ii(oe, i)), m;
        }
        return It.cancel = wt, It.flush = at, It;
      }
      var p_ = ee(function(o, i) {
        return Kp(o, 1, i);
      }), f_ = ee(function(o, i, a) {
        return Kp(o, Nt(i) || 0, a);
      });
      function c_(o) {
        return wr(o, ir);
      }
      function Wn(o, i) {
        if (typeof o != "function" || i != null && typeof i != "function")
          throw new Ut(F);
        var a = function() {
          var s = arguments, f = i ? i.apply(this, s) : s[0], d = a.cache;
          if (d.has(f))
            return d.get(f);
          var m = o.apply(this, s);
          return a.cache = d.set(f, m) || d, m;
        };
        return a.cache = new (Wn.Cache || Sr)(), a;
      }
      Wn.Cache = Sr;
      function Hn(o) {
        if (typeof o != "function")
          throw new Ut(F);
        return function() {
          var i = arguments;
          switch (i.length) {
            case 0:
              return !o.call(this);
            case 1:
              return !o.call(this, i[0]);
            case 2:
              return !o.call(this, i[0], i[1]);
            case 3:
              return !o.call(this, i[0], i[1], i[2]);
          }
          return !o.apply(this, i);
        };
      }
      function l_(o) {
        return oc(2, o);
      }
      var d_ = eg(function(o, i) {
        i = i.length == 1 && Y(i[0]) ? W(i[0], Tt(H())) : W(He(i, 1), Tt(H()));
        var a = i.length;
        return ee(function(s) {
          for (var f = -1, d = Ge(s.length, a); ++f < d; )
            s[f] = i[f].call(this, s[f]);
          return ot(o, this, s);
        });
      }), tp = ee(function(o, i) {
        var a = $r(i, Jo(tp));
        return wr(o, je, t, i, a);
      }), yc = ee(function(o, i) {
        var a = $r(i, Jo(yc));
        return wr(o, Ht, t, i, a);
      }), g_ = Ir(function(o, i) {
        return wr(o, st, t, t, t, i);
      });
      function m_(o, i) {
        if (typeof o != "function")
          throw new Ut(F);
        return i = i === t ? i : J(i), ee(o, i);
      }
      function __(o, i) {
        if (typeof o != "function")
          throw new Ut(F);
        return i = i == null ? 0 : Ne(J(i), 0), ee(function(a) {
          var s = a[i], f = zr(a, 0, i);
          return s && fe(f, s), ot(o, this, f);
        });
      }
      function v_(o, i, a) {
        var s = !0, f = !0;
        if (typeof o != "function")
          throw new Ut(F);
        return we(a) && (s = "leading" in a ? !!a.leading : s, f = "trailing" in a ? !!a.trailing : f), uc(o, i, {
          leading: s,
          maxWait: i,
          trailing: f
        });
      }
      function A_(o) {
        return rc(o, 1);
      }
      function h_(o, i) {
        return tp(Ns(i), o);
      }
      function b_() {
        if (!arguments.length)
          return [];
        var o = arguments[0];
        return Y(o) ? o : [o];
      }
      function C_(o) {
        return Et(o, $t);
      }
      function x_(o, i) {
        return i = typeof i == "function" ? i : t, Et(o, $t, i);
      }
      function D_(o) {
        return Et(o, ye | $t);
      }
      function T_(o, i) {
        return i = typeof i == "function" ? i : t, Et(o, ye | $t, i);
      }
      function S_(o, i) {
        return i == null || Gp(o, i, $e(i));
      }
      function er(o, i) {
        return o === i || o !== o && i !== i;
      }
      var R_ = kn(Rs), w_ = kn(function(o, i) {
        return o >= i;
      }), Ao = ef(function() {
        return arguments;
      }()) ? ef : function(o) {
        return Pe(o) && _e.call(o, "callee") && !Lp.call(o, "callee");
      }, Y = C.isArray, I_ = an ? Tt(an) : kd;
      function _t(o) {
        return o != null && Qn(o.length) && !Or(o);
      }
      function Be(o) {
        return Pe(o) && _t(o);
      }
      function P_(o) {
        return o === !0 || o === !1 || Pe(o) && it(o) == se;
      }
      var Gr = Wl || cp, O_ = un ? Tt(un) : Vd;
      function q_(o) {
        return Pe(o) && o.nodeType === 1 && !Pi(o);
      }
      function B_(o) {
        if (o == null)
          return !0;
        if (_t(o) && (Y(o) || typeof o == "string" || typeof o.splice == "function" || Gr(o) || Zo(o) || Ao(o)))
          return !o.length;
        var i = Ke(o);
        if (i == et || i == tt)
          return !o.size;
        if (wi(o))
          return !Ps(o).length;
        for (var a in o)
          if (_e.call(o, a))
            return !1;
        return !0;
      }
      function U_(o, i) {
        return Ti(o, i);
      }
      function M_(o, i, a) {
        a = typeof a == "function" ? a : t;
        var s = a ? a(o, i) : t;
        return s === t ? Ti(o, i, t, a) : !!s;
      }
      function rp(o) {
        if (!Pe(o))
          return !1;
        var i = it(o);
        return i == Xe || i == ri || typeof o.message == "string" && typeof o.name == "string" && !Pi(o);
      }
      function E_(o) {
        return typeof o == "number" && $p(o);
      }
      function Or(o) {
        if (!we(o))
          return !1;
        var i = it(o);
        return i == Ct || i == xt || i == ti || i == wo;
      }
      function sc(o) {
        return typeof o == "number" && o == J(o);
      }
      function Qn(o) {
        return typeof o == "number" && o > -1 && o % 1 == 0 && o <= qt;
      }
      function we(o) {
        var i = typeof o;
        return o != null && (i == "object" || i == "function");
      }
      function Pe(o) {
        return o != null && typeof o == "object";
      }
      var pc = yn ? Tt(yn) : Ld;
      function k_(o, i) {
        return o === i || Is(o, i, Qs(i));
      }
      function V_(o, i, a) {
        return a = typeof a == "function" ? a : t, Is(o, i, Qs(i), a);
      }
      function N_(o) {
        return fc(o) && o != +o;
      }
      function L_(o) {
        if (xg(o))
          throw new G(re);
        return tf(o);
      }
      function F_(o) {
        return o === null;
      }
      function $_(o) {
        return o == null;
      }
      function fc(o) {
        return typeof o == "number" || Pe(o) && it(o) == yr;
      }
      function Pi(o) {
        if (!Pe(o) || it(o) != pt)
          return !1;
        var i = An(o);
        if (i === null)
          return !0;
        var a = _e.call(i, "constructor") && i.constructor;
        return typeof a == "function" && a instanceof a && gn.call(a) == Vl;
      }
      var op = yo ? Tt(yo) : Fd;
      function j_(o) {
        return sc(o) && o >= -qt && o <= qt;
      }
      var cc = sn ? Tt(sn) : $d;
      function zn(o) {
        return typeof o == "string" || !Y(o) && Pe(o) && it(o) == hr;
      }
      function Rt(o) {
        return typeof o == "symbol" || Pe(o) && it(o) == br;
      }
      var Zo = pn ? Tt(pn) : jd;
      function W_(o) {
        return o === t;
      }
      function H_(o) {
        return Pe(o) && Ke(o) == sr;
      }
      function Q_(o) {
        return Pe(o) && it(o) == Io;
      }
      var z_ = kn(Os), G_ = kn(function(o, i) {
        return o <= i;
      });
      function lc(o) {
        if (!o)
          return [];
        if (_t(o))
          return zn(o) ? Zt(o) : mt(o);
        if (_i && o[_i])
          return Sl(o[_i]());
        var i = Ke(o), a = i == et ? vs : i == tt ? cn : Xo;
        return a(o);
      }
      function qr(o) {
        if (!o)
          return o === 0 ? o : 0;
        if (o = Nt(o), o === Qt || o === -Qt) {
          var i = o < 0 ? -1 : 1;
          return i * Yr;
        }
        return o === o ? o : 0;
      }
      function J(o) {
        var i = qr(o), a = i % 1;
        return i === i ? a ? i - a : i : 0;
      }
      function dc(o) {
        return o ? go(J(o), 0, ze) : 0;
      }
      function Nt(o) {
        if (typeof o == "number")
          return o;
        if (Rt(o))
          return nr;
        if (we(o)) {
          var i = typeof o.valueOf == "function" ? o.valueOf() : o;
          o = we(i) ? i + "" : i;
        }
        if (typeof o != "string")
          return o === 0 ? o : +o;
        o = qp(o);
        var a = zt.test(o);
        return a || Gy.test(o) ? Yt(o.slice(2), a ? 2 : 8) : Qy.test(o) ? nr : +o;
      }
      function gc(o) {
        return dr(o, vt(o));
      }
      function K_(o) {
        return o ? go(J(o), -qt, qt) : o === 0 ? o : 0;
      }
      function de(o) {
        return o == null ? "" : St(o);
      }
      var Y_ = Ko(function(o, i) {
        if (wi(i) || _t(i)) {
          dr(i, $e(i), o);
          return;
        }
        for (var a in i)
          _e.call(i, a) && Ci(o, a, i[a]);
      }), mc = Ko(function(o, i) {
        dr(i, vt(i), o);
      }), Gn = Ko(function(o, i, a, s) {
        dr(i, vt(i), o, s);
      }), J_ = Ko(function(o, i, a, s) {
        dr(i, $e(i), o, s);
      }), Z_ = Ir(Ds);
      function X_(o, i) {
        var a = Go(o);
        return i == null ? a : zp(a, i);
      }
      var ev = ee(function(o, i) {
        o = Ce(o);
        var a = -1, s = i.length, f = s > 2 ? i[2] : t;
        for (f && nt(i[0], i[1], f) && (s = 1); ++a < s; )
          for (var d = i[a], m = vt(d), _ = -1, h = m.length; ++_ < h; ) {
            var R = m[_], w = o[R];
            (w === t || er(w, Ho[R]) && !_e.call(o, R)) && (o[R] = d[R]);
          }
        return o;
      }), tv = ee(function(o) {
        return o.push(t, Bf), ot(_c, t, o);
      });
      function rv(o, i) {
        return Jt(o, H(i, 3), lr);
      }
      function ov(o, i) {
        return Jt(o, H(i, 3), Ss);
      }
      function iv(o, i) {
        return o == null ? o : Ts(o, H(i, 3), vt);
      }
      function nv(o, i) {
        return o == null ? o : Zp(o, H(i, 3), vt);
      }
      function av(o, i) {
        return o && lr(o, H(i, 3));
      }
      function uv(o, i) {
        return o && Ss(o, H(i, 3));
      }
      function yv(o) {
        return o == null ? [] : In(o, $e(o));
      }
      function sv(o) {
        return o == null ? [] : In(o, vt(o));
      }
      function ip(o, i, a) {
        var s = o == null ? t : mo(o, i);
        return s === t ? a : s;
      }
      function pv(o, i) {
        return o != null && Ef(o, i, Bd);
      }
      function np(o, i) {
        return o != null && Ef(o, i, Ud);
      }
      var fv = wf(function(o, i, a) {
        i != null && typeof i.toString != "function" && (i = mn.call(i)), o[i] = a;
      }, up(At)), cv = wf(function(o, i, a) {
        i != null && typeof i.toString != "function" && (i = mn.call(i)), _e.call(o, i) ? o[i].push(a) : o[i] = [a];
      }, H), lv = ee(Di);
      function $e(o) {
        return _t(o) ? Hp(o) : Ps(o);
      }
      function vt(o) {
        return _t(o) ? Hp(o, !0) : Wd(o);
      }
      function dv(o, i) {
        var a = {};
        return i = H(i, 3), lr(o, function(s, f, d) {
          Rr(a, i(s, f, d), s);
        }), a;
      }
      function gv(o, i) {
        var a = {};
        return i = H(i, 3), lr(o, function(s, f, d) {
          Rr(a, f, i(s, f, d));
        }), a;
      }
      var mv = Ko(function(o, i, a) {
        Pn(o, i, a);
      }), _c = Ko(function(o, i, a, s) {
        Pn(o, i, a, s);
      }), _v = Ir(function(o, i) {
        var a = {};
        if (o == null)
          return a;
        var s = !1;
        i = W(i, function(d) {
          return d = Qr(d, o), s || (s = d.length > 1), d;
        }), dr(o, Ws(o), a), s && (a = Et(a, ye | or | $t, fg));
        for (var f = i.length; f--; )
          Es(a, i[f]);
        return a;
      });
      function vv(o, i) {
        return vc(o, Hn(H(i)));
      }
      var Av = Ir(function(o, i) {
        return o == null ? {} : Qd(o, i);
      });
      function vc(o, i) {
        if (o == null)
          return {};
        var a = W(Ws(o), function(s) {
          return [s];
        });
        return i = H(i), sf(o, a, function(s, f) {
          return i(s, f[0]);
        });
      }
      function hv(o, i, a) {
        i = Qr(i, o);
        var s = -1, f = i.length;
        for (f || (f = 1, o = t); ++s < f; ) {
          var d = o == null ? t : o[gr(i[s])];
          d === t && (s = f, d = a), o = Or(d) ? d.call(o) : d;
        }
        return o;
      }
      function bv(o, i, a) {
        return o == null ? o : Si(o, i, a);
      }
      function Cv(o, i, a, s) {
        return s = typeof s == "function" ? s : t, o == null ? o : Si(o, i, a, s);
      }
      var Ac = Of($e), hc = Of(vt);
      function xv(o, i, a) {
        var s = Y(o), f = s || Gr(o) || Zo(o);
        if (i = H(i, 4), a == null) {
          var d = o && o.constructor;
          f ? a = s ? new d() : [] : we(o) ? a = Or(d) ? Go(An(o)) : {} : a = {};
        }
        return (f ? g : lr)(o, function(m, _, h) {
          return i(a, m, _, h);
        }), a;
      }
      function Dv(o, i) {
        return o == null ? !0 : Es(o, i);
      }
      function Tv(o, i, a) {
        return o == null ? o : df(o, i, Ns(a));
      }
      function Sv(o, i, a, s) {
        return s = typeof s == "function" ? s : t, o == null ? o : df(o, i, Ns(a), s);
      }
      function Xo(o) {
        return o == null ? [] : _s(o, $e(o));
      }
      function Rv(o) {
        return o == null ? [] : _s(o, vt(o));
      }
      function wv(o, i, a) {
        return a === t && (a = i, i = t), a !== t && (a = Nt(a), a = a === a ? a : 0), i !== t && (i = Nt(i), i = i === i ? i : 0), go(Nt(o), i, a);
      }
      function Iv(o, i, a) {
        return i = qr(i), a === t ? (a = i, i = 0) : a = qr(a), o = Nt(o), Md(o, i, a);
      }
      function Pv(o, i, a) {
        if (a && typeof a != "boolean" && nt(o, i, a) && (i = a = t), a === t && (typeof i == "boolean" ? (a = i, i = t) : typeof o == "boolean" && (a = o, o = t)), o === t && i === t ? (o = 0, i = 1) : (o = qr(o), i === t ? (i = o, o = 0) : i = qr(i)), o > i) {
          var s = o;
          o = i, i = s;
        }
        if (a || o % 1 || i % 1) {
          var f = jp();
          return Ge(o + f * (i - o + nn("1e-" + ((f + "").length - 1))), i);
        }
        return Bs(o, i);
      }
      var Ov = Yo(function(o, i, a) {
        return i = i.toLowerCase(), o + (a ? bc(i) : i);
      });
      function bc(o) {
        return ap(de(o).toLowerCase());
      }
      function Cc(o) {
        return o = de(o), o && o.replace(Yy, bl).replace(ys, "");
      }
      function qv(o, i, a) {
        o = de(o), i = St(i);
        var s = o.length;
        a = a === t ? s : go(J(a), 0, s);
        var f = a;
        return a -= i.length, a >= 0 && o.slice(a, f) == i;
      }
      function Bv(o) {
        return o = de(o), o && ii.test(o) ? o.replace(Ei, Cl) : o;
      }
      function Uv(o) {
        return o = de(o), o && Fy.test(o) ? o.replace(ui, "\\$&") : o;
      }
      var Mv = Yo(function(o, i, a) {
        return o + (a ? "-" : "") + i.toLowerCase();
      }), Ev = Yo(function(o, i, a) {
        return o + (a ? " " : "") + i.toLowerCase();
      }), kv = Tf("toLowerCase");
      function Vv(o, i, a) {
        o = de(o), i = J(i);
        var s = i ? jo(o) : 0;
        if (!i || s >= i)
          return o;
        var f = (i - s) / 2;
        return En(xn(f), a) + o + En(Cn(f), a);
      }
      function Nv(o, i, a) {
        o = de(o), i = J(i);
        var s = i ? jo(o) : 0;
        return i && s < i ? o + En(i - s, a) : o;
      }
      function Lv(o, i, a) {
        o = de(o), i = J(i);
        var s = i ? jo(o) : 0;
        return i && s < i ? En(i - s, a) + o : o;
      }
      function Fv(o, i, a) {
        return a || i == null ? i = 0 : i && (i = +i), Gl(de(o).replace(yi, ""), i || 0);
      }
      function $v(o, i, a) {
        return (a ? nt(o, i, a) : i === t) ? i = 1 : i = J(i), Us(de(o), i);
      }
      function jv() {
        var o = arguments, i = de(o[0]);
        return o.length < 3 ? i : i.replace(o[1], o[2]);
      }
      var Wv = Yo(function(o, i, a) {
        return o + (a ? "_" : "") + i.toLowerCase();
      });
      function Hv(o, i, a) {
        return a && typeof a != "number" && nt(o, i, a) && (i = a = t), a = a === t ? ze : a >>> 0, a ? (o = de(o), o && (typeof i == "string" || i != null && !op(i)) && (i = St(i), !i && $o(o)) ? zr(Zt(o), 0, a) : o.split(i, a)) : [];
      }
      var Qv = Yo(function(o, i, a) {
        return o + (a ? " " : "") + ap(i);
      });
      function zv(o, i, a) {
        return o = de(o), a = a == null ? 0 : go(J(a), 0, o.length), i = St(i), o.slice(a, a + i.length) == i;
      }
      function Gv(o, i, a) {
        var s = l.templateSettings;
        a && nt(o, i, a) && (i = t), o = de(o), i = Gn({}, i, s, qf);
        var f = Gn({}, i.imports, s.imports, qf), d = $e(f), m = _s(f, d), _, h, R = 0, w = i.interpolate || Mo, I = "__p += '", M = As(
          (i.escape || Mo).source + "|" + w.source + "|" + (w === Bo ? Hy : Mo).source + "|" + (i.evaluate || Mo).source + "|$",
          "g"
        ), N = "//# sourceURL=" + (_e.call(i, "sourceURL") ? (i.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++rn + "]") + `
`;
        o.replace(M, function(z, oe, ae, wt, at, It) {
          return ae || (ae = wt), I += o.slice(R, It).replace(Gt, xl), oe && (_ = !0, I += `' +
__e(` + oe + `) +
'`), at && (h = !0, I += `';
` + at + `;
__p += '`), ae && (I += `' +
((__t = (` + ae + `)) == null ? '' : __t) +
'`), R = It + z.length, z;
        }), I += `';
`;
        var Q = _e.call(i, "variable") && i.variable;
        if (!Q)
          I = `with (obj) {
` + I + `
}
`;
        else if (jy.test(Q))
          throw new G(be);
        I = (h ? I.replace(Ui, "") : I).replace(ky, "$1").replace(Vy, "$1;"), I = "function(" + (Q || "obj") + `) {
` + (Q ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (_ ? ", __e = _.escape" : "") + (h ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + I + `return __p
}`;
        var Z = Dc(function() {
          return ce(d, N + "return " + I).apply(t, m);
        });
        if (Z.source = I, rp(Z))
          throw Z;
        return Z;
      }
      function Kv(o) {
        return de(o).toLowerCase();
      }
      function Yv(o) {
        return de(o).toUpperCase();
      }
      function Jv(o, i, a) {
        if (o = de(o), o && (a || i === t))
          return qp(o);
        if (!o || !(i = St(i)))
          return o;
        var s = Zt(o), f = Zt(i), d = Bp(s, f), m = Up(s, f) + 1;
        return zr(s, d, m).join("");
      }
      function Zv(o, i, a) {
        if (o = de(o), o && (a || i === t))
          return o.slice(0, Ep(o) + 1);
        if (!o || !(i = St(i)))
          return o;
        var s = Zt(o), f = Up(s, Zt(i)) + 1;
        return zr(s, 0, f).join("");
      }
      function Xv(o, i, a) {
        if (o = de(o), o && (a || i === t))
          return o.replace(yi, "");
        if (!o || !(i = St(i)))
          return o;
        var s = Zt(o), f = Bp(s, Zt(i));
        return zr(s, f).join("");
      }
      function eA(o, i) {
        var a = vr, s = xo;
        if (we(i)) {
          var f = "separator" in i ? i.separator : f;
          a = "length" in i ? J(i.length) : a, s = "omission" in i ? St(i.omission) : s;
        }
        o = de(o);
        var d = o.length;
        if ($o(o)) {
          var m = Zt(o);
          d = m.length;
        }
        if (a >= d)
          return o;
        var _ = a - jo(s);
        if (_ < 1)
          return s;
        var h = m ? zr(m, 0, _).join("") : o.slice(0, _);
        if (f === t)
          return h + s;
        if (m && (_ += h.length - _), op(f)) {
          if (o.slice(_).search(f)) {
            var R, w = h;
            for (f.global || (f = As(f.source, de(Vi.exec(f)) + "g")), f.lastIndex = 0; R = f.exec(w); )
              var I = R.index;
            h = h.slice(0, I === t ? _ : I);
          }
        } else if (o.indexOf(St(f), _) != _) {
          var M = h.lastIndexOf(f);
          M > -1 && (h = h.slice(0, M));
        }
        return h + s;
      }
      function tA(o) {
        return o = de(o), o && Ny.test(o) ? o.replace(Mi, Pl) : o;
      }
      var rA = Yo(function(o, i, a) {
        return o + (a ? " " : "") + i.toUpperCase();
      }), ap = Tf("toUpperCase");
      function xc(o, i, a) {
        return o = de(o), i = a ? t : i, i === t ? Tl(o) ? Bl(o) : lt(o) : o.match(i) || [];
      }
      var Dc = ee(function(o, i) {
        try {
          return ot(o, t, i);
        } catch (a) {
          return rp(a) ? a : new G(a);
        }
      }), oA = Ir(function(o, i) {
        return g(i, function(a) {
          a = gr(a), Rr(o, a, ep(o[a], o));
        }), o;
      });
      function iA(o) {
        var i = o == null ? 0 : o.length, a = H();
        return o = i ? W(o, function(s) {
          if (typeof s[1] != "function")
            throw new Ut(F);
          return [a(s[0]), s[1]];
        }) : [], ee(function(s) {
          for (var f = -1; ++f < i; ) {
            var d = o[f];
            if (ot(d[0], this, s))
              return ot(d[1], this, s);
          }
        });
      }
      function nA(o) {
        return Pd(Et(o, ye));
      }
      function up(o) {
        return function() {
          return o;
        };
      }
      function aA(o, i) {
        return o == null || o !== o ? i : o;
      }
      var uA = Rf(), yA = Rf(!0);
      function At(o) {
        return o;
      }
      function yp(o) {
        return rf(typeof o == "function" ? o : Et(o, ye));
      }
      function sA(o) {
        return nf(Et(o, ye));
      }
      function pA(o, i) {
        return af(o, Et(i, ye));
      }
      var fA = ee(function(o, i) {
        return function(a) {
          return Di(a, o, i);
        };
      }), cA = ee(function(o, i) {
        return function(a) {
          return Di(o, a, i);
        };
      });
      function sp(o, i, a) {
        var s = $e(i), f = In(i, s);
        a == null && !(we(i) && (f.length || !s.length)) && (a = i, i = o, o = this, f = In(i, $e(i)));
        var d = !(we(a) && "chain" in a) || !!a.chain, m = Or(o);
        return g(f, function(_) {
          var h = i[_];
          o[_] = h, m && (o.prototype[_] = function() {
            var R = this.__chain__;
            if (d || R) {
              var w = o(this.__wrapped__), I = w.__actions__ = mt(this.__actions__);
              return I.push({ func: h, args: arguments, thisArg: o }), w.__chain__ = R, w;
            }
            return h.apply(o, fe([this.value()], arguments));
          });
        }), o;
      }
      function lA() {
        return qe._ === this && (qe._ = Nl), this;
      }
      function pp() {
      }
      function dA(o) {
        return o = J(o), ee(function(i) {
          return uf(i, o);
        });
      }
      var gA = Fs(W), mA = Fs(P), _A = Fs(Fe);
      function Tc(o) {
        return Gs(o) ? ls(gr(o)) : zd(o);
      }
      function vA(o) {
        return function(i) {
          return o == null ? t : mo(o, i);
        };
      }
      var AA = If(), hA = If(!0);
      function fp() {
        return [];
      }
      function cp() {
        return !1;
      }
      function bA() {
        return {};
      }
      function CA() {
        return "";
      }
      function xA() {
        return !0;
      }
      function DA(o, i) {
        if (o = J(o), o < 1 || o > qt)
          return [];
        var a = ze, s = Ge(o, ze);
        i = H(i), o -= ze;
        for (var f = ms(s, i); ++a < o; )
          i(a);
        return f;
      }
      function TA(o) {
        return Y(o) ? W(o, gr) : Rt(o) ? [o] : mt(Hf(de(o)));
      }
      function SA(o) {
        var i = ++kl;
        return de(o) + i;
      }
      var RA = Mn(function(o, i) {
        return o + i;
      }, 0), wA = $s("ceil"), IA = Mn(function(o, i) {
        return o / i;
      }, 1), PA = $s("floor");
      function OA(o) {
        return o && o.length ? wn(o, At, Rs) : t;
      }
      function qA(o, i) {
        return o && o.length ? wn(o, H(i, 2), Rs) : t;
      }
      function BA(o) {
        return po(o, At);
      }
      function UA(o, i) {
        return po(o, H(i, 2));
      }
      function MA(o) {
        return o && o.length ? wn(o, At, Os) : t;
      }
      function EA(o, i) {
        return o && o.length ? wn(o, H(i, 2), Os) : t;
      }
      var kA = Mn(function(o, i) {
        return o * i;
      }, 1), VA = $s("round"), NA = Mn(function(o, i) {
        return o - i;
      }, 0);
      function LA(o) {
        return o && o.length ? gs(o, At) : 0;
      }
      function FA(o, i) {
        return o && o.length ? gs(o, H(i, 2)) : 0;
      }
      return l.after = s_, l.ary = rc, l.assign = Y_, l.assignIn = mc, l.assignInWith = Gn, l.assignWith = J_, l.at = Z_, l.before = oc, l.bind = ep, l.bindAll = oA, l.bindKey = ic, l.castArray = b_, l.chain = Xf, l.chunk = Pg, l.compact = Og, l.concat = qg, l.cond = iA, l.conforms = nA, l.constant = up, l.countBy = Lm, l.create = X_, l.curry = nc, l.curryRight = ac, l.debounce = uc, l.defaults = ev, l.defaultsDeep = tv, l.defer = p_, l.delay = f_, l.difference = Bg, l.differenceBy = Ug, l.differenceWith = Mg, l.drop = Eg, l.dropRight = kg, l.dropRightWhile = Vg, l.dropWhile = Ng, l.fill = Lg, l.filter = $m, l.flatMap = Hm, l.flatMapDeep = Qm, l.flatMapDepth = zm, l.flatten = Kf, l.flattenDeep = Fg, l.flattenDepth = $g, l.flip = c_, l.flow = uA, l.flowRight = yA, l.fromPairs = jg, l.functions = yv, l.functionsIn = sv, l.groupBy = Gm, l.initial = Hg, l.intersection = Qg, l.intersectionBy = zg, l.intersectionWith = Gg, l.invert = fv, l.invertBy = cv, l.invokeMap = Ym, l.iteratee = yp, l.keyBy = Jm, l.keys = $e, l.keysIn = vt, l.map = $n, l.mapKeys = dv, l.mapValues = gv, l.matches = sA, l.matchesProperty = pA, l.memoize = Wn, l.merge = mv, l.mergeWith = _c, l.method = fA, l.methodOf = cA, l.mixin = sp, l.negate = Hn, l.nthArg = dA, l.omit = _v, l.omitBy = vv, l.once = l_, l.orderBy = Zm, l.over = gA, l.overArgs = d_, l.overEvery = mA, l.overSome = _A, l.partial = tp, l.partialRight = yc, l.partition = Xm, l.pick = Av, l.pickBy = vc, l.property = Tc, l.propertyOf = vA, l.pull = Zg, l.pullAll = Jf, l.pullAllBy = Xg, l.pullAllWith = em, l.pullAt = tm, l.range = AA, l.rangeRight = hA, l.rearg = g_, l.reject = r_, l.remove = rm, l.rest = m_, l.reverse = Zs, l.sampleSize = i_, l.set = bv, l.setWith = Cv, l.shuffle = n_, l.slice = om, l.sortBy = y_, l.sortedUniq = pm, l.sortedUniqBy = fm, l.split = Hv, l.spread = __, l.tail = cm, l.take = lm, l.takeRight = dm, l.takeRightWhile = gm, l.takeWhile = mm, l.tap = Om, l.throttle = v_, l.thru = Fn, l.toArray = lc, l.toPairs = Ac, l.toPairsIn = hc, l.toPath = TA, l.toPlainObject = gc, l.transform = xv, l.unary = A_, l.union = _m, l.unionBy = vm, l.unionWith = Am, l.uniq = hm, l.uniqBy = bm, l.uniqWith = Cm, l.unset = Dv, l.unzip = Xs, l.unzipWith = Zf, l.update = Tv, l.updateWith = Sv, l.values = Xo, l.valuesIn = Rv, l.without = xm, l.words = xc, l.wrap = h_, l.xor = Dm, l.xorBy = Tm, l.xorWith = Sm, l.zip = Rm, l.zipObject = wm, l.zipObjectDeep = Im, l.zipWith = Pm, l.entries = Ac, l.entriesIn = hc, l.extend = mc, l.extendWith = Gn, sp(l, l), l.add = RA, l.attempt = Dc, l.camelCase = Ov, l.capitalize = bc, l.ceil = wA, l.clamp = wv, l.clone = C_, l.cloneDeep = D_, l.cloneDeepWith = T_, l.cloneWith = x_, l.conformsTo = S_, l.deburr = Cc, l.defaultTo = aA, l.divide = IA, l.endsWith = qv, l.eq = er, l.escape = Bv, l.escapeRegExp = Uv, l.every = Fm, l.find = jm, l.findIndex = zf, l.findKey = rv, l.findLast = Wm, l.findLastIndex = Gf, l.findLastKey = ov, l.floor = PA, l.forEach = ec, l.forEachRight = tc, l.forIn = iv, l.forInRight = nv, l.forOwn = av, l.forOwnRight = uv, l.get = ip, l.gt = R_, l.gte = w_, l.has = pv, l.hasIn = np, l.head = Yf, l.identity = At, l.includes = Km, l.indexOf = Wg, l.inRange = Iv, l.invoke = lv, l.isArguments = Ao, l.isArray = Y, l.isArrayBuffer = I_, l.isArrayLike = _t, l.isArrayLikeObject = Be, l.isBoolean = P_, l.isBuffer = Gr, l.isDate = O_, l.isElement = q_, l.isEmpty = B_, l.isEqual = U_, l.isEqualWith = M_, l.isError = rp, l.isFinite = E_, l.isFunction = Or, l.isInteger = sc, l.isLength = Qn, l.isMap = pc, l.isMatch = k_, l.isMatchWith = V_, l.isNaN = N_, l.isNative = L_, l.isNil = $_, l.isNull = F_, l.isNumber = fc, l.isObject = we, l.isObjectLike = Pe, l.isPlainObject = Pi, l.isRegExp = op, l.isSafeInteger = j_, l.isSet = cc, l.isString = zn, l.isSymbol = Rt, l.isTypedArray = Zo, l.isUndefined = W_, l.isWeakMap = H_, l.isWeakSet = Q_, l.join = Kg, l.kebabCase = Mv, l.last = Vt, l.lastIndexOf = Yg, l.lowerCase = Ev, l.lowerFirst = kv, l.lt = z_, l.lte = G_, l.max = OA, l.maxBy = qA, l.mean = BA, l.meanBy = UA, l.min = MA, l.minBy = EA, l.stubArray = fp, l.stubFalse = cp, l.stubObject = bA, l.stubString = CA, l.stubTrue = xA, l.multiply = kA, l.nth = Jg, l.noConflict = lA, l.noop = pp, l.now = jn, l.pad = Vv, l.padEnd = Nv, l.padStart = Lv, l.parseInt = Fv, l.random = Pv, l.reduce = e_, l.reduceRight = t_, l.repeat = $v, l.replace = jv, l.result = hv, l.round = VA, l.runInContext = v, l.sample = o_, l.size = a_, l.snakeCase = Wv, l.some = u_, l.sortedIndex = im, l.sortedIndexBy = nm, l.sortedIndexOf = am, l.sortedLastIndex = um, l.sortedLastIndexBy = ym, l.sortedLastIndexOf = sm, l.startCase = Qv, l.startsWith = zv, l.subtract = NA, l.sum = LA, l.sumBy = FA, l.template = Gv, l.times = DA, l.toFinite = qr, l.toInteger = J, l.toLength = dc, l.toLower = Kv, l.toNumber = Nt, l.toSafeInteger = K_, l.toString = de, l.toUpper = Yv, l.trim = Jv, l.trimEnd = Zv, l.trimStart = Xv, l.truncate = eA, l.unescape = tA, l.uniqueId = SA, l.upperCase = rA, l.upperFirst = ap, l.each = ec, l.eachRight = tc, l.first = Yf, sp(l, function() {
        var o = {};
        return lr(l, function(i, a) {
          _e.call(l.prototype, a) || (o[a] = i);
        }), o;
      }(), { chain: !1 }), l.VERSION = O, g(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(o) {
        l[o].placeholder = l;
      }), g(["drop", "take"], function(o, i) {
        ne.prototype[o] = function(a) {
          a = a === t ? 1 : Ne(J(a), 0);
          var s = this.__filtered__ && !i ? new ne(this) : this.clone();
          return s.__filtered__ ? s.__takeCount__ = Ge(a, s.__takeCount__) : s.__views__.push({
            size: Ge(a, ze),
            type: o + (s.__dir__ < 0 ? "Right" : "")
          }), s;
        }, ne.prototype[o + "Right"] = function(a) {
          return this.reverse()[o](a).reverse();
        };
      }), g(["filter", "map", "takeWhile"], function(o, i) {
        var a = i + 1, s = a == Do || a == So;
        ne.prototype[o] = function(f) {
          var d = this.clone();
          return d.__iteratees__.push({
            iteratee: H(f, 3),
            type: a
          }), d.__filtered__ = d.__filtered__ || s, d;
        };
      }), g(["head", "last"], function(o, i) {
        var a = "take" + (i ? "Right" : "");
        ne.prototype[o] = function() {
          return this[a](1).value()[0];
        };
      }), g(["initial", "tail"], function(o, i) {
        var a = "drop" + (i ? "" : "Right");
        ne.prototype[o] = function() {
          return this.__filtered__ ? new ne(this) : this[a](1);
        };
      }), ne.prototype.compact = function() {
        return this.filter(At);
      }, ne.prototype.find = function(o) {
        return this.filter(o).head();
      }, ne.prototype.findLast = function(o) {
        return this.reverse().find(o);
      }, ne.prototype.invokeMap = ee(function(o, i) {
        return typeof o == "function" ? new ne(this) : this.map(function(a) {
          return Di(a, o, i);
        });
      }), ne.prototype.reject = function(o) {
        return this.filter(Hn(H(o)));
      }, ne.prototype.slice = function(o, i) {
        o = J(o);
        var a = this;
        return a.__filtered__ && (o > 0 || i < 0) ? new ne(a) : (o < 0 ? a = a.takeRight(-o) : o && (a = a.drop(o)), i !== t && (i = J(i), a = i < 0 ? a.dropRight(-i) : a.take(i - o)), a);
      }, ne.prototype.takeRightWhile = function(o) {
        return this.reverse().takeWhile(o).reverse();
      }, ne.prototype.toArray = function() {
        return this.take(ze);
      }, lr(ne.prototype, function(o, i) {
        var a = /^(?:filter|find|map|reject)|While$/.test(i), s = /^(?:head|last)$/.test(i), f = l[s ? "take" + (i == "last" ? "Right" : "") : i], d = s || /^find/.test(i);
        f && (l.prototype[i] = function() {
          var m = this.__wrapped__, _ = s ? [1] : arguments, h = m instanceof ne, R = _[0], w = h || Y(m), I = function(oe) {
            var ae = f.apply(l, fe([oe], _));
            return s && M ? ae[0] : ae;
          };
          w && a && typeof R == "function" && R.length != 1 && (h = w = !1);
          var M = this.__chain__, N = !!this.__actions__.length, Q = d && !M, Z = h && !N;
          if (!d && w) {
            m = Z ? m : new ne(this);
            var z = o.apply(m, _);
            return z.__actions__.push({ func: Fn, args: [I], thisArg: t }), new Mt(z, M);
          }
          return Q && Z ? o.apply(this, _) : (z = this.thru(I), Q ? s ? z.value()[0] : z.value() : z);
        });
      }), g(["pop", "push", "shift", "sort", "splice", "unshift"], function(o) {
        var i = ln[o], a = /^(?:push|sort|unshift)$/.test(o) ? "tap" : "thru", s = /^(?:pop|shift)$/.test(o);
        l.prototype[o] = function() {
          var f = arguments;
          if (s && !this.__chain__) {
            var d = this.value();
            return i.apply(Y(d) ? d : [], f);
          }
          return this[a](function(m) {
            return i.apply(Y(m) ? m : [], f);
          });
        };
      }), lr(ne.prototype, function(o, i) {
        var a = l[i];
        if (a) {
          var s = a.name + "";
          _e.call(zo, s) || (zo[s] = []), zo[s].push({ name: i, func: a });
        }
      }), zo[Un(t, bt).name] = [{
        name: "wrapper",
        func: t
      }], ne.prototype.clone = td, ne.prototype.reverse = rd, ne.prototype.value = od, l.prototype.at = qm, l.prototype.chain = Bm, l.prototype.commit = Um, l.prototype.next = Mm, l.prototype.plant = km, l.prototype.reverse = Vm, l.prototype.toJSON = l.prototype.valueOf = l.prototype.value = Nm, l.prototype.first = l.prototype.head, _i && (l.prototype[_i] = Em), l;
    }, Wo = Ul();
    ft ? ((ft.exports = Wo)._ = Wo, no._ = Wo) : qe._ = Wo;
  }).call(Pt);
})(Xn, Xn.exports);
var mw = Xn.exports;
const vp = /* @__PURE__ */ Bc(mw), _w = {
  boolean: "valueBoolean",
  choice: "valueCoding",
  decimal: "valueDecimal",
  integer: "valueInteger",
  date: "valueDate",
  dateTime: "valueDateTime",
  string: "valueString",
  time: "valueTime",
  uri: "valueUri",
  Attachment: "valueAttachment",
  Coding: "valueCoding",
  quantity: "valueQuantity"
}, vw = (n) => {
  if (typeof n == "boolean")
    return n;
  switch (n.toLowerCase()) {
    case "true":
      return !0;
    case "false":
      return !1;
    default:
      return;
  }
};
function Aw(n, e) {
  return Oi(() => {
    if (!e.enableWhen)
      return !0;
    const t = e.enableWhen.map((O) => {
      const { question: q, operator: re } = O, F = n.itemMap.get(q);
      switch (re) {
        case "=":
          if (!Array.isArray(F == null ? void 0 : F.responseValue.value)) {
            const be = (F == null ? void 0 : F.responseValue.value) !== void 0;
            return be && O.answerBoolean !== void 0 ? vw(
              F.responseValue.value
            ) === O.answerBoolean : be && O.answerCoding !== void 0 && F.responseValue.value.code === O.answerCoding.code;
          }
          return !1;
        default:
          return !0;
      }
    });
    return e.enableBehavior ? e.enableBehavior === "all" ? !t.filter((O) => !O).length : !!t.filter((O) => O).length : t[0];
  });
}
function hw(n, e) {
  return Oi({
    get: () => vp.get(n.response, e.selector.value),
    set: (t) => vp.set(n.response, e.selector.value, t)
  });
}
function bw(n, e) {
  return Oi(() => {
    const t = [];
    if (e.parentLinkId) {
      let O = n.itemMap.get(e.parentLinkId);
      for (; O; ) {
        const q = [];
        q.push(O.linkId), O.repeats && O.type === "group" && q.push(O.index.value), q.push("items"), t.unshift(...q), O = O.parentLinkId ? n.itemMap.get(O.parentLinkId) : void 0;
      }
    }
    return t.push(e.linkId), e.type !== "group" && (t.push("answer"), t.push(_w[e.type])), t;
  });
}
function Cw(n, e) {
  return Oi(() => {
    if (!e.items)
      return !0;
    for (const t of e.items)
      if (t.enabled.value)
        return !0;
    return !1;
  });
}
class Pp extends dw {
  /**
   * @constructor
   * @param {Form} context
   * @param {FormItem} item
   * @param {string} parent
   */
  constructor(t, O, q = "") {
    super(O);
    // eslint-disable-next-line no-use-before-define
    Ee(this, "items");
    Ee(this, "parentLinkId");
    // computed reactive properties not part of FHIR QuestionnaireItem
    Ee(this, "index");
    Ee(this, "isComplete");
    Ee(this, "enabled");
    Ee(this, "responseValue");
    // the value of the answer
    Ee(this, "selector");
    // lodash _.set _.get selector
    Ee(this, "visible");
    if (!this.linkId)
      throw new Error("QuestionnaireItem.linkId is required");
    if (!this.type)
      throw new Error("QuestionnaireItem.type is required");
    this.items = this.item ? this.item.map((re) => new Pp(t, re, this.linkId)) : [], this.parentLinkId = q, t.itemMap.set(this.linkId, this), delete this.item, this.index = Rc(0), this.isComplete = Rc(!1), this.enabled = Aw(t, this), this.selector = bw(t, this), this.responseValue = hw(t, this), this.visible = Cw(t, this);
  }
}
class xw extends cw {
  // managed response object
  /**
   * @constructor
   * @param {r4.Questionnaire} q - Questionnaire to convert
   */
  constructor(t) {
    super(t);
    Ee(this, "items");
    // item tree
    Ee(this, "itemMap", /* @__PURE__ */ new Map());
    // lookup table for items
    Ee(this, "response", Kn({}));
    if (!this.url)
      throw new Error("Questionnaire.url is required");
    if (!this.status)
      throw new Error("Questionnaire.status is required");
    this.items = t.item ? t.item.map((O) => new Pp(this, O)) : [], delete this.item;
  }
  get url() {
    return this.$source.url;
  }
  applyQuestionnaireResponse(t) {
    function O(q) {
      const re = {};
      return q.forEach((F) => {
        const be = F.linkId, me = {};
        F.answer && (me.answer = F.answer[0]), F.item && (me.items = { ...O(F.item) }), re[be] = me;
      }), re;
    }
    this.response = Kn({
      ...O(t.item || [])
    });
  }
  getQuestionnaireResponse() {
    const t = new gw({
      resourceType: "QuestionnaireResponse",
      status: "in-progress",
      questionnaire: this.url,
      authored: (/* @__PURE__ */ new Date()).toISOString()
    });
    function O(q, re) {
      const F = [];
      return Object.entries(re).forEach(([be, me]) => {
        if (vp.isArray(me))
          me.forEach((xe) => {
            const Re = q.itemMap.get(be), ye = {
              linkId: be,
              text: Re == null ? void 0 : Re.text
            };
            xe.answer && (ye.answer = [xe.answer]), xe.items && (ye.item = O(q, xe.items)), F.push(ye);
          });
        else {
          const xe = q.itemMap.get(be), Re = {
            linkId: be,
            text: xe == null ? void 0 : xe.text
          };
          me.answer && (Re.answer = [me.answer]), me.items && (Re.item = O(q, me.items)), F.push(Re);
        }
      }), F;
    }
    return t.item = O(this, this.response), WA(t);
  }
}
const Lt = {
  silent: Number.NEGATIVE_INFINITY,
  fatal: 0,
  error: 0,
  warn: 1,
  log: 2,
  info: 3,
  success: 3,
  fail: 3,
  ready: 3,
  start: 3,
  debug: 4,
  trace: 5,
  verbose: Number.POSITIVE_INFINITY
}, Oc = {
  // Silent
  silent: {
    level: -1
  },
  // Level 0
  fatal: {
    level: Lt.fatal
  },
  error: {
    level: Lt.error
  },
  // Level 1
  warn: {
    level: Lt.warn
  },
  // Level 2
  log: {
    level: Lt.log
  },
  // Level 3
  info: {
    level: Lt.info
  },
  success: {
    level: Lt.success
  },
  fail: {
    level: Lt.fail
  },
  ready: {
    level: Lt.info
  },
  start: {
    level: Lt.info
  },
  // Level 4
  debug: {
    level: Lt.debug
  },
  // Level 5
  trace: {
    level: Lt.trace
  },
  // Verbose
  verbose: {
    level: Lt.verbose
  }
};
function lp(n) {
  return n !== null && typeof n == "object";
}
function Ap(n, e, t = ".", O) {
  if (!lp(e))
    return Ap(n, {}, t, O);
  const q = Object.assign({}, e);
  for (const re in n) {
    if (re === "__proto__" || re === "constructor")
      continue;
    const F = n[re];
    F != null && (O && O(q, re, F, t) || (Array.isArray(F) && Array.isArray(q[re]) ? q[re] = [...F, ...q[re]] : lp(F) && lp(q[re]) ? q[re] = Ap(
      F,
      q[re],
      (t ? `${t}.` : "") + re.toString(),
      O
    ) : q[re] = F));
  }
  return q;
}
function Dw(n) {
  return (...e) => (
    // eslint-disable-next-line unicorn/no-array-reduce
    e.reduce((t, O) => Ap(t, O, "", n), {})
  );
}
const Tw = Dw();
function Sw(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function Rw(n) {
  return !(!Sw(n) || !n.message && !n.args || n.stack);
}
let dp = !1;
const qc = [];
class Qe {
  constructor(e = {}) {
    const t = e.types || Oc;
    this.options = Tw(
      {
        ...e,
        defaults: { ...e.defaults },
        level: gp(e.level, t),
        reporters: [...e.reporters || []]
      },
      {
        types: Oc,
        throttle: 1e3,
        throttleMin: 5,
        formatOptions: {
          date: !0,
          colors: !1,
          compact: !0
        }
      }
    );
    for (const O in t) {
      const q = {
        type: O,
        ...this.options.defaults,
        ...t[O]
      };
      this[O] = this._wrapLogFn(q), this[O].raw = this._wrapLogFn(
        q,
        !0
      );
    }
    this.options.mockFn && this.mockTypes(), this._lastLog = {};
  }
  get level() {
    return this.options.level;
  }
  set level(e) {
    this.options.level = gp(
      e,
      this.options.types,
      this.options.level
    );
  }
  prompt(e, t) {
    if (!this.options.prompt)
      throw new Error("prompt is not supported!");
    return this.options.prompt(e, t);
  }
  create(e) {
    return new Qe({
      ...this.options,
      ...e
    });
  }
  withDefaults(e) {
    return this.create({
      ...this.options,
      defaults: {
        ...this.options.defaults,
        ...e
      }
    });
  }
  withTag(e) {
    return this.withDefaults({
      tag: this.options.defaults.tag ? this.options.defaults.tag + ":" + e : e
    });
  }
  addReporter(e) {
    return this.options.reporters.push(e), this;
  }
  removeReporter(e) {
    if (e) {
      const t = this.options.reporters.indexOf(e);
      if (t >= 0)
        return this.options.reporters.splice(t, 1);
    } else
      this.options.reporters.splice(0);
    return this;
  }
  setReporters(e) {
    return this.options.reporters = Array.isArray(e) ? e : [e], this;
  }
  wrapAll() {
    this.wrapConsole(), this.wrapStd();
  }
  restoreAll() {
    this.restoreConsole(), this.restoreStd();
  }
  wrapConsole() {
    for (const e in this.options.types)
      console["__" + e] || (console["__" + e] = console[e]), console[e] = this[e].raw;
  }
  restoreConsole() {
    for (const e in this.options.types)
      console["__" + e] && (console[e] = console["__" + e], delete console["__" + e]);
  }
  wrapStd() {
    this._wrapStream(this.options.stdout, "log"), this._wrapStream(this.options.stderr, "log");
  }
  _wrapStream(e, t) {
    e && (e.__write || (e.__write = e.write), e.write = (O) => {
      this[t].raw(String(O).trim());
    });
  }
  restoreStd() {
    this._restoreStream(this.options.stdout), this._restoreStream(this.options.stderr);
  }
  _restoreStream(e) {
    e && e.__write && (e.write = e.__write, delete e.__write);
  }
  pauseLogs() {
    dp = !0;
  }
  resumeLogs() {
    dp = !1;
    const e = qc.splice(0);
    for (const t of e)
      t[0]._logFn(t[1], t[2]);
  }
  mockTypes(e) {
    const t = e || this.options.mockFn;
    if (typeof t == "function")
      for (const O in this.options.types)
        this[O] = t(O, this.options.types[O]) || this[O], this[O].raw = this[O];
  }
  _wrapLogFn(e, t) {
    return (...O) => {
      if (dp) {
        qc.push([this, e, O, t]);
        return;
      }
      return this._logFn(e, O, t);
    };
  }
  _logFn(e, t, O) {
    if ((e.level || 0) > this.level)
      return !1;
    const q = {
      date: /* @__PURE__ */ new Date(),
      args: [],
      ...e,
      level: gp(e.level, this.options.types)
    };
    !O && t.length === 1 && Rw(t[0]) ? Object.assign(q, t[0]) : q.args = [...t], q.message && (q.args.unshift(q.message), delete q.message), q.additional && (Array.isArray(q.additional) || (q.additional = q.additional.split(`
`)), q.args.push(`
` + q.additional.join(`
`)), delete q.additional), q.type = typeof q.type == "string" ? q.type.toLowerCase() : "log", q.tag = typeof q.tag == "string" ? q.tag.toLowerCase() : "";
    const re = (be = !1) => {
      const me = (this._lastLog.count || 0) - this.options.throttleMin;
      if (this._lastLog.object && me > 0) {
        const xe = [...this._lastLog.object.args];
        me > 1 && xe.push(`(repeated ${me} times)`), this._log({ ...this._lastLog.object, args: xe }), this._lastLog.count = 1;
      }
      be && (this._lastLog.object = q, this._log(q));
    };
    clearTimeout(this._lastLog.timeout);
    const F = this._lastLog.time && q.date ? q.date.getTime() - this._lastLog.time.getTime() : 0;
    if (this._lastLog.time = q.date, F < this.options.throttle)
      try {
        const be = JSON.stringify([
          q.type,
          q.tag,
          q.args
        ]), me = this._lastLog.serialized === be;
        if (this._lastLog.serialized = be, me && (this._lastLog.count = (this._lastLog.count || 0) + 1, this._lastLog.count > this.options.throttleMin)) {
          this._lastLog.timeout = setTimeout(
            re,
            this.options.throttle
          );
          return;
        }
      } catch {
      }
    re(!0);
  }
  _log(e) {
    for (const t of this.options.reporters)
      t.log(e, {
        options: this.options
      });
  }
}
function gp(n, e = {}, t = 3) {
  return n === void 0 ? t : typeof n == "number" ? n : e[n] && e[n].level !== void 0 ? e[n].level : t;
}
Qe.prototype.add = Qe.prototype.addReporter;
Qe.prototype.remove = Qe.prototype.removeReporter;
Qe.prototype.clear = Qe.prototype.removeReporter;
Qe.prototype.withScope = Qe.prototype.withTag;
Qe.prototype.mock = Qe.prototype.mockTypes;
Qe.prototype.pause = Qe.prototype.pauseLogs;
Qe.prototype.resume = Qe.prototype.resumeLogs;
function ww(n = {}) {
  return new Qe(n);
}
class Iw {
  constructor(e) {
    this.options = { ...e }, this.defaultColor = "#7f8c8d", this.levelColorMap = {
      0: "#c0392b",
      // Red
      1: "#f39c12",
      // Yellow
      3: "#00BCD4"
      // Cyan
    }, this.typeColorMap = {
      success: "#2ecc71"
      // Green
    };
  }
  _getLogFn(e) {
    return e < 1 ? console.__error || console.error : e === 1 ? console.__warn || console.warn : console.__log || console.log;
  }
  log(e) {
    const t = this._getLogFn(e.level), O = e.type !== "log" ? e.type : "", q = e.tag || "", F = `
      background: ${this.typeColorMap[e.type] || this.levelColorMap[e.level] || this.defaultColor};
      border-radius: 0.5em;
      color: white;
      font-weight: bold;
      padding: 2px 0.5em;
    `, be = `%c${[q, O].filter(Boolean).join(":")}`;
    typeof e.args[0] == "string" ? t(
      `${be}%c ${e.args[0]}`,
      F,
      // Empty string as style resets to default console style
      "",
      ...e.args.slice(1)
    ) : t(be, F, ...e.args);
  }
}
function _l(n = {}) {
  return ww({
    reporters: n.reporters || [new Iw({})],
    prompt(t, O = {}) {
      return O.type === "confirm" ? Promise.resolve(confirm(t)) : Promise.resolve(prompt(t));
    },
    ...n
  });
}
_l();
class qw {
  constructor() {
    Ee(this, "_log", _l().withTag("fhir-engine"));
    Ee(this, "meta", Kn({
      autoSave: !1,
      debug: !1
    }));
    Ee(this, "state", Kn({
      status: "waiting",
      activeForm: null,
      formKeys: []
    }));
    Ee(this, "forms", /* @__PURE__ */ new Map());
    Ee(this, "plugins", []);
  }
  async init() {
    var e;
    if (this._log.debug("init"), this.state.status !== "waiting")
      throw new Error("Engine already initialized");
    if (this.state.formKeys.length === 0)
      throw new Error("Engine has no forms to run");
    this.state.status = "initializing";
    for (const t of this.plugins)
      await ((e = t.onInit) == null ? void 0 : e.call(this));
    this.state.activeForm === null && (this.state.activeForm = this.state.formKeys[0]), this._log.debug("init() ~ running"), this.state.status = "running";
  }
  async loadConfig(e) {
    if (this._log.level = e.debug ? 5 : 3, this._log.debug("loadConfig", e), e.fhirResources && e.fhirResources.length > 0) {
      for (const t of e.fhirResources || [])
        await this.loadFhirResource(t);
      delete e.fhirResources;
    }
    Object.assign(this.meta, e);
  }
  async loadPlugin(e) {
    var t;
    this._log.debug("loadPlugin", e), this.plugins.push(e), await ((t = e.onLoad) == null ? void 0 : t.call(this));
  }
  async loadFhirResource(e) {
    var t;
    if (this._log.debug("loadFhirResource", e), !e.resourceType)
      throw new Error("Invalid resource");
    switch (e.resourceType) {
      case "Questionnaire": {
        const O = new xw(e);
        this.forms.set(O.url, O), this.state.formKeys.includes(O.url) || this.state.formKeys.push(O.url);
        for (const q of this.plugins)
          await ((t = q.onFormLoad) == null ? void 0 : t.call(this, O));
        this._log.debug("Form loaded", this.forms.get(O.url));
        break;
      }
      case "QuestionnaireResponse": {
        if (this.state.status === "running")
          throw new Error("Cannot load QuestionnaireResponse after init");
        const O = dl(e);
        if (!O.questionnaire)
          throw new Error(
            "QuestionnaireResponse missing questionnaire reference"
          );
        const q = this.forms.get(O.questionnaire);
        if (!q)
          throw new Error(
            "QuestionnaireResponse references unknown questionnaire"
          );
        q.applyQuestionnaireResponse(O), this._log.debug("Response applied", q.response);
        break;
      }
      default:
        throw new Error("Unsupported resource type");
    }
  }
  get activeForm() {
    return Oi(() => this.forms.get(this.state.activeForm || ""));
  }
  nextForm() {
    const e = this.state.formKeys.indexOf(this.state.activeForm || "");
    if (e === -1)
      throw new Error("Invalid active form");
    if (e + 1 >= this.state.formKeys.length)
      throw new Error("No next form");
    this.state.activeForm = this.state.formKeys[e + 1];
  }
  prevForm() {
    const e = this.state.formKeys.indexOf(this.state.activeForm || "");
    if (e === -1)
      throw new Error("Invalid active form");
    if (e - 1 < 0)
      throw new Error("No previous form");
    this.state.activeForm = this.state.formKeys[e - 1];
  }
  setAnswer(e, t) {
    if (this._log.debug("setAnswer", e, t), !this.activeForm.value)
      throw new Error("Engine not running");
    const q = this.activeForm.value.itemMap.get(e);
    if (!q)
      throw new Error("Invalid Question" + e);
    q.responseValue.value = t;
  }
  async save() {
    var O;
    if (this._log.debug("save()"), this.state.status !== "running" || !this.activeForm.value)
      throw new Error("Engine not running");
    const t = this.activeForm.value.getQuestionnaireResponse();
    for (const q of this.plugins)
      await ((O = q.onFormSave) == null ? void 0 : O.call(this, t));
  }
}
export {
  qw as FhirEngine,
  xw as Form,
  Pp as FormItem,
  cw as Questionnaire,
  dw as QuestionnaireItem,
  gw as QuestionnaireResponse
};
